import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
};

export type AccessToken = {
  __typename?: 'AccessToken';
  validForSeconds?: Maybe<Scalars['Int']['output']>;
  validUntil?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Represents a User's request to manage their account. */
export type AccountManagementRequest = {
  __typename?: 'AccountManagementRequest';
  /** The time the request was created. */
  insertedAt: Scalars['DateTime']['output'];
  /** If true, will request account be permanently deleted. */
  permanentAccountDeletion: Scalars['Boolean']['output'];
  /** If true, will request all account data be permanently deleted. */
  permanentDataDeletion: Scalars['Boolean']['output'];
  /** The ID of the requesting user */
  requestingUserId: Scalars['ID']['output'];
  /** If not null, the request has been resolved. */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountManagementRequestResult = {
  __typename?: 'AccountManagementRequestResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<AccountManagementRequest>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type Adjustment = {
  __typename?: 'Adjustment';
  amountInCents: Money;
  counterAdjustment?: Maybe<Adjustment>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  transaction?: Maybe<WalletTransaction>;
  walletId: Scalars['ID']['output'];
  walletType: WalletType;
};

export type AdjustmentPage = {
  __typename?: 'AdjustmentPage';
  data: Array<Adjustment>;
  page?: Maybe<BasePage>;
};

export type AnalyticsBroadcastStats = {
  __typename?: 'AnalyticsBroadcastStats';
  broadcastId?: Maybe<Scalars['ID']['output']>;
  broadcastName?: Maybe<Scalars['String']['output']>;
  fulfilled?: Maybe<Scalars['Int']['output']>;
  fulfillmentRate?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  totalUniqueMembers?: Maybe<Scalars['Int']['output']>;
  viewRate?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsGroup = {
  __typename?: 'AnalyticsGroup';
  count: Scalars['Int']['output'];
  interval: Scalars['DateTime']['output'];
};

export enum AnalyticsInterval {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Second = 'SECOND',
  Year = 'YEAR'
}

/** A streak repair. */
export type AnswerStreakRepair = {
  __typename?: 'AnswerStreakRepair';
  amountInCents: Money;
  insertedAt: Scalars['DateTime']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The status of an answer streak challenge. */
export enum AnswerStreakStatus {
  AnswerStreakCompleted = 'ANSWER_STREAK_COMPLETED',
  AnswerStreakIncremented = 'ANSWER_STREAK_INCREMENTED',
  AnswerStreakStarted = 'ANSWER_STREAK_STARTED'
}

export type AnswerStreakUpdatedEvent = {
  __typename?: 'AnswerStreakUpdatedEvent';
  status?: Maybe<AnswerStreakStatus>;
};

export type AppInfo = {
  __typename?: 'AppInfo';
  blogUrl: Scalars['String']['output'];
  cookieNoticeUrl: Scalars['String']['output'];
  feedbackUrl: Scalars['String']['output'];
  marketingSiteUrl: Scalars['String']['output'];
  privacyPolicyUrl: Scalars['String']['output'];
  supportEmail: Scalars['String']['output'];
  termsOfServiceUrl: Scalars['String']['output'];
};

/**
 * Represents metadata that can be associated to a paged query response.
 * https://hexdocs.pm/flop/Flop.html#module-pagination
 */
export type BasePage = {
  __typename?: 'BasePage';
  currentOffset?: Maybe<Scalars['Int']['output']>;
  currentPage?: Maybe<Scalars['Int']['output']>;
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  nextOffset?: Maybe<Scalars['Int']['output']>;
  nextPage?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  previousOffset?: Maybe<Scalars['Int']['output']>;
  previousPage?: Maybe<Scalars['Int']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type BasicResult = {
  __typename?: 'BasicResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Result>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/**
 * Represents a block between two Profiles.
 * Blocks limit most interactions between the two specified profiles.
 * Only the blockingProfile user can remove the block.
 */
export type Block = {
  __typename?: 'Block';
  /** The profile that is blocked */
  blockedProfile: Profile;
  /** The profile that did the blocking */
  blockingProfile: Profile;
  /** The unique ID of the block. */
  id: Scalars['ID']['output'];
  /** When was the block created. */
  insertedAt: Scalars['DateTime']['output'];
};

export type BlockEvent = {
  __typename?: 'BlockEvent';
  block: Block;
  type: BlockEventType;
};

export enum BlockEventType {
  BlockAdded = 'BLOCK_ADDED',
  BlockRemoved = 'BLOCK_REMOVED'
}

export enum BlockStatus {
  /** The profile is blocked. */
  Blocked = 'BLOCKED',
  /** The profile is blocking the other profile. */
  Blocking = 'BLOCKING',
  /** The profile is not blocked. */
  NotBlocked = 'NOT_BLOCKED'
}

/** Specify pagination, order_by, and filtering criteria for Broadcasts. */
export type Broadcast = {
  __typename?: 'Broadcast';
  /** The datetime the broadcast was archived */
  broadcastArchivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The datetime the broadcast is scheduled to end */
  broadcastEnd?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the broadcast */
  broadcastName: Scalars['String']['output'];
  /** The datetime the broadcast was first sent */
  broadcastPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The datetime the broadcast is scheduled to be sent */
  broadcastStart?: Maybe<Scalars['DateTime']['output']>;
  /** The target(s) of the broadcast */
  broadcastTarget: BroadcastTarget;
  /** Costs for the broadcast */
  costs?: Maybe<BroadcastCosts>;
  /** Costs for the follow up message */
  followUpMessageCosts?: Maybe<BroadcastCosts>;
  /** Stats for the follow up message */
  followUpMessageStats?: Maybe<BroadcastStats>;
  /** The follow-up message template */
  followUpMessageTemplate?: Maybe<MessageTemplate>;
  /** The ID of the broadcast */
  id: Scalars['ID']['output'];
  /** The datetime the broadcast was created */
  insertedAt: Scalars['DateTime']['output'];
  /** If true, the broadcast will be persistent */
  isPersistent: Scalars['Boolean']['output'];
  /** The message template of the broadcast */
  messageTemplate?: Maybe<MessageTemplate>;
  /** Stats for the broadcast */
  stats?: Maybe<BroadcastStats>;
  /** The status of the broadcast */
  status: BroadcastStatus;
  /** The datetime the broadcast was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type BroadcastCosts = {
  __typename?: 'BroadcastCosts';
  currentCost?: Maybe<Money>;
  finalCost?: Maybe<Money>;
  messagePrice?: Maybe<Money>;
  outstandingCost?: Maybe<Money>;
  potentialTotalCost?: Maybe<Money>;
  returnedCost?: Maybe<Money>;
};

export type BroadcastFilters = {
  __typename?: 'BroadcastFilters';
  attribute: BroadcastQueryAttributes;
  op: PageFilterOp;
  value: PageFilterValues;
};

export type BroadcastFiltersInput = {
  attribute: BroadcastQueryAttributes;
  op: PageFilterOp;
  value: PageFilterValuesInput;
};

export type BroadcastInput = {
  /** Attachment photo crop settings in pixels.  x,y,w,h. */
  attachmentPhotoCrop?: InputMaybe<Scalars['String']['input']>;
  /** The name of the broadcast */
  broadcastName?: InputMaybe<Scalars['String']['input']>;
  /** The datetime the broadcast is scheduled to be sent. Must be a future datetime. */
  broadcastStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** The targets of the broadcast */
  broadcastTarget?: InputMaybe<BroadcastTargetInput>;
  deleteFollowUpMessageTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /** The follow-up message template. */
  followUpMessageTemplate?: InputMaybe<MessageTemplateInput>;
  /** If true, the broadcast will be persistent */
  isPersistent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The message template of the broadcast. */
  messageTemplate?: InputMaybe<MessageTemplateInput>;
  /** If true, will send the broadcast immediately upon successful creation. */
  sendImmediately?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BroadcastOrderBy = {
  __typename?: 'BroadcastOrderBy';
  attribute: BroadcastQueryAttributes;
  direction: PageOrderDirection;
};

export type BroadcastOrderByInput = {
  attribute: BroadcastQueryAttributes;
  direction: PageOrderDirection;
};

export type BroadcastPage = {
  __typename?: 'BroadcastPage';
  data: Array<Broadcast>;
  page?: Maybe<BasePage>;
  query?: Maybe<BroadcastQuery>;
};

export type BroadcastPageInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<BroadcastFiltersInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BroadcastOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type BroadcastQuery = {
  __typename?: 'BroadcastQuery';
  filters?: Maybe<Array<BroadcastFilters>>;
  orderBy?: Maybe<Array<BroadcastOrderBy>>;
};

export enum BroadcastQueryAttributes {
  /** The broadcast's body. */
  Body = 'BODY',
  /** The datetime the broadcast was archived. */
  BroadcastArchivedAt = 'BROADCAST_ARCHIVED_AT',
  /** The datetime the broadcast was scheduled to end. */
  BroadcastEnd = 'BROADCAST_END',
  /** The broadcast's name. */
  BroadcastName = 'BROADCAST_NAME',
  /** The broadcast's price per message. */
  BroadcastPrice = 'BROADCAST_PRICE',
  /** The datetime the broadcast was published. */
  BroadcastPublishedAt = 'BROADCAST_PUBLISHED_AT',
  /** The datetime the broadcast was scheduled to start. */
  BroadcastStart = 'BROADCAST_START',
  /** Full text search by broadcast name and message template body. */
  FullText = 'FULL_TEXT',
  /** The broadcast's ID */
  Id = 'ID',
  /** The datetime the broadcast was created. */
  InsertedAt = 'INSERTED_AT',
  /** If true, the broadcast will be persistent. */
  IsPersistent = 'IS_PERSISTENT',
  /** The datetime the broadcast was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type BroadcastResult = {
  __typename?: 'BroadcastResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Broadcast>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type BroadcastStats = {
  __typename?: 'BroadcastStats';
  expired?: Maybe<Scalars['Int']['output']>;
  fulfilled?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  pollResponses?: Maybe<Array<Maybe<PollResponse>>>;
  rejected?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BroadcastStatsQueryResult = {
  __typename?: 'BroadcastStatsQueryResult';
  followUpMessageStats?: Maybe<BroadcastStats>;
  stats: BroadcastStats;
};

/** Represents the current status of a broadcast. */
export enum BroadcastStatus {
  /** The broadcast has been archived, and is no longer active. */
  Archived = 'ARCHIVED',
  /** The broadcast has been completed, all sent messages have responses, or have expired.. */
  Complete = 'COMPLETE',
  /** The broadcast is a draft, and has not been scheduled, or sent. */
  Draft = 'DRAFT',
  /** The broadcast has been sent, and is awaiting responses. */
  Live = 'LIVE',
  /** The broadcast is scheduled to be sent at a future date. */
  Scheduled = 'SCHEDULED',
  /** The broadcast status is unknown. */
  Unknown = 'UNKNOWN'
}

export type BroadcastTarget = {
  __typename?: 'BroadcastTarget';
  /** If true, broadcast will be sent to all followers at the time the broadcast is sent. */
  allFollowers: Scalars['Boolean']['output'];
  radiusKm?: Maybe<Scalars['Float']['output']>;
  usePrimaryLocation?: Maybe<Scalars['Boolean']['output']>;
};

/** Specify a broadcast target. */
export type BroadcastTargetInput = {
  /** The type of the user to receive the broadcast. If true, when broadcast is sent, all followers will receive the broadcast. */
  allFollowers?: InputMaybe<Scalars['Boolean']['input']>;
  radiusKm?: InputMaybe<Scalars['Float']['input']>;
  usePrimaryLocation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Challenge = {
  __typename?: 'Challenge';
  /** A more verbose description of the challenge, meant to be displayed to the user if they want more details. */
  description: Scalars['String']['output'];
  /** One or more challenges may share this group name.  They are related, and ordered by groupOrder. */
  group: Scalars['String']['output'];
  /** The order in which challenges will be accomplished within a group. */
  groupOrder: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** A unique, human readable key for this challenge. */
  key: Scalars['String']['output'];
  /** Reports progress for the logged in user on this specific challenge. */
  progress: ChallengeProgress;
  /** A short description of the challenge, meant for use as a sub-header. */
  shortDescription: Scalars['String']['output'];
  /** A human readable title. */
  title: Scalars['String']['output'];
  /** Specifies the type of the challenge. */
  type: ChallengeType;
};

/** An event that can happen related to a challenge. */
export type ChallengeEvent = AnswerStreakUpdatedEvent | CorrectMilestoneReachedEvent | IncorrectMilestoneReachedEvent;

/** The filter type for challenges. */
export type ChallengeFilter = {
  /** If true, only return complete.  If false only return incomplete. If null, do not filter based on is_complete. */
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, only return expired.  If false, only return non-expired.  If null, do not filter based on expired_at. */
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An interface that provides fields that are common to challenges. */
export type ChallengeProgress = {
  __typename?: 'ChallengeProgress';
  /** The datetime that the challenge was completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The datetime the challenge expires, and can no longer be completed. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Reports if the challenge is complete based on the challenge's specific completion criteria. */
  isComplete: Scalars['Boolean']['output'];
  /** Reports if the challenge is expired based on the challenge's expired_at datetime. */
  isExpired: Scalars['Boolean']['output'];
  state?: Maybe<ProgressState>;
};

/** The types of challenges that are available. */
export enum ChallengeType {
  /** A challenge that is either complete, or not complete. */
  Boolean = 'BOOLEAN',
  /** A challenge that counts from zero, to a goal amount. */
  Count = 'COUNT',
  /** An ongoing challenge where something must be accomplished repeatedly, in a set amount of time. */
  Streak = 'STREAK'
}

export type ChangeMemberProfileResult = {
  __typename?: 'ChangeMemberProfileResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<EditableMember>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type ChangeVendorProfileResult = {
  __typename?: 'ChangeVendorProfileResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<EditableVendor>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type ChannelPreference = {
  __typename?: 'ChannelPreference';
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ChannelPreferenceInput = {
  enabled: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
};

export type CommunityDiscovery = {
  __typename?: 'CommunityDiscovery';
  /** DEPRECATED: use vendor field */
  community: Profile;
  /** DEPRECATED: use follow_record field */
  conversation?: Maybe<ConversationPreview>;
  followRecord?: Maybe<FollowRecord>;
  vendor: PublicVendor;
};

export type CommunityDiscoveryFilters = {
  __typename?: 'CommunityDiscoveryFilters';
  attribute: CommunityDiscoveryQueryAttributes;
  op: PageFilterOp;
  value: PageFilterValues;
};

export type CommunityDiscoveryFiltersInput = {
  attribute: CommunityDiscoveryQueryAttributes;
  op: PageFilterOp;
  value: PageFilterValuesInput;
};

export type CommunityDiscoveryOrderBy = {
  __typename?: 'CommunityDiscoveryOrderBy';
  attribute: CommunityDiscoveryQueryAttributes;
  direction: PageOrderDirection;
};

export type CommunityDiscoveryOrderByInput = {
  attribute: CommunityDiscoveryQueryAttributes;
  direction: PageOrderDirection;
};

export type CommunityDiscoveryPage = {
  __typename?: 'CommunityDiscoveryPage';
  data: Array<CommunityDiscovery>;
  page?: Maybe<BasePage>;
  query?: Maybe<CommunityDiscoveryQuery>;
};

export type CommunityDiscoveryPageInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<CommunityDiscoveryFiltersInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommunityDiscoveryOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type CommunityDiscoveryQuery = {
  __typename?: 'CommunityDiscoveryQuery';
  filters?: Maybe<Array<CommunityDiscoveryFilters>>;
  orderBy?: Maybe<Array<CommunityDiscoveryOrderBy>>;
};

export enum CommunityDiscoveryQueryAttributes {
  /** The ID of the logged in user. Will be null if user is not following a particular community. */
  CommunityFollowerId = 'COMMUNITY_FOLLOWER_ID',
  /** The display name of the community */
  DisplayName = 'DISPLAY_NAME',
  /** Used for sorting by distance km (must be used with the 'radius_km' filter) */
  DistanceKm = 'DISTANCE_KM',
  /** Full text search by community name, title and introduction fields. */
  FullText = 'FULL_TEXT',
  /** The id of the community */
  Id = 'ID',
  /** The datetime the community was inserted UTC */
  InsertedAt = 'INSERTED_AT',
  /** If the community is non-profit */
  IsNonProfit = 'IS_NON_PROFIT',
  /** The radius in km from the user's location */
  RadiusKm = 'RADIUS_KM',
  /** The datetime the community was updated at UTC */
  UpdatedAt = 'UPDATED_AT'
}

export enum ContentReportReasons {
  Inappropriate = 'INAPPROPRIATE',
  Other = 'OTHER',
  Safety = 'SAFETY',
  Spam = 'SPAM'
}

export enum ContentReportTarget {
  Media = 'MEDIA',
  Message = 'MESSAGE',
  Profile = 'PROFILE'
}

export type Conversation = {
  __typename?: 'Conversation';
  /** Return any blocks between the conversation participants. */
  blocks: Array<Block>;
  conversationEvents: Array<Maybe<ConversationEvent>>;
  conversationSettings: ConversationSettings;
  id: Scalars['ID']['output'];
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  messagePreview?: Maybe<Message>;
  messages: Array<Maybe<Message>>;
  partnerProfile: Profile;
  type: ConversationType;
  unreadMessageCount?: Maybe<Scalars['Int']['output']>;
};

export type ConversationEvent = {
  __typename?: 'ConversationEvent';
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  metadata?: Maybe<ConversationEventMetadata>;
  type: ConversationEventType;
};

export type ConversationEventMetadata = {
  __typename?: 'ConversationEventMetadata';
  previousPriceInCents: Money;
  updatedPriceInCents: Money;
};

export enum ConversationEventType {
  PricingPaymentsDisabled = 'PRICING_PAYMENTS_DISABLED',
  PricingPaymentsEnabled = 'PRICING_PAYMENTS_ENABLED',
  PricingReplyPriceChanged = 'PRICING_REPLY_PRICE_CHANGED',
  PricingViewPriceChanged = 'PRICING_VIEW_PRICE_CHANGED'
}

export type ConversationPreview = {
  __typename?: 'ConversationPreview';
  id: Scalars['ID']['output'];
  messagePreview?: Maybe<Message>;
  partnerProfile: Profile;
  type: ConversationType;
  unreadMessageCount?: Maybe<Scalars['Int']['output']>;
};

export type ConversationSettings = {
  __typename?: 'ConversationSettings';
  canSendMedia: Scalars['Boolean']['output'];
  currentUser: ParticipantSettings;
  partner: ParticipantSettings;
};

export enum ConversationType {
  Earning = 'EARNING',
  Paying = 'PAYING'
}

/** An event that can happen across any conversation. */
export type ConversationsEvent = BlockEvent | ConversationEvent | MediaEvent | MessageEvent | ParticipantSettingsEvent | TypingEvent;

export type CorrectMilestoneReachedEvent = {
  __typename?: 'CorrectMilestoneReachedEvent';
  milestone?: Maybe<Scalars['Int']['output']>;
  swayCashEarned?: Maybe<Scalars['Int']['output']>;
};

export enum DailyStatus {
  Correct = 'CORRECT',
  Incorrect = 'INCORRECT',
  NoAnswer = 'NO_ANSWER'
}

/** A device token required to enable push notifications for a specific channel. */
export type DeviceToken = {
  __typename?: 'DeviceToken';
  /** The client provided device id if one exists. */
  deviceId?: Maybe<Scalars['String']['output']>;
  /** The client provided device name if one exists. */
  deviceName?: Maybe<Scalars['String']['output']>;
  /** The device token */
  deviceToken: Scalars['String']['output'];
  /** A SwayDM assigned ID for the device token. */
  id: Scalars['ID']['output'];
  /** The date time the device token was created. */
  insertedAt: Scalars['DateTime']['output'];
  /** The push notification service this token is for. */
  service: PushService;
};

/** Input for creating a new device token. */
export type DeviceTokenInput = {
  /** The id of the device the token was created on. */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the device the token was created on. */
  deviceName?: InputMaybe<Scalars['String']['input']>;
  /** The device token. */
  deviceToken: Scalars['String']['input'];
  /** The service the token is for. */
  service: PushService;
};

export type DeviceTokenResult = {
  __typename?: 'DeviceTokenResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<DeviceToken>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Payload for donation goal reached notifications. */
export type DonationGoalReachedPayload = {
  __typename?: 'DonationGoalReachedPayload';
  /** The ID of the related redemption. */
  redemptionId: Scalars['ID']['output'];
};

/** Payload for donation summary notifications. */
export type DonationSummaryPayload = {
  __typename?: 'DonationSummaryPayload';
  /** The end date of the donation summary week. */
  endDate: Scalars['DateTime']['output'];
  /** The ID of the profile. */
  profileId: Scalars['String']['output'];
  /** The start date of the donation summary week. */
  startDate: Scalars['DateTime']['output'];
  /** The top percentage of the user in the week. */
  topPercentage: Scalars['Float']['output'];
  /** The total sway cash the user donated in the week. */
  totalSwayCashDonated: Scalars['Int']['output'];
};

export type EditableMember = {
  __typename?: 'EditableMember';
  /** Displayed under full name in conversation, and used as public profile URL part. */
  displayName: Scalars['String']['output'];
  /** Displayed on profile as the first name. Used as part of full name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The unique ID of the profile. */
  id: Scalars['ID']['output'];
  /** Displayed on profile as the last name. Used as part of full name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Profile crop settings in pixels.  x,y,w,h */
  profilePhotoCrop?: Maybe<Scalars['String']['output']>;
  /** The profile photo MediaPointer (may be null if set via web). */
  profilePhotoMediaPointer?: Maybe<MediaPointer>;
  /** MediaPointer ID for profile photo. */
  profilePhotoMediaPointerId?: Maybe<Scalars['ID']['output']>;
  /** A URL to resolve the profile's main image.  Used for their public profile, avatar when logged in, avatar on conversations and messages, and avatar in emails (via knock). */
  profilePhotoUrl: Scalars['String']['output'];
  /** A URL to resolve the profile's main image.  Used for their public profile, avatar when logged in, avatar on conversations and messages, and avatar in emails (via knock). */
  profilePhotoUrlSrcset: Scalars['String']['output'];
  /** The type of profile. */
  profileType: ProfileType;
  /** The timezone in which dates should be displayed.  Also used to transform dates to UTC when submitting dates. */
  timezone?: Maybe<Scalars['String']['output']>;
};

/** A search result */
export type EditableProfile = EditableMember | EditableVendor;

export type EditableVendor = {
  __typename?: 'EditableVendor';
  /** Displayed on profile at bottom as a longer introduction. */
  bio?: Maybe<Scalars['String']['output']>;
  /** The city in which the vendor is located. */
  city?: Maybe<Scalars['String']['output']>;
  /** Displayed under full name in conversation, and used as public profile URL part. */
  displayName: Scalars['String']['output'];
  /** Displayed on profile as the first name. Used as part of full name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The unique ID of the profile. */
  id: Scalars['ID']['output'];
  /** Displayed on profile as the last name. Used as part of full name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Return all profile links */
  profileLinks: Array<ProfileLink>;
  /** Profile crop settings in pixels.  x,y,w,h */
  profilePhotoCrop?: Maybe<Scalars['String']['output']>;
  /** The profile photo MediaPointer (may be null if set via web). */
  profilePhotoMediaPointer?: Maybe<MediaPointer>;
  /** MediaPointer ID for profile photo. */
  profilePhotoMediaPointerId?: Maybe<Scalars['ID']['output']>;
  /** A URL to resolve the profile's main image.  Used for their public profile, avatar when logged in, avatar on conversations and messages, and avatar in emails (via knock). */
  profilePhotoUrl: Scalars['String']['output'];
  /** A URL to resolve the profile's main image.  Used for their public profile, avatar when logged in, avatar on conversations and messages, and avatar in emails (via knock). */
  profilePhotoUrlSrcset: Scalars['String']['output'];
  /** The type of profile. */
  profileType: ProfileType;
  /** The state in which the vendor is located. */
  state?: Maybe<Scalars['String']['output']>;
  /** The timezone in which dates should be displayed.  Also used to transform dates to UTC when submitting dates. */
  timezone?: Maybe<Scalars['String']['output']>;
  /** The name of the community (Vendor). */
  vendorName: Scalars['String']['output'];
};

export type EmojiReaction = {
  __typename?: 'EmojiReaction';
  id: Scalars['ID']['output'];
  reactedAt: Scalars['DateTime']['output'];
  reaction: Scalars['String']['output'];
  reactorDisplayName: Scalars['String']['output'];
  reactorProfileId: Scalars['ID']['output'];
};

/**
 * An ExternalTransaction represents an adjustment between a wallet an an external system.
 * Examples include stripe deposits and withdrawals.
 */
export type ExternalTransaction = WalletTransaction & {
  __typename?: 'ExternalTransaction';
  expectedAmountInCents?: Maybe<Money>;
  forcedFailureAt?: Maybe<Scalars['DateTime']['output']>;
  forcedFailureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  providerTransactionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ExternalTransactionStatus>;
  type?: Maybe<ExternalTransactionType>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ExternalTransactionStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

export enum ExternalTransactionType {
  Deposit = 'DEPOSIT',
  Refund = 'REFUND',
  Topup = 'TOPUP',
  Withdrawal = 'WITHDRAWAL'
}

/** Represents a feature flag as it's exposed to the outside world. */
export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  /** Indicates whether this feature flag is currently enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The unique name of the feature flag. */
  name: Scalars['String']['output'];
};

/** Describes settings and preferences of a user's feed. */
export type Feed = {
  __typename?: 'Feed';
  createdAt: Scalars['DateTime']['output'];
  geoPoint?: Maybe<GeoPoint>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Describes a feed item. */
export type FeedItem = {
  /** The date and time the item was added to the feed. */
  addedAt: Scalars['DateTime']['output'];
  /** The number of milliseconds the item was viewed. */
  deltaMs?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the feed instance. */
  feedInstanceId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the feed item. Should be unique within the feed. */
  id: Scalars['ID']['output'];
  /** The date and time the item was dismissed from the feed. */
  seenAt?: Maybe<Scalars['DateTime']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
};

/** A feed item that contains one or more interactions. */
export type FeedItemInteraction = FeedItem & {
  __typename?: 'FeedItemInteraction';
  /** The date and time the item was added to the feed. */
  addedAt: Scalars['DateTime']['output'];
  /** The number of milliseconds the item was viewed. */
  deltaMs?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the feed instance. */
  feedInstanceId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the feed item. Should be unique within the feed. */
  id: Scalars['ID']['output'];
  /** The interactions associated with the feed item. */
  interactions: Array<Interaction>;
  /** The date and time the item was dismissed from the feed. */
  seenAt?: Maybe<Scalars['DateTime']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
};

/** A feed item that contains a notification. */
export type FeedItemNotification = FeedItem & {
  __typename?: 'FeedItemNotification';
  /** The date and time the item was added to the feed. */
  addedAt: Scalars['DateTime']['output'];
  /** The number of milliseconds the item was viewed. */
  deltaMs?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the feed instance. */
  feedInstanceId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the feed item. Should be unique within the feed. */
  id: Scalars['ID']['output'];
  /** The notification associated with the feed item. */
  notification: FeedNotification;
  /** The date and time the item was dismissed from the feed. */
  seenAt?: Maybe<Scalars['DateTime']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
};

/** A feed item that contains an onboarding suggestion. */
export type FeedItemOnboardingItem = FeedItem & {
  __typename?: 'FeedItemOnboardingItem';
  /** The date and time the item was added to the feed. */
  addedAt: Scalars['DateTime']['output'];
  /** The number of milliseconds the item was viewed. */
  deltaMs?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the feed instance. */
  feedInstanceId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the feed item. Should be unique within the feed. */
  id: Scalars['ID']['output'];
  /** The onboarding item associated with the feed item. */
  onboardingItem: OnboardingItem;
  /** The date and time the item was dismissed from the feed. */
  seenAt?: Maybe<Scalars['DateTime']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
};

/** A feed item that contains a persistent broadcast. */
export type FeedItemPersistentBroadcastSuggestion = FeedItem & {
  __typename?: 'FeedItemPersistentBroadcastSuggestion';
  /** The date and time the item was added to the feed. */
  addedAt: Scalars['DateTime']['output'];
  /** The number of milliseconds the item was viewed. */
  deltaMs?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the feed instance. */
  feedInstanceId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the feed item. Should be unique within the feed. */
  id: Scalars['ID']['output'];
  /** DEPRECATED: The interaction for the persistent broadcast. */
  interaction?: Maybe<Interaction>;
  /** The interaction_id of the persistent broadcast */
  interactionId: Scalars['ID']['output'];
  /** The date and time the item was dismissed from the feed. */
  seenAt?: Maybe<Scalars['DateTime']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
};

/** A feed item that contains a poll. */
export type FeedItemPoll = FeedItem & {
  __typename?: 'FeedItemPoll';
  /** The date and time the item was added to the feed. */
  addedAt: Scalars['DateTime']['output'];
  /** The number of milliseconds the item was viewed. */
  deltaMs?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the feed instance. */
  feedInstanceId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the feed item. Should be unique within the feed. */
  id: Scalars['ID']['output'];
  pollSuggestion: PollSuggestion;
  /** The date and time the item was dismissed from the feed. */
  seenAt?: Maybe<Scalars['DateTime']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
};

/** A feed item that contains a redemption suggestion. */
export type FeedItemRedemptionSuggestion = FeedItem & {
  __typename?: 'FeedItemRedemptionSuggestion';
  /** The date and time the item was added to the feed. */
  addedAt: Scalars['DateTime']['output'];
  /** The number of milliseconds the item was viewed. */
  deltaMs?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the feed instance. */
  feedInstanceId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the feed item. Should be unique within the feed. */
  id: Scalars['ID']['output'];
  /** The redemption suggestion associated with the feed item. */
  redemptionSuggestion: RedemptionSuggestion;
  /** The date and time the item was dismissed from the feed. */
  seenAt?: Maybe<Scalars['DateTime']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
};

/** A feed item that contains a session suggestion. */
export type FeedItemSessionSummary = FeedItem & {
  __typename?: 'FeedItemSessionSummary';
  /** The date and time the item was added to the feed. */
  addedAt: Scalars['DateTime']['output'];
  /** The number of milliseconds the item was viewed. */
  deltaMs?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the feed instance. */
  feedInstanceId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the feed item. Should be unique within the feed. */
  id: Scalars['ID']['output'];
  /** The date and time the item was dismissed from the feed. */
  seenAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the session. */
  sessionId: Scalars['String']['output'];
  supplierId?: Maybe<Scalars['String']['output']>;
};

/** A feed item that contains an unclaimed suggestion. */
export type FeedItemUnclaimedVendorSuggestion = FeedItem & {
  __typename?: 'FeedItemUnclaimedVendorSuggestion';
  /** The date and time the item was added to the feed. */
  addedAt: Scalars['DateTime']['output'];
  /** The number of milliseconds the item was viewed. */
  deltaMs?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the feed instance. */
  feedInstanceId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the feed item. Should be unique within the feed. */
  id: Scalars['ID']['output'];
  /** The date and time the item was dismissed from the feed. */
  seenAt?: Maybe<Scalars['DateTime']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
  /** The vendor suggestion associated with the feed item. */
  unclaimedVendorSuggestion: UnclaimedVendorSuggestion;
};

/** A feed item that contains a vendor suggestion. */
export type FeedItemVendorSuggestion = FeedItem & {
  __typename?: 'FeedItemVendorSuggestion';
  /** The date and time the item was added to the feed. */
  addedAt: Scalars['DateTime']['output'];
  /** The number of milliseconds the item was viewed. */
  deltaMs?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the feed instance. */
  feedInstanceId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the feed item. Should be unique within the feed. */
  id: Scalars['ID']['output'];
  /** The date and time the item was dismissed from the feed. */
  seenAt?: Maybe<Scalars['DateTime']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
  /** The vendor suggestion associated with the feed item. */
  vendorSuggestion: VendorSuggestion;
};

/** A notification to be displayed within the feed. */
export type FeedNotification = {
  __typename?: 'FeedNotification';
  /** The body of the notification. */
  body: Scalars['String']['output'];
  /** The payload of the notification. */
  payload?: Maybe<FeedNotificationPayload>;
  /** (DEPRECATED) The optional id of the redemption associated with the notification. */
  redemptionId?: Maybe<Scalars['String']['output']>;
  /** The title of the notification. */
  title: Scalars['String']['output'];
  /** The type of notification */
  type: FeedNotificationType;
};

/** The notification payload based on the notification type. */
export type FeedNotificationPayload = DonationGoalReachedPayload | DonationSummaryPayload | GenericNotificationPayload | LastStreakRepairUsedPayload | LeaderboardEarningSummaryPayload | LeaderboardNonWinnerPayload | LeaderboardWinnerPayload | ReferredAccountVerifiedPayload;

export enum FeedNotificationType {
  AnswerStreakCompleted = 'ANSWER_STREAK_COMPLETED',
  AnswerStreakIncremented = 'ANSWER_STREAK_INCREMENTED',
  AnswerStreakMissed = 'ANSWER_STREAK_MISSED',
  AnswerStreakStarted = 'ANSWER_STREAK_STARTED',
  CorrectMilestoneReached = 'CORRECT_MILESTONE_REACHED',
  DonationGoalReached = 'DONATION_GOAL_REACHED',
  DonationSummary = 'DONATION_SUMMARY',
  GenericNotification = 'GENERIC_NOTIFICATION',
  IncorrectMilestoneReached = 'INCORRECT_MILESTONE_REACHED',
  LastStreakRepairUsed = 'LAST_STREAK_REPAIR_USED',
  LeaderboardEarningSummary = 'LEADERBOARD_EARNING_SUMMARY',
  LeaderboardNonWinner = 'LEADERBOARD_NON_WINNER',
  LeaderboardWinner = 'LEADERBOARD_WINNER',
  Message = 'MESSAGE',
  ReferredAccountVerified = 'REFERRED_ACCOUNT_VERIFIED'
}

/** A session from the feed. */
export type FeedSession = {
  __typename?: 'FeedSession';
  /** The date of the session. */
  date: Scalars['Date']['output'];
  /** The id of the session. */
  id: Scalars['String']['output'];
  /** The number of polls answered in the session. */
  pollsAnswered: Scalars['Int']['output'];
  /** The sway cash earned in the session. */
  swayCashEarned: Scalars['Int']['output'];
  /** The number of trivia correct in the session. */
  triviaCorrect: Scalars['Int']['output'];
  /** The number of trivia incorrect in the session. */
  triviaIncorrect: Scalars['Int']['output'];
};

/** Answer first poll of the day. types [:first_poll_of_the_day] */
export type FirstPollOfTheDay = {
  __typename?: 'FirstPollOfTheDay';
  profileId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Represents a member following a vendor. */
export type FollowRecord = {
  __typename?: 'FollowRecord';
  /** The conversation preview if one exists. */
  conversation?: Maybe<ConversationPreview>;
  conversationId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  /** Member Profile */
  member: MemberProfile;
  memberId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Vendor Profile */
  vendor: PublicVendor;
  vendorId: Scalars['ID']['output'];
};

export type FollowResult = {
  __typename?: 'FollowResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<ConversationPreview>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type FollowerPage = {
  __typename?: 'FollowerPage';
  data: Array<FollowRecord>;
  page?: Maybe<BasePage>;
  query?: Maybe<FollowerPageQuery>;
};

export type FollowerPageFilters = {
  __typename?: 'FollowerPageFilters';
  attribute: FollowerPageQueryAttributes;
  op: PageFilterOp;
  value: PageFilterValues;
};

export type FollowerPageFiltersInput = {
  attribute: FollowerPageQueryAttributes;
  op: PageFilterOp;
  value: PageFilterValuesInput;
};

export type FollowerPageInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FollowerPageFiltersInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FollowerPageOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type FollowerPageOrderBy = {
  __typename?: 'FollowerPageOrderBy';
  attribute: FollowerPageQueryAttributes;
  direction: PageOrderDirection;
};

export type FollowerPageOrderByInput = {
  attribute: FollowerPageQueryAttributes;
  direction: PageOrderDirection;
};

export type FollowerPageQuery = {
  __typename?: 'FollowerPageQuery';
  filters?: Maybe<Array<FollowerPageFilters>>;
  orderBy?: Maybe<Array<FollowerPageOrderBy>>;
};

export enum FollowerPageQueryAttributes {
  /** The datetime the follow was created. */
  InsertedAt = 'INSERTED_AT',
  /** The member display name */
  MemberDisplayName = 'MEMBER_DISPLAY_NAME',
  /** The member full name */
  MemberFullName = 'MEMBER_FULL_NAME',
  /** The ID of the member */
  MemberId = 'MEMBER_ID',
  /** The datetime the follow was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

/** Payload for generic notifications. */
export type GenericNotificationPayload = {
  __typename?: 'GenericNotificationPayload';
  /** The action button color of the notification. */
  actionButtonColor?: Maybe<Scalars['String']['output']>;
  /** The action text of the notification. */
  actionText?: Maybe<Scalars['String']['output']>;
  /** The action url of the notification. */
  actionUrl?: Maybe<Scalars['String']['output']>;
  /** The background color of the notification. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The badge color of the notification. */
  badgeColor?: Maybe<Scalars['String']['output']>;
  /** A badge text for the notification. */
  badgeText?: Maybe<Scalars['String']['output']>;
  /** The body of the notification. */
  body: Scalars['String']['output'];
  /** The subtitle of the notification. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** The title of the notification. */
  title: Scalars['String']['output'];
  /** The icon url at the top of the notification. */
  topIcon?: Maybe<Scalars['String']['output']>;
};

/** Represents a geo-location point on earth. */
export type GeoPoint = {
  __typename?: 'GeoPoint';
  /** The latitude of the point. */
  lat: Scalars['Float']['output'];
  /** The longitude of the point. */
  lng: Scalars['Float']['output'];
};

export type GeoPointInput = {
  /** The latitude of the point. */
  latitude: Scalars['Float']['input'];
  /** The longitude of the point. */
  longitude: Scalars['Float']['input'];
};

/** Top level type for impression analytics. */
export type ImpressionAnalytics = {
  __typename?: 'ImpressionAnalytics';
  /** The breakdown of impressions by their type. */
  impressionStats?: Maybe<Array<ImpressionStats>>;
  /** The total count of all impressions in this result. */
  total?: Maybe<Scalars['Int']['output']>;
};

/** Top level type for stats of a specific impression type. */
export type ImpressionStats = {
  __typename?: 'ImpressionStats';
  /** The action taken to make the impression, such as 'skipped', or 'viewed'. */
  action?: Maybe<Scalars['String']['output']>;
  /** The source of the action, such as 'feed', 'page', or 'conversation' */
  actionSource?: Maybe<Scalars['String']['output']>;
  /** The target type of the impression, such as 'broadcast' or 'redemption'. */
  targetType?: Maybe<Scalars['String']['output']>;
  /** The count of all impressions matching the type */
  total?: Maybe<Scalars['Int']['output']>;
};

export type IncorrectMilestoneReachedEvent = {
  __typename?: 'IncorrectMilestoneReachedEvent';
  milestone?: Maybe<Scalars['Int']['output']>;
};

/** Interface to expose common fields for every interaction. */
export type Interaction = {
  /** Details for any call to action. Intended to be displayed in the UI. */
  ctaDetails?: Maybe<Scalars['String']['output']>;
  /** A title for any call to action. Intended to be displayed in the UI. */
  ctaTitle?: Maybe<Scalars['String']['output']>;
  /** The earning potential of the interaction (if applicable). */
  earningPotential?: Maybe<Money>;
  /** The expiration date/time of the interaction (if applicable). */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Follow-up interaction. Intended to use for follow up messages. */
  followUpInteraction?: Maybe<Interaction>;
  id: Scalars['ID']['output'];
  /** The type of interaction */
  interactionType: InteractionType;
  /** The status of the interaction */
  status: InteractionStatus;
};

/** User can complete this interaction with a click. */
export type InteractionClick = Interaction & {
  __typename?: 'InteractionClick';
  clickDetails?: Maybe<Scalars['String']['output']>;
  /** Details for any call to action. Intended to be displayed in the UI. */
  ctaDetails?: Maybe<Scalars['String']['output']>;
  /** A title for any call to action. Intended to be displayed in the UI. */
  ctaTitle?: Maybe<Scalars['String']['output']>;
  /** The earning potential of the interaction (if applicable). */
  earningPotential?: Maybe<Money>;
  /** The expiration date/time of the interaction (if applicable). */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Follow-up interaction. Intended to use for follow up messages. */
  followUpInteraction?: Maybe<Interaction>;
  id: Scalars['ID']['output'];
  /** The type of interaction */
  interactionType: InteractionType;
  /** The message the user will be acknowledging. */
  message: Message;
  /** The primary media for the click interaction */
  primaryMedia?: Maybe<MediaPointer>;
  /** The status of the interaction */
  status: InteractionStatus;
};

/**
 * An interaction that provides various options to the end user.
 * Poll options can contain various types.  For example, PollTextOptions can be mixed with PollMediaOptions.
 */
export type InteractionPoll = Interaction & {
  __typename?: 'InteractionPoll';
  /** Text that will show after the user has answered */
  bonusText?: Maybe<Scalars['String']['output']>;
  /** Additional context that may appear at the bottom of the view. */
  caption?: Maybe<Scalars['String']['output']>;
  /**
   * If :q_and_a type, the user will earn only if a correct answer is chosen.≈
   * If user pick incorrect answer, they will instead get no SC, unless :consolation_price is set.
   */
  consolationPrice?: Maybe<Scalars['Int']['output']>;
  creator?: Maybe<PublicVendor>;
  /** Details for any call to action. Intended to be displayed in the UI. */
  ctaDetails?: Maybe<Scalars['String']['output']>;
  /** A title for any call to action. Intended to be displayed in the UI. */
  ctaTitle?: Maybe<Scalars['String']['output']>;
  /** The earning potential of the interaction (if applicable). */
  earningPotential?: Maybe<Money>;
  /** The expiration date/time of the interaction (if applicable). */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Follow-up interaction. Intended to use for follow up messages. */
  followUpInteraction?: Maybe<Interaction>;
  id: Scalars['ID']['output'];
  /** The type of interaction */
  interactionType: InteractionType;
  /** DEPRECATED: Resolves a related message if one exists. */
  message?: Maybe<Message>;
  /** List the options of this poll (in order they should appear). */
  options: Array<Maybe<PollOption>>;
  /** The ID of the poll, this is different than the interactionId */
  pollId?: Maybe<Scalars['ID']['output']>;
  /** If poll is complete, and user has access to view results, this field will resolve to the poll results. */
  pollResults?: Maybe<PollResults>;
  /** The type of poll */
  pollType?: Maybe<PollType>;
  /**
   * The amount the user will earn.
   * If :poll type, user will earn for answering.
   * If :q_and_a type, the user will earn only if a correct answer is chosen.
   * If user pick incorrect answer, they will instead get no SC, unless :consolation_price is set.
   */
  price?: Maybe<Scalars['Int']['output']>;
  /** The primary media for the poll */
  primaryMedia?: Maybe<MediaPointer>;
  /** The optional question of the poll. */
  question?: Maybe<Scalars['String']['output']>;
  /** The status of the interaction */
  status: InteractionStatus;
  /** If user has participated in the poll, this field will resolve to their selected answer. */
  userAnswer?: Maybe<UserAnswer>;
};

/**
 * An interaction that involves a requested redemption.
 * E.g. The user has a pending or approved redemption.
 */
export type InteractionRedemption = Interaction & {
  __typename?: 'InteractionRedemption';
  /** Details for any call to action. Intended to be displayed in the UI. */
  ctaDetails?: Maybe<Scalars['String']['output']>;
  /** A title for any call to action. Intended to be displayed in the UI. */
  ctaTitle?: Maybe<Scalars['String']['output']>;
  /** The earning potential of the interaction (if applicable). */
  earningPotential?: Maybe<Money>;
  /** The expiration date/time of the interaction (if applicable). */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Follow-up interaction. Intended to use for follow up messages. */
  followUpInteraction?: Maybe<Interaction>;
  id: Scalars['ID']['output'];
  /** The type of interaction */
  interactionType: InteractionType;
  /** The message associated to this redemption. Don't resolve unless resolving by the interaction ID. */
  message?: Maybe<Message>;
  redemption: Redemption;
  redemptionDetails?: Maybe<Scalars['String']['output']>;
  /** The status of the interaction */
  status: InteractionStatus;
};

/**
 * * Not currently implemented
 * An interaction that involves a redemption offer.
 * E.g. The user is being offered a redemption, there is no transaction here.
 */
export type InteractionRedemptionOffer = Interaction & {
  __typename?: 'InteractionRedemptionOffer';
  /** Details for any call to action. Intended to be displayed in the UI. */
  ctaDetails?: Maybe<Scalars['String']['output']>;
  /** A title for any call to action. Intended to be displayed in the UI. */
  ctaTitle?: Maybe<Scalars['String']['output']>;
  /** The earning potential of the interaction (if applicable). */
  earningPotential?: Maybe<Money>;
  /** The expiration date/time of the interaction (if applicable). */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Follow-up interaction. Intended to use for follow up messages. */
  followUpInteraction?: Maybe<Interaction>;
  id: Scalars['ID']['output'];
  /** The type of interaction */
  interactionType: InteractionType;
  /** The message associated to this redemption offer. Don't resolve unless resolving by the interaction ID. */
  message?: Maybe<Message>;
  redemptions: Array<Redemption>;
  /** The status of the interaction */
  status: InteractionStatus;
};

/** User can complete this interaction by replying to a message. */
export type InteractionReply = Interaction & {
  __typename?: 'InteractionReply';
  /** Details for any call to action. Intended to be displayed in the UI. */
  ctaDetails?: Maybe<Scalars['String']['output']>;
  /** A title for any call to action. Intended to be displayed in the UI. */
  ctaTitle?: Maybe<Scalars['String']['output']>;
  /** The earning potential of the interaction (if applicable). */
  earningPotential?: Maybe<Money>;
  /** The expiration date/time of the interaction (if applicable). */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Follow-up interaction. Intended to use for follow up messages. */
  followUpInteraction?: Maybe<Interaction>;
  id: Scalars['ID']['output'];
  /** The type of interaction */
  interactionType: InteractionType;
  /** The message the user will be replying to. */
  message: Message;
  /** The primary media for the reply interaction */
  primaryMedia?: Maybe<MediaPointer>;
  replyDetails?: Maybe<Scalars['String']['output']>;
  /** The status of the interaction */
  status: InteractionStatus;
};

/** Payload object for interaction mutation results. */
export type InteractionResult = {
  __typename?: 'InteractionResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Interaction>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Describes the state the interaction is currently in. */
export enum InteractionStatus {
  Complete = 'COMPLETE',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

/** Describes the type of interaction. */
export enum InteractionType {
  Click = 'CLICK',
  Poll = 'POLL',
  Redemption = 'REDEMPTION',
  RedemptionOffer = 'REDEMPTION_OFFER',
  Reply = 'REPLY'
}

/**
 * An InternalTransaction represents an amount moved between two SwayDM wallets.
 * Typically this is a result of a promotion, or an internal transfer.
 */
export type InternalTransaction = WalletTransaction & {
  __typename?: 'InternalTransaction';
  /** The amount of the transaction. */
  amountInCents: Money;
  /** A short description of the transaction. */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  /** Will be populated if this InternalTransaction was applied by a Promotion. */
  promotion?: Maybe<Promotion>;
  updatedAt: Scalars['DateTime']['output'];
};

export type KnockCredentials = {
  __typename?: 'KnockCredentials';
  feedChannelId?: Maybe<Scalars['String']['output']>;
  publicKey?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userToken?: Maybe<Scalars['String']['output']>;
};

/** Payload for out of streak repairs notifications. */
export type LastStreakRepairUsedPayload = {
  __typename?: 'LastStreakRepairUsedPayload';
  /** The date of the last streak repair usage. */
  usedAt: Scalars['DateTime']['output'];
};

/** Payload for leaderboard earning summary notifications. */
export type LeaderboardEarningSummaryPayload = {
  __typename?: 'LeaderboardEarningSummaryPayload';
  /** The end date of the summary. */
  endDate: Scalars['DateTime']['output'];
  /** The leaderboard entry of the current user. */
  leaderboardEntry: SwayCashLeaderboardRecord;
  /** The start date of the summary. */
  startDate: Scalars['DateTime']['output'];
  /** The SC earned in last week. */
  swayCash: Money;
  /** The top leaderboard entries. */
  topLeaderboardEntries?: Maybe<Array<SwayCashLeaderboardRecord>>;
  /** The updated SC balance. */
  updatedBalance: Money;
};

/** Payload for leaderboard non winner notifications. */
export type LeaderboardNonWinnerPayload = {
  __typename?: 'LeaderboardNonWinnerPayload';
  /** The end date of the leaderboard week. */
  endDate: Scalars['DateTime']['output'];
  /** The margin between the non-winner and the winner. */
  marginToWinner: Money;
  /** The position of the non-winner on the leaderboard. */
  position: Scalars['Int']['output'];
  /** The start date of the leaderboard week. */
  startDate: Scalars['DateTime']['output'];
  /** The SC earned by the non-winner last week. */
  swayCash: Money;
};

/** Payload for leaderboard winner notifications. */
export type LeaderboardWinnerPayload = {
  __typename?: 'LeaderboardWinnerPayload';
  /** The end date of the leaderboard week. */
  endDate: Scalars['DateTime']['output'];
  /** The number of participants who didn't win. */
  nonWinnerCount: Scalars['Int']['output'];
  /** The start date of the leaderboard week. */
  startDate: Scalars['DateTime']['output'];
  /** The SC earned by the winner last week. */
  swayCash: Money;
  /** The margin of the winner with the second place. */
  winnerMargin: Money;
};

export type Link = {
  __typename?: 'Link';
  /**
   * Analytics for the given link.
   * Defaults to hourly rollup for the past 7 days
   */
  activity?: Maybe<LinkActivity>;
  /** Link creator profile */
  creator: Profile;
  /** Disabled at timestamp of the link */
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Id of the link */
  id: Scalars['ID']['output'];
  /** Inserted at timestamp of the link */
  insertedAt: Scalars['DateTime']['output'];
  /** Internal flag of the link */
  internal: Scalars['Boolean']['output'];
  /** Name of the link */
  name?: Maybe<Scalars['String']['output']>;
  /** Profile to redirect to */
  redirectProfile?: Maybe<Profile>;
  /** Redemption to redirect to */
  redirectRedemption?: Maybe<Redemption>;
  /** Short code of the link */
  shortCode?: Maybe<Scalars['String']['output']>;
  /** The stored URI that will be redirected to, unless a redirect profile or redemption is specified. */
  storedUri: Scalars['String']['output'];
  /** Tracking code of the link */
  trackingCode?: Maybe<Scalars['String']['output']>;
  /** The type of link */
  type?: Maybe<Scalars['String']['output']>;
  /** Updated at timestamp of the link */
  updatedAt: Scalars['DateTime']['output'];
  /** URI of the link. */
  uri: Scalars['String']['output'];
};


export type LinkActivityArgs = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  granularity?: InputMaybe<AnalyticsInterval>;
  lookbackInterval?: InputMaybe<Scalars['Int']['input']>;
  lookbackUnit?: InputMaybe<AnalyticsInterval>;
};

export type LinkActivity = {
  __typename?: 'LinkActivity';
  asOf?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<Array<AnalyticsGroup>>;
  granularity?: Maybe<AnalyticsInterval>;
  lookbackInterval?: Maybe<Scalars['Int']['output']>;
  lookbackUnit?: Maybe<AnalyticsInterval>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type LinkCreateInput = {
  /** Name of the link */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Profile flag for link - true if associating with current_profile, false if associating with redemption */
  profile?: InputMaybe<Scalars['Boolean']['input']>;
  /** Redemption id for link - used for associating with redemption when profile is false */
  redemptionId?: InputMaybe<Scalars['ID']['input']>;
};

export type LinkFilters = {
  __typename?: 'LinkFilters';
  attribute: LinkQueryAttributes;
  op: PageFilterOp;
  value: PageFilterValues;
};

export type LinkFiltersInput = {
  attribute: LinkQueryAttributes;
  op: PageFilterOp;
  value: PageFilterValuesInput;
};

export type LinkInput = {
  /** Id of the link */
  id: Scalars['ID']['input'];
  /** Name of the link */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Profile flag for link - true if associating with current_profile, false if associating with redemption */
  profile?: InputMaybe<Scalars['Boolean']['input']>;
  /** Redemption id for link - used for associating with redemption when profile is false */
  redemptionId?: InputMaybe<Scalars['ID']['input']>;
};

export type LinkOrderBy = {
  __typename?: 'LinkOrderBy';
  attribute: LinkQueryAttributes;
  direction: PageOrderDirection;
};

export type LinkOrderByInput = {
  attribute: LinkQueryAttributes;
  direction: PageOrderDirection;
};

export type LinkPage = {
  __typename?: 'LinkPage';
  data: Array<Link>;
  page?: Maybe<BasePage>;
  query?: Maybe<LinkQuery>;
};

export type LinkPageInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<LinkFiltersInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LinkOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type LinkQuery = {
  __typename?: 'LinkQuery';
  filters?: Maybe<Array<LinkFilters>>;
  orderBy?: Maybe<Array<LinkOrderBy>>;
};

export enum LinkQueryAttributes {
  /** Link creator profile */
  CreatorId = 'CREATOR_ID',
  /** Disabled at timestamp of the link */
  DisabledAt = 'DISABLED_AT',
  /** Id of the link */
  Id = 'ID',
  /** Inserted at timestamp of the link */
  InsertedAt = 'INSERTED_AT',
  /** Internal flag of the link */
  Internal = 'INTERNAL',
  /** Name of the link */
  Name = 'NAME',
  /** Profile to redirect to */
  RedirectProfileId = 'REDIRECT_PROFILE_ID',
  /** Redemption to redirect to */
  RedirectRedemptionId = 'REDIRECT_REDEMPTION_ID',
  /** Short code of the link */
  ShortCode = 'SHORT_CODE',
  /** Tracking code of the link */
  TrackingCode = 'TRACKING_CODE',
  /** Updated at timestamp of the link */
  UpdatedAt = 'UPDATED_AT',
  /** URI of the link */
  Uri = 'URI'
}

export type LinkResult = {
  __typename?: 'LinkResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Link>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Represents a physical geo location. */
export type Location = {
  __typename?: 'Location';
  /** The address of the location. */
  address?: Maybe<Scalars['String']['output']>;
  /** If true, this location is the primary location for the user. */
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  /** The city of the location. */
  location: GeoPoint;
  /** The title of the location. */
  title?: Maybe<Scalars['String']['output']>;
};

export type MarkViewedResponse = {
  __typename?: 'MarkViewedResponse';
  messages: Array<Maybe<Message>>;
  updated: Scalars['Int']['output'];
};

/** A media event represents a change in the MediaPointer status. */
export type MediaEvent = {
  __typename?: 'MediaEvent';
  mediaPointer: MediaPointer;
  type: MediaEventType;
};

export enum MediaEventType {
  /** The media has become available for use. */
  MediaAvailable = 'MEDIA_AVAILABLE'
}

/** Used to pass options to underlying media providers such as Imgix or Mux */
export type MediaOption = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Represents stored media that can be accessed for various purposes. */
export type MediaPointer = {
  __typename?: 'MediaPointer';
  /** If status is AVAILABLE, will return a signed URL with the specific arguments applied. */
  downloadUrl?: Maybe<SignedUrl>;
  /** If status is AVAILABLE, will return a list of signed URLs to access original, and proxies of the original media. */
  downloadUrls: Array<SignedUrl>;
  /** The filesize of the original media. */
  filesizeInBytes: Scalars['Int']['output'];
  /** The unique ID of the MediaPointer */
  id: Scalars['ID']['output'];
  /** The type of media */
  mediaType: MediaType;
  /** The mimetype of the underlying original media. */
  mimeType: Scalars['String']['output'];
  /** A name that can be displayed to the user that represents this media.  Does not need to be unique. */
  name: Scalars['String']['output'];
  /** The provider of the underlying media. */
  provider: MediaProvider;
  /** The status of the MediaPointer.  Determines if Media can be accessed, and if post-upload processing is complete. */
  status: MediaPointerStatus;
};


/** Represents stored media that can be accessed for various purposes. */
export type MediaPointerDownloadUrlArgs = {
  encoding: SignedUrlKey;
  imgixOpts?: InputMaybe<Array<MediaOption>>;
  muxOpts?: InputMaybe<Array<MediaOption>>;
};


/** Represents stored media that can be accessed for various purposes. */
export type MediaPointerDownloadUrlsArgs = {
  imgixOpts?: InputMaybe<Array<MediaOption>>;
  muxOpts?: InputMaybe<Array<MediaOption>>;
  only?: InputMaybe<Array<SignedUrlKey>>;
};

/**
 * MediaPointerStatus represents the state of the MediaPointer.  This is necessary because there are numerous
 * process involved in preparing the media before it can be available for use.
 */
export enum MediaPointerStatus {
  /** The media has been archived, and may be retrieved. */
  Archived = 'ARCHIVED',
  /** The media is available for download. */
  Available = 'AVAILABLE',
  /** The media encountered an error */
  Error = 'ERROR',
  /** Media is being upload, or processed. */
  Pending = 'PENDING',
  /** The media has been removed, an cannot be retrieved. */
  Removed = 'REMOVED'
}

export enum MediaProvider {
  /** The underlying provider is Mux.  Used for Video */
  Mux = 'MUX',
  /** The underlying provider is Amazon S3. Proxies may be hosted via Imgix. Used for Images. */
  S3 = 'S3'
}

export enum MediaType {
  Binary = 'BINARY',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

/** Object that provides signed URLs that allow clients to upload directly to external providers. */
export type MediaUpload = {
  __typename?: 'MediaUpload';
  mediaPointer: MediaPointer;
  uploadUrls: Array<SignedUrl>;
};

export type MediaUploadResult = {
  __typename?: 'MediaUploadResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<MediaUpload>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type MemberProfile = {
  __typename?: 'MemberProfile';
  /** Returns any blocks between the two profiles. */
  blockStatus: BlockStatus;
  /** DEPRECATED: The conversation preview if one exists. */
  conversation?: Maybe<ConversationPreview>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The display name of the member profile. */
  displayName: Scalars['String']['output'];
  /** Returns the follow record between the two profiles. */
  followRecord?: Maybe<FollowRecord>;
  /** Full name of the profile. */
  fullName: Scalars['String']['output'];
  /** The id of the profile. */
  id: Scalars['ID']['output'];
  /** A URL to resolve the Vendor's main image. */
  photoUrl: Scalars['String']['output'];
  /** A URL to resolve the Vendor's main image. */
  photoUrlSrcset: Scalars['String']['output'];
};

/** Member referral data. */
export type MemberReferral = {
  __typename?: 'MemberReferral';
  /**
   * Analytics for all referrals done via non-short links.
   * Defaults to hourly rollup for the past 7 days
   */
  activity?: Maybe<LinkActivity>;
  /** A member referral link. */
  referralLink: Link;
  /** Stats for referrals. */
  referralStats: ReferralStats;
};


/** Member referral data. */
export type MemberReferralActivityArgs = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  granularity?: InputMaybe<AnalyticsInterval>;
  lookbackInterval?: InputMaybe<Scalars['Int']['input']>;
  lookbackUnit?: InputMaybe<AnalyticsInterval>;
  pathPrefix?: InputMaybe<Scalars['String']['input']>;
};

export type Message = {
  __typename?: 'Message';
  attachments: Array<MediaPointer>;
  author: Profile;
  body: Scalars['String']['output'];
  conversationId?: Maybe<Scalars['ID']['output']>;
  conversationPreview?: Maybe<ConversationPreview>;
  emojiReactions?: Maybe<Array<Maybe<EmojiReaction>>>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  /** Returns any pending, complete, or expired interactions.  This can be used in place of transaction / type fields. */
  interactions: Array<Interaction>;
  recipientHasViewed: Scalars['Boolean']['output'];
  sentBySway: Scalars['Boolean']['output'];
  transaction?: Maybe<MessageTransaction>;
  type?: Maybe<MessageType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MessageEvent = {
  __typename?: 'MessageEvent';
  message: Message;
  type: MessageEventType;
};

export enum MessageEventType {
  MessageCannedResponseReceived = 'MESSAGE_CANNED_RESPONSE_RECEIVED',
  MessageExpired = 'MESSAGE_EXPIRED',
  MessagePaymentRefused = 'MESSAGE_PAYMENT_REFUSED',
  MessageReactionModified = 'MESSAGE_REACTION_MODIFIED',
  MessageRecipientHasViewed = 'MESSAGE_RECIPIENT_HAS_VIEWED',
  MessageSent = 'MESSAGE_SENT',
  MessageViewed = 'MESSAGE_VIEWED'
}

/** Specify a message template */
export type MessageTemplate = {
  __typename?: 'MessageTemplate';
  /** The body of the message template. */
  body?: Maybe<Scalars['String']['output']>;
  /** The optional name of the message template. */
  name?: Maybe<Scalars['String']['output']>;
  /** DEPRECATED: The poll options of the message template. */
  options?: Maybe<Array<Maybe<PollOption>>>;
  /** The poll associated to the message template. */
  poll?: Maybe<PollObject>;
  /** The price of the message template. */
  price?: Maybe<Money>;
  /** The primary attachment of the message template. */
  primaryAttachment?: Maybe<MediaPointer>;
  /** Any redemption offers associated with the message template. */
  redemptionOffers?: Maybe<Array<Maybe<Redemption>>>;
  /** The message type of the message template. */
  type: MessageType;
};

/** Specify a message template input. */
export type MessageTemplateInput = {
  /** The body of the message template. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** The optional name of the message template. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** DEPRECATED: Poll options for the message template. */
  options?: InputMaybe<Array<InputMaybe<PollOptionInput>>>;
  /** The poll associated to the message template. */
  poll?: InputMaybe<PollObjectInput>;
  /** The price of the message template. */
  price?: InputMaybe<Scalars['Int']['input']>;
  /** Default media options that can be overridden on query. */
  primaryAttachmentDefaultMediaOptions?: InputMaybe<Array<MediaOption>>;
  /** The media pointer ID of the primary attachment of the message template */
  primaryAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  /** Any redemption offers associated with the message template. */
  redemptionOffers?: InputMaybe<RedemptionOffersInput>;
  /** The message type of the message template. */
  type?: InputMaybe<MessageType>;
};

/**
 * A MessageTransaction is a specific type of WalletTransaction that typically manages a user's opportunity
 * to earn money on SwayDM.  A message transaction has a "price" which determines how much will be
 * added or removed to any target wallets when resolved.
 *
 * When first created, the message transaction is pending, and a negative adjustment is created from the
 * message sender's wallet.
 *
 * When fulfilled, the price is split based on SwayDM's transaction fee, and an adjustment is created
 * for the fee to a system wallet, and to the recipient's wallet.
 *
 * If a message is expired, or rejected, a counter adjustment is created on the sender's wallet to
 * compensate for their original adjustment.  (example: original: -1.00, counter: +1.00)
 */
export type MessageTransaction = WalletTransaction & {
  __typename?: 'MessageTransaction';
  /** Any adjustments currently associated with this MessageTransaction. */
  adjustments?: Maybe<Array<Adjustment>>;
  /** The amount the logged in user may earn, or has earned, based on the default sway txn fee, or their profile's transaction_percent_override. */
  earningPotential: Money;
  /** The datetime the transaction will expire, and move to an expired status. */
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  /** The full amount that was initially removed from the transaction initiator's wallet. */
  price: Money;
  /** The datetime the last expiration reminder was sent. */
  reminderSentAt?: Maybe<Scalars['DateTime']['output']>;
  /** The datetime the transaction was resolved at. (no longer pending) */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The current status of the transaction. */
  status: MessageTransactionStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** Possible MessageTransaction status values. */
export enum MessageTransactionStatus {
  Expired = 'EXPIRED',
  Fulfilled = 'FULFILLED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum MessageType {
  Message = 'MESSAGE',
  Reply = 'REPLY',
  View = 'VIEW'
}

export type Money = {
  __typename?: 'Money';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type MoneyInput = {
  amount: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
};

/** Payload object for interaction mutation results. */
export type NewMessageResult = {
  __typename?: 'NewMessageResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Message>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type NotificationPreferences = {
  __typename?: 'NotificationPreferences';
  channels: Array<Maybe<ChannelPreference>>;
  workflows: Array<Maybe<WorkflowPreference>>;
};

export type NotificationPreferencesInput = {
  channels: Array<InputMaybe<ChannelPreferenceInput>>;
  workflows: Array<InputMaybe<WorkflowPreferenceInput>>;
};

/** An onboarding item to be displayed within the feed. */
export type OnboardingItem = {
  __typename?: 'OnboardingItem';
  /** The type of onboarding item. */
  type: OnboardingItemType;
};

export enum OnboardingItemType {
  WelcomeMessage = 'WELCOME_MESSAGE'
}

export enum PageFilterOp {
  Contains = 'CONTAINS',
  Empty = 'EMPTY',
  Eq = 'EQ',
  Gt = 'GT',
  GtEq = 'GT_EQ',
  Ilike = 'ILIKE',
  IlikeAnd = 'ILIKE_AND',
  IlikeOr = 'ILIKE_OR',
  In = 'IN',
  Like = 'LIKE',
  LikeAnd = 'LIKE_AND',
  LikeOr = 'LIKE_OR',
  Lt = 'LT',
  LtEq = 'LT_EQ',
  NotContains = 'NOT_CONTAINS',
  NotEmpty = 'NOT_EMPTY',
  NotEq = 'NOT_EQ',
  NotIlike = 'NOT_ILIKE',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE'
}

export type PageFilterValues = {
  __typename?: 'PageFilterValues';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  float?: Maybe<Scalars['Float']['output']>;
  floats?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  integer?: Maybe<Scalars['Int']['output']>;
  integers?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  string?: Maybe<Scalars['String']['output']>;
  strings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PageFilterValuesInput = {
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  float?: InputMaybe<Scalars['Float']['input']>;
  floats?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  integer?: InputMaybe<Scalars['Int']['input']>;
  integers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  string?: InputMaybe<Scalars['String']['input']>;
  strings?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum PageOrderDirection {
  Asc = 'ASC',
  AscNullsFirst = 'ASC_NULLS_FIRST',
  AscNullsLast = 'ASC_NULLS_LAST',
  Desc = 'DESC',
  DescNullsFirst = 'DESC_NULLS_FIRST',
  DescNullsLast = 'DESC_NULLS_LAST'
}

export type ParticipantSettings = {
  __typename?: 'ParticipantSettings';
  acceptMedia: Scalars['Boolean']['output'];
  conversationId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  profile: Profile;
  updatedAt: Scalars['DateTime']['output'];
};

export type ParticipantSettingsEvent = {
  __typename?: 'ParticipantSettingsEvent';
  earnerSettings: ParticipantSettings;
  payerSettings: ParticipantSettings;
  type: ParticipantSettingsEventType;
};

export enum ParticipantSettingsEventType {
  ParticipantSettingsModified = 'PARTICIPANT_SETTINGS_MODIFIED'
}

/** An event related to a poll. */
export type PollEvents = FirstPollOfTheDay;

export type PollFilters = {
  __typename?: 'PollFilters';
  attribute: PollQueryAttributes;
  op: PageFilterOp;
  value: PageFilterValues;
};

export type PollFiltersInput = {
  attribute: PollQueryAttributes;
  op: PageFilterOp;
  value: PageFilterValuesInput;
};

/**
 * * Not currently implemented
 * A poll option that can contain text, and media (image or vide).
 */
export type PollMediaOption = PollOption & {
  __typename?: 'PollMediaOption';
  /** Text the user should see for this option only if the media is unavailable. */
  altText: Scalars['String']['output'];
  correct?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Media the user should see for this option. */
  mediaPointer: MediaPointer;
  /** The order in which the option should be in relation to other options. */
  order?: Maybe<Scalars['Int']['output']>;
  /** Text the user will see for this option. */
  text: Scalars['String']['output'];
  /** The type of poll option */
  type: PollOptionType;
};

/** Specify a poll for a given message template. */
export type PollObject = {
  __typename?: 'PollObject';
  /** Text that will show after the user has answered */
  bonusText?: Maybe<Scalars['String']['output']>;
  /** Additional context that may appear at the bottom of the view. */
  caption?: Maybe<Scalars['String']['output']>;
  /**
   * If :q_and_a type, the user will earn only if a correct answer is chosen.≈
   * If user pick incorrect answer, they will instead get no SC, unless :consolation_price is set.
   */
  consolationPrice?: Maybe<Scalars['Int']['output']>;
  /** The datetime this poll will become unavailable to members */
  endAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the poll */
  id: Scalars['ID']['output'];
  /** If true, this poll will be displayed soon. */
  important?: Maybe<Scalars['Boolean']['output']>;
  /** A name to describe the poll, internal facing only */
  name?: Maybe<Scalars['String']['output']>;
  /** The options the user will be able to pick from. */
  options?: Maybe<Array<Maybe<PollOption>>>;
  /**
   * The amount the user will earn.
   * If :poll type, user will earn for answering.
   * If :q_and_a type, the user will earn only if a correct answer is chosen.
   * If user pick incorrect answer, they will instead get no SC, unless :consolation_price is set.
   */
  price?: Maybe<Scalars['Int']['output']>;
  /** The primary media for the poll */
  primaryMedia?: Maybe<MediaPointer>;
  /** The question that the viewer will be prompted to answer. */
  question?: Maybe<Scalars['String']['output']>;
  /** The datetime this poll will become available to members. */
  startAt?: Maybe<Scalars['DateTime']['output']>;
  /** The status of the poll */
  status: PollStatus;
  /** The type of poll */
  type?: Maybe<PollType>;
};

/** Specify a poll input for a given message template. */
export type PollObjectInput = {
  /** Text that will show after the user has answered */
  bonusText?: InputMaybe<Scalars['String']['input']>;
  /** Additional context that may appear at the bottom of the view. */
  caption?: InputMaybe<Scalars['String']['input']>;
  /**
   * If :q_and_a type, the user will earn only if a correct answer is chosen.≈
   * If user pick incorrect answer, they will instead get no SC, unless :consolation_price is set.
   */
  consolationPrice?: InputMaybe<Scalars['Int']['input']>;
  /** The datetime this poll will become unavailable to members */
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** If true, this poll will be displayed as soon as possible. */
  important?: InputMaybe<Scalars['Boolean']['input']>;
  /** A name to describe the poll, internal facing only */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The options the user will be able to pick from. */
  options?: InputMaybe<Array<InputMaybe<PollOptionInput>>>;
  /**
   * The amount the user will earn.
   * If :poll type, user will earn for answering.
   * If :q_and_a type, the user will earn only if a correct answer is chosen.
   * If user pick incorrect answer, they will instead get no SC, unless :consolation_price is set.
   */
  price?: InputMaybe<Scalars['Int']['input']>;
  /** Default media options that can be overridden on query. */
  primaryMediaDefaultMediaOptions?: InputMaybe<Array<MediaOption>>;
  /** The media pointer ID of the primary attachment of the poll */
  primaryMediaId?: InputMaybe<Scalars['ID']['input']>;
  /** The question that the viewer will be prompted to answer. */
  question?: InputMaybe<Scalars['String']['input']>;
  /** The datetime this poll will become available to members. */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The type of poll */
  type?: InputMaybe<PollType>;
};

/** An interface that provides fields common accross all poll options. */
export type PollOption = {
  correct?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** The order in which the option should be in relation to other options. */
  order?: Maybe<Scalars['Int']['output']>;
  /** The type of poll option */
  type: PollOptionType;
};

/** Specify a poll option input. */
export type PollOptionInput = {
  /** If media cannot load, this alternate text will be displayed. */
  altText?: InputMaybe<Scalars['String']['input']>;
  /** If true, this will be set as a correct answer. */
  correct?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * ID must be provided to preserve option ID, otherwise it will be considered a new option.
   * A new option will not retain any historical response statistics.
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /** If media type, provide the media pointer, must have been created by current user. */
  mediaPointerId?: InputMaybe<Scalars['ID']['input']>;
  /** The text of the poll option */
  text: Scalars['String']['input'];
  /** The type of the poll option, default is text */
  type?: InputMaybe<PollOptionType>;
};

/**
 * * Not currently implemented
 * Results for a specific poll option.
 */
export type PollOptionResult = {
  __typename?: 'PollOptionResult';
  /** The option these results are related to. */
  pollOption: PollOption;
  /** The number of responses for this option. */
  responseCount?: Maybe<Scalars['Int']['output']>;
  /** The percentage of responses for this option. */
  responsePct?: Maybe<Scalars['Float']['output']>;
};

export enum PollOptionType {
  PollMedia = 'POLL_MEDIA',
  PollText = 'POLL_TEXT'
}

export type PollOrderBy = {
  __typename?: 'PollOrderBy';
  attribute: PollQueryAttributes;
  direction: PageOrderDirection;
};

export type PollOrderByInput = {
  attribute: PollQueryAttributes;
  direction: PageOrderDirection;
};

export type PollPage = {
  __typename?: 'PollPage';
  data: Array<PollObject>;
  page?: Maybe<BasePage>;
  query?: Maybe<PollQuery>;
};

/** Specify pagination, order_by, and filtering criteria for Polls. */
export type PollPageInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<PollFiltersInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PollOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type PollQuery = {
  __typename?: 'PollQuery';
  filters?: Maybe<Array<PollFilters>>;
  orderBy?: Maybe<Array<PollOrderBy>>;
};

export enum PollQueryAttributes {
  /** The poll bonus text. */
  BonusText = 'BONUS_TEXT',
  /** The poll caption. */
  Caption = 'CAPTION',
  /** The poll consolation price. */
  ConsolationPrice = 'CONSOLATION_PRICE',
  /** The ID of the profile who created the poll */
  CreatorId = 'CREATOR_ID',
  /** The datetime the poll will end. */
  EndAt = 'END_AT',
  /** The poll's ID */
  Id = 'ID',
  /** The datetime the poll was created. */
  InsertedAt = 'INSERTED_AT',
  /** The poll's name. */
  Name = 'NAME',
  /** The poll price. */
  Price = 'PRICE',
  /** The poll question. */
  Question = 'QUESTION',
  /** The datetime the poll will start. */
  StartAt = 'START_AT',
  /** The status of the poll */
  Status = 'STATUS',
  /** The poll type (poll, q_and_q). */
  Type = 'TYPE',
  /** The datetime the poll was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type PollResponse = {
  __typename?: 'PollResponse';
  count: Scalars['Int']['output'];
  pollOption: PollOption;
};

export type PollResult = {
  __typename?: 'PollResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<PollObject>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/**
 * * Not currently implemented
 * Poll results.
 */
export type PollResults = {
  __typename?: 'PollResults';
  /** List of results for each option. */
  pollOptionResults?: Maybe<Array<Maybe<PollOptionResult>>>;
  /** The total number of responses received for this poll. */
  totalResponseCount?: Maybe<Scalars['Int']['output']>;
};

export enum PollStatus {
  Archived = 'ARCHIVED',
  Complete = 'COMPLETE',
  Draft = 'DRAFT',
  Live = 'LIVE',
  Scheduled = 'SCHEDULED'
}

export type PollSuggestion = {
  __typename?: 'PollSuggestion';
  creatorDisplayName?: Maybe<Scalars['String']['output']>;
  /** The poll interaction_id of the poll suggestion */
  interactionId: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
};

/** A poll option that only contains text. */
export type PollTextOption = PollOption & {
  __typename?: 'PollTextOption';
  correct?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** The order in which the option should be in relation to other options. */
  order?: Maybe<Scalars['Int']['output']>;
  /** Text the user will see for this option. */
  text: Scalars['String']['output'];
  /** The type of poll option */
  type: PollOptionType;
};

export enum PollType {
  /** This poll type has no correct or incorrect answer, for gathering information. */
  Poll = 'POLL',
  /** This poll type has correct / incorrect answers. */
  QAndA = 'Q_AND_A'
}

export type Pricing = {
  __typename?: 'Pricing';
  profileSpecific: Scalars['Boolean']['output'];
  replyPrice?: Maybe<Money>;
  viewPrice?: Maybe<Money>;
};

export type Profile = {
  __typename?: 'Profile';
  /** Return any blocks between these two profiles. */
  blocks: Array<Block>;
  /** The name of the community (Vendor). */
  communityName?: Maybe<Scalars['String']['output']>;
  /** Displayed under full name in conversation, and used as public profile URL part. */
  displayName: Scalars['String']['output'];
  /** True if this profile has earning capability enabled. */
  earningEnabled: Scalars['Boolean']['output'];
  /** Displayed on profile as the first name. Used as part of full name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** True if this profile has sent a paid. */
  firstPaidMessageSent: Scalars['Boolean']['output'];
  /** The unique ID of the profile. */
  id: Scalars['ID']['output'];
  /** Displayed on profile at bottom as a longer introduction. */
  introduction?: Maybe<Scalars['String']['output']>;
  /** If false, this profile has been deactivated.  They cannot receive new messages, or send messages. */
  isActive: Scalars['Boolean']['output'];
  /** Flag to indicate if the profile is a non-profit. */
  isNonProfit: Scalars['Boolean']['output'];
  /** Displayed on profile as the last name. Used as part of full name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Global participant settings for this profile. */
  participantSettings: ParticipantSettings;
  /** Return pricing for this profile, considers profile specific pricing. */
  pricing: Pricing;
  /** The primary location for the profile. */
  primaryLocation?: Maybe<GeoPoint>;
  /** Return all profile links */
  profileLinks: Array<ProfileLink>;
  /** Profile crop settings in pixels.  x,y,w,h */
  profilePhotoCrop?: Maybe<Scalars['String']['output']>;
  /** The profile photo MediaPointer (may be null if set via web). */
  profilePhotoMediaPointer?: Maybe<MediaPointer>;
  /** MediaPointer ID for profile photo. */
  profilePhotoMediaPointerId?: Maybe<Scalars['ID']['output']>;
  /** A URL to resolve the profile's main image.  Used for their public profile, avatar when logged in, avatar on conversations and messages, and avatar in emails (via knock). */
  profilePhotoUrl: Scalars['String']['output'];
  /** A URL to resolve the profile's main image.  Used for their public profile, avatar when logged in, avatar on conversations and messages, and avatar in emails (via knock). */
  profilePhotoUrlSrcset: Scalars['String']['output'];
  /** DEPRECATED: A URL to resolve the profile's main image.  Used for their public profile, avatar when logged in, avatar on conversations and messages, and avatar in emails (via knock). */
  profilePictureUrl: Scalars['String']['output'];
  /** The type of profile. */
  profileType: ProfileType;
  /** Return active redemptions for this profile sorted by position, ascending. */
  redemptions: Array<Redemption>;
  /** The timezone in which dates should be displayed.  Also used to transform dates to UTC when submitting dates. */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Displayed on profile under full name. */
  title?: Maybe<Scalars['String']['output']>;
  /** If true, this profile is unclaimed. */
  unclaimed: Scalars['Boolean']['output'];
  /** If true, this profile has been verified by a SwayDM Employee.  (This can be set via the Admin interface. */
  verified: Scalars['Boolean']['output'];
};

/** Links that should show up on a user's public Profile. */
export type ProfileLink = {
  __typename?: 'ProfileLink';
  id?: Maybe<Scalars['String']['output']>;
  /** The text that will display on the profile. */
  title?: Maybe<Scalars['String']['output']>;
  /** The URL that the browser should redirect to when clicked. */
  url?: Maybe<Scalars['String']['output']>;
};

export type ProfileLinkInput = {
  /** If provided, will update the link, and will not create a new ID on save. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The displayed title of the link. */
  title: Scalars['String']['input'];
  /** The url of the link.  Should start with http(s):// */
  url: Scalars['String']['input'];
};

export type ProfilePromotion = {
  __typename?: 'ProfilePromotion';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProfileResult = {
  __typename?: 'ProfileResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Profile>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export enum ProfileType {
  Community = 'COMMUNITY',
  CommunityFollower = 'COMMUNITY_FOLLOWER',
  Earner = 'EARNER',
  Payer = 'PAYER',
  Unknown = 'UNKNOWN'
}

/** The progress for a specific type of challenge. */
export type ProgressFallback = {
  __typename?: 'ProgressFallback';
  message?: Maybe<Scalars['String']['output']>;
};

/** Union type that represents the progress details for a specific challenge type. */
export type ProgressState = ProgressFallback | ProgressTriviaAnswerCounts | ProgressTriviaAnswerStreaks;

export type ProgressTriviaAnswerCounts = {
  __typename?: 'ProgressTriviaAnswerCounts';
  completedCorrectMilestones?: Maybe<Array<Scalars['Int']['output']>>;
  completedIncorrectMilestones?: Maybe<Array<Scalars['Int']['output']>>;
  correct?: Maybe<Scalars['Int']['output']>;
  incorrect?: Maybe<Scalars['Int']['output']>;
  milestones?: Maybe<Array<Scalars['Int']['output']>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ProgressTriviaAnswerStreaks = {
  __typename?: 'ProgressTriviaAnswerStreaks';
  completedStreaks?: Maybe<Scalars['Int']['output']>;
  currentStreak?: Maybe<Scalars['Int']['output']>;
  dailyStatus: Array<Maybe<TriviaDailyStatus>>;
  goal?: Maybe<Scalars['Int']['output']>;
  lastResponseAt?: Maybe<Scalars['DateTime']['output']>;
  moreThanFourteenDaysReward?: Maybe<Scalars['Int']['output']>;
  moreThanSevenDaysReward?: Maybe<Scalars['Int']['output']>;
  overallStreak?: Maybe<Scalars['Int']['output']>;
  recordStreak?: Maybe<Scalars['Int']['output']>;
  swayCashReward?: Maybe<Scalars['Int']['output']>;
  totalSwayCashEarned?: Maybe<Scalars['Int']['output']>;
};


export type ProgressTriviaAnswerStreaksDailyStatusArgs = {
  lookback?: InputMaybe<Scalars['Int']['input']>;
};

export type Promotion = {
  __typename?: 'Promotion';
  defaultAmountInCents?: Maybe<Money>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  name?: Maybe<Scalars['String']['output']>;
  profilePromotion?: Maybe<ProfilePromotion>;
  spendingCapInCents?: Maybe<Money>;
  suspended: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PublicVendor = {
  __typename?: 'PublicVendor';
  /** A text blurb describing the vendor. */
  bio?: Maybe<Scalars['String']['output']>;
  /** Returns any blocks between the two profiles. */
  blockStatus: BlockStatus;
  /** Displayed under full name in conversation, and used as public profile URL part. */
  displayName: Scalars['String']['output'];
  /** Returns the follow record between the two profiles. */
  followRecord?: Maybe<FollowRecord>;
  /** The unique ID of the vendor (profile_id). */
  id: Scalars['ID']['output'];
  /** Flag to indicate if the vendor is a non-profit. */
  isNonProfit: Scalars['Boolean']['output'];
  /** The name of the community (Vendor). */
  name: Scalars['String']['output'];
  /** A URL to resolve the Vendor's main image. */
  photoUrl: Scalars['String']['output'];
  /** A URL to resolve the Vendor's main image. */
  photoUrlSrcset: Scalars['String']['output'];
  /** The primary location for the profile. */
  primaryLocation?: Maybe<GeoPoint>;
  /** Return all profile links */
  profileLinks: Array<ProfileLink>;
  /** Return active redemptions for this vendor sorted by position, ascending. */
  redemptions: Array<Redemption>;
  referralLink: Scalars['String']['output'];
  /** Is this an unclaimed profile? */
  unclaimed: Scalars['Boolean']['output'];
  /** If true, this vendor has been verified by a SwayDM Employee.  (This can be set via the Admin interface.) */
  verified: Scalars['Boolean']['output'];
};

/** The supported push notification services. */
export enum PushService {
  /** Apple Push Notification Service */
  Apns = 'APNS',
  /** Expo */
  Expo = 'EXPO',
  /** Firebase Cloud Messaging */
  Fcm = 'FCM'
}

export type Redemption = {
  __typename?: 'Redemption';
  /** Is this redemption currently active. */
  active: Scalars['Boolean']['output'];
  /** The datetime the redemption was archived at */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** DEPRECATED: The community offering the redemption. */
  community: Profile;
  /** DEPRECATED: Bad confirmation text override field. Do not use. */
  confirmationOverride?: Maybe<Scalars['String']['output']>;
  /** The optional override text to use in place of confirmation text when confirmation a redemption. (should be treated as raw html) */
  confirmationTextOverrideHtml?: Maybe<Scalars['String']['output']>;
  /** A description of the redemption. */
  description: Scalars['String']['output'];
  /** The donation progress for this redemption. Only available if the redemption is non-profit. */
  donationProgress?: Maybe<RedemptionDonationProgress>;
  /** If the redemption is excluded from global rank randomization. */
  excludeFromRandomization: Scalars['Boolean']['output'];
  /** Global redemption discovery rank. */
  globalRank: Scalars['Int']['output'];
  /** Redemption history for this redemption for the current user. Ordered by most recent first. */
  history?: Maybe<Array<RedemptionRecord>>;
  /** The ID of the redemption. */
  id: Scalars['ID']['output'];
  /** If the redemption is important */
  important?: Maybe<Scalars['Boolean']['output']>;
  /** The datetime the redemption was inserted at */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** If the redemption is non-profit */
  isNonProfit: Scalars['Boolean']['output'];
  /** Indicates if the redemption is a sweepstakes. */
  isSweepstakes: Scalars['Boolean']['output'];
  /** limits */
  limits?: Maybe<RedemptionLimits>;
  /** DEPRECATED: The linked profile */
  linkedProfile?: Maybe<Profile>;
  /** The linked profile */
  linkedVendor?: Maybe<PublicVendor>;
  /** The location of the redemption, based on the primary location of the vendor. */
  location?: Maybe<GeoPoint>;
  /** The name of the redemption. */
  name: Scalars['String']['output'];
  /** The position the redemption should be ordered in on the community's profile. */
  position: Scalars['Int']['output'];
  /** The price of the redemption. */
  price: Money;
  /** The primary media object. */
  primaryMedia?: Maybe<MediaPointer>;
  /** DEPRECATED: The amount of times the redemption was redeemed across all users, for all time. */
  redeemCount: Scalars['Int']['output'];
  /** A link to this redemption proxied by the link service, with the current user's referral code attached. */
  referralLink: Scalars['String']['output'];
  /** If the redemption is saved by the current user. Always false if the current user is not a community follower. */
  saved?: Maybe<Scalars['Boolean']['output']>;
  /** If the redemption is spotlight */
  spotlight?: Maybe<Scalars['Boolean']['output']>;
  /** The stats for the redemption */
  stats?: Maybe<RedemptionStats>;
  /** The datetime the redemption was updated at */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The datetime the redemption will no longer be redeemable.  If null, there is no end date, and the redemption
   * will be redeemable indefinitely (as long as it's active, and limits have not been reached).
   */
  validEnd?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The datetime the redemption will be redeemable.  If null, there is no start date, and the redemption
   * will be redeemable immediately (as long as it's active, and limits have not been reached).
   */
  validStart?: Maybe<Scalars['DateTime']['output']>;
  /** The vendor offering the redemption */
  vendor: PublicVendor;
  /** DEPRECATED: The amount of times the redemption was viewed across all users, for all time. */
  viewCount: Scalars['Int']['output'];
};


export type RedemptionHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RedemptionLimitsArgs = {
  evaluate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RedemptionContext = {
  __typename?: 'RedemptionContext';
  bonusAmountGranted?: Maybe<Scalars['Int']['output']>;
  conversation?: Maybe<Conversation>;
  message?: Maybe<Message>;
  messageTransaction?: Maybe<MessageTransaction>;
  redemption?: Maybe<Redemption>;
};

export type RedemptionDonationProgress = {
  __typename?: 'RedemptionDonationProgress';
  /** The current donation amount. */
  current: Money;
  /** The goal donation amount. Only available if the redemption has a global count limit. */
  goal?: Maybe<Money>;
  /** The progress towards the goal donation amount as a percentage. Only available if the redemption has a global count limit. */
  progress?: Maybe<Scalars['Int']['output']>;
};

export type RedemptionFilters = {
  __typename?: 'RedemptionFilters';
  attribute: RedemptionQueryAttributes;
  op: PageFilterOp;
  value: PageFilterValues;
};

export type RedemptionFiltersInput = {
  attribute: RedemptionQueryAttributes;
  op: PageFilterOp;
  value: PageFilterValuesInput;
};

export type RedemptionHistoryFiltersInput = {
  attribute: RedemptionHistoryQueryAttributes;
  op: PageFilterOp;
  value: PageFilterValuesInput;
};

export type RedemptionHistoryOrderByInput = {
  attribute: RedemptionHistoryQueryAttributes;
  direction: PageOrderDirection;
};

export type RedemptionHistoryPage = {
  __typename?: 'RedemptionHistoryPage';
  data: Array<RedemptionHistoryRecord>;
  page?: Maybe<BasePage>;
};

/** Specify pagination, order_by, and filtering criteria for Redemption History. */
export type RedemptionHistoryPageInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<RedemptionHistoryFiltersInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RedemptionHistoryOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export enum RedemptionHistoryQueryAttributes {
  /** The ID of the redemption history record. */
  Id = 'ID',
  /** The datetime the redemption was inserted at. */
  InsertedAt = 'INSERTED_AT',
  /** The ID of the member. */
  MemberId = 'MEMBER_ID',
  /** The ID of the message transaction. */
  MessageTransactionId = 'MESSAGE_TRANSACTION_ID',
  /** The ID of the redemption. */
  RedemptionId = 'REDEMPTION_ID',
  /** The name of the redemption. */
  RedemptionName = 'REDEMPTION_NAME',
  /** The price of the redemption. */
  RedemptionPrice = 'REDEMPTION_PRICE',
  /** The ID of the vendor. */
  VendorId = 'VENDOR_ID'
}

export type RedemptionHistoryRecord = {
  __typename?: 'RedemptionHistoryRecord';
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  member: Profile;
  redemption: Redemption;
  redemptionName: Scalars['String']['output'];
  redemptionPrice: Money;
  vendor: PublicVendor;
};

/** Specify a redemption offer. */
export type RedemptionInput = {
  /** The ID of the redemption offer */
  redemptionId: Scalars['ID']['input'];
};

export type RedemptionLimit = {
  /** If limit was evaluated, this will indicate if the current user has hit the limit of this limit. */
  blocking?: Maybe<Scalars['Boolean']['output']>;
  /** If limit was evaluated, this will be the current count of redemptions for the current user for this limit. */
  count?: Maybe<Scalars['Int']['output']>;
  /** A human readable description of the limit. */
  description: Scalars['String']['output'];
  /** The ID of the redemption limit. */
  id: Scalars['ID']['output'];
  /** The limit value. */
  limit: Scalars['Int']['output'];
  /** The scope of the limit. */
  limitScope: RedemptionLimitScope;
  /** The type of the limit. */
  limitType: RedemptionLimitType;
};

/** Limit is based on a count of redemption history records. */
export type RedemptionLimitCount = RedemptionLimit & {
  __typename?: 'RedemptionLimitCount';
  /** If limit was evaluated, this will indicate if the current user has hit the limit of this limit. */
  blocking?: Maybe<Scalars['Boolean']['output']>;
  /** If limit was evaluated, this will be the current count of redemptions for the current user for this limit. */
  count?: Maybe<Scalars['Int']['output']>;
  /** A human readable description of the limit. */
  description: Scalars['String']['output'];
  /** The ID of the redemption limit. */
  id: Scalars['ID']['output'];
  /** The limit value. */
  limit: Scalars['Int']['output'];
  /** The scope of the limit. */
  limitScope: RedemptionLimitScope;
  /** The type of the limit. */
  limitType: RedemptionLimitType;
};

export type RedemptionLimitInput = {
  /** The time the rate limit window end will be moved from the current time to the end of the current day */
  endOfDay?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the limit if it was previously created */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The interval of the limit (rate limit only) */
  interval?: InputMaybe<Scalars['Int']['input']>;
  /** The limit value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The scope of the limit */
  limitScope?: InputMaybe<RedemptionLimitScope>;
  /** The type of the limit */
  limitType?: InputMaybe<RedemptionLimitType>;
  /** The unit of the limit (rate limit only */
  unit?: InputMaybe<RedemptionLimitUnit>;
};

/** Limit is based on the rate of redemption history record creation over a period of time. */
export type RedemptionLimitRate = RedemptionLimit & {
  __typename?: 'RedemptionLimitRate';
  /** If limit was evaluated, this will indicate if the current user has hit the limit of this limit. */
  blocking?: Maybe<Scalars['Boolean']['output']>;
  /** If limit was evaluated, this will be the current count of redemptions for the current user for this limit. */
  count?: Maybe<Scalars['Int']['output']>;
  /** A human readable description of the limit. */
  description: Scalars['String']['output'];
  /**
   * If true, the rate limit evaluation window will be shifted so that the end of the window
   * is the end of the current day.  The end of the day is determined by the vendor's timezone.
   */
  endOfDay?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the redemption limit. */
  id: Scalars['ID']['output'];
  /** The interval of time to evaluate the rate limit over.  interval * unit = rate limit period. */
  interval: Scalars['Int']['output'];
  /** The limit value. */
  limit: Scalars['Int']['output'];
  /** The scope of the limit. */
  limitScope: RedemptionLimitScope;
  /** The type of the limit. */
  limitType: RedemptionLimitType;
  /** The unit of time to evaluate the rate limit over. */
  unit: RedemptionLimitUnit;
};

/** The scope of the limit. */
export enum RedemptionLimitScope {
  /** The limit is global. */
  Global = 'GLOBAL',
  /** The limit is per user. */
  User = 'USER'
}

/** The type of the limit. */
export enum RedemptionLimitType {
  /** The redemption limitation is a limit on the number of redemptions. */
  Count = 'COUNT',
  /** The redemption limitation is a rate limit on the number of redemptions. */
  RateLimit = 'RATE_LIMIT'
}

/** The unit of time to evaluate the rate limit over. */
export enum RedemptionLimitUnit {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Second = 'SECOND',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type RedemptionLimits = {
  __typename?: 'RedemptionLimits';
  canRedeem?: Maybe<Scalars['Boolean']['output']>;
  /**
   * If limits were evaluated, can_redeem will be false if any limits return with blocking == true.
   * If limits were not evaluted, can_redeem will be null.
   */
  id: Scalars['ID']['output'];
  /** The redemption limits, and their evaluation state (if evaluated). */
  limits?: Maybe<Array<RedemptionLimit>>;
};

export type RedemptionMutationResult = {
  __typename?: 'RedemptionMutationResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Redemption>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Specify a broadcast redemption offers. */
export type RedemptionOffersInput = {
  offers?: InputMaybe<Array<InputMaybe<RedemptionInput>>>;
};

export type RedemptionOrderBy = {
  __typename?: 'RedemptionOrderBy';
  attribute: RedemptionQueryAttributes;
  direction: PageOrderDirection;
};

export type RedemptionOrderByInput = {
  attribute: RedemptionQueryAttributes;
  direction: PageOrderDirection;
};

export type RedemptionPage = {
  __typename?: 'RedemptionPage';
  data: Array<Redemption>;
  page?: Maybe<BasePage>;
  query?: Maybe<RedemptionQuery>;
};

/** Specify pagination, order_by, and filtering criteria for Redemptions. */
export type RedemptionPageInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<RedemptionFiltersInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RedemptionOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type RedemptionQuery = {
  __typename?: 'RedemptionQuery';
  filters?: Maybe<Array<RedemptionFilters>>;
  orderBy?: Maybe<Array<RedemptionOrderBy>>;
};

/** Attributes that can be used when specifying a sort or filter redemptions. */
export enum RedemptionQueryAttributes {
  /** Is the redemption active */
  Active = 'ACTIVE',
  /** The datetime the redemption was archived at UTC */
  ArchivedAt = 'ARCHIVED_AT',
  /** The ID of the community the redemption is offered by. */
  CommunityId = 'COMMUNITY_ID',
  /** The display_name of the community that is offering the redemption */
  CommunityName = 'COMMUNITY_NAME',
  /** The description of the redemption */
  Description = 'DESCRIPTION',
  /** Full text search by name and description */
  FullText = 'FULL_TEXT',
  /** If true, will include the redemption if the global limit was reached. */
  GlobalLimitReached = 'GLOBAL_LIMIT_REACHED',
  /** The global ranking of the redemption */
  GlobalRank = 'GLOBAL_RANK',
  /** The ID of the redemption. */
  Id = 'ID',
  /** If the redemption is important */
  Important = 'IMPORTANT',
  /** The datetime the redemption was inserted at UTC */
  InsertedAt = 'INSERTED_AT',
  /** Is the redemption created by a non-profit vendor, or is linked profile a non-profit vendor. Only supports 'EQ' on a boolean value. */
  IsNonProfit = 'IS_NON_PROFIT',
  /** Indicates if the redemption is a sweepstakes. */
  IsSweepstakes = 'IS_SWEEPSTAKES',
  /** The name of the redemption */
  Name = 'NAME',
  /** The position of the redemption */
  Position = 'POSITION',
  /** The price of the redemption. */
  Price = 'PRICE',
  /** The radius in km from the user's location */
  RadiusKm = 'RADIUS_KM',
  /** The amount of times the redemption was redemeed */
  RedeemCount = 'REDEEM_COUNT',
  /** The datetime the redemption was saved */
  SavedAt = 'SAVED_AT',
  /** The ID of the profile who saved the redemption */
  SavedByMemberId = 'SAVED_BY_MEMBER_ID',
  /** If the redemption is spotlight */
  Spotlight = 'SPOTLIGHT',
  /** The datetime the redemption was updated at UTC */
  UpdatedAt = 'UPDATED_AT',
  /**
   * Specifies a datetime to check if the redemption is valid for that datetime. (between valid_start and valid_end)
   * Only works with CONTAINS operator.
   */
  ValidDateRange = 'VALID_DATE_RANGE',
  /** Valid start datetime of the redemption */
  ValidStart = 'VALID_START',
  /** The amount of times the redemption was viewed */
  ViewCount = 'VIEW_COUNT'
}

/** A record of a redemption */
export type RedemptionRecord = {
  __typename?: 'RedemptionRecord';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Money>;
  redeemedAt: Scalars['DateTime']['output'];
};

export type RedemptionResult = {
  __typename?: 'RedemptionResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<RedemptionContext>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Analytics of a redemption */
export type RedemptionStats = {
  __typename?: 'RedemptionStats';
  qrCodeScans: Scalars['Int']['output'];
  redeemCount: Scalars['Int']['output'];
  saveCount: Scalars['Int']['output'];
  viewCount: Scalars['Int']['output'];
};

/** A redemption suggestion to be displayed within the feed. */
export type RedemptionSuggestion = {
  __typename?: 'RedemptionSuggestion';
  /** The id of the redemption. */
  redemptionId: Scalars['String']['output'];
};

export type RedemptionUpdateInput = {
  /** If true, the redemption offer is active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** The amount of the redemption offer in SC Cents, i.e. 100 = 1 SC */
  amountInCents?: InputMaybe<MoneyInput>;
  /** The confirmation text override for the redemption offer */
  confirmationTextOverride?: InputMaybe<Scalars['String']['input']>;
  /** The description of the redemption offer */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Exclude from randomization (admin only) */
  excludeFromRandomization?: InputMaybe<Scalars['Boolean']['input']>;
  /** The global rank of the redemption. (admin only) */
  globalRank?: InputMaybe<Scalars['Int']['input']>;
  /** If the redemption is important */
  important?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the redemption is a sweepstakes. */
  isSweepstakes?: InputMaybe<Scalars['Boolean']['input']>;
  /** The limitations of the redemption */
  limits?: InputMaybe<Array<RedemptionLimitInput>>;
  /** The linked profile ID */
  linkedProfileId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the redemption offer */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Default imgix media options that can be overridden on query. */
  primaryMediaDefaultMediaOptions?: InputMaybe<Array<MediaOption>>;
  /** The primary media ID of the redemption offer */
  primaryMediaId?: InputMaybe<Scalars['ID']['input']>;
  /** If the redemption is spotlight */
  spotlight?: InputMaybe<Scalars['Boolean']['input']>;
  /** The datetime the redemption offer is valid until */
  validEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** The datetime the redemption offer is valid from */
  validStart?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedemptionsMutationResult = {
  __typename?: 'RedemptionsMutationResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Array<Redemption>>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Various statistics for member referrals. */
export type ReferralStats = {
  __typename?: 'ReferralStats';
  /** Referral earnings over past 30 days. */
  earnings: Money;
  /** Referral count over past 30 days. */
  referralCount: Scalars['Int']['output'];
};


/** Various statistics for member referrals. */
export type ReferralStatsEarningsArgs = {
  pastDays?: InputMaybe<Scalars['Int']['input']>;
};


/** Various statistics for member referrals. */
export type ReferralStatsReferralCountArgs = {
  pastDays?: InputMaybe<Scalars['Int']['input']>;
};

/** Payload for referred account verified notifications. */
export type ReferredAccountVerifiedPayload = {
  __typename?: 'ReferredAccountVerifiedPayload';
  /** The ID of the referred. */
  referredId: Scalars['String']['output'];
  /** The profile full name of the referred. */
  referredName: Scalars['String']['output'];
  /** The amount of the referral bonus. */
  swayCash: Money;
};

export enum RepeatsDays {
  Fri = 'FRI',
  Mon = 'MON',
  Sat = 'SAT',
  Sun = 'SUN',
  Thu = 'THU',
  Tue = 'TUE',
  Wed = 'WED'
}

export enum RepeatsFrequency {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type Result = {
  __typename?: 'Result';
  message: Scalars['String']['output'];
};

export enum RoleName {
  /** Ability to view, modify, and perform actions on Adjustments via the admin interface. */
  Adjustments = 'ADJUSTMENTS',
  /** Ability to view built-in SwayDM analytics. */
  Analytics = 'ANALYTICS',
  /** Ability to view, modify, and perform actions on behalf of Communities via the admin interface. */
  CommunityAdmin = 'COMMUNITY_ADMIN',
  /** Role given to an employee of SwayDM. Should gate access to admin functionality like Kaffy. */
  Employee = 'EMPLOYEE',
  /** Ability to view, modify, and perform actions on ExternalTransactions via the admin interface */
  ExternalTransactions = 'EXTERNAL_TRANSACTIONS',
  /** Ability view and modify feature flags. */
  FeatureFlags = 'FEATURE_FLAGS',
  /** Ability to view auto generated internal documentation. */
  InternalDocs = 'INTERNAL_DOCS',
  /** Ability to view, modify, and perform actions on InternalTransactions via the admin interface */
  InternalTransactions = 'INTERNAL_TRANSACTIONS',
  /** Ability to view, modify, and perform actions on Invitations via the admin interface. */
  Invitations = 'INVITATIONS',
  /** Ability to view, modify, and perform actions on MessageTransactions via the admin interface */
  MessageTransactions = 'MESSAGE_TRANSACTIONS',
  /** Ability to view design parts page. */
  Parts = 'PARTS',
  /** Ability to view, modify, and perform actions on Profiles via the admin interface. */
  Profiles = 'PROFILES',
  /** Ability to view, modify, and perform actions on Promotions via the admin interface */
  Promotions = 'PROMOTIONS',
  /** Ability to perform sales operations. */
  SalesOps = 'SALES_OPS',
  /** Ability to view, modify, and perform actions on accounting Snapshots via the admin interface. */
  Snapshots = 'SNAPSHOTS',
  /** Ability to do anything in the app, along with grant and revoke roles from other users. */
  SuperAdmin = 'SUPER_ADMIN',
  /** Ability to view, modify, and perform actions on Users via the admin interface. */
  Users = 'USERS',
  /** Ability to view, modify, and perform actions on Wallets via the admin interface. */
  Wallets = 'WALLETS'
}

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /**
   * Account Deactivation.
   * User's profile will no longer be public.
   * Cannot send or receive messages.
   * Will not receive any future notifications.
   * Account can be reactivated within 30 days.
   */
  accountDeactivate: UserActivationResult;
  /**
   * Account Reactivation
   * User's profile will become public again.
   * Can send and receive messages.
   * Will receive notifications.
   */
  accountReactivate: UserActivationResult;
  /** Add a device token for push notifications. */
  addDeviceToken: DeviceTokenResult;
  addReaction: Message;
  /**
   * Block a profile.  Will return a Block if it already exists.
   * Blocking profile will be the profile of the currently logged in user.
   */
  blockProfile: Block;
  /**
   * Archive a broadcast.
   *
   * Archive a broadcast to move it to the archived tab.
   * Archiving a live or scheduled broadcast will cancel the broadcast. No further messages will be sent.
   */
  broadcastArchive: BroadcastResult;
  /**
   * Create a new broadcast.
   *
   * Will send automatically if broadcast_start is unspecified, and send_immediately is true.
   *
   * If broadcast_start is not specified, and send_immediately is unspecified or false,
   * the broadcast will be created in a draft state, and will not sent until updated.
   */
  broadcastCreate: BroadcastResult;
  /**
   * Publish a broadcast.
   *
   * Publish != send. State will show as published until the first broadcast is actually sent.
   *
   * If broadcastStart is set, broadcast will send at the broadcastStart datetime.
   * If broadcastStart is not set, broadcast will send immediately.
   *
   * This also schedules the broadcast summary to be sent in 50 hours after the broadcast is sent.
   */
  broadcastPublish: BroadcastResult;
  /**
   * Unarchive a broadcast.
   *
   * A broadcast can be unarchived to move it back to the current broadcasts tab.  It will appear in a draft state.
   * If it has already been completed, it cannot be rescheduled, or modified.
   */
  broadcastUnarchive: BroadcastResult;
  /**
   * Update a broadcast.
   *
   * # If Draft or Scheduled
   * Any fields are editable in draft state.
   * You may change the broadcast_start to a future date.
   * You may set broadcast_start to nil, and specify send_immediately to send the broadcast immediately.
   *
   * # If Live
   * If the broadcast is in a sent state, updates to the message will only be reflected in future sends.
   * You may change the
   *
   * # If Complete / Archived
   * The broadcast cannot be edited.
   */
  broadcastUpdate: BroadcastResult;
  /** Change the logged in user's email address.  Will need to be confirmed via email. */
  changeEmail: BasicResult;
  /** Modify the profile of the currently logged in member. */
  changeMemberProfile: ChangeMemberProfileResult;
  /** Change the logged in user's password. */
  changePassword: BasicResult;
  /** Modify the profile of the currently logged in user. */
  changeProfile: ProfileResult;
  /** Modify the profile of the currently logged in vendor. */
  changeVendorProfile: ChangeVendorProfileResult;
  /** Create an access token for the current user. */
  createAccessToken: AccessToken;
  deleteReaction: Message;
  /** Set if earner onboarding has been completed. */
  earnerOnboarding: User;
  /**
   * Mark a feed item as seen.
   * A dismissed item will not be returned in future feed item queries, but can still be used to specify as
   * an 'after_id'.
   */
  feedItemSeen: BasicResult;
  /** Set the feed's geolocation. */
  feedSetGeoPoint: BasicResult;
  /**
   * Follow a community.  Will return an error if logged in profile is not allowed to
   * follow the specified community.
   */
  follow: FollowResult;
  /** Hide a suggested profile */
  hideSuggestedProfile: BasicResult;
  /** Click on a message to earn. */
  interactionClick: InteractionResult;
  /** Approve a redemption request. */
  interactionRedemptionApprove: InteractionResult;
  /** Reject a redemption request. */
  interactionRedemptionDeny: InteractionResult;
  /** Reply to a message to earn. */
  interactionReply: InteractionResult;
  /** Respond to a poll interaction.  Will return the updated interaction in the result. */
  interactionRespondToPoll: InteractionResult;
  /**
   * Associate a link to a profile or redemption.
   * Only one of profile or redemption_id is required.
   * If profile is true, the link will be associated with the current profile.
   * If profile is false or not provided and redemption_id is provided, the link will be associated with the redemption.
   * Link must not be associated with a profile or redemption.
   * If associating to a redemption, the redemption must be owned by the current user.
   */
  linkAssociate: LinkResult;
  /** Deprecated */
  linkChangeAssociation: LinkResult;
  /** Create a new link associated to a profile or redemption */
  linkCreate: LinkResult;
  /** (UN-AUTHED) Sign in user */
  login: Session;
  /** Logging out will invalidate all bearer tokens, and user tokens. */
  logout: Scalars['String']['output'];
  markViewed?: Maybe<MarkViewedResponse>;
  /** Send a message, will return success status, and changeset errors. */
  newMessage: NewMessageResult;
  notifyUserTyped?: Maybe<Scalars['String']['output']>;
  /** Set poll to archived. */
  pollArchive: PollResult;
  /** Set poll to complete. */
  pollComplete: PollResult;
  /** Create a new poll. */
  pollCreate: PollResult;
  /** Publish a poll.  Will respect start_at and end_at. */
  pollPublish: PollResult;
  /** Revert poll to draft status. */
  pollRevertToDraft: PollResult;
  /** Set a poll to live. Will set start_at to current datetime. Will optionally set end_at. */
  pollSetToLive: PollResult;
  /** Update an existing poll. */
  pollUpdate: PollResult;
  /** Purchase a streak repair for the current profile. */
  purchaseAnswerStreakRepair: AnswerStreakRepair;
  /** Redeem a redemption */
  redeem: RedemptionResult;
  /** Archive a redemption */
  redemptionArchive: RedemptionMutationResult;
  /** Clone a redemption */
  redemptionClone: RedemptionMutationResult;
  /** Create a redemption */
  redemptionCreate: RedemptionMutationResult;
  /** Like a redemption */
  redemptionLike: BasicResult;
  /** Save a redemption */
  redemptionSave: RedemptionMutationResult;
  /** Unarchive a redemption */
  redemptionUnarchive: RedemptionMutationResult;
  /** Unlike a redemption */
  redemptionUnlike: BasicResult;
  /** Unsave a redemption */
  redemptionUnsave: RedemptionMutationResult;
  /** Update a redemption */
  redemptionUpdate: RedemptionMutationResult;
  /**
   * Will update the position of the specified redemptions to the index of the id in the ids input.
   *
   * Before:
   * Assume A, B and C are redemption UUIDs.
   *
   * redemption A: position 0
   * redemption B: position 1
   * redemption C: position 2
   *
   * Operation:
   * call reorder_redemptions with ids: [B, A, C]
   *
   * Result:
   * Returns the modified redemptions, positions will now be:
   * redemption B: position 0
   * redemption A: position 1
   * redemption C: position 2
   */
  redemptionsReorder?: Maybe<RedemptionsMutationResult>;
  refusePayment?: Maybe<Message>;
  /** Register Member */
  registerMember: BasicResult;
  /** Register Vendor */
  registerVendor: BasicResult;
  /** Remove a device token. */
  removeDeviceToken: DeviceTokenResult;
  reportContent: Scalars['String']['output'];
  /**
   * Request account management, specify account and/or account data deletion.
   * Account deletion will result in a disabled account.
   * Data deletion will result in data being deleted, specified in our process:
   * https://sway.dm/info/account-deletion/
   */
  requestAccountManagementAction: AccountManagementRequestResult;
  resendEmailVerification: BasicResult;
  /** (UN-AUTHED) Confirm Reset Password.  If account exists, will send a password reset email. */
  resetPasswordFinalize: BasicResult;
  /** (UN-AUTHED) Initiate Reset Password.  If account exists, will send a password reset email. */
  resetPasswordInitiate: BasicResult;
  /** Send an invite with your referral link to an email address, or SMS phone number. */
  sendInvite: BasicResult;
  /**
   * DEPRECATED
   * Send a message, will fail with a generic message, and 500.
   */
  sendMessage: Message;
  setDefaultNotificationPreferencesForMobile: NotificationPreferences;
  /**
   * Use this mutation to modify the MedaiPointer status.  This is used for certain providers where
   * the client must mark them as complete, such as S3.  Mux has webhooks that automatically set the status.
   */
  setMediaPointerStatus: MediaPointer;
  setNotificationPreferences: NotificationPreferences;
  /** Set profile, or conversation level participant settings. Returns the global, or conversation specific settings. */
  setParticipantSettings: ParticipantSettings;
  /** Will cancel a verification if one is pending. */
  smsRemove: SmsUserResult;
  /** Will cancel a verification if one is pending. */
  smsVerificationCancel: SmsPendingVerificationResult;
  /** Initiate an SMS Verification Flow.  Calling this again will resend the code. */
  smsVerificationInitiate: SmsPendingVerificationResult;
  /** Send a code the verify the currently pending phone number. */
  smsVerificationVerify: SmsUserResult;
  /** Accept the a version of the Terms of Service. */
  tosAccept: UserTosAcceptedResult;
  /** Unblock a profile.  Will return the Block if it was removed. */
  unblockProfile?: Maybe<Block>;
  /**
   * Create  MediaPointer that will return one or more SignedUrls for purposes of uploading
   * media directly from the client to the storage provider.
   */
  uploadMedia: MediaUploadResult;
  viewMessage?: Maybe<Message>;
};


export type RootMutationTypeAccountDeactivateArgs = {
  password: Scalars['String']['input'];
};


export type RootMutationTypeAddDeviceTokenArgs = {
  deviceToken: DeviceTokenInput;
};


export type RootMutationTypeAddReactionArgs = {
  messageId: Scalars['ID']['input'];
  reaction: Scalars['String']['input'];
};


export type RootMutationTypeBlockProfileArgs = {
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  profileId: Scalars['ID']['input'];
};


export type RootMutationTypeBroadcastArchiveArgs = {
  broadcastId: Scalars['ID']['input'];
};


export type RootMutationTypeBroadcastCreateArgs = {
  broadcast: BroadcastInput;
};


export type RootMutationTypeBroadcastPublishArgs = {
  broadcastId: Scalars['ID']['input'];
};


export type RootMutationTypeBroadcastUnarchiveArgs = {
  broadcastId: Scalars['ID']['input'];
};


export type RootMutationTypeBroadcastUpdateArgs = {
  broadcast: BroadcastInput;
  broadcastId: Scalars['ID']['input'];
};


export type RootMutationTypeChangeEmailArgs = {
  currentPassword: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type RootMutationTypeChangeMemberProfileArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  profilePhotoCrop?: InputMaybe<Scalars['String']['input']>;
  profilePhotoMediaPointerId?: InputMaybe<Scalars['ID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type RootMutationTypeChangeProfileArgs = {
  communityName?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  profileLinks?: InputMaybe<Array<ProfileLinkInput>>;
  profilePhotoCrop?: InputMaybe<Scalars['String']['input']>;
  profilePhotoMediaPointerId?: InputMaybe<Scalars['ID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeChangeVendorProfileArgs = {
  bio?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  profileLinks?: InputMaybe<Array<ProfileLinkInput>>;
  profilePhotoCrop?: InputMaybe<Scalars['String']['input']>;
  profilePhotoMediaPointerId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeDeleteReactionArgs = {
  emojiReactionId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
};


export type RootMutationTypeEarnerOnboardingArgs = {
  complete: Scalars['Boolean']['input'];
};


export type RootMutationTypeFeedItemSeenArgs = {
  deltaMs: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type RootMutationTypeFeedSetGeoPointArgs = {
  geoPoint?: InputMaybe<GeoPointInput>;
};


export type RootMutationTypeFollowArgs = {
  communityId: Scalars['ID']['input'];
};


export type RootMutationTypeHideSuggestedProfileArgs = {
  profileId: Scalars['ID']['input'];
};


export type RootMutationTypeInteractionClickArgs = {
  interactionId: Scalars['ID']['input'];
};


export type RootMutationTypeInteractionRedemptionApproveArgs = {
  interactionId: Scalars['ID']['input'];
};


export type RootMutationTypeInteractionRedemptionDenyArgs = {
  interactionId: Scalars['ID']['input'];
};


export type RootMutationTypeInteractionReplyArgs = {
  body: Scalars['String']['input'];
  interactionId: Scalars['ID']['input'];
};


export type RootMutationTypeInteractionRespondToPollArgs = {
  pollId: Scalars['ID']['input'];
  pollOptionId: Scalars['ID']['input'];
};


export type RootMutationTypeLinkAssociateArgs = {
  link: LinkInput;
};


export type RootMutationTypeLinkChangeAssociationArgs = {
  link: LinkInput;
};


export type RootMutationTypeLinkCreateArgs = {
  link: LinkCreateInput;
};


export type RootMutationTypeLoginArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailToken?: InputMaybe<Scalars['String']['input']>;
  magicLinkToken?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeLogoutArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeMarkViewedArgs = {
  conversationId: Scalars['ID']['input'];
};


export type RootMutationTypeNewMessageArgs = {
  body: Scalars['String']['input'];
  conversationId: Scalars['ID']['input'];
  mediaPointerIds?: Array<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  type?: MessageType;
};


export type RootMutationTypeNotifyUserTypedArgs = {
  conversationId: Scalars['ID']['input'];
};


export type RootMutationTypePollArchiveArgs = {
  pollId: Scalars['ID']['input'];
};


export type RootMutationTypePollCompleteArgs = {
  pollId: Scalars['ID']['input'];
};


export type RootMutationTypePollCreateArgs = {
  poll: PollObjectInput;
};


export type RootMutationTypePollPublishArgs = {
  pollId: Scalars['ID']['input'];
};


export type RootMutationTypePollRevertToDraftArgs = {
  pollId: Scalars['ID']['input'];
};


export type RootMutationTypePollSetToLiveArgs = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  pollId: Scalars['ID']['input'];
};


export type RootMutationTypePollUpdateArgs = {
  poll: PollObjectInput;
  pollId: Scalars['ID']['input'];
};


export type RootMutationTypeRedeemArgs = {
  redemptionId: Scalars['ID']['input'];
};


export type RootMutationTypeRedemptionArchiveArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeRedemptionCloneArgs = {
  redemptionId: Scalars['ID']['input'];
};


export type RootMutationTypeRedemptionCreateArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeRedemptionLikeArgs = {
  redemptionId: Scalars['ID']['input'];
};


export type RootMutationTypeRedemptionSaveArgs = {
  redemptionId: Scalars['ID']['input'];
};


export type RootMutationTypeRedemptionUnarchiveArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeRedemptionUnlikeArgs = {
  redemptionId: Scalars['ID']['input'];
};


export type RootMutationTypeRedemptionUnsaveArgs = {
  redemptionId: Scalars['ID']['input'];
};


export type RootMutationTypeRedemptionUpdateArgs = {
  id: Scalars['ID']['input'];
  redemption: RedemptionUpdateInput;
};


export type RootMutationTypeRedemptionsReorderArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeRefusePaymentArgs = {
  messageId: Scalars['ID']['input'];
};


export type RootMutationTypeRegisterMemberArgs = {
  acceptedTerms: Scalars['Boolean']['input'];
  acquisitionSource: Scalars['String']['input'];
  communityId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  redemptionId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeRegisterVendorArgs = {
  acceptedTerms: Scalars['Boolean']['input'];
  acquisitionSource: Scalars['String']['input'];
  communityName: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeRemoveDeviceTokenArgs = {
  deviceTokenId: Scalars['ID']['input'];
};


export type RootMutationTypeReportContentArgs = {
  reportMessageOther?: InputMaybe<Scalars['String']['input']>;
  reportReasons: Array<ContentReportReasons>;
  targetId: Scalars['ID']['input'];
  targetType: ContentReportTarget;
};


export type RootMutationTypeRequestAccountManagementActionArgs = {
  password: Scalars['String']['input'];
  permanentAccountDeletion: Scalars['Boolean']['input'];
  permanentDataDeletion: Scalars['Boolean']['input'];
};


export type RootMutationTypeResendEmailVerificationArgs = {
  email: Scalars['String']['input'];
};


export type RootMutationTypeResetPasswordFinalizeArgs = {
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type RootMutationTypeResetPasswordInitiateArgs = {
  email: Scalars['String']['input'];
};


export type RootMutationTypeSendInviteArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  sms?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeSendMessageArgs = {
  body: Scalars['String']['input'];
  conversationId: Scalars['ID']['input'];
  mediaPointerIds?: Array<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  type?: MessageType;
};


export type RootMutationTypeSetMediaPointerStatusArgs = {
  mediaPointerId: Scalars['ID']['input'];
  status: MediaPointerStatus;
};


export type RootMutationTypeSetNotificationPreferencesArgs = {
  notificationPreferences: NotificationPreferencesInput;
};


export type RootMutationTypeSetParticipantSettingsArgs = {
  acceptMedia: Scalars['Boolean']['input'];
  conversationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeSmsVerificationInitiateArgs = {
  smsPhoneNumber: Scalars['String']['input'];
};


export type RootMutationTypeSmsVerificationVerifyArgs = {
  code: Scalars['String']['input'];
};


export type RootMutationTypeTosAcceptArgs = {
  version: Scalars['String']['input'];
};


export type RootMutationTypeUnblockProfileArgs = {
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  profileId: Scalars['ID']['input'];
};


export type RootMutationTypeUploadMediaArgs = {
  broadcastId?: InputMaybe<Scalars['ID']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  filesizeInBytes: Scalars['Int']['input'];
  mediaType: MediaType;
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  profileId?: InputMaybe<Scalars['ID']['input']>;
  redemptionId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeViewMessageArgs = {
  messageId: Scalars['ID']['input'];
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /**
   * If any account deletion requests exist for the authenticated user, they will be returned in
   * descending order by resolved_at (nulls first), inserted_at.
   */
  accountManagementRequests: Array<AccountManagementRequest>;
  /** Get the amount of available streak repairs for the current profile. */
  amountOfAvailableStreakRepairs: Scalars['Int']['output'];
  /** Get the current price of a streak repair. */
  answerStreakRepairPrice: Money;
  appInfo: AppInfo;
  /**
   * Return statistics for a given broadcast.
   * This query is restricted to vendors, and the broadcast must be related to the vendor.
   */
  broadcastStats: BroadcastStatsQueryResult;
  /**
   * Return broadcast targets for the current user.
   * A broadcast target is a user that will receive a broadcast.
   * Targets can be filtered by various criteria.
   * See query field documentation for details.
   */
  broadcastTargets: TargetedMemberPage;
  /**
   * Return broadcasts for the current user.
   * See query field documentation for details.
   */
  broadcasts: BroadcastPage;
  /** Return a single challenge if it is associated to the logged in user. */
  challenge: Challenge;
  /** Return all challenges pertaining to the logged in user. */
  challenges: Array<Challenge>;
  conversation: Conversation;
  conversations?: Maybe<Array<ConversationPreview>>;
  /** List all device tokens associated with the current user. */
  deviceTokens: Array<DeviceToken>;
  discoverCommunities?: Maybe<CommunityDiscoveryPage>;
  /**
   * Discover redemptions
   * Default query is all active redemptions for active vendors, sorted by global rank descending, updated at descending.
   */
  discoverRedemptions?: Maybe<RedemptionPage>;
  /** Retrieve the editable profile of the currently logged in user. */
  editableProfile: EditableProfile;
  /**
   * Return all public feature flags. with their global status.
   * If no user is authenticated, the global status will be used.
   * If user is authenticated, the current profile is as an actor to determine the status.
   * If the user authenticated has the employee UserRole, the 'employee' feature flag group is checked as well.
   */
  features: Array<Maybe<FeatureFlag>>;
  /** Get the current user's feed configuration. */
  feed: Feed;
  /** Get a single feed item by ID. */
  feedItem?: Maybe<FeedItem>;
  /** Get feed items for the current user. */
  feedItems: Array<FeedItem>;
  /** Retrieves a feed session by ID. */
  feedSession?: Maybe<FeedSession>;
  /** Return followers for the currently logged in vendor */
  followers?: Maybe<FollowerPage>;
  /** Return a single redemption based on a provided ID. */
  getRedemption?: Maybe<Redemption>;
  /** Get logged user */
  impersonator?: Maybe<User>;
  /** Retrieve one interaction by id. */
  interactionOne: Interaction;
  interactions: Array<Maybe<Interaction>>;
  knockCredentials: KnockCredentials;
  /** Get a link by id or short code. Only one of id or short code is required */
  linkGet?: Maybe<Link>;
  /** Get links that were created or linked to the current user. Optionally specify pagination, filter, and ordering. */
  linksGet?: Maybe<LinkPage>;
  lookupMember: MemberProfile;
  magicLink: AccessToken;
  /** Return a media pointer, but only if the authenticated user is the creator. */
  mediaPointer: MediaPointer;
  memberReferral?: Maybe<MemberReferral>;
  message: Message;
  /** Returns the nearest spotlight redemption based on the user's location. */
  nearestSpotlightRedemption?: Maybe<Redemption>;
  notificationPreferences: NotificationPreferences;
  /**
   * DEPRECATED, use `interactionOne`
   * Retrieve one interaction by id.
   */
  oneInteraction: Interaction;
  /** Get all polls. Will automatically filter to polls the authed user created. */
  pollAll: PollPage;
  /** Get a single poll.  Can only retrieve polls the authed user created. */
  pollGet: PollObject;
  /** Return the poll results. */
  pollResults?: Maybe<PollResults>;
  /**
   * Retrieve a profile by ID or display name.
   * Only one argument is required.
   */
  profile: Profile;
  /** Return all locations related to the profile of the logged in user. */
  profileLocations: Array<Maybe<Location>>;
  profileName: Scalars['String']['output'];
  /**
   * Redemptions history
   * If the user is a community follower, will return all history records of redemptions that have been redeemed by the user.
   * If the user is a community, will return all history records of their redemptions.
   */
  redemptionHistory?: Maybe<RedemptionHistoryPage>;
  redemptionLimits?: Maybe<RedemptionLimits>;
  /**
   * Redemptions
   * Will only ever return redemptions created by the logged in user.
   * Default query is all unarchived redemptions created by the logged in user, sorted by position descending.
   */
  redemptions?: Maybe<RedemptionPage>;
  /** Return a list of redemptions that the user has liked. */
  redemptionsLiked?: Maybe<RedemptionPage>;
  /** Return a list of redemptions that the user has saved. */
  redemptionsSaved?: Maybe<RedemptionPage>;
  /** Will return the current phone number pending verification if a number is awaiting verification. */
  smsVerificationCurrent?: Maybe<SmsPendingVerification>;
  /**
   * Return all suggested profiles for the logged in user.
   * Currently ordered by suggested_at date, descending.
   */
  suggestedProfiles: SuggestedProfilePage;
  /** Get the top profiles on the swaycash earnings leaderboard, earnings for a profile, and the position for a profile with padding. */
  swayCashLeaderboard: SwayCashLeaderboard;
  /** A list of all possible timezones that can be used as the profile.timezone value. */
  timezoneOptions: Array<Scalars['String']['output']>;
  /** Returns the top live redemption for a given vendor. */
  topLiveRedemption?: Maybe<Redemption>;
  tosCurrent: TosVersion;
  /** Get the top profiles on the trivia leaderboard, correct/incorrect answers for a profile, and the position for a profile with padding. */
  triviaLeaderboard: TriviaLeaderboard;
  unreadMessageCount: Scalars['Int']['output'];
  /** Get logged user */
  user: User;
  vendor: PublicVendor;
  /** Get vendor analytics. */
  vendorAnalytics: VendorAnalytics;
  /**
   * DEPRECATED
   * Get vendor weekly analytics.
   */
  vendorWeeklyAnalytics?: Maybe<VendorWeeklyAnalytics>;
  /** Return the main wallet of the logged in user. */
  wallet?: Maybe<Wallet>;
};


export type RootQueryTypeBroadcastStatsArgs = {
  broadcastId: Scalars['ID']['input'];
};


export type RootQueryTypeBroadcastTargetsArgs = {
  query?: InputMaybe<TargetedMemberPageInput>;
};


export type RootQueryTypeBroadcastsArgs = {
  query?: InputMaybe<BroadcastPageInput>;
};


export type RootQueryTypeChallengeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeChallengesArgs = {
  filter?: InputMaybe<ChallengeFilter>;
  limit?: Scalars['Int']['input'];
};


export type RootQueryTypeConversationArgs = {
  id: Scalars['ID']['input'];
  messagesQuantity?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeConversationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeDiscoverCommunitiesArgs = {
  currentLocation?: InputMaybe<GeoPointInput>;
  query?: InputMaybe<CommunityDiscoveryPageInput>;
};


export type RootQueryTypeDiscoverRedemptionsArgs = {
  currentLocation?: InputMaybe<GeoPointInput>;
  query?: InputMaybe<RedemptionPageInput>;
};


export type RootQueryTypeFeedItemArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeFeedItemsArgs = {
  afterId?: InputMaybe<Scalars['ID']['input']>;
  excludeSeenBefore?: InputMaybe<Scalars['DateTime']['input']>;
  geoPoint?: InputMaybe<GeoPointInput>;
  includeAfterItemInFeed?: InputMaybe<Scalars['Boolean']['input']>;
  includeSeen?: InputMaybe<Scalars['Boolean']['input']>;
  maxItems?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeFeedSessionArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeFollowersArgs = {
  query?: InputMaybe<FollowerPageInput>;
};


export type RootQueryTypeGetRedemptionArgs = {
  id: Scalars['ID']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeInteractionOneArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeLinkGetArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeLinksGetArgs = {
  query?: InputMaybe<LinkPageInput>;
};


export type RootQueryTypeLookupMemberArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeMediaPointerArgs = {
  mediaPointerId: Scalars['ID']['input'];
};


export type RootQueryTypeMessageArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeNearestSpotlightRedemptionArgs = {
  currentLocation?: InputMaybe<GeoPointInput>;
};


export type RootQueryTypeOneInteractionArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypePollAllArgs = {
  query?: InputMaybe<PollPageInput>;
};


export type RootQueryTypePollGetArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypePollResultsArgs = {
  includeRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  pollId: Scalars['ID']['input'];
};


export type RootQueryTypeProfileArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeProfileNameArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeRedemptionHistoryArgs = {
  query?: InputMaybe<RedemptionHistoryPageInput>;
};


export type RootQueryTypeRedemptionLimitsArgs = {
  evaluate?: InputMaybe<Scalars['Boolean']['input']>;
  redemptionId: Scalars['ID']['input'];
};


export type RootQueryTypeRedemptionsArgs = {
  query?: InputMaybe<RedemptionPageInput>;
};


export type RootQueryTypeRedemptionsSavedArgs = {
  currentLocation?: InputMaybe<GeoPointInput>;
  query?: InputMaybe<RedemptionPageInput>;
};


export type RootQueryTypeSuggestedProfilesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeTopLiveRedemptionArgs = {
  vendorId: Scalars['ID']['input'];
};


export type RootQueryTypeVendorArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeVendorAnalyticsArgs = {
  lookbackDays?: Scalars['Int']['input'];
};


export type RootQueryTypeVendorWeeklyAnalyticsArgs = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  /** Subscribe to challenge events (e.g. milestones reached). */
  challengeEvents?: Maybe<ChallengeEvent>;
  conversationEvent?: Maybe<ConversationsEvent>;
  conversationsEvent?: Maybe<ConversationsEvent>;
  pollEvents?: Maybe<PollEvents>;
  /** Subscribe to wallet balance updates. */
  walletEvents?: Maybe<WalletEvent>;
};


export type RootSubscriptionTypeConversationEventArgs = {
  conversationId: Scalars['ID']['input'];
};

/** Represents a user session */
export type Session = {
  __typename?: 'Session';
  /** The access token for the session */
  accessToken?: Maybe<AccessToken>;
  /** The impersonator of the user. This is only present if an admin user is impersonating another user. */
  impersonator?: Maybe<User>;
  /** The user associated with the session */
  user?: Maybe<User>;
};

/** A SignedUrl provides a url that the client can use to access the original media, or a proxy of the original. */
export type SignedUrl = {
  __typename?: 'SignedUrl';
  /** The expected size of the binary data the SignedURL references. */
  expectedSizeInBytes?: Maybe<Scalars['Int']['output']>;
  /**
   * If specified, represents how many seconds the SignedUrl will be valid for.  Typically the stream will remain active
   * as long as it is first accessed before SignedUrl expires.
   */
  expiresInSeconds?: Maybe<Scalars['Int']['output']>;
  /** The version of the original media this SignedUrl represents. */
  key: SignedUrlKey;
  /** The MediaPointer ID this SignedUrl is associated to. */
  mediaPointerId: Scalars['ID']['output'];
  /** The media type the SignedURL references. */
  mediaType: MediaType;
  /** A JSON formatted string that contains any metadata associated with this SignedURL. */
  metadata?: Maybe<Scalars['String']['output']>;
  /** The media type the SignedURL references. */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** The provider of the SignedURL. */
  provider: MediaProvider;
  /** The URL that references the original media, or proxy. */
  url: Scalars['String']['output'];
};

/** Used to define which specific representation of the media a SignedUrl represents. */
export enum SignedUrlKey {
  /** The original media, or closest approximation of the original that is stored by the provider. */
  Original = 'ORIGINAL',
  /** A proxy to an image that is modified in some way. */
  Proxy = 'PROXY',
  /** A proxy to an image that is  modified in some way. Returned as a string that can be used in the srcset attribute of an img tag. */
  ProxySrcset = 'PROXY_SRCSET',
  /** Video only, image that mux player can use to create scrollable preview. */
  Storyboard = 'STORYBOARD',
  /** An image that has a minimal size and limited quality to show in the UI. */
  Thumbnail = 'THUMBNAIL',
  /** An animated image to be used as a way to show a short preview of a video. */
  ThumbnailAnimated = 'THUMBNAIL_ANIMATED'
}

/** Contains a status message, and phone number */
export type SmsPendingVerification = {
  __typename?: 'SmsPendingVerification';
  message?: Maybe<Scalars['String']['output']>;
  smsPhoneNumber?: Maybe<Scalars['String']['output']>;
};

export type SmsPendingVerificationResult = {
  __typename?: 'SmsPendingVerificationResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<SmsPendingVerification>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Contains a message, and updated user. */
export type SmsUser = {
  __typename?: 'SmsUser';
  message: Scalars['String']['output'];
  user: User;
};

export type SmsUserResult = {
  __typename?: 'SmsUserResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<SmsUser>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Represents a profile suggested for following or messaging to another profile. */
export type SuggestedProfile = {
  __typename?: 'SuggestedProfile';
  /** The datetime this profile was suggested. */
  suggestedAt: Scalars['DateTime']['output'];
  /** The profile that has been suggested. */
  suggestedProfile: Profile;
  /** A short description of why this profile was suggested.  Could be from viewing a profile, or via suggestion list entry. */
  suggestedVia?: Maybe<Scalars['String']['output']>;
};

/** Paged results for suggested profiles. */
export type SuggestedProfilePage = {
  __typename?: 'SuggestedProfilePage';
  data: Array<SuggestedProfile>;
  page?: Maybe<BasePage>;
};

/** Describes the weekly sway cash leaderboard operations. */
export type SwayCashLeaderboard = {
  __typename?: 'SwayCashLeaderboard';
  /** The earnings for a specific profile. */
  earningsFor?: Maybe<SwayCashLeaderboardRecord>;
  /** Get the oldest leaderboard record for the sway cash leaderboard. */
  oldestLeaderboardDate?: Maybe<Scalars['Date']['output']>;
  /** The position for a specific profile with padding. */
  positionFor?: Maybe<Array<SwayCashLeaderboardRecord>>;
  /** The top profiles on the leaderboard. Defaults to 5. */
  top: Array<SwayCashLeaderboardRecord>;
  /** The total count of profiles on the leaderboard. */
  totalCount: Scalars['Int']['output'];
};


/** Describes the weekly sway cash leaderboard operations. */
export type SwayCashLeaderboardEarningsForArgs = {
  profileId?: InputMaybe<Scalars['ID']['input']>;
  weeksBack?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the weekly sway cash leaderboard operations. */
export type SwayCashLeaderboardPositionForArgs = {
  padding?: InputMaybe<Scalars['Int']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  weeksBack?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the weekly sway cash leaderboard operations. */
export type SwayCashLeaderboardTopArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  top?: InputMaybe<Scalars['Int']['input']>;
  weeksBack?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the weekly sway cash leaderboard operations. */
export type SwayCashLeaderboardTotalCountArgs = {
  weeksBack?: InputMaybe<Scalars['Int']['input']>;
};

/** Describes a weekly sway cash leaderboard record. */
export type SwayCashLeaderboardRecord = {
  __typename?: 'SwayCashLeaderboardRecord';
  /** The display name of the profile. */
  displayName: Scalars['String']['output'];
  /** The first name of the profile. */
  firstName: Scalars['String']['output'];
  /** The last name of the profile. */
  lastName: Scalars['String']['output'];
  /** The streak of the profile. */
  overallStreak?: Maybe<Scalars['Int']['output']>;
  /** The ID of the profile. */
  profileId: Scalars['ID']['output'];
  rank: Scalars['Int']['output'];
  /** The unique position of the profile in the ordered leaderboard, calculated after sorting the leaderboard. */
  rowNumber?: Maybe<Scalars['Int']['output']>;
  /** The amount of sway cash the profile has earned on this week's leaderboard. */
  swayCash: Money;
};

export type TargetedMember = {
  __typename?: 'TargetedMember';
  followedAt?: Maybe<Scalars['DateTime']['output']>;
  isFollower: Scalars['Boolean']['output'];
  member: MemberProfile;
};

export type TargetedMemberFiltersInput = {
  attribute: TargetedMemberQueryAttributes;
  op: PageFilterOp;
  value: PageFilterValuesInput;
};

export type TargetedMemberOrderByInput = {
  attribute: BroadcastQueryAttributes;
  direction: PageOrderDirection;
};

export type TargetedMemberPage = {
  __typename?: 'TargetedMemberPage';
  data: Array<TargetedMember>;
  page?: Maybe<BasePage>;
  query?: Maybe<BroadcastQuery>;
};

export type TargetedMemberPageInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  broadcastTarget?: InputMaybe<BroadcastTargetInput>;
  filters?: InputMaybe<Array<TargetedMemberFiltersInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TargetedMemberOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export enum TargetedMemberQueryAttributes {
  /** The datetime the member followed the logged in vendor. */
  FollowedAt = 'FOLLOWED_AT',
  /** The broadcast's ID. */
  Id = 'ID',
  /** The datetime the member was inserted. */
  InsertedAt = 'INSERTED_AT'
}

/** Represents a User's acceptance of a Terms of Service version. */
export type TosAccepted = {
  __typename?: 'TosAccepted';
  /** The ID of the accepted the Terms of Service record. */
  id: Scalars['ID']['output'];
  /** The date the user accepted the Terms of Service. */
  insertedAt: Scalars['DateTime']['output'];
  user: User;
  /** The version of the Terms of Service that were accepted. */
  version: TosVersion;
};

/** Represents a Terms of Service version. */
export type TosVersion = {
  __typename?: 'TosVersion';
  /** The content of the Terms of Service */
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The date this version was inserted. */
  insertedAt: Scalars['DateTime']['output'];
  /** If true, users must accept this version to continue using the service. */
  requireUserAcceptance: Scalars['Boolean']['output'];
  /** The version of the Terms of Service */
  version: Scalars['String']['output'];
};

export type TriviaDailyStatus = {
  __typename?: 'TriviaDailyStatus';
  day?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<DailyStatus>;
};

/** Describes the weekly trivia leaderboard operations. */
export type TriviaLeaderboard = {
  __typename?: 'TriviaLeaderboard';
  /** The answers for a specific profile. */
  answersFor?: Maybe<TriviaLeaderboardRecord>;
  /** Get the oldest leaderboard record for the trivia leaderboard. */
  oldestLeaderboardDate?: Maybe<Scalars['Date']['output']>;
  /** The position for a specific profile with padding. */
  positionFor?: Maybe<Array<TriviaLeaderboardRecord>>;
  /** The top profiles on the trivia leaderboard. Defaults to 5. */
  top: Array<TriviaLeaderboardRecord>;
  /** The total count of profiles on the leaderboard. */
  totalCount: Scalars['Int']['output'];
};


/** Describes the weekly trivia leaderboard operations. */
export type TriviaLeaderboardAnswersForArgs = {
  profileId?: InputMaybe<Scalars['ID']['input']>;
  weeksBack?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the weekly trivia leaderboard operations. */
export type TriviaLeaderboardPositionForArgs = {
  padding?: InputMaybe<Scalars['Int']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  weeksBack?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the weekly trivia leaderboard operations. */
export type TriviaLeaderboardTopArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  top?: InputMaybe<Scalars['Int']['input']>;
  weeksBack?: InputMaybe<Scalars['Int']['input']>;
};


/** Describes the weekly trivia leaderboard operations. */
export type TriviaLeaderboardTotalCountArgs = {
  weeksBack?: InputMaybe<Scalars['Int']['input']>;
};

/** Describes a weekly trivia leaderboard record. */
export type TriviaLeaderboardRecord = {
  __typename?: 'TriviaLeaderboardRecord';
  /** The number of correct answers the profile has. */
  correctCount: Scalars['Int']['output'];
  /** The display name of the profile. */
  displayName: Scalars['String']['output'];
  /** The first name of the profile. */
  firstName: Scalars['String']['output'];
  /** The number of incorrect answers the profile has. */
  incorrectCount: Scalars['Int']['output'];
  /** The last time the profile answered correctly. */
  lastCorrectAt?: Maybe<Scalars['DateTime']['output']>;
  /** The last name of the profile. */
  lastName: Scalars['String']['output'];
  /** The ID of the profile. */
  profileId: Scalars['ID']['output'];
  /** The rank of the profile on the trivia leaderboard. */
  rank: Scalars['Int']['output'];
  /** The unique position of the profile in the ordered leaderboard, calculated after sorting the leaderboard. */
  rowNumber?: Maybe<Scalars['Int']['output']>;
};

export type TypingEvent = {
  __typename?: 'TypingEvent';
  conversationId: Scalars['ID']['output'];
  profile: Profile;
  timestamp: Scalars['DateTime']['output'];
  type: TypingEventType;
};

export enum TypingEventType {
  TypingStarted = 'TYPING_STARTED'
}

/** A unclaimed suggestion to be displayed within the feed. */
export type UnclaimedVendorSuggestion = {
  __typename?: 'UnclaimedVendorSuggestion';
  /** The ids of the vendors. */
  vendorsIds: Array<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  acceptedTerms: Scalars['Boolean']['output'];
  adminDeactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  anonymizedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Return all blocks where the user is the blocking profile. */
  blocks: Array<Block>;
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Specifies the datetime the user completed the earner onboarding flow. */
  earnerOnboardingLastSeen?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** The last version of the Terms of Service the user accepted. */
  lastTosAccepted?: Maybe<TosAccepted>;
  /** (DEPRECATED) Return all locations related to the profile of the logged in user. */
  locations?: Maybe<Array<Maybe<Location>>>;
  participantSettings: ParticipantSettings;
  profile?: Maybe<Profile>;
  smsLast4?: Maybe<Scalars['String']['output']>;
  userRoles?: Maybe<Array<Maybe<UserRole>>>;
};

/** Contains a message, and updated user. */
export type UserActivation = {
  __typename?: 'UserActivation';
  message?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type UserActivationResult = {
  __typename?: 'UserActivationResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<UserActivation>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Union of possible user answer types. */
export type UserAnswer = Message | PollMediaOption | PollTextOption;

/** Represents a user role which gives that user specific permissions. */
export type UserRole = {
  __typename?: 'UserRole';
  /** The name of the role. */
  roleName: RoleName;
};

export type UserTosAcceptedResult = {
  __typename?: 'UserTosAcceptedResult';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<TosAccepted>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/**
 * Validation messages are returned when mutation input does not meet the requirements.
 *   While client-side validation is highly recommended to provide the best User Experience,
 *   All inputs will always be validated server-side.
 *
 *   Some examples of validations are:
 *
 *   * Username must be at least 10 characters
 *   * Email field does not contain an email address
 *   * Birth Date is required
 *
 *   While GraphQL has support for required values, mutation data fields are always
 *   set to optional in our API. This allows 'required field' messages
 *   to be returned in the same manner as other validations. The only exceptions
 *   are id fields, which may be required to perform updates or deletes.
 */
export type ValidationMessage = {
  __typename?: 'ValidationMessage';
  /** A unique error code for the type of validation used. */
  code: Scalars['String']['output'];
  /**
   * The input field that the error applies to. The field can be used to
   * identify which field the error message should be displayed next to in the
   * presentation layer.
   *
   * If there are multiple errors to display for a field, multiple validation
   * messages will be in the result.
   *
   * This field may be null in cases where an error cannot be applied to a specific field.
   */
  field?: Maybe<Scalars['String']['output']>;
  /**
   * A friendly error message, appropriate for display to the end user.
   *
   * The message is interpolated to include the appropriate variables.
   *
   * Example: `Username must be at least 10 characters`
   *
   * This message may change without notice, so we do not recommend you match against the text.
   * Instead, use the *code* field for matching.
   */
  message?: Maybe<Scalars['String']['output']>;
  /** A list of substitutions to be applied to a validation message template */
  options?: Maybe<Array<Maybe<ValidationOption>>>;
  /**
   * A template used to generate the error message, with placeholders for option substitution.
   *
   * Example: `Username must be at least {count} characters`
   *
   * This message may change without notice, so we do not recommend you match against the text.
   * Instead, use the *code* field for matching.
   */
  template?: Maybe<Scalars['String']['output']>;
};

export type ValidationOption = {
  __typename?: 'ValidationOption';
  /** The name of a variable to be substituted in a validation message template */
  key: Scalars['String']['output'];
  /** The value of a variable to be substituted in a validation message template */
  value: Scalars['String']['output'];
};

/** Container type for vendor analytics. */
export type VendorAnalytics = {
  __typename?: 'VendorAnalytics';
  /** The count of redemptions within the time period. */
  completedRedemptionsCount: Scalars['Int']['output'];
  /** The end of the time period the analytics pertain to. */
  endAt: Scalars['DateTime']['output'];
  /**
   * DEPRECATED
   * The count of messages that are fulfilled.
   */
  fulfilledMessagesCount: Scalars['Int']['output'];
  /** Impression analytics */
  impressionAnalytics?: Maybe<ImpressionAnalytics>;
  /** The number of days specified to look back */
  lookbackDays: Scalars['Int']['output'];
  /** The count of new followers within the time period. */
  newFollowerCount: Scalars['Int']['output'];
  /** The count of PollResponses (Poll and Trivia) within the time period. */
  responseCount: Scalars['Int']['output'];
  /** The start of the time period the analytics pertain to. */
  startAt: Scalars['DateTime']['output'];
};


/** Container type for vendor analytics. */
export type VendorAnalyticsImpressionAnalyticsArgs = {
  actionSources?: InputMaybe<Array<Scalars['String']['input']>>;
  actions?: InputMaybe<Array<Scalars['String']['input']>>;
  targetTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A redemption suggestion to be displayed within the feed. */
export type VendorSuggestion = {
  __typename?: 'VendorSuggestion';
  /** The id of the vendor. */
  vendorId: Scalars['String']['output'];
};

export type VendorWeeklyAnalytics = {
  __typename?: 'VendorWeeklyAnalytics';
  broadcastStats?: Maybe<Array<Maybe<AnalyticsBroadcastStats>>>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  memberAcquisitionSwaycashEarned?: Maybe<Scalars['Int']['output']>;
  newFollowers?: Maybe<Scalars['Int']['output']>;
  persistentBroadcastStats?: Maybe<Array<Maybe<AnalyticsBroadcastStats>>>;
  redemptionSwaycashEarned?: Maybe<Scalars['Int']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  successfulRedemptions?: Maybe<Scalars['Int']['output']>;
  totalSwaycashEarned?: Maybe<Scalars['Int']['output']>;
};

export type Wallet = {
  __typename?: 'Wallet';
  /** List of adjustments for this wallet. */
  adjustments?: Maybe<AdjustmentPage>;
  /** The current balance of this wallet. */
  balance: Money;
  /** If true, no adjustments can be created for this wallet. */
  frozen: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The purpose of the wallet. */
  role: WalletRole;
  /** The type of wallet. */
  type: WalletType;
};


export type WalletAdjustmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type WalletBalanceEvent = {
  __typename?: 'WalletBalanceEvent';
  updatedAt: Scalars['DateTime']['output'];
};

/** An event that can occur on a wallet. */
export type WalletEvent = WalletBalanceEvent;

export enum WalletRole {
  Earning = 'EARNING',
  Paying = 'PAYING',
  System = 'SYSTEM'
}

/**
 * A wallet transaction represents an addition of an Adjustment to a wallet.
 * The Adjustment may be positive or negative.
 */
export type WalletTransaction = {
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum WalletType {
  PromotionalWallet = 'PROMOTIONAL_WALLET',
  TransactionFeeWallet = 'TRANSACTION_FEE_WALLET',
  UserWallet = 'USER_WALLET'
}

export type WorkflowPreference = {
  __typename?: 'WorkflowPreference';
  /** The channel preferences for this workflow preference. */
  channelPreferences: Array<Maybe<ChannelPreference>>;
  /** The description of the workflow preference. */
  description: Scalars['String']['output'];
  /** The type of the workflow preference. */
  enabled: Scalars['Boolean']['output'];
  /** The SwayDM assigned ID for the workflow preference. */
  id: Scalars['ID']['output'];
  /** The key of the workflow preference. */
  key: Scalars['String']['output'];
  /** List if types this preference applies to. If null, applies to all profile types. */
  profileTypes?: Maybe<Array<Maybe<ProfileType>>>;
  /** The schedule for this workflow preference. */
  schedule?: Maybe<WorkflowSchedule>;
  /** The title of the workflow preference. */
  title?: Maybe<Scalars['String']['output']>;
};

export type WorkflowPreferenceInput = {
  channelPreferences: Array<InputMaybe<ChannelPreferenceInput>>;
  enabled: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
};

/** The schedule for a workflow preference. */
export type WorkflowSchedule = {
  __typename?: 'WorkflowSchedule';
  /** The human readable schedule. */
  humanReadableSchedule?: Maybe<Scalars['String']['output']>;
  /** The last time this workflow was triggered. */
  lastOccuranceAt?: Maybe<Scalars['DateTime']['output']>;
  /** The next time this workflow will be triggered. */
  nextOccurrenceAt?: Maybe<Scalars['DateTime']['output']>;
  /** The schedule repeat definitions. */
  repeats?: Maybe<Array<WorkflowScheduleRepeats>>;
};

/** A schedule repeat definition. */
export type WorkflowScheduleRepeats = {
  __typename?: 'WorkflowScheduleRepeats';
  /** The day of the month the repeat occurs on. */
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  /** The days of the week the repeat occurs on. */
  days?: Maybe<Array<Maybe<RepeatsDays>>>;
  /** The frequency of the repeat. */
  frequency: RepeatsFrequency;
  /** The hours of the day the repeat occurs on. */
  hours?: Maybe<Scalars['Int']['output']>;
  /** The interval of the repeat. */
  interval?: Maybe<Scalars['Int']['output']>;
  /** The minutes of the hour the repeat occurs on. */
  minutes?: Maybe<Scalars['Int']['output']>;
};

export type AccountDeactivateMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type AccountDeactivateMutation = { __typename?: 'RootMutationType', accountDeactivate: { __typename?: 'UserActivationResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'UserActivation', message?: string | null, user: { __typename?: 'User', id?: string | null, adminDeactivatedAt?: string | null, deactivatedAt?: string | null } } | null } };

export type AccountReactivateMutationVariables = Exact<{ [key: string]: never; }>;


export type AccountReactivateMutation = { __typename?: 'RootMutationType', accountReactivate: { __typename?: 'UserActivationResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'UserActivation', message?: string | null, user: { __typename?: 'User', id?: string | null, adminDeactivatedAt?: string | null, deactivatedAt?: string | null } } | null } };

export type RequestAccountManagementActionMutationVariables = Exact<{
  password: Scalars['String']['input'];
  permanentAccountDeletion: Scalars['Boolean']['input'];
  permanentDataDeletion: Scalars['Boolean']['input'];
}>;


export type RequestAccountManagementActionMutation = { __typename?: 'RootMutationType', requestAccountManagementAction: { __typename?: 'AccountManagementRequestResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'AccountManagementRequest', insertedAt: string, permanentAccountDeletion: boolean, permanentDataDeletion: boolean, requestingUserId: string, resolvedAt?: string | null } | null } };

export type VendorAnalyticsQueryVariables = Exact<{
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type VendorAnalyticsQuery = { __typename?: 'RootQueryType', vendorAnalytics: { __typename?: 'VendorAnalytics', completedRedemptionsCount: number, responseCount: number, lookbackDays: number, newFollowerCount: number, startAt: string, endAt: string, impressionAnalytics?: { __typename?: 'ImpressionAnalytics', total?: number | null, impressionStats?: Array<{ __typename?: 'ImpressionStats', action?: string | null, actionSource?: string | null, targetType?: string | null, total?: number | null }> | null } | null } };

export type VendorWeeklyAnalyticsQueryVariables = Exact<{
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type VendorWeeklyAnalyticsQuery = { __typename?: 'RootQueryType', vendorWeeklyAnalytics?: { __typename?: 'VendorWeeklyAnalytics', startAt?: string | null, endAt?: string | null, memberAcquisitionSwaycashEarned?: number | null, newFollowers?: number | null, redemptionSwaycashEarned?: number | null, successfulRedemptions?: number | null, totalSwaycashEarned?: number | null, broadcastStats?: Array<{ __typename?: 'AnalyticsBroadcastStats', broadcastId?: string | null, broadcastName?: string | null, fulfilled?: number | null, fulfillmentRate?: number | null, total?: number | null, totalUniqueMembers?: number | null, viewRate?: number | null, views?: number | null } | null> | null, persistentBroadcastStats?: Array<{ __typename?: 'AnalyticsBroadcastStats', broadcastId?: string | null, broadcastName?: string | null, fulfilled?: number | null, fulfillmentRate?: number | null, total?: number | null, totalUniqueMembers?: number | null, viewRate?: number | null, views?: number | null } | null> | null } | null };

export type AnalyticsVendorProfileViewsQueryVariables = Exact<{
  actionSources?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  actions?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  targetTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnalyticsVendorProfileViewsQuery = { __typename?: 'RootQueryType', vendorAnalytics: { __typename?: 'VendorAnalytics', impressionAnalytics?: { __typename?: 'ImpressionAnalytics', total?: number | null, impressionStats?: Array<{ __typename?: 'ImpressionStats', action?: string | null, actionSource?: string | null, targetType?: string | null, total?: number | null }> | null } | null } };

export type AnalyticsVendorRedemptionViewsQueryVariables = Exact<{
  actionSources?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  actions?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  targetTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnalyticsVendorRedemptionViewsQuery = { __typename?: 'RootQueryType', vendorAnalytics: { __typename?: 'VendorAnalytics', impressionAnalytics?: { __typename?: 'ImpressionAnalytics', total?: number | null, impressionStats?: Array<{ __typename?: 'ImpressionStats', action?: string | null, actionSource?: string | null, targetType?: string | null, total?: number | null }> | null } | null } };

export type BroadcastPartsFragment = { __typename?: 'Broadcast', id: string, broadcastArchivedAt?: string | null, broadcastEnd?: string | null, broadcastName: string, broadcastPublishedAt?: string | null, broadcastStart?: string | null, insertedAt: string, status: BroadcastStatus, updatedAt: string, isPersistent: boolean, broadcastTarget: { __typename?: 'BroadcastTarget', allFollowers: boolean, radiusKm?: number | null, usePrimaryLocation?: boolean | null }, followUpMessageTemplate?: { __typename?: 'MessageTemplate', name?: string | null, body?: string | null, type: MessageType, price?: { __typename?: 'Money', amount?: number | null } | null, redemptionOffers?: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null } | null> | null, primaryAttachment?: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> } | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null> | null } | null, messageTemplate?: { __typename?: 'MessageTemplate', name?: string | null, body?: string | null, type: MessageType, price?: { __typename?: 'Money', amount?: number | null } | null, redemptionOffers?: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null } | null> | null, primaryAttachment?: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> } | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null> | null } | null, costs?: { __typename?: 'BroadcastCosts', finalCost?: { __typename?: 'Money', amount?: number | null } | null, potentialTotalCost?: { __typename?: 'Money', amount?: number | null } | null, messagePrice?: { __typename?: 'Money', amount?: number | null } | null, currentCost?: { __typename?: 'Money', amount?: number | null } | null, outstandingCost?: { __typename?: 'Money', amount?: number | null } | null, returnedCost?: { __typename?: 'Money', amount?: number | null } | null } | null, followUpMessageCosts?: { __typename?: 'BroadcastCosts', finalCost?: { __typename?: 'Money', amount?: number | null } | null, potentialTotalCost?: { __typename?: 'Money', amount?: number | null } | null, messagePrice?: { __typename?: 'Money', amount?: number | null } | null, currentCost?: { __typename?: 'Money', amount?: number | null } | null, outstandingCost?: { __typename?: 'Money', amount?: number | null } | null, returnedCost?: { __typename?: 'Money', amount?: number | null } | null } | null };

export type BroadcastCostsPartsFragment = { __typename?: 'BroadcastCosts', finalCost?: { __typename?: 'Money', amount?: number | null } | null, potentialTotalCost?: { __typename?: 'Money', amount?: number | null } | null, messagePrice?: { __typename?: 'Money', amount?: number | null } | null, currentCost?: { __typename?: 'Money', amount?: number | null } | null, outstandingCost?: { __typename?: 'Money', amount?: number | null } | null, returnedCost?: { __typename?: 'Money', amount?: number | null } | null };

export type BroadcastStatsPartsFragment = { __typename?: 'BroadcastStats', expired?: number | null, fulfilled?: number | null, pending?: number | null, rejected?: number | null, total?: number | null, pollResponses?: Array<{ __typename?: 'PollResponse', count: number, pollOption: { __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', text: string } } | null> | null };

export type BroadcastArchiveMutationVariables = Exact<{
  broadcastId: Scalars['ID']['input'];
}>;


export type BroadcastArchiveMutation = { __typename?: 'RootMutationType', broadcastArchive: { __typename?: 'BroadcastResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Broadcast', id: string, broadcastArchivedAt?: string | null, broadcastEnd?: string | null, broadcastName: string, broadcastPublishedAt?: string | null, broadcastStart?: string | null, insertedAt: string, status: BroadcastStatus, updatedAt: string, isPersistent: boolean, broadcastTarget: { __typename?: 'BroadcastTarget', allFollowers: boolean, radiusKm?: number | null, usePrimaryLocation?: boolean | null }, followUpMessageTemplate?: { __typename?: 'MessageTemplate', name?: string | null, body?: string | null, type: MessageType, price?: { __typename?: 'Money', amount?: number | null } | null, redemptionOffers?: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null } | null> | null, primaryAttachment?: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> } | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null> | null } | null, messageTemplate?: { __typename?: 'MessageTemplate', name?: string | null, body?: string | null, type: MessageType, price?: { __typename?: 'Money', amount?: number | null } | null, redemptionOffers?: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null } | null> | null, primaryAttachment?: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> } | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null> | null } | null, costs?: { __typename?: 'BroadcastCosts', finalCost?: { __typename?: 'Money', amount?: number | null } | null, potentialTotalCost?: { __typename?: 'Money', amount?: number | null } | null, messagePrice?: { __typename?: 'Money', amount?: number | null } | null, currentCost?: { __typename?: 'Money', amount?: number | null } | null, outstandingCost?: { __typename?: 'Money', amount?: number | null } | null, returnedCost?: { __typename?: 'Money', amount?: number | null } | null } | null, followUpMessageCosts?: { __typename?: 'BroadcastCosts', finalCost?: { __typename?: 'Money', amount?: number | null } | null, potentialTotalCost?: { __typename?: 'Money', amount?: number | null } | null, messagePrice?: { __typename?: 'Money', amount?: number | null } | null, currentCost?: { __typename?: 'Money', amount?: number | null } | null, outstandingCost?: { __typename?: 'Money', amount?: number | null } | null, returnedCost?: { __typename?: 'Money', amount?: number | null } | null } | null } | null } };

export type BroadcastUnarchiveMutationVariables = Exact<{
  broadcastId: Scalars['ID']['input'];
}>;


export type BroadcastUnarchiveMutation = { __typename?: 'RootMutationType', broadcastUnarchive: { __typename?: 'BroadcastResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Broadcast', id: string, broadcastArchivedAt?: string | null, broadcastEnd?: string | null, broadcastName: string, broadcastPublishedAt?: string | null, broadcastStart?: string | null, insertedAt: string, status: BroadcastStatus, updatedAt: string, isPersistent: boolean, broadcastTarget: { __typename?: 'BroadcastTarget', allFollowers: boolean, radiusKm?: number | null, usePrimaryLocation?: boolean | null }, followUpMessageTemplate?: { __typename?: 'MessageTemplate', name?: string | null, body?: string | null, type: MessageType, price?: { __typename?: 'Money', amount?: number | null } | null, redemptionOffers?: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null } | null> | null, primaryAttachment?: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> } | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null> | null } | null, messageTemplate?: { __typename?: 'MessageTemplate', name?: string | null, body?: string | null, type: MessageType, price?: { __typename?: 'Money', amount?: number | null } | null, redemptionOffers?: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null } | null> | null, primaryAttachment?: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> } | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null> | null } | null, costs?: { __typename?: 'BroadcastCosts', finalCost?: { __typename?: 'Money', amount?: number | null } | null, potentialTotalCost?: { __typename?: 'Money', amount?: number | null } | null, messagePrice?: { __typename?: 'Money', amount?: number | null } | null, currentCost?: { __typename?: 'Money', amount?: number | null } | null, outstandingCost?: { __typename?: 'Money', amount?: number | null } | null, returnedCost?: { __typename?: 'Money', amount?: number | null } | null } | null, followUpMessageCosts?: { __typename?: 'BroadcastCosts', finalCost?: { __typename?: 'Money', amount?: number | null } | null, potentialTotalCost?: { __typename?: 'Money', amount?: number | null } | null, messagePrice?: { __typename?: 'Money', amount?: number | null } | null, currentCost?: { __typename?: 'Money', amount?: number | null } | null, outstandingCost?: { __typename?: 'Money', amount?: number | null } | null, returnedCost?: { __typename?: 'Money', amount?: number | null } | null } | null } | null } };

export type BroadcastCreateMutationVariables = Exact<{
  broadcast: BroadcastInput;
}>;


export type BroadcastCreateMutation = { __typename?: 'RootMutationType', broadcastCreate: { __typename?: 'BroadcastResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Broadcast', id: string, broadcastArchivedAt?: string | null, broadcastEnd?: string | null, broadcastName: string, broadcastPublishedAt?: string | null, broadcastStart?: string | null, insertedAt: string, status: BroadcastStatus, updatedAt: string, isPersistent: boolean, broadcastTarget: { __typename?: 'BroadcastTarget', allFollowers: boolean, radiusKm?: number | null, usePrimaryLocation?: boolean | null }, followUpMessageTemplate?: { __typename?: 'MessageTemplate', name?: string | null, body?: string | null, type: MessageType, price?: { __typename?: 'Money', amount?: number | null } | null, redemptionOffers?: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null } | null> | null, primaryAttachment?: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> } | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null> | null } | null, messageTemplate?: { __typename?: 'MessageTemplate', name?: string | null, body?: string | null, type: MessageType, price?: { __typename?: 'Money', amount?: number | null } | null, redemptionOffers?: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null } | null> | null, primaryAttachment?: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> } | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null> | null } | null, costs?: { __typename?: 'BroadcastCosts', finalCost?: { __typename?: 'Money', amount?: number | null } | null, potentialTotalCost?: { __typename?: 'Money', amount?: number | null } | null, messagePrice?: { __typename?: 'Money', amount?: number | null } | null, currentCost?: { __typename?: 'Money', amount?: number | null } | null, outstandingCost?: { __typename?: 'Money', amount?: number | null } | null, returnedCost?: { __typename?: 'Money', amount?: number | null } | null } | null, followUpMessageCosts?: { __typename?: 'BroadcastCosts', finalCost?: { __typename?: 'Money', amount?: number | null } | null, potentialTotalCost?: { __typename?: 'Money', amount?: number | null } | null, messagePrice?: { __typename?: 'Money', amount?: number | null } | null, currentCost?: { __typename?: 'Money', amount?: number | null } | null, outstandingCost?: { __typename?: 'Money', amount?: number | null } | null, returnedCost?: { __typename?: 'Money', amount?: number | null } | null } | null } | null } };

export type BroadcastPublishMutationVariables = Exact<{
  broadcastId: Scalars['ID']['input'];
}>;


export type BroadcastPublishMutation = { __typename?: 'RootMutationType', broadcastPublish: { __typename?: 'BroadcastResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Broadcast', id: string, broadcastArchivedAt?: string | null, broadcastEnd?: string | null, broadcastName: string, broadcastPublishedAt?: string | null, broadcastStart?: string | null, insertedAt: string, status: BroadcastStatus, updatedAt: string, isPersistent: boolean, broadcastTarget: { __typename?: 'BroadcastTarget', allFollowers: boolean, radiusKm?: number | null, usePrimaryLocation?: boolean | null }, followUpMessageTemplate?: { __typename?: 'MessageTemplate', name?: string | null, body?: string | null, type: MessageType, price?: { __typename?: 'Money', amount?: number | null } | null, redemptionOffers?: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null } | null> | null, primaryAttachment?: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> } | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null> | null } | null, messageTemplate?: { __typename?: 'MessageTemplate', name?: string | null, body?: string | null, type: MessageType, price?: { __typename?: 'Money', amount?: number | null } | null, redemptionOffers?: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null } | null> | null, primaryAttachment?: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> } | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null> | null } | null, costs?: { __typename?: 'BroadcastCosts', finalCost?: { __typename?: 'Money', amount?: number | null } | null, potentialTotalCost?: { __typename?: 'Money', amount?: number | null } | null, messagePrice?: { __typename?: 'Money', amount?: number | null } | null, currentCost?: { __typename?: 'Money', amount?: number | null } | null, outstandingCost?: { __typename?: 'Money', amount?: number | null } | null, returnedCost?: { __typename?: 'Money', amount?: number | null } | null } | null, followUpMessageCosts?: { __typename?: 'BroadcastCosts', finalCost?: { __typename?: 'Money', amount?: number | null } | null, potentialTotalCost?: { __typename?: 'Money', amount?: number | null } | null, messagePrice?: { __typename?: 'Money', amount?: number | null } | null, currentCost?: { __typename?: 'Money', amount?: number | null } | null, outstandingCost?: { __typename?: 'Money', amount?: number | null } | null, returnedCost?: { __typename?: 'Money', amount?: number | null } | null } | null } | null } };

export type BroadcastUpdateMutationVariables = Exact<{
  broadcast: BroadcastInput;
  broadcastId: Scalars['ID']['input'];
}>;


export type BroadcastUpdateMutation = { __typename?: 'RootMutationType', broadcastUpdate: { __typename?: 'BroadcastResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Broadcast', id: string, broadcastArchivedAt?: string | null, broadcastEnd?: string | null, broadcastName: string, broadcastPublishedAt?: string | null, broadcastStart?: string | null, insertedAt: string, status: BroadcastStatus, updatedAt: string, isPersistent: boolean, broadcastTarget: { __typename?: 'BroadcastTarget', allFollowers: boolean, radiusKm?: number | null, usePrimaryLocation?: boolean | null }, followUpMessageTemplate?: { __typename?: 'MessageTemplate', name?: string | null, body?: string | null, type: MessageType, price?: { __typename?: 'Money', amount?: number | null } | null, redemptionOffers?: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null } | null> | null, primaryAttachment?: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> } | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null> | null } | null, messageTemplate?: { __typename?: 'MessageTemplate', name?: string | null, body?: string | null, type: MessageType, price?: { __typename?: 'Money', amount?: number | null } | null, redemptionOffers?: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null } | null> | null, primaryAttachment?: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> } | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null> | null } | null, costs?: { __typename?: 'BroadcastCosts', finalCost?: { __typename?: 'Money', amount?: number | null } | null, potentialTotalCost?: { __typename?: 'Money', amount?: number | null } | null, messagePrice?: { __typename?: 'Money', amount?: number | null } | null, currentCost?: { __typename?: 'Money', amount?: number | null } | null, outstandingCost?: { __typename?: 'Money', amount?: number | null } | null, returnedCost?: { __typename?: 'Money', amount?: number | null } | null } | null, followUpMessageCosts?: { __typename?: 'BroadcastCosts', finalCost?: { __typename?: 'Money', amount?: number | null } | null, potentialTotalCost?: { __typename?: 'Money', amount?: number | null } | null, messagePrice?: { __typename?: 'Money', amount?: number | null } | null, currentCost?: { __typename?: 'Money', amount?: number | null } | null, outstandingCost?: { __typename?: 'Money', amount?: number | null } | null, returnedCost?: { __typename?: 'Money', amount?: number | null } | null } | null } | null } };

export type BroadcastsQueryVariables = Exact<{
  query?: InputMaybe<BroadcastPageInput>;
}>;


export type BroadcastsQuery = { __typename?: 'RootQueryType', broadcasts: { __typename?: 'BroadcastPage', data: Array<{ __typename?: 'Broadcast', id: string, broadcastArchivedAt?: string | null, broadcastEnd?: string | null, broadcastName: string, broadcastPublishedAt?: string | null, broadcastStart?: string | null, insertedAt: string, status: BroadcastStatus, updatedAt: string, isPersistent: boolean, stats?: { __typename?: 'BroadcastStats', expired?: number | null, fulfilled?: number | null, pending?: number | null, rejected?: number | null, total?: number | null, pollResponses?: Array<{ __typename?: 'PollResponse', count: number, pollOption: { __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', text: string } } | null> | null } | null, followUpMessageStats?: { __typename?: 'BroadcastStats', expired?: number | null, fulfilled?: number | null, pending?: number | null, rejected?: number | null, total?: number | null, pollResponses?: Array<{ __typename?: 'PollResponse', count: number, pollOption: { __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', text: string } } | null> | null } | null, broadcastTarget: { __typename?: 'BroadcastTarget', allFollowers: boolean, radiusKm?: number | null, usePrimaryLocation?: boolean | null }, followUpMessageTemplate?: { __typename?: 'MessageTemplate', name?: string | null, body?: string | null, type: MessageType, price?: { __typename?: 'Money', amount?: number | null } | null, redemptionOffers?: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null } | null> | null, primaryAttachment?: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> } | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null> | null } | null, messageTemplate?: { __typename?: 'MessageTemplate', name?: string | null, body?: string | null, type: MessageType, price?: { __typename?: 'Money', amount?: number | null } | null, redemptionOffers?: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null } | null> | null, primaryAttachment?: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> } | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null> | null } | null, costs?: { __typename?: 'BroadcastCosts', finalCost?: { __typename?: 'Money', amount?: number | null } | null, potentialTotalCost?: { __typename?: 'Money', amount?: number | null } | null, messagePrice?: { __typename?: 'Money', amount?: number | null } | null, currentCost?: { __typename?: 'Money', amount?: number | null } | null, outstandingCost?: { __typename?: 'Money', amount?: number | null } | null, returnedCost?: { __typename?: 'Money', amount?: number | null } | null } | null, followUpMessageCosts?: { __typename?: 'BroadcastCosts', finalCost?: { __typename?: 'Money', amount?: number | null } | null, potentialTotalCost?: { __typename?: 'Money', amount?: number | null } | null, messagePrice?: { __typename?: 'Money', amount?: number | null } | null, currentCost?: { __typename?: 'Money', amount?: number | null } | null, outstandingCost?: { __typename?: 'Money', amount?: number | null } | null, returnedCost?: { __typename?: 'Money', amount?: number | null } | null } | null }>, page?: { __typename?: 'BasePage', currentOffset?: number | null, currentPage?: number | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, nextOffset?: number | null, nextPage?: number | null, pageSize?: number | null, previousOffset?: number | null, previousPage?: number | null, startCursor?: string | null, totalCount?: number | null, totalPages?: number | null } | null, query?: { __typename?: 'BroadcastQuery', filters?: Array<{ __typename?: 'BroadcastFilters', attribute: BroadcastQueryAttributes, op: PageFilterOp, value: { __typename?: 'PageFilterValues', boolean?: boolean | null, float?: number | null, floats?: Array<number | null> | null, integer?: number | null, integers?: Array<number | null> | null, string?: string | null, strings?: Array<string | null> | null } }> | null } | null } };

export type BroadcastTargetsQueryVariables = Exact<{
  query?: InputMaybe<TargetedMemberPageInput>;
}>;


export type BroadcastTargetsQuery = { __typename?: 'RootQueryType', broadcastTargets: { __typename?: 'TargetedMemberPage', data: Array<{ __typename?: 'TargetedMember', member: { __typename?: 'MemberProfile', id: string, displayName: string, fullName: string, photoUrl: string, photoUrlSrcset: string } }>, page?: { __typename?: 'BasePage', totalCount?: number | null } | null } };

export type ChallengesOverviewQueryVariables = Exact<{
  lookback?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChallengesOverviewQuery = { __typename?: 'RootQueryType', challengeAnswerCounts: { __typename?: 'Challenge', progress: { __typename?: 'ChallengeProgress', state?: { __typename?: 'ProgressFallback' } | { __typename?: 'ProgressTriviaAnswerCounts', completedCorrectMilestones?: Array<number> | null, completedIncorrectMilestones?: Array<number> | null, correct?: number | null, incorrect?: number | null, milestones?: Array<number> | null, total?: number | null } | { __typename?: 'ProgressTriviaAnswerStreaks' } | null } }, challengeAnswerStreaks: { __typename?: 'Challenge', progress: { __typename?: 'ChallengeProgress', state?: { __typename?: 'ProgressFallback' } | { __typename?: 'ProgressTriviaAnswerCounts' } | { __typename?: 'ProgressTriviaAnswerStreaks', overallStreak?: number | null, goal?: number | null, recordStreak?: number | null, moreThanSevenDaysReward?: number | null, moreThanFourteenDaysReward?: number | null, lastResponseAt?: string | null, dailyStatus: Array<{ __typename?: 'TriviaDailyStatus', day?: string | null, status?: DailyStatus | null } | null> } | null } } };

export type AnswerStreakShieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type AnswerStreakShieldsQuery = { __typename?: 'RootQueryType', amountOfAvailableStreakRepairs: number, answerStreakRepairPrice: { __typename?: 'Money', amount?: number | null, currency?: string | null } };

export type PurchaseStreakShieldMutationVariables = Exact<{ [key: string]: never; }>;


export type PurchaseStreakShieldMutation = { __typename?: 'RootMutationType', purchaseAnswerStreakRepair: { __typename?: 'AnswerStreakRepair', amountInCents: { __typename?: 'Money', amount?: number | null, currency?: string | null } } };

export type MilestonesEventSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type MilestonesEventSubscription = { __typename?: 'RootSubscriptionType', challengeEvents?: { __typename?: 'AnswerStreakUpdatedEvent' } | { __typename?: 'CorrectMilestoneReachedEvent', milestone?: number | null, swayCashEarned?: number | null } | { __typename?: 'IncorrectMilestoneReachedEvent' } | null };

export type ChallengesEventSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ChallengesEventSubscription = { __typename?: 'RootSubscriptionType', challengeEvents?: { __typename?: 'AnswerStreakUpdatedEvent', status?: AnswerStreakStatus | null } | { __typename?: 'CorrectMilestoneReachedEvent' } | { __typename?: 'IncorrectMilestoneReachedEvent' } | null };

export type FollowCommunityMutationVariables = Exact<{
  communityId: Scalars['ID']['input'];
}>;


export type FollowCommunityMutation = { __typename?: 'RootMutationType', follow: { __typename?: 'FollowResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'ConversationPreview', id: string, type: ConversationType, unreadMessageCount?: number | null, messagePreview?: { __typename?: 'Message', id: string, sentBySway: boolean, body: string, insertedAt: string, type?: MessageType | null, attachments: Array<{ __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, thumbnail?: { __typename?: 'SignedUrl', url: string } | null, thumbnailSrcSet?: { __typename?: 'SignedUrl', url: string } | null, fullSize?: { __typename?: 'SignedUrl', url: string } | null, fullSizeSrcSet?: { __typename?: 'SignedUrl', url: string } | null, thumbnailAnimated?: { __typename?: 'SignedUrl', url: string } | null, original?: { __typename?: 'SignedUrl', url: string } | null, storyboard?: { __typename?: 'SignedUrl', url: string } | null }>, author: { __typename?: 'Profile', id: string, communityName?: string | null, firstName?: string | null, lastName?: string | null, profilePictureUrl: string }, emojiReactions?: Array<{ __typename?: 'EmojiReaction', id: string, reactedAt: string, reaction: string, reactorProfileId: string } | null> | null, interactions: Array<{ __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, options: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null>, pollResults?: { __typename?: 'PollResults', totalResponseCount?: number | null, pollOptionResults?: Array<{ __typename?: 'PollOptionResult', pollOption: { __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } } | null> | null } | null, userAnswer?: { __typename?: 'Message' } | { __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', id: string, order?: number | null, text: string, type: PollOptionType } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, redemption: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }>, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null }>, transaction?: { __typename?: 'MessageTransaction', id: string, status: MessageTransactionStatus, expiresAt: string, price: { __typename?: 'Money', amount?: number | null }, earningPotential: { __typename?: 'Money', amount?: number | null } } | null } | null, partnerProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, earningEnabled: boolean, firstName?: string | null, introduction?: string | null, lastName?: string | null, profilePhotoUrl: string, profilePictureUrl: string, profileType: ProfileType, timezone?: string | null, unclaimed: boolean, verified: boolean, isNonProfit: boolean, blocks: Array<{ __typename?: 'Block', id: string, insertedAt: string, blockingProfile: { __typename?: 'Profile', id: string }, blockedProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, firstName?: string | null, lastName?: string | null, profilePictureUrl: string, profileType: ProfileType, verified: boolean } }>, pricing: { __typename?: 'Pricing', replyPrice?: { __typename?: 'Money', amount?: number | null } | null }, profileLinks: Array<{ __typename?: 'ProfileLink', id?: string | null, title?: string | null, url?: string | null }>, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, linkedVendor?: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string } | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }> } } | null } };

export type RegisterVendorMutationVariables = Exact<{
  communityName: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  acceptedTerms: Scalars['Boolean']['input'];
  acquisitionSource: Scalars['String']['input'];
}>;


export type RegisterVendorMutation = { __typename?: 'RootMutationType', registerVendor: { __typename?: 'BasicResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Result', message: string } | null } };

export type VendorQueryVariables = Exact<{
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type VendorQuery = { __typename?: 'RootQueryType', vendor: { __typename?: 'PublicVendor', bio?: string | null, displayName: string, id: string, name: string, photoUrl: string, photoUrlSrcset: string, referralLink: string, verified: boolean, blockStatus: BlockStatus, unclaimed: boolean, isNonProfit: boolean, profileLinks: Array<{ __typename?: 'ProfileLink', id?: string | null, title?: string | null, url?: string | null }>, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, description: string, name: string, isNonProfit: boolean, redeemCount: number, saved?: boolean | null, vendor: { __typename?: 'PublicVendor', id: string, name: string, photoUrl: string }, price: { __typename?: 'Money', amount?: number | null }, limits?: { __typename?: 'RedemptionLimits', limits?: Array<{ __typename?: 'RedemptionLimitCount', limit: number, limitScope: RedemptionLimitScope, blocking?: boolean | null, count?: number | null, description: string, limitType: RedemptionLimitType } | { __typename?: 'RedemptionLimitRate', limit: number, limitScope: RedemptionLimitScope, blocking?: boolean | null, count?: number | null, description: string, endOfDay?: boolean | null, interval: number, limitType: RedemptionLimitType, unit: RedemptionLimitUnit }> | null } | null, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, linkedVendor?: { __typename?: 'PublicVendor', id: string, displayName: string, photoUrl: string, name: string } | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, proxy?: { __typename?: 'SignedUrl', url: string } | null, proxySrcSet?: { __typename?: 'SignedUrl', url: string } | null } | null }>, followRecord?: { __typename?: 'FollowRecord', conversationId?: string | null, memberId: string, vendorId: string } | null } };

export type CommunitiesDiscoveryQueryVariables = Exact<{
  query?: InputMaybe<CommunityDiscoveryPageInput>;
  currentLocation?: InputMaybe<GeoPointInput>;
}>;


export type CommunitiesDiscoveryQuery = { __typename?: 'RootQueryType', discoverCommunities?: { __typename?: 'CommunityDiscoveryPage', data: Array<{ __typename?: 'CommunityDiscovery', vendor: { __typename?: 'PublicVendor', id: string, name: string, displayName: string, photoUrl: string, unclaimed: boolean, isNonProfit: boolean }, followRecord?: { __typename?: 'FollowRecord', conversationId?: string | null } | null }>, page?: { __typename?: 'BasePage', currentOffset?: number | null, currentPage?: number | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, nextOffset?: number | null, nextPage?: number | null, pageSize?: number | null, previousOffset?: number | null, previousPage?: number | null, startCursor?: string | null, totalCount?: number | null, totalPages?: number | null } | null, query?: { __typename?: 'CommunityDiscoveryQuery', filters?: Array<{ __typename?: 'CommunityDiscoveryFilters', attribute: CommunityDiscoveryQueryAttributes, op: PageFilterOp, value: { __typename?: 'PageFilterValues', boolean?: boolean | null, float?: number | null, floats?: Array<number | null> | null, integer?: number | null, integers?: Array<number | null> | null, string?: string | null, strings?: Array<string | null> | null } }> | null } | null } | null };

export type LookupMemberQueryVariables = Exact<{
  displayName?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type LookupMemberQuery = { __typename?: 'RootQueryType', lookupMember: { __typename?: 'MemberProfile', deactivatedAt?: string | null, displayName: string, fullName: string, id: string, photoUrl: string, photoUrlSrcset: string, blockStatus: BlockStatus, followRecord?: { __typename?: 'FollowRecord', conversationId?: string | null, memberId: string, vendorId: string } | null } };

export type FeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type FeaturesQuery = { __typename?: 'RootQueryType', features: Array<{ __typename?: 'FeatureFlag', enabled?: boolean | null, name: string } | null> };

export type FeedMessagePreviewMediaPointerFragment = { __typename?: 'MediaPointer', id: string, mediaType: MediaType, mimeType: string, name: string, thumbnail?: { __typename?: 'SignedUrl', url: string } | null };

type FeedInteractionPoll_InteractionClick_Fragment = { __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionPoll_InteractionPoll_Fragment = { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, mimeType: string, name: string, thumbnail?: { __typename?: 'SignedUrl', url: string } | null } | null, pollMessage?: { __typename?: 'Message', body: string, conversationId?: string | null, author: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, profilePictureUrl: string } } | null, options: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null>, pollResults?: { __typename?: 'PollResults', totalResponseCount?: number | null, pollOptionResults?: Array<{ __typename?: 'PollOptionResult', pollOption: { __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } } | null> | null } | null, userAnswer?: { __typename?: 'Message' } | { __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', id: string, order?: number | null, text: string, type: PollOptionType } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionPoll_InteractionRedemption_Fragment = { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionPoll_InteractionRedemptionOffer_Fragment = { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionPoll_InteractionReply_Fragment = { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

export type FeedInteractionPollFragment = FeedInteractionPoll_InteractionClick_Fragment | FeedInteractionPoll_InteractionPoll_Fragment | FeedInteractionPoll_InteractionRedemption_Fragment | FeedInteractionPoll_InteractionRedemptionOffer_Fragment | FeedInteractionPoll_InteractionReply_Fragment;

type FeedInteractionReply_InteractionClick_Fragment = { __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionReply_InteractionPoll_Fragment = { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionReply_InteractionRedemption_Fragment = { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionReply_InteractionRedemptionOffer_Fragment = { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionReply_InteractionReply_Fragment = { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, mimeType: string, name: string, thumbnail?: { __typename?: 'SignedUrl', url: string } | null } | null, replyMessage: { __typename?: 'Message', body: string, attachments: Array<{ __typename?: 'MediaPointer', id: string, mediaType: MediaType, mimeType: string, name: string, thumbnail?: { __typename?: 'SignedUrl', url: string } | null }>, author: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, profilePictureUrl: string } }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

export type FeedInteractionReplyFragment = FeedInteractionReply_InteractionClick_Fragment | FeedInteractionReply_InteractionPoll_Fragment | FeedInteractionReply_InteractionRedemption_Fragment | FeedInteractionReply_InteractionRedemptionOffer_Fragment | FeedInteractionReply_InteractionReply_Fragment;

type FeedInteractionClick_InteractionClick_Fragment = { __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, mimeType: string, name: string, thumbnail?: { __typename?: 'SignedUrl', url: string } | null } | null, clickMessage: { __typename?: 'Message', body: string, attachments: Array<{ __typename?: 'MediaPointer', id: string, mediaType: MediaType, mimeType: string, name: string, thumbnail?: { __typename?: 'SignedUrl', url: string } | null }>, author: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, profilePictureUrl: string } }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionClick_InteractionPoll_Fragment = { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionClick_InteractionRedemption_Fragment = { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionClick_InteractionRedemptionOffer_Fragment = { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionClick_InteractionReply_Fragment = { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

export type FeedInteractionClickFragment = FeedInteractionClick_InteractionClick_Fragment | FeedInteractionClick_InteractionPoll_Fragment | FeedInteractionClick_InteractionRedemption_Fragment | FeedInteractionClick_InteractionRedemptionOffer_Fragment | FeedInteractionClick_InteractionReply_Fragment;

type FeedInteractionRedemption_InteractionClick_Fragment = { __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionRedemption_InteractionPoll_Fragment = { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionRedemption_InteractionRedemption_Fragment = { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, redemptionMessage?: { __typename?: 'Message', body: string, attachments: Array<{ __typename?: 'MediaPointer', id: string, mediaType: MediaType, mimeType: string, name: string, thumbnail?: { __typename?: 'SignedUrl', url: string } | null }>, author: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, profilePictureUrl: string } } | null, redemption: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionRedemption_InteractionRedemptionOffer_Fragment = { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionRedemption_InteractionReply_Fragment = { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

export type FeedInteractionRedemptionFragment = FeedInteractionRedemption_InteractionClick_Fragment | FeedInteractionRedemption_InteractionPoll_Fragment | FeedInteractionRedemption_InteractionRedemption_Fragment | FeedInteractionRedemption_InteractionRedemptionOffer_Fragment | FeedInteractionRedemption_InteractionReply_Fragment;

type FeedInteractionRedemptionOffer_InteractionClick_Fragment = { __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionRedemptionOffer_InteractionPoll_Fragment = { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionRedemptionOffer_InteractionRedemption_Fragment = { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, redemptionOfferMessage?: { __typename?: 'Message', body: string, attachments: Array<{ __typename?: 'MediaPointer', id: string, mediaType: MediaType, mimeType: string, name: string, thumbnail?: { __typename?: 'SignedUrl', url: string } | null }>, author: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, profilePictureUrl: string } } | null, redemption: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionRedemptionOffer_InteractionRedemptionOffer_Fragment = { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type FeedInteractionRedemptionOffer_InteractionReply_Fragment = { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

export type FeedInteractionRedemptionOfferFragment = FeedInteractionRedemptionOffer_InteractionClick_Fragment | FeedInteractionRedemptionOffer_InteractionPoll_Fragment | FeedInteractionRedemptionOffer_InteractionRedemption_Fragment | FeedInteractionRedemptionOffer_InteractionRedemptionOffer_Fragment | FeedInteractionRedemptionOffer_InteractionReply_Fragment;

export type FeedItemSeenMutationVariables = Exact<{
  feedItemSeenId: Scalars['ID']['input'];
  deltaMs: Scalars['Int']['input'];
}>;


export type FeedItemSeenMutation = { __typename?: 'RootMutationType', feedItemSeen: { __typename?: 'BasicResult', successful: boolean, result?: { __typename?: 'Result', message: string } | null } };

export type FeedSetGeoPointMutationVariables = Exact<{
  geoPoint?: InputMaybe<GeoPointInput>;
}>;


export type FeedSetGeoPointMutation = { __typename?: 'RootMutationType', feedSetGeoPoint: { __typename?: 'BasicResult', successful: boolean, result?: { __typename?: 'Result', message: string } | null } };

export type FeedInteractionItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FeedInteractionItemQuery = { __typename?: 'RootQueryType', oneInteraction: { __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } };

export type FeedQueryVariables = Exact<{ [key: string]: never; }>;


export type FeedQuery = { __typename?: 'RootQueryType', feed: { __typename?: 'Feed', id: string, key: string, name: string } };

export type FeedItemsQueryVariables = Exact<{
  afterId?: InputMaybe<Scalars['ID']['input']>;
  excludeSeenBefore?: InputMaybe<Scalars['DateTime']['input']>;
  geoPoint?: InputMaybe<GeoPointInput>;
  includeAfterItemInFeed?: InputMaybe<Scalars['Boolean']['input']>;
  includeSeen?: InputMaybe<Scalars['Boolean']['input']>;
  maxItems?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FeedItemsQuery = { __typename?: 'RootQueryType', feedItems: Array<{ __typename?: 'FeedItemInteraction', seenAt?: string | null, id: string, feedInstanceId?: string | null, addedAt: string, deltaMs?: number | null, interactions: Array<{ __typename?: 'InteractionClick', id: string, interactionType: InteractionType } | { __typename?: 'InteractionPoll', id: string, interactionType: InteractionType } | { __typename?: 'InteractionRedemption', id: string, interactionType: InteractionType } | { __typename?: 'InteractionRedemptionOffer', id: string, interactionType: InteractionType } | { __typename?: 'InteractionReply', id: string, interactionType: InteractionType }> } | { __typename?: 'FeedItemNotification', seenAt?: string | null, id: string, feedInstanceId?: string | null, addedAt: string, deltaMs?: number | null, notification: { __typename?: 'FeedNotification', body: string, title: string, type: FeedNotificationType, payload?: { __typename?: 'DonationGoalReachedPayload', redemptionId: string } | { __typename?: 'DonationSummaryPayload', profileId: string, startDate: string, endDate: string, totalSwayCashDonated: number, topPercentage: number } | { __typename?: 'GenericNotificationPayload', topIcon?: string | null, title: string, subtitle?: string | null, body: string, badgeText?: string | null, badgeColor?: string | null, actionText?: string | null, actionUrl?: string | null, actionButtonColor?: string | null, backgroundColor?: string | null } | { __typename?: 'LastStreakRepairUsedPayload', usedAt: string } | { __typename?: 'LeaderboardEarningSummaryPayload', startDate: string, endDate: string, swayCash: { __typename?: 'Money', amount?: number | null }, updatedBalance: { __typename?: 'Money', amount?: number | null }, leaderboardEntry: { __typename?: 'SwayCashLeaderboardRecord', displayName: string, firstName: string, lastName: string, profileId: string, rank: number, rowNumber?: number | null, overallStreak?: number | null, swayCash: { __typename?: 'Money', amount?: number | null } }, topLeaderboardEntries?: Array<{ __typename?: 'SwayCashLeaderboardRecord', displayName: string, firstName: string, lastName: string, profileId: string, rank: number, rowNumber?: number | null, overallStreak?: number | null, swayCash: { __typename?: 'Money', amount?: number | null } }> | null } | { __typename?: 'LeaderboardNonWinnerPayload', position: number, startDate: string, endDate: string, swayCash: { __typename?: 'Money', amount?: number | null }, marginToWinner: { __typename?: 'Money', amount?: number | null } } | { __typename?: 'LeaderboardWinnerPayload', nonWinnerCount: number, startDate: string, endDate: string, swayCash: { __typename?: 'Money', amount?: number | null }, winnerMargin: { __typename?: 'Money', amount?: number | null } } | { __typename?: 'ReferredAccountVerifiedPayload', referredName: string, referredId: string, swayCash: { __typename?: 'Money', amount?: number | null } } | null } } | { __typename?: 'FeedItemOnboardingItem', id: string, feedInstanceId?: string | null, addedAt: string, deltaMs?: number | null, seenAt?: string | null, onboardingItem: { __typename?: 'OnboardingItem', type: OnboardingItemType } } | { __typename?: 'FeedItemPersistentBroadcastSuggestion', id: string, feedInstanceId?: string | null, addedAt: string, deltaMs?: number | null, seenAt?: string | null, interaction?: { __typename?: 'InteractionClick', id: string, interactionType: InteractionType } | { __typename?: 'InteractionPoll', id: string, interactionType: InteractionType } | { __typename?: 'InteractionRedemption', id: string, interactionType: InteractionType } | { __typename?: 'InteractionRedemptionOffer', id: string, interactionType: InteractionType } | { __typename?: 'InteractionReply', id: string, interactionType: InteractionType } | null } | { __typename?: 'FeedItemPoll', id: string, feedInstanceId?: string | null, addedAt: string, deltaMs?: number | null, seenAt?: string | null, pollSuggestion: { __typename?: 'PollSuggestion', interactionId: string } } | { __typename?: 'FeedItemRedemptionSuggestion', id: string, feedInstanceId?: string | null, addedAt: string, deltaMs?: number | null, seenAt?: string | null, redemptionSuggestion: { __typename?: 'RedemptionSuggestion', redemptionId: string } } | { __typename?: 'FeedItemSessionSummary', id: string, feedInstanceId?: string | null, addedAt: string, deltaMs?: number | null, seenAt?: string | null } | { __typename?: 'FeedItemUnclaimedVendorSuggestion', id: string, feedInstanceId?: string | null, addedAt: string, deltaMs?: number | null, seenAt?: string | null, unclaimedVendorSuggestion: { __typename?: 'UnclaimedVendorSuggestion', vendorsIds: Array<string> } } | { __typename?: 'FeedItemVendorSuggestion', id: string, feedInstanceId?: string | null, addedAt: string, deltaMs?: number | null, seenAt?: string | null, vendorSuggestion: { __typename?: 'VendorSuggestion', vendorId: string } }> };

export type FeedGetSingleInteractionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type FeedGetSingleInteractionQuery = { __typename?: 'RootQueryType', oneInteraction: { __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, mimeType: string, name: string, thumbnail?: { __typename?: 'SignedUrl', url: string } | null } | null, clickMessage: { __typename?: 'Message', body: string, attachments: Array<{ __typename?: 'MediaPointer', id: string, mediaType: MediaType, mimeType: string, name: string, thumbnail?: { __typename?: 'SignedUrl', url: string } | null }>, author: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, profilePictureUrl: string } }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, mimeType: string, name: string, thumbnail?: { __typename?: 'SignedUrl', url: string } | null } | null, pollMessage?: { __typename?: 'Message', body: string, conversationId?: string | null, author: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, profilePictureUrl: string } } | null, options: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null>, pollResults?: { __typename?: 'PollResults', totalResponseCount?: number | null, pollOptionResults?: Array<{ __typename?: 'PollOptionResult', pollOption: { __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } } | null> | null } | null, userAnswer?: { __typename?: 'Message' } | { __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', id: string, order?: number | null, text: string, type: PollOptionType } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, redemptionMessage?: { __typename?: 'Message', body: string, attachments: Array<{ __typename?: 'MediaPointer', id: string, mediaType: MediaType, mimeType: string, name: string, thumbnail?: { __typename?: 'SignedUrl', url: string } | null }>, author: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, profilePictureUrl: string } } | null, redemption: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, mimeType: string, name: string, thumbnail?: { __typename?: 'SignedUrl', url: string } | null } | null, replyMessage: { __typename?: 'Message', body: string, attachments: Array<{ __typename?: 'MediaPointer', id: string, mediaType: MediaType, mimeType: string, name: string, thumbnail?: { __typename?: 'SignedUrl', url: string } | null }>, author: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, profilePictureUrl: string } }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } };

export type FeedGetSingleRedemptionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  evaluate?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type FeedGetSingleRedemptionQuery = { __typename?: 'RootQueryType', getRedemption?: { __typename?: 'Redemption', id: string, description: string, name: string, isNonProfit: boolean, referralLink: string, isSweepstakes: boolean, validEnd?: string | null, saved?: boolean | null, limits?: { __typename?: 'RedemptionLimits', canRedeem?: boolean | null, limits?: Array<{ __typename?: 'RedemptionLimitCount', blocking?: boolean | null, count?: number | null, description: string, id: string, limit: number, limitScope: RedemptionLimitScope, limitType: RedemptionLimitType } | { __typename?: 'RedemptionLimitRate', blocking?: boolean | null, count?: number | null, description: string, endOfDay?: boolean | null, id: string, interval: number, limit: number, limitScope: RedemptionLimitScope, limitType: RedemptionLimitType, unit: RedemptionLimitUnit }> | null } | null, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, linkedVendor?: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string } | null, location?: { __typename?: 'GeoPoint', lat: number, lng: number } | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', filesizeInBytes: number, id: string, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrl?: { __typename?: 'SignedUrl', url: string } | null, downloadUrls: Array<{ __typename?: 'SignedUrl', key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', id: string, displayName: string, photoUrl: string, photoUrlSrcset: string, name: string } } | null };

export type FeedGetSingleVendorQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type FeedGetSingleVendorQuery = { __typename?: 'RootQueryType', vendor: { __typename?: 'PublicVendor', displayName: string, id: string, name: string, photoUrl: string, referralLink: string, verified: boolean, blockStatus: BlockStatus, bio?: string | null, unclaimed: boolean, isNonProfit: boolean, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, validEnd?: string | null, description: string, name: string, isNonProfit: boolean, redeemCount: number, saved?: boolean | null, vendor: { __typename?: 'PublicVendor', id: string, name: string, photoUrl: string }, price: { __typename?: 'Money', amount?: number | null }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, linkedVendor?: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string } | null, limits?: { __typename?: 'RedemptionLimits', limits?: Array<{ __typename?: 'RedemptionLimitCount', blocking?: boolean | null, count?: number | null, description: string, limit: number, limitScope: RedemptionLimitScope, limitType: RedemptionLimitType } | { __typename?: 'RedemptionLimitRate', blocking?: boolean | null, count?: number | null, description: string, endOfDay?: boolean | null, interval: number, limit: number, limitScope: RedemptionLimitScope, limitType: RedemptionLimitType, unit: RedemptionLimitUnit }> | null } | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, proxy?: { __typename?: 'SignedUrl', url: string } | null, proxySrcSet?: { __typename?: 'SignedUrl', url: string } | null } | null }>, followRecord?: { __typename?: 'FollowRecord', conversationId?: string | null, memberId: string, vendorId: string } | null } };

export type FeedGetVendorsQueryVariables = Exact<{
  query?: InputMaybe<CommunityDiscoveryPageInput>;
}>;


export type FeedGetVendorsQuery = { __typename?: 'RootQueryType', discoverCommunities?: { __typename?: 'CommunityDiscoveryPage', data: Array<{ __typename?: 'CommunityDiscovery', vendor: { __typename?: 'PublicVendor', id: string, name: string, displayName: string } }>, query?: { __typename?: 'CommunityDiscoveryQuery', filters?: Array<{ __typename?: 'CommunityDiscoveryFilters', attribute: CommunityDiscoveryQueryAttributes, op: PageFilterOp, value: { __typename?: 'PageFilterValues', boolean?: boolean | null, float?: number | null, floats?: Array<number | null> | null, integer?: number | null, integers?: Array<number | null> | null, string?: string | null, strings?: Array<string | null> | null } }> | null } | null } | null };

export type FeedGetSinglePollQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  encoding: SignedUrlKey;
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type FeedGetSinglePollQuery = { __typename?: 'RootQueryType', oneInteraction: { __typename?: 'InteractionClick', interactionType: InteractionType } | { __typename?: 'InteractionPoll', bonusText?: string | null, caption?: string | null, consolationPrice?: number | null, expiresAt?: string | null, id: string, question?: string | null, status: InteractionStatus, pollId?: string | null, pollType?: PollType | null, interactionType: InteractionType, creator?: { __typename?: 'PublicVendor', name: string, displayName: string, photoUrl: string, photoUrlSrcset: string } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null, userAnswer?: { __typename?: 'Message' } | { __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', correct?: boolean | null, id: string, text: string, type: PollOptionType } | null, options: Array<{ __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', correct?: boolean | null, id: string, order?: number | null, text: string, type: PollOptionType } | null>, pollResults?: { __typename?: 'PollResults', totalResponseCount?: number | null, pollOptionResults?: Array<{ __typename?: 'PollOptionResult', responseCount?: number | null, responsePct?: number | null, pollOption: { __typename?: 'PollMediaOption', id: string } | { __typename?: 'PollTextOption', id: string } } | null> | null } | null, primaryMedia?: { __typename?: 'MediaPointer', mediaType: MediaType, downloadUrl?: { __typename?: 'SignedUrl', url: string } | null } | null } | { __typename?: 'InteractionRedemption', interactionType: InteractionType } | { __typename?: 'InteractionRedemptionOffer', interactionType: InteractionType } | { __typename?: 'InteractionReply', interactionType: InteractionType } };

export type SessionSummaryCardQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SessionSummaryCardQuery = { __typename?: 'RootQueryType', feedSession?: { __typename?: 'FeedSession', date: string, id: string, pollsAnswered: number, swayCashEarned: number, triviaCorrect: number, triviaIncorrect: number } | null, challengeAnswerStreaks: { __typename?: 'Challenge', progress: { __typename?: 'ChallengeProgress', state?: { __typename?: 'ProgressFallback' } | { __typename?: 'ProgressTriviaAnswerCounts' } | { __typename?: 'ProgressTriviaAnswerStreaks', overallStreak?: number | null } | null } }, challengeAnswerCounts: { __typename?: 'Challenge', progress: { __typename?: 'ChallengeProgress', state?: { __typename?: 'ProgressFallback' } | { __typename?: 'ProgressTriviaAnswerCounts', correct?: number | null, completedCorrectMilestones?: Array<number> | null, milestones?: Array<number> | null } | { __typename?: 'ProgressTriviaAnswerStreaks' } | null } } };

export type PagePartsFragment = { __typename?: 'BasePage', currentOffset?: number | null, currentPage?: number | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, nextOffset?: number | null, nextPage?: number | null, pageSize?: number | null, previousOffset?: number | null, previousPage?: number | null, startCursor?: string | null, totalCount?: number | null, totalPages?: number | null };

export type PageFilterPartsFragment = { __typename?: 'PageFilterValues', boolean?: boolean | null, float?: number | null, floats?: Array<number | null> | null, integer?: number | null, integers?: Array<number | null> | null, string?: string | null, strings?: Array<string | null> | null };

export type ValidationMessagePartsFragment = { __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null };

export type InteractionResultPartsFragment = { __typename?: 'InteractionResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, options: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null>, pollResults?: { __typename?: 'PollResults', totalResponseCount?: number | null, pollOptionResults?: Array<{ __typename?: 'PollOptionResult', pollOption: { __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } } | null> | null } | null, userAnswer?: { __typename?: 'Message' } | { __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', id: string, order?: number | null, text: string, type: PollOptionType } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, redemption: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }>, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | null };

type InteractionParts_InteractionClick_Fragment = { __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type InteractionParts_InteractionPoll_Fragment = { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, options: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null>, pollResults?: { __typename?: 'PollResults', totalResponseCount?: number | null, pollOptionResults?: Array<{ __typename?: 'PollOptionResult', pollOption: { __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } } | null> | null } | null, userAnswer?: { __typename?: 'Message' } | { __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', id: string, order?: number | null, text: string, type: PollOptionType } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type InteractionParts_InteractionRedemption_Fragment = { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, redemption: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type InteractionParts_InteractionRedemptionOffer_Fragment = { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }>, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

type InteractionParts_InteractionReply_Fragment = { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null };

export type InteractionPartsFragment = InteractionParts_InteractionClick_Fragment | InteractionParts_InteractionPoll_Fragment | InteractionParts_InteractionRedemption_Fragment | InteractionParts_InteractionRedemptionOffer_Fragment | InteractionParts_InteractionReply_Fragment;

type PollOptionParts_PollMediaOption_Fragment = { __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType };

type PollOptionParts_PollTextOption_Fragment = { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType };

export type PollOptionPartsFragment = PollOptionParts_PollMediaOption_Fragment | PollOptionParts_PollTextOption_Fragment;

export type InteractionClickMutationVariables = Exact<{
  interactionId: Scalars['ID']['input'];
}>;


export type InteractionClickMutation = { __typename?: 'RootMutationType', interactionClick: { __typename?: 'InteractionResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, options: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null>, pollResults?: { __typename?: 'PollResults', totalResponseCount?: number | null, pollOptionResults?: Array<{ __typename?: 'PollOptionResult', pollOption: { __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } } | null> | null } | null, userAnswer?: { __typename?: 'Message' } | { __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', id: string, order?: number | null, text: string, type: PollOptionType } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, redemption: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }>, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | null } };

export type InteractionReplyMutationVariables = Exact<{
  body: Scalars['String']['input'];
  interactionId: Scalars['ID']['input'];
}>;


export type InteractionReplyMutation = { __typename?: 'RootMutationType', interactionReply: { __typename?: 'InteractionResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, options: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null>, pollResults?: { __typename?: 'PollResults', totalResponseCount?: number | null, pollOptionResults?: Array<{ __typename?: 'PollOptionResult', pollOption: { __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } } | null> | null } | null, userAnswer?: { __typename?: 'Message' } | { __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', id: string, order?: number | null, text: string, type: PollOptionType } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, redemption: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }>, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | null } };

export type InteractionRespondToPollMutationVariables = Exact<{
  pollId: Scalars['ID']['input'];
  pollOptionId: Scalars['ID']['input'];
}>;


export type InteractionRespondToPollMutation = { __typename?: 'RootMutationType', interactionRespondToPoll: { __typename?: 'InteractionResult', successful: boolean, result?: { __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, pollResults?: { __typename?: 'PollResults', totalResponseCount?: number | null, pollOptionResults?: Array<{ __typename?: 'PollOptionResult', responseCount?: number | null, responsePct?: number | null, pollOption: { __typename?: 'PollMediaOption', id: string, correct?: boolean | null, type: PollOptionType, order?: number | null } | { __typename?: 'PollTextOption', text: string, id: string, correct?: boolean | null, type: PollOptionType, order?: number | null } } | null> | null } | null, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, options: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null>, userAnswer?: { __typename?: 'Message' } | { __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', id: string, order?: number | null, text: string, type: PollOptionType } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, redemption: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }>, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, followUpInteraction?: { __typename?: 'InteractionClick', id: string } | { __typename?: 'InteractionPoll', id: string } | { __typename?: 'InteractionRedemption', id: string } | { __typename?: 'InteractionRedemptionOffer', id: string } | { __typename?: 'InteractionReply', id: string } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | null, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null } };

export type SwayCashLeaderboardPartsFragment = { __typename?: 'SwayCashLeaderboardRecord', displayName: string, firstName: string, lastName: string, profileId: string, rank: number, rowNumber?: number | null, overallStreak?: number | null, swayCash: { __typename?: 'Money', amount?: number | null } };

export type TriviaLeaderboardPartsFragment = { __typename?: 'TriviaLeaderboardRecord', correctCount: number, displayName: string, firstName: string, incorrectCount: number, lastCorrectAt?: string | null, lastName: string, profileId: string, rank: number, rowNumber?: number | null };

export type SwayCashLeaderboardQueryVariables = Exact<{
  top?: InputMaybe<Scalars['Int']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  padding?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  weeksBack?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SwayCashLeaderboardQuery = { __typename?: 'RootQueryType', swayCashLeaderboard: { __typename?: 'SwayCashLeaderboard', totalCount: number, oldestLeaderboardDate?: string | null, earningsFor?: { __typename?: 'SwayCashLeaderboardRecord', displayName: string, firstName: string, lastName: string, profileId: string, rank: number, rowNumber?: number | null, overallStreak?: number | null, swayCash: { __typename?: 'Money', amount?: number | null } } | null, positionFor?: Array<{ __typename?: 'SwayCashLeaderboardRecord', displayName: string, firstName: string, lastName: string, profileId: string, rank: number, rowNumber?: number | null, overallStreak?: number | null, swayCash: { __typename?: 'Money', amount?: number | null } }> | null, top: Array<{ __typename?: 'SwayCashLeaderboardRecord', displayName: string, firstName: string, lastName: string, profileId: string, rank: number, rowNumber?: number | null, overallStreak?: number | null, swayCash: { __typename?: 'Money', amount?: number | null } }> } };

export type TriviaLeaderboardQueryVariables = Exact<{
  top?: InputMaybe<Scalars['Int']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  padding?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  weeksBack?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TriviaLeaderboardQuery = { __typename?: 'RootQueryType', triviaLeaderboard: { __typename?: 'TriviaLeaderboard', totalCount: number, oldestLeaderboardDate?: string | null, top: Array<{ __typename?: 'TriviaLeaderboardRecord', correctCount: number, displayName: string, firstName: string, incorrectCount: number, lastCorrectAt?: string | null, lastName: string, profileId: string, rank: number, rowNumber?: number | null }>, answersFor?: { __typename?: 'TriviaLeaderboardRecord', correctCount: number, displayName: string, firstName: string, incorrectCount: number, lastCorrectAt?: string | null, lastName: string, profileId: string, rank: number, rowNumber?: number | null } | null, positionFor?: Array<{ __typename?: 'TriviaLeaderboardRecord', correctCount: number, displayName: string, firstName: string, incorrectCount: number, lastCorrectAt?: string | null, lastName: string, profileId: string, rank: number, rowNumber?: number | null }> | null } };

export type LinkPartsFragment = { __typename?: 'Link', id: string, disabledAt?: string | null, insertedAt: string, internal: boolean, name?: string | null, shortCode?: string | null, trackingCode?: string | null, updatedAt: string, uri: string, creator: { __typename?: 'Profile', id: string }, redirectProfile?: { __typename?: 'Profile', id: string, displayName: string, profilePhotoUrl: string, profilePhotoUrlSrcset: string } | null, redirectRedemption?: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, name: string, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, proxy?: { __typename?: 'SignedUrl', url: string } | null, proxySrcSet?: { __typename?: 'SignedUrl', url: string } | null } | null } | null };

export type ActivityPartsFragment = { __typename?: 'Link', activity?: { __typename?: 'LinkActivity', granularity?: AnalyticsInterval | null, lookbackInterval?: number | null, lookbackUnit?: AnalyticsInterval | null, total?: number | null, data?: Array<{ __typename?: 'AnalyticsGroup', count: number, interval: string }> | null } | null };

export type LinkAssociateMutationVariables = Exact<{
  link: LinkInput;
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type LinkAssociateMutation = { __typename?: 'RootMutationType', linkAssociate: { __typename?: 'LinkResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Link', id: string, disabledAt?: string | null, insertedAt: string, internal: boolean, name?: string | null, shortCode?: string | null, trackingCode?: string | null, updatedAt: string, uri: string, creator: { __typename?: 'Profile', id: string }, redirectProfile?: { __typename?: 'Profile', id: string, displayName: string, profilePhotoUrl: string, profilePhotoUrlSrcset: string } | null, redirectRedemption?: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, name: string, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, proxy?: { __typename?: 'SignedUrl', url: string } | null, proxySrcSet?: { __typename?: 'SignedUrl', url: string } | null } | null } | null } | null } };

export type LinkCreateMutationVariables = Exact<{
  link: LinkCreateInput;
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type LinkCreateMutation = { __typename?: 'RootMutationType', linkCreate: { __typename?: 'LinkResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Link', id: string, disabledAt?: string | null, insertedAt: string, internal: boolean, name?: string | null, shortCode?: string | null, trackingCode?: string | null, updatedAt: string, uri: string, creator: { __typename?: 'Profile', id: string }, redirectProfile?: { __typename?: 'Profile', id: string, displayName: string, profilePhotoUrl: string, profilePhotoUrlSrcset: string } | null, redirectRedemption?: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, name: string, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, proxy?: { __typename?: 'SignedUrl', url: string } | null, proxySrcSet?: { __typename?: 'SignedUrl', url: string } | null } | null } | null } | null } };

export type LinkGetSingleQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type LinkGetSingleQuery = { __typename?: 'RootQueryType', linkGet?: { __typename?: 'Link', id: string, disabledAt?: string | null, insertedAt: string, internal: boolean, name?: string | null, shortCode?: string | null, trackingCode?: string | null, updatedAt: string, uri: string, creator: { __typename?: 'Profile', id: string }, redirectProfile?: { __typename?: 'Profile', id: string, displayName: string, profilePhotoUrl: string, profilePhotoUrlSrcset: string } | null, redirectRedemption?: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, name: string, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, proxy?: { __typename?: 'SignedUrl', url: string } | null, proxySrcSet?: { __typename?: 'SignedUrl', url: string } | null } | null } | null, activity?: { __typename?: 'LinkActivity', granularity?: AnalyticsInterval | null, lookbackInterval?: number | null, lookbackUnit?: AnalyticsInterval | null, total?: number | null, data?: Array<{ __typename?: 'AnalyticsGroup', count: number, interval: string }> | null } | null } | null };

export type LinksGetMultipleQueryVariables = Exact<{
  query?: InputMaybe<LinkPageInput>;
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type LinksGetMultipleQuery = { __typename?: 'RootQueryType', linksGet?: { __typename?: 'LinkPage', data: Array<{ __typename?: 'Link', id: string, disabledAt?: string | null, insertedAt: string, internal: boolean, name?: string | null, shortCode?: string | null, trackingCode?: string | null, updatedAt: string, uri: string, creator: { __typename?: 'Profile', id: string }, redirectProfile?: { __typename?: 'Profile', id: string, displayName: string, profilePhotoUrl: string, profilePhotoUrlSrcset: string } | null, redirectRedemption?: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, name: string, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, proxy?: { __typename?: 'SignedUrl', url: string } | null, proxySrcSet?: { __typename?: 'SignedUrl', url: string } | null } | null } | null, activity?: { __typename?: 'LinkActivity', granularity?: AnalyticsInterval | null, lookbackInterval?: number | null, lookbackUnit?: AnalyticsInterval | null, total?: number | null, data?: Array<{ __typename?: 'AnalyticsGroup', count: number, interval: string }> | null } | null }>, page?: { __typename?: 'BasePage', currentOffset?: number | null, currentPage?: number | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, nextOffset?: number | null, nextPage?: number | null, pageSize?: number | null, previousOffset?: number | null, previousPage?: number | null, startCursor?: string | null, totalCount?: number | null, totalPages?: number | null } | null } | null };

export type MagicLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type MagicLinkQuery = { __typename?: 'RootQueryType', magicLink: { __typename?: 'AccessToken', validForSeconds?: number | null, validUntil?: string | null, value?: string | null } };

export type MediaPointerPartsFragment = { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> };

export type MediaPointerProxyPartsFragment = { __typename?: 'MediaPointer', proxy?: { __typename?: 'SignedUrl', url: string } | null };

export type MediaPointerProxySrcSetPartsFragment = { __typename?: 'MediaPointer', proxySrcSet?: { __typename?: 'SignedUrl', url: string } | null };

export type SignedUrlPartsFragment = { __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string };

export type SignedUploadUrlPartsFragment = { __typename?: 'SignedUrl', key: SignedUrlKey, mediaPointerId: string, metadata?: string | null, url: string };

export type UploadMediaMutationVariables = Exact<{
  broadcastId?: InputMaybe<Scalars['ID']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  filesizeInBytes: Scalars['Int']['input'];
  mediaType: MediaType;
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  profileId?: InputMaybe<Scalars['ID']['input']>;
  redemptionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UploadMediaMutation = { __typename?: 'RootMutationType', uploadMedia: { __typename?: 'MediaUploadResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'MediaUpload', mediaPointer: { __typename?: 'MediaPointer', id: string }, uploadUrls: Array<{ __typename?: 'SignedUrl', key: SignedUrlKey, mediaPointerId: string, metadata?: string | null, url: string }> } | null } };

export type SetMediaPointerStatusMutationVariables = Exact<{
  mediaPointerId: Scalars['ID']['input'];
  status: MediaPointerStatus;
}>;


export type SetMediaPointerStatusMutation = { __typename?: 'RootMutationType', setMediaPointerStatus: { __typename?: 'MediaPointer', id: string } };

export type MediaPointerQueryVariables = Exact<{
  mediaPointerId: Scalars['ID']['input'];
  optsOriginal?: InputMaybe<Array<MediaOption> | MediaOption>;
  opts9by16?: InputMaybe<Array<MediaOption> | MediaOption>;
  opts1by1?: InputMaybe<Array<MediaOption> | MediaOption>;
  opts5by3?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type MediaPointerQuery = { __typename?: 'RootQueryType', mediaPointer: { __typename?: 'MediaPointer', id: string, name: string, status: MediaPointerStatus, mediaType: MediaType, original?: { __typename?: 'SignedUrl', url: string } | null, nine_by_sixteen?: { __typename?: 'SignedUrl', url: string } | null, one_by_one?: { __typename?: 'SignedUrl', url: string } | null, five_by_three?: { __typename?: 'SignedUrl', url: string } | null } };

export type UploadMediaEventSubscriptionVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type UploadMediaEventSubscription = { __typename?: 'RootSubscriptionType', conversationEvent?: { __typename?: 'BlockEvent' } | { __typename?: 'ConversationEvent' } | { __typename: 'MediaEvent', mediaType: MediaEventType, mediaPointer: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, thumbnail?: { __typename?: 'SignedUrl', url: string } | null, thumbnailSrcSet?: { __typename?: 'SignedUrl', url: string } | null, fullSize?: { __typename?: 'SignedUrl', url: string } | null, fullSizeSrcSet?: { __typename?: 'SignedUrl', url: string } | null, thumbnailAnimated?: { __typename?: 'SignedUrl', url: string } | null, original?: { __typename?: 'SignedUrl', url: string } | null, storyboard?: { __typename?: 'SignedUrl', url: string } | null } } | { __typename?: 'MessageEvent' } | { __typename?: 'ParticipantSettingsEvent' } | { __typename?: 'TypingEvent' } | null };

export type RegisterMemberMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  acceptedTerms: Scalars['Boolean']['input'];
  acquisitionSource: Scalars['String']['input'];
  communityId?: InputMaybe<Scalars['ID']['input']>;
  redemptionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RegisterMemberMutation = { __typename?: 'RootMutationType', registerMember: { __typename?: 'BasicResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Result', message: string } | null } };

export type EarnerOnboardingMutationVariables = Exact<{
  complete: Scalars['Boolean']['input'];
}>;


export type EarnerOnboardingMutation = { __typename?: 'RootMutationType', earnerOnboarding: { __typename?: 'User', earnerOnboardingLastSeen?: string | null } };

export type MemberReferralPageQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberReferralPageQuery = { __typename?: 'RootQueryType', memberReferral?: { __typename?: 'MemberReferral', referralLink: { __typename?: 'Link', name?: string | null, uri: string, activity?: { __typename?: 'LinkActivity', granularity?: AnalyticsInterval | null, lookbackInterval?: number | null, lookbackUnit?: AnalyticsInterval | null, total?: number | null, data?: Array<{ __typename?: 'AnalyticsGroup', count: number, interval: string }> | null } | null }, referralStats: { __typename?: 'ReferralStats', referralCount: number, earnings: { __typename?: 'Money', amount?: number | null } }, activity?: { __typename?: 'LinkActivity', granularity?: AnalyticsInterval | null, lookbackInterval?: number | null, lookbackUnit?: AnalyticsInterval | null, total?: number | null, data?: Array<{ __typename?: 'AnalyticsGroup', count: number, interval: string }> | null } | null } | null };

export type MessagePartsFragment = { __typename?: 'Message', id: string, sentBySway: boolean, body: string, insertedAt: string, type?: MessageType | null, attachments: Array<{ __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, thumbnail?: { __typename?: 'SignedUrl', url: string } | null, thumbnailSrcSet?: { __typename?: 'SignedUrl', url: string } | null, fullSize?: { __typename?: 'SignedUrl', url: string } | null, fullSizeSrcSet?: { __typename?: 'SignedUrl', url: string } | null, thumbnailAnimated?: { __typename?: 'SignedUrl', url: string } | null, original?: { __typename?: 'SignedUrl', url: string } | null, storyboard?: { __typename?: 'SignedUrl', url: string } | null }>, author: { __typename?: 'Profile', id: string, communityName?: string | null, firstName?: string | null, lastName?: string | null, profilePictureUrl: string }, emojiReactions?: Array<{ __typename?: 'EmojiReaction', id: string, reactedAt: string, reaction: string, reactorProfileId: string } | null> | null, interactions: Array<{ __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, options: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null>, pollResults?: { __typename?: 'PollResults', totalResponseCount?: number | null, pollOptionResults?: Array<{ __typename?: 'PollOptionResult', pollOption: { __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } } | null> | null } | null, userAnswer?: { __typename?: 'Message' } | { __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', id: string, order?: number | null, text: string, type: PollOptionType } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, redemption: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }>, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null }>, transaction?: { __typename?: 'MessageTransaction', id: string, status: MessageTransactionStatus, expiresAt: string, price: { __typename?: 'Money', amount?: number | null }, earningPotential: { __typename?: 'Money', amount?: number | null } } | null };

export type MessagePreviewMediaPointerPartsFragment = { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, thumbnail?: { __typename?: 'SignedUrl', url: string } | null, thumbnailSrcSet?: { __typename?: 'SignedUrl', url: string } | null, fullSize?: { __typename?: 'SignedUrl', url: string } | null, fullSizeSrcSet?: { __typename?: 'SignedUrl', url: string } | null, thumbnailAnimated?: { __typename?: 'SignedUrl', url: string } | null, original?: { __typename?: 'SignedUrl', url: string } | null, storyboard?: { __typename?: 'SignedUrl', url: string } | null };

export type MessageTemplatePartsFragment = { __typename?: 'MessageTemplate', name?: string | null, body?: string | null, type: MessageType, price?: { __typename?: 'Money', amount?: number | null } | null, redemptionOffers?: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null } | null> | null, primaryAttachment?: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> } | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null> | null };

export type EmojiReactionPartsFragment = { __typename?: 'EmojiReaction', id: string, reactedAt: string, reaction: string, reactorProfileId: string };

export type TransactionPartsFragment = { __typename?: 'MessageTransaction', id: string, status: MessageTransactionStatus, expiresAt: string, price: { __typename?: 'Money', amount?: number | null }, earningPotential: { __typename?: 'Money', amount?: number | null } };

export type ViewMessageMutationVariables = Exact<{
  messageId: Scalars['ID']['input'];
}>;


export type ViewMessageMutation = { __typename?: 'RootMutationType', viewMessage?: { __typename?: 'Message', id: string, transaction?: { __typename?: 'MessageTransaction', id: string, status: MessageTransactionStatus } | null } | null };

export type SendMessageMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
  body: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  mediaPointerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  type: MessageType;
}>;


export type SendMessageMutation = { __typename?: 'RootMutationType', sendMessage: { __typename?: 'Message', id: string, sentBySway: boolean, body: string, insertedAt: string, type?: MessageType | null, attachments: Array<{ __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, thumbnail?: { __typename?: 'SignedUrl', url: string } | null, thumbnailSrcSet?: { __typename?: 'SignedUrl', url: string } | null, fullSize?: { __typename?: 'SignedUrl', url: string } | null, fullSizeSrcSet?: { __typename?: 'SignedUrl', url: string } | null, thumbnailAnimated?: { __typename?: 'SignedUrl', url: string } | null, original?: { __typename?: 'SignedUrl', url: string } | null, storyboard?: { __typename?: 'SignedUrl', url: string } | null }>, author: { __typename?: 'Profile', id: string, communityName?: string | null, firstName?: string | null, lastName?: string | null, profilePictureUrl: string }, emojiReactions?: Array<{ __typename?: 'EmojiReaction', id: string, reactedAt: string, reaction: string, reactorProfileId: string } | null> | null, interactions: Array<{ __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, options: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null>, pollResults?: { __typename?: 'PollResults', totalResponseCount?: number | null, pollOptionResults?: Array<{ __typename?: 'PollOptionResult', pollOption: { __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } } | null> | null } | null, userAnswer?: { __typename?: 'Message' } | { __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', id: string, order?: number | null, text: string, type: PollOptionType } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, redemption: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }>, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null }>, transaction?: { __typename?: 'MessageTransaction', id: string, status: MessageTransactionStatus, expiresAt: string, price: { __typename?: 'Money', amount?: number | null }, earningPotential: { __typename?: 'Money', amount?: number | null } } | null } };

export type ReportContentMutationVariables = Exact<{
  reportMessageOther?: InputMaybe<Scalars['String']['input']>;
  reportReasons: Array<ContentReportReasons> | ContentReportReasons;
  targetId: Scalars['ID']['input'];
  targetType: ContentReportTarget;
}>;


export type ReportContentMutation = { __typename?: 'RootMutationType', reportContent: string };

export type AddReactionMutationVariables = Exact<{
  messageId: Scalars['ID']['input'];
  reaction: Scalars['String']['input'];
}>;


export type AddReactionMutation = { __typename?: 'RootMutationType', addReaction: { __typename?: 'Message', id: string, sentBySway: boolean, body: string, insertedAt: string, type?: MessageType | null, attachments: Array<{ __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, thumbnail?: { __typename?: 'SignedUrl', url: string } | null, thumbnailSrcSet?: { __typename?: 'SignedUrl', url: string } | null, fullSize?: { __typename?: 'SignedUrl', url: string } | null, fullSizeSrcSet?: { __typename?: 'SignedUrl', url: string } | null, thumbnailAnimated?: { __typename?: 'SignedUrl', url: string } | null, original?: { __typename?: 'SignedUrl', url: string } | null, storyboard?: { __typename?: 'SignedUrl', url: string } | null }>, author: { __typename?: 'Profile', id: string, communityName?: string | null, firstName?: string | null, lastName?: string | null, profilePictureUrl: string }, emojiReactions?: Array<{ __typename?: 'EmojiReaction', id: string, reactedAt: string, reaction: string, reactorProfileId: string } | null> | null, interactions: Array<{ __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, options: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null>, pollResults?: { __typename?: 'PollResults', totalResponseCount?: number | null, pollOptionResults?: Array<{ __typename?: 'PollOptionResult', pollOption: { __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } } | null> | null } | null, userAnswer?: { __typename?: 'Message' } | { __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', id: string, order?: number | null, text: string, type: PollOptionType } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, redemption: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }>, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null }>, transaction?: { __typename?: 'MessageTransaction', id: string, status: MessageTransactionStatus, expiresAt: string, price: { __typename?: 'Money', amount?: number | null }, earningPotential: { __typename?: 'Money', amount?: number | null } } | null } };

export type DeleteReactionMutationVariables = Exact<{
  emojiReactionId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
}>;


export type DeleteReactionMutation = { __typename?: 'RootMutationType', deleteReaction: { __typename?: 'Message', id: string, sentBySway: boolean, body: string, insertedAt: string, type?: MessageType | null, attachments: Array<{ __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, thumbnail?: { __typename?: 'SignedUrl', url: string } | null, thumbnailSrcSet?: { __typename?: 'SignedUrl', url: string } | null, fullSize?: { __typename?: 'SignedUrl', url: string } | null, fullSizeSrcSet?: { __typename?: 'SignedUrl', url: string } | null, thumbnailAnimated?: { __typename?: 'SignedUrl', url: string } | null, original?: { __typename?: 'SignedUrl', url: string } | null, storyboard?: { __typename?: 'SignedUrl', url: string } | null }>, author: { __typename?: 'Profile', id: string, communityName?: string | null, firstName?: string | null, lastName?: string | null, profilePictureUrl: string }, emojiReactions?: Array<{ __typename?: 'EmojiReaction', id: string, reactedAt: string, reaction: string, reactorProfileId: string } | null> | null, interactions: Array<{ __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, options: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null>, pollResults?: { __typename?: 'PollResults', totalResponseCount?: number | null, pollOptionResults?: Array<{ __typename?: 'PollOptionResult', pollOption: { __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } } | null> | null } | null, userAnswer?: { __typename?: 'Message' } | { __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', id: string, order?: number | null, text: string, type: PollOptionType } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, redemption: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }>, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null }>, transaction?: { __typename?: 'MessageTransaction', id: string, status: MessageTransactionStatus, expiresAt: string, price: { __typename?: 'Money', amount?: number | null }, earningPotential: { __typename?: 'Money', amount?: number | null } } | null } };

export type MessageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MessageQuery = { __typename?: 'RootQueryType', message: { __typename?: 'Message', id: string, sentBySway: boolean, body: string, insertedAt: string, type?: MessageType | null, attachments: Array<{ __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, thumbnail?: { __typename?: 'SignedUrl', url: string } | null, thumbnailSrcSet?: { __typename?: 'SignedUrl', url: string } | null, fullSize?: { __typename?: 'SignedUrl', url: string } | null, fullSizeSrcSet?: { __typename?: 'SignedUrl', url: string } | null, thumbnailAnimated?: { __typename?: 'SignedUrl', url: string } | null, original?: { __typename?: 'SignedUrl', url: string } | null, storyboard?: { __typename?: 'SignedUrl', url: string } | null }>, author: { __typename?: 'Profile', id: string, communityName?: string | null, firstName?: string | null, lastName?: string | null, profilePictureUrl: string }, emojiReactions?: Array<{ __typename?: 'EmojiReaction', id: string, reactedAt: string, reaction: string, reactorProfileId: string } | null> | null, interactions: Array<{ __typename?: 'InteractionClick', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionPoll', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, options: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } | null>, pollResults?: { __typename?: 'PollResults', totalResponseCount?: number | null, pollOptionResults?: Array<{ __typename?: 'PollOptionResult', pollOption: { __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType } | { __typename?: 'PollTextOption', text: string, id: string, order?: number | null, type: PollOptionType } } | null> | null } | null, userAnswer?: { __typename?: 'Message' } | { __typename?: 'PollMediaOption' } | { __typename?: 'PollTextOption', id: string, order?: number | null, text: string, type: PollOptionType } | null, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemption', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, redemption: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionRedemptionOffer', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, downloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, price: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }>, earningPotential?: { __typename?: 'Money', amount?: number | null } | null } | { __typename?: 'InteractionReply', id: string, ctaDetails?: string | null, ctaTitle?: string | null, expiresAt?: string | null, interactionType: InteractionType, status: InteractionStatus, earningPotential?: { __typename?: 'Money', amount?: number | null } | null }>, transaction?: { __typename?: 'MessageTransaction', id: string, status: MessageTransactionStatus, expiresAt: string, price: { __typename?: 'Money', amount?: number | null }, earningPotential: { __typename?: 'Money', amount?: number | null } } | null } };

export type NotificationPreferencesPartsFragment = { __typename?: 'NotificationPreferences', channels: Array<{ __typename?: 'ChannelPreference', id: string, description: string, enabled: boolean, type: string, title?: string | null } | null>, workflows: Array<{ __typename?: 'WorkflowPreference', id: string, description: string, enabled: boolean, key: string, profileTypes?: Array<ProfileType | null> | null, title?: string | null, channelPreferences: Array<{ __typename?: 'ChannelPreference', id: string, description: string, enabled: boolean, type: string } | null> } | null> };

export type SmsPendingVerificationPartsFragment = { __typename?: 'SmsPendingVerification', message?: string | null, smsPhoneNumber?: string | null };

export type ChannelPreferencePartsFragment = { __typename?: 'ChannelPreference', id: string, description: string, enabled: boolean, title?: string | null, type: string };

export type WorkflowPreferencePartsFragment = { __typename?: 'WorkflowPreference', id: string, description: string, enabled: boolean, key: string, profileTypes?: Array<ProfileType | null> | null, title?: string | null, channelPreferences: Array<{ __typename?: 'ChannelPreference', id: string, description: string, enabled: boolean, title?: string | null, type: string } | null> };

export type SetNotificationPreferencesMutationVariables = Exact<{
  np: NotificationPreferencesInput;
}>;


export type SetNotificationPreferencesMutation = { __typename?: 'RootMutationType', setNotificationPreferences: { __typename?: 'NotificationPreferences', channels: Array<{ __typename?: 'ChannelPreference', id: string, enabled: boolean, type: string } | null>, workflows: Array<{ __typename?: 'WorkflowPreference', id: string, enabled: boolean, key: string, channelPreferences: Array<{ __typename?: 'ChannelPreference', id: string, enabled: boolean, type: string } | null> } | null> } };

export type SmsRemoveMutationVariables = Exact<{ [key: string]: never; }>;


export type SmsRemoveMutation = { __typename?: 'RootMutationType', smsRemove: { __typename?: 'SmsUserResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'SmsUser', message: string } | null } };

export type SmsVerificationCancelMutationVariables = Exact<{ [key: string]: never; }>;


export type SmsVerificationCancelMutation = { __typename?: 'RootMutationType', smsVerificationCancel: { __typename?: 'SmsPendingVerificationResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'SmsPendingVerification', message?: string | null } | null } };

export type SmsVerificationInitiateMutationVariables = Exact<{
  smsPhoneNumber: Scalars['String']['input'];
}>;


export type SmsVerificationInitiateMutation = { __typename?: 'RootMutationType', smsVerificationInitiate: { __typename?: 'SmsPendingVerificationResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'SmsPendingVerification', message?: string | null, smsPhoneNumber?: string | null } | null } };

export type SmsVerificationVerifyMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type SmsVerificationVerifyMutation = { __typename?: 'RootMutationType', smsVerificationVerify: { __typename?: 'SmsUserResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'SmsUser', message: string, user: { __typename?: 'User', id?: string | null, acceptedTerms: boolean, adminDeactivatedAt?: string | null, anonymizedAt?: string | null, confirmedAt?: string | null, deactivatedAt?: string | null, earnerOnboardingLastSeen?: string | null, email?: string | null, smsLast4?: string | null, blocks: Array<{ __typename?: 'Block', id: string, insertedAt: string, blockingProfile: { __typename?: 'Profile', id: string }, blockedProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, firstName?: string | null, lastName?: string | null, profilePictureUrl: string, profileType: ProfileType, verified: boolean } }>, lastTosAccepted?: { __typename?: 'TosAccepted', id: string, insertedAt: string, version: { __typename?: 'TosVersion', id: string, version: string, requireUserAcceptance: boolean, insertedAt: string }, user: { __typename?: 'User', id?: string | null, acceptedTerms: boolean } } | null, profile?: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, earningEnabled: boolean, firstName?: string | null, introduction?: string | null, lastName?: string | null, profilePhotoUrl: string, profilePictureUrl: string, profileType: ProfileType, timezone?: string | null, unclaimed: boolean, verified: boolean, isNonProfit: boolean, blocks: Array<{ __typename?: 'Block', id: string, insertedAt: string, blockingProfile: { __typename?: 'Profile', id: string }, blockedProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, firstName?: string | null, lastName?: string | null, profilePictureUrl: string, profileType: ProfileType, verified: boolean } }>, pricing: { __typename?: 'Pricing', replyPrice?: { __typename?: 'Money', amount?: number | null } | null }, profileLinks: Array<{ __typename?: 'ProfileLink', id?: string | null, title?: string | null, url?: string | null }>, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, linkedVendor?: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string } | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }> } | null, userRoles?: Array<{ __typename?: 'UserRole', roleName: RoleName } | null> | null } } | null } };

export type SetDefaultNotificationPreferencesForMobileMutationVariables = Exact<{ [key: string]: never; }>;


export type SetDefaultNotificationPreferencesForMobileMutation = { __typename?: 'RootMutationType', setDefaultNotificationPreferencesForMobile: { __typename?: 'NotificationPreferences', channels: Array<{ __typename?: 'ChannelPreference', description: string, enabled: boolean, id: string, title?: string | null, type: string } | null>, workflows: Array<{ __typename?: 'WorkflowPreference', description: string, enabled: boolean, id: string, key: string, profileTypes?: Array<ProfileType | null> | null, title?: string | null, channelPreferences: Array<{ __typename?: 'ChannelPreference', description: string, enabled: boolean, id: string, title?: string | null, type: string } | null> } | null> } };

export type ResendEmailVerificationMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResendEmailVerificationMutation = { __typename?: 'RootMutationType', resendEmailVerification: { __typename?: 'BasicResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Result', message: string } | null } };

export type KnockCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type KnockCredentialsQuery = { __typename?: 'RootQueryType', knockCredentials: { __typename?: 'KnockCredentials', publicKey?: string | null, userToken?: string | null, userId?: string | null, feedChannelId?: string | null } };

export type NotificationPreferencesPageQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationPreferencesPageQuery = { __typename?: 'RootQueryType', notificationPreferences: { __typename?: 'NotificationPreferences', channels: Array<{ __typename?: 'ChannelPreference', id: string, description: string, enabled: boolean, type: string, title?: string | null } | null>, workflows: Array<{ __typename?: 'WorkflowPreference', id: string, description: string, enabled: boolean, key: string, profileTypes?: Array<ProfileType | null> | null, title?: string | null, channelPreferences: Array<{ __typename?: 'ChannelPreference', id: string, description: string, enabled: boolean, type: string } | null> } | null> }, user: { __typename?: 'User', id?: string | null, acceptedTerms: boolean, adminDeactivatedAt?: string | null, anonymizedAt?: string | null, confirmedAt?: string | null, deactivatedAt?: string | null, earnerOnboardingLastSeen?: string | null, email?: string | null, smsLast4?: string | null, blocks: Array<{ __typename?: 'Block', id: string, insertedAt: string, blockingProfile: { __typename?: 'Profile', id: string }, blockedProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, firstName?: string | null, lastName?: string | null, profilePictureUrl: string, profileType: ProfileType, verified: boolean } }>, lastTosAccepted?: { __typename?: 'TosAccepted', id: string, insertedAt: string, version: { __typename?: 'TosVersion', id: string, version: string, requireUserAcceptance: boolean, insertedAt: string }, user: { __typename?: 'User', id?: string | null, acceptedTerms: boolean } } | null, profile?: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, earningEnabled: boolean, firstName?: string | null, introduction?: string | null, lastName?: string | null, profilePhotoUrl: string, profilePictureUrl: string, profileType: ProfileType, timezone?: string | null, unclaimed: boolean, verified: boolean, isNonProfit: boolean, blocks: Array<{ __typename?: 'Block', id: string, insertedAt: string, blockingProfile: { __typename?: 'Profile', id: string }, blockedProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, firstName?: string | null, lastName?: string | null, profilePictureUrl: string, profileType: ProfileType, verified: boolean } }>, pricing: { __typename?: 'Pricing', replyPrice?: { __typename?: 'Money', amount?: number | null } | null }, profileLinks: Array<{ __typename?: 'ProfileLink', id?: string | null, title?: string | null, url?: string | null }>, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, linkedVendor?: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string } | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }> } | null, userRoles?: Array<{ __typename?: 'UserRole', roleName: RoleName } | null> | null }, smsVerificationCurrent?: { __typename?: 'SmsPendingVerification', message?: string | null, smsPhoneNumber?: string | null } | null };

export type NotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationPreferencesQuery = { __typename?: 'RootQueryType', notificationPreferences: { __typename?: 'NotificationPreferences', channels: Array<{ __typename?: 'ChannelPreference', id: string, description: string, enabled: boolean, title?: string | null, type: string } | null>, workflows: Array<{ __typename?: 'WorkflowPreference', id: string, description: string, enabled: boolean, key: string, profileTypes?: Array<ProfileType | null> | null, title?: string | null, channelPreferences: Array<{ __typename?: 'ChannelPreference', id: string, description: string, enabled: boolean, title?: string | null, type: string } | null> } | null> } };

export type SmsVerificationCurrentQueryVariables = Exact<{ [key: string]: never; }>;


export type SmsVerificationCurrentQuery = { __typename?: 'RootQueryType', smsVerificationCurrent?: { __typename?: 'SmsPendingVerification', message?: string | null, smsPhoneNumber?: string | null } | null };

export type ProfilePartsFragment = { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, earningEnabled: boolean, firstName?: string | null, introduction?: string | null, lastName?: string | null, profilePhotoUrl: string, profilePictureUrl: string, profileType: ProfileType, timezone?: string | null, unclaimed: boolean, verified: boolean, isNonProfit: boolean, blocks: Array<{ __typename?: 'Block', id: string, insertedAt: string, blockingProfile: { __typename?: 'Profile', id: string }, blockedProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, firstName?: string | null, lastName?: string | null, profilePictureUrl: string, profileType: ProfileType, verified: boolean } }>, pricing: { __typename?: 'Pricing', replyPrice?: { __typename?: 'Money', amount?: number | null } | null }, profileLinks: Array<{ __typename?: 'ProfileLink', id?: string | null, title?: string | null, url?: string | null }>, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, linkedVendor?: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string } | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }> };

export type BlockPartsFragment = { __typename?: 'Block', id: string, insertedAt: string, blockingProfile: { __typename?: 'Profile', id: string }, blockedProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, firstName?: string | null, lastName?: string | null, profilePictureUrl: string, profileType: ProfileType, verified: boolean } };

export type BlockSubscriptionPartsFragment = { __typename: 'BlockEvent', blockType: BlockEventType, block: { __typename?: 'Block', id: string, insertedAt: string, blockingProfile: { __typename?: 'Profile', id: string }, blockedProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, firstName?: string | null, lastName?: string | null, profilePictureUrl: string, profileType: ProfileType, verified: boolean } } };

export type BlockProfileMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
  profileId: Scalars['ID']['input'];
}>;


export type BlockProfileMutation = { __typename?: 'RootMutationType', blockProfile: { __typename?: 'Block', id: string, insertedAt: string, blockingProfile: { __typename?: 'Profile', id: string }, blockedProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, firstName?: string | null, lastName?: string | null, profilePictureUrl: string, profileType: ProfileType, verified: boolean } } };

export type ChangeVendorProfileMutationVariables = Exact<{
  displayName: Scalars['String']['input'];
  vendorName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  bio?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  profileLinks?: InputMaybe<Array<ProfileLinkInput> | ProfileLinkInput>;
  profilePhotoMediaPointerId?: InputMaybe<Scalars['ID']['input']>;
  profilePhotoCrop?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeVendorProfileMutation = { __typename?: 'RootMutationType', changeVendorProfile: { __typename?: 'ChangeVendorProfileResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null } | null> | null } };

export type ChangeMemberProfileMutationVariables = Exact<{
  displayName: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeMemberProfileMutation = { __typename?: 'RootMutationType', changeMemberProfile: { __typename?: 'ChangeMemberProfileResult', successful: boolean, result?: { __typename?: 'EditableMember', displayName: string, firstName?: string | null, id: string, lastName?: string | null, profileType: ProfileType, timezone?: string | null } | null, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null } | null> | null } };

export type UnBlockProfileMutationVariables = Exact<{
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  profileId: Scalars['ID']['input'];
}>;


export type UnBlockProfileMutation = { __typename?: 'RootMutationType', unblockProfile?: { __typename?: 'Block', id: string, insertedAt: string, blockingProfile: { __typename?: 'Profile', id: string }, blockedProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, firstName?: string | null, lastName?: string | null, profilePictureUrl: string, profileType: ProfileType, verified: boolean } } | null };

export type HideSuggestedProfileMutationVariables = Exact<{
  profileId: Scalars['ID']['input'];
}>;


export type HideSuggestedProfileMutation = { __typename?: 'RootMutationType', hideSuggestedProfile: { __typename?: 'BasicResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Result', message: string } | null } };

export type EditableProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type EditableProfileQuery = { __typename?: 'RootQueryType', editableProfile: { __typename?: 'EditableMember', displayName: string, firstName?: string | null, id: string, lastName?: string | null, profilePhotoCrop?: string | null, profilePhotoMediaPointerId?: string | null, profilePhotoUrl: string, profilePhotoUrlSrcset: string, profileType: ProfileType, timezone?: string | null, profilePhotoMediaPointer?: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> } | null } | { __typename?: 'EditableVendor', bio?: string | null, displayName: string, firstName?: string | null, id: string, lastName?: string | null, profilePhotoCrop?: string | null, profilePhotoMediaPointerId?: string | null, profilePhotoUrl: string, profilePhotoUrlSrcset: string, profileType: ProfileType, timezone?: string | null, vendorName: string, city?: string | null, state?: string | null, profileLinks: Array<{ __typename?: 'ProfileLink', id?: string | null, title?: string | null, url?: string | null }>, profilePhotoMediaPointer?: { __typename?: 'MediaPointer', id: string, filesizeInBytes: number, mediaType: MediaType, mimeType: string, name: string, provider: MediaProvider, status: MediaPointerStatus, downloadUrls: Array<{ __typename?: 'SignedUrl', expectedSizeInBytes?: number | null, expiresInSeconds?: number | null, key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, mimeType?: string | null, provider: MediaProvider, url: string }> } | null } };

export type ProfileNameQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProfileNameQuery = { __typename?: 'RootQueryType', profileName: string };

export type ProfileTimezoneQueryVariables = Exact<{
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProfileTimezoneQuery = { __typename?: 'RootQueryType', profile: { __typename?: 'Profile', timezone?: string | null } };

export type ProfileQueryVariables = Exact<{
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProfileQuery = { __typename?: 'RootQueryType', profile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, earningEnabled: boolean, firstName?: string | null, introduction?: string | null, lastName?: string | null, profilePhotoUrl: string, profilePictureUrl: string, profileType: ProfileType, timezone?: string | null, unclaimed: boolean, verified: boolean, isNonProfit: boolean, blocks: Array<{ __typename?: 'Block', id: string, insertedAt: string, blockingProfile: { __typename?: 'Profile', id: string }, blockedProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, firstName?: string | null, lastName?: string | null, profilePictureUrl: string, profileType: ProfileType, verified: boolean } }>, pricing: { __typename?: 'Pricing', replyPrice?: { __typename?: 'Money', amount?: number | null } | null }, profileLinks: Array<{ __typename?: 'ProfileLink', id?: string | null, title?: string | null, url?: string | null }>, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, linkedVendor?: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string } | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }> } };

export type ProfileLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileLocationsQuery = { __typename?: 'RootQueryType', profileLocations: Array<{ __typename?: 'Location', isPrimary?: boolean | null, title?: string | null, address?: string | null, location: { __typename?: 'GeoPoint', lat: number, lng: number } } | null> };

export type SuggestedProfilesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuggestedProfilesQuery = { __typename?: 'RootQueryType', suggestedProfiles: { __typename?: 'SuggestedProfilePage', data: Array<{ __typename?: 'SuggestedProfile', suggestedAt: string, suggestedVia?: string | null, suggestedProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, earningEnabled: boolean, firstName?: string | null, introduction?: string | null, lastName?: string | null, profilePhotoUrl: string, profilePictureUrl: string, profileType: ProfileType, timezone?: string | null, unclaimed: boolean, verified: boolean, isNonProfit: boolean, blocks: Array<{ __typename?: 'Block', id: string, insertedAt: string, blockingProfile: { __typename?: 'Profile', id: string }, blockedProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, firstName?: string | null, lastName?: string | null, profilePictureUrl: string, profileType: ProfileType, verified: boolean } }>, pricing: { __typename?: 'Pricing', replyPrice?: { __typename?: 'Money', amount?: number | null } | null }, profileLinks: Array<{ __typename?: 'ProfileLink', id?: string | null, title?: string | null, url?: string | null }>, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, linkedVendor?: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string } | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }> } }>, page?: { __typename?: 'BasePage', currentOffset?: number | null, currentPage?: number | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, nextOffset?: number | null, nextPage?: number | null, pageSize?: number | null, previousOffset?: number | null, previousPage?: number | null, startCursor?: string | null, totalCount?: number | null, totalPages?: number | null } | null } };

export type RedemptionPartsFragment = { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null };

type RedemptionLimitParts_RedemptionLimitCount_Fragment = { __typename?: 'RedemptionLimitCount', blocking?: boolean | null, count?: number | null, description: string, limit: number, limitScope: RedemptionLimitScope, limitType: RedemptionLimitType };

type RedemptionLimitParts_RedemptionLimitRate_Fragment = { __typename?: 'RedemptionLimitRate', blocking?: boolean | null, count?: number | null, description: string, endOfDay?: boolean | null, interval: number, limit: number, limitScope: RedemptionLimitScope, limitType: RedemptionLimitType, unit: RedemptionLimitUnit };

export type RedemptionLimitPartsFragment = RedemptionLimitParts_RedemptionLimitCount_Fragment | RedemptionLimitParts_RedemptionLimitRate_Fragment;

export type RedemptionMediaPreviewPartsFragment = { __typename?: 'Redemption', primaryMedia?: { __typename?: 'MediaPointer', id: string, proxy?: { __typename?: 'SignedUrl', url: string } | null, proxySrcSet?: { __typename?: 'SignedUrl', url: string } | null } | null };

export type RedemptionArchiveMutationVariables = Exact<{
  redemptionId: Scalars['ID']['input'];
}>;


export type RedemptionArchiveMutation = { __typename?: 'RootMutationType', redemptionArchive: { __typename?: 'RedemptionMutationResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null } | null } };

export type RedemptionCreateMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type RedemptionCreateMutation = { __typename?: 'RootMutationType', redemptionCreate: { __typename?: 'RedemptionMutationResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Redemption', id: string, name: string } | null } };

export type RedemptionUnarchiveMutationVariables = Exact<{
  redemptionId: Scalars['ID']['input'];
}>;


export type RedemptionUnarchiveMutation = { __typename?: 'RootMutationType', redemptionUnarchive: { __typename?: 'RedemptionMutationResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null } | null } };

export type RedemptionUpdateMutationVariables = Exact<{
  redemptionId: Scalars['ID']['input'];
  redemption: RedemptionUpdateInput;
}>;


export type RedemptionUpdateMutation = { __typename?: 'RootMutationType', redemptionUpdate: { __typename?: 'RedemptionMutationResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Redemption', id: string, name: string } | null } };

export type RedemptionsReorderMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RedemptionsReorderMutation = { __typename?: 'RootMutationType', redemptionsReorder?: { __typename?: 'RedemptionsMutationResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: Array<{ __typename?: 'Redemption', id: string, position: number }> | null } | null };

export type RedemptionSaveMutationVariables = Exact<{
  redemptionId: Scalars['ID']['input'];
}>;


export type RedemptionSaveMutation = { __typename?: 'RootMutationType', redemptionSave: { __typename?: 'RedemptionMutationResult', successful: boolean, result?: { __typename?: 'Redemption', id: string, saved?: boolean | null } | null, messages?: Array<{ __typename?: 'ValidationMessage', code: string } | null> | null } };

export type RedemptionUnsaveMutationVariables = Exact<{
  redemptionId: Scalars['ID']['input'];
}>;


export type RedemptionUnsaveMutation = { __typename?: 'RootMutationType', redemptionUnsave: { __typename?: 'RedemptionMutationResult', successful: boolean, result?: { __typename?: 'Redemption', id: string, saved?: boolean | null } | null, messages?: Array<{ __typename?: 'ValidationMessage', code: string } | null> | null } };

export type RedemptionCloneMutationVariables = Exact<{
  redemptionId: Scalars['ID']['input'];
}>;


export type RedemptionCloneMutation = { __typename?: 'RootMutationType', redemptionClone: { __typename?: 'RedemptionMutationResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Redemption', id: string } | null } };

export type RedeemMutationVariables = Exact<{
  redemptionId: Scalars['ID']['input'];
}>;


export type RedeemMutation = { __typename?: 'RootMutationType', redeem: { __typename?: 'RedemptionResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'RedemptionContext', bonusAmountGranted?: number | null, redemption?: { __typename?: 'Redemption', id: string, name: string, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null } | null } | null } };

export type RedemptionsQueryVariables = Exact<{
  query?: InputMaybe<RedemptionPageInput>;
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type RedemptionsQuery = { __typename?: 'RootQueryType', redemptions?: { __typename?: 'RedemptionPage', data: Array<{ __typename?: 'Redemption', redeemCount: number, id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, vendor: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string }, stats?: { __typename?: 'RedemptionStats', viewCount: number, redeemCount: number, saveCount: number, qrCodeScans: number } | null, limits?: { __typename?: 'RedemptionLimits', id: string, canRedeem?: boolean | null, limits?: Array<{ __typename?: 'RedemptionLimitCount', blocking?: boolean | null, count?: number | null, description: string, limit: number, limitScope: RedemptionLimitScope, limitType: RedemptionLimitType } | { __typename?: 'RedemptionLimitRate', blocking?: boolean | null, count?: number | null, description: string, endOfDay?: boolean | null, interval: number, limit: number, limitScope: RedemptionLimitScope, limitType: RedemptionLimitType, unit: RedemptionLimitUnit }> | null } | null, linkedVendor?: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string } | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }>, proxy?: { __typename?: 'SignedUrl', url: string } | null, proxySrcSet?: { __typename?: 'SignedUrl', url: string } | null } | null, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }>, page?: { __typename?: 'BasePage', currentOffset?: number | null, currentPage?: number | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, nextOffset?: number | null, nextPage?: number | null, pageSize?: number | null, previousOffset?: number | null, previousPage?: number | null, startCursor?: string | null, totalCount?: number | null, totalPages?: number | null } | null, query?: { __typename?: 'RedemptionQuery', filters?: Array<{ __typename?: 'RedemptionFilters', attribute: RedemptionQueryAttributes, op: PageFilterOp, value: { __typename?: 'PageFilterValues', boolean?: boolean | null, float?: number | null, floats?: Array<number | null> | null, integer?: number | null, integers?: Array<number | null> | null, string?: string | null, strings?: Array<string | null> | null } }> | null } | null } | null };

export type RedemptionsDiscoveryQueryVariables = Exact<{
  query?: InputMaybe<RedemptionPageInput>;
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
  currentLocation?: InputMaybe<GeoPointInput>;
  evaluate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RedemptionsDiscoveryQuery = { __typename?: 'RootQueryType', discoverRedemptions?: { __typename?: 'RedemptionPage', data: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, description: string, name: string, isNonProfit: boolean, isSweepstakes: boolean, validEnd?: string | null, redeemCount: number, saved?: boolean | null, vendor: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string }, limits?: { __typename?: 'RedemptionLimits', id: string, canRedeem?: boolean | null, limits?: Array<{ __typename?: 'RedemptionLimitCount', blocking?: boolean | null, count?: number | null, description: string, limit: number, limitScope: RedemptionLimitScope, limitType: RedemptionLimitType } | { __typename?: 'RedemptionLimitRate', blocking?: boolean | null, count?: number | null, description: string, endOfDay?: boolean | null, interval: number, limit: number, limitScope: RedemptionLimitScope, limitType: RedemptionLimitType, unit: RedemptionLimitUnit }> | null } | null, price: { __typename?: 'Money', amount?: number | null }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, linkedVendor?: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, proxy?: { __typename?: 'SignedUrl', url: string } | null, proxySrcSet?: { __typename?: 'SignedUrl', url: string } | null } | null }>, page?: { __typename?: 'BasePage', currentOffset?: number | null, currentPage?: number | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, nextOffset?: number | null, nextPage?: number | null, pageSize?: number | null, previousOffset?: number | null, previousPage?: number | null, startCursor?: string | null, totalCount?: number | null, totalPages?: number | null } | null, query?: { __typename?: 'RedemptionQuery', filters?: Array<{ __typename?: 'RedemptionFilters', attribute: RedemptionQueryAttributes, op: PageFilterOp, value: { __typename?: 'PageFilterValues', boolean?: boolean | null, float?: number | null, floats?: Array<number | null> | null, integer?: number | null, integers?: Array<number | null> | null, string?: string | null, strings?: Array<string | null> | null } }> | null } | null } | null };

export type RedemptionsGetSingleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
  evaluate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RedemptionsGetSingleQuery = { __typename?: 'RootQueryType', getRedemption?: { __typename?: 'Redemption', id: string, active: boolean, confirmationTextOverrideHtml?: string | null, description: string, redeemCount: number, name: string, important?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, referralLink: string, validEnd?: string | null, archivedAt?: string | null, saved?: boolean | null, vendor: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string }, limits?: { __typename?: 'RedemptionLimits', id: string, canRedeem?: boolean | null, limits?: Array<{ __typename?: 'RedemptionLimitCount', blocking?: boolean | null, count?: number | null, description: string, limit: number, limitScope: RedemptionLimitScope, limitType: RedemptionLimitType } | { __typename?: 'RedemptionLimitRate', blocking?: boolean | null, count?: number | null, description: string, endOfDay?: boolean | null, interval: number, limit: number, limitScope: RedemptionLimitScope, limitType: RedemptionLimitType, unit: RedemptionLimitUnit }> | null } | null, location?: { __typename?: 'GeoPoint', lat: number, lng: number } | null, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, linkedVendor?: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string, followRecord?: { __typename?: 'FollowRecord', conversationId?: string | null, memberId: string, vendorId: string } | null } | null, price: { __typename?: 'Money', amount?: number | null }, stats?: { __typename?: 'RedemptionStats', viewCount: number, redeemCount: number, saveCount: number, qrCodeScans: number } | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, proxy?: { __typename?: 'SignedUrl', url: string } | null, proxySrcSet?: { __typename?: 'SignedUrl', url: string } | null } | null } | null };

export type RedemptionMemberHistoryQueryVariables = Exact<{
  query?: InputMaybe<RedemptionHistoryPageInput>;
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type RedemptionMemberHistoryQuery = { __typename?: 'RootQueryType', redemptionHistory?: { __typename?: 'RedemptionHistoryPage', data: Array<{ __typename?: 'RedemptionHistoryRecord', id: string, redemptionName: string, insertedAt: string, redemptionPrice: { __typename?: 'Money', amount?: number | null }, vendor: { __typename?: 'PublicVendor', id: string, name: string, displayName: string, photoUrl: string }, redemption: { __typename?: 'Redemption', id: string, isNonProfit: boolean, isSweepstakes: boolean, primaryMedia?: { __typename?: 'MediaPointer', id: string, proxy?: { __typename?: 'SignedUrl', url: string } | null, proxySrcSet?: { __typename?: 'SignedUrl', url: string } | null } | null } }>, page?: { __typename?: 'BasePage', currentOffset?: number | null, currentPage?: number | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, nextOffset?: number | null, nextPage?: number | null, pageSize?: number | null, previousOffset?: number | null, previousPage?: number | null, startCursor?: string | null, totalCount?: number | null, totalPages?: number | null } | null } | null };

export type RedemptionVendorHistoryQueryVariables = Exact<{
  query?: InputMaybe<RedemptionHistoryPageInput>;
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type RedemptionVendorHistoryQuery = { __typename?: 'RootQueryType', redemptionHistory?: { __typename?: 'RedemptionHistoryPage', data: Array<{ __typename?: 'RedemptionHistoryRecord', id: string, redemptionName: string, insertedAt: string, redemptionPrice: { __typename?: 'Money', amount?: number | null }, member: { __typename?: 'Profile', displayName: string, profilePhotoUrl: string }, redemption: { __typename?: 'Redemption', id: string, primaryMedia?: { __typename?: 'MediaPointer', id: string, proxy?: { __typename?: 'SignedUrl', url: string } | null, proxySrcSet?: { __typename?: 'SignedUrl', url: string } | null } | null }, vendor: { __typename?: 'PublicVendor', name: string, displayName: string, photoUrl: string } }>, page?: { __typename?: 'BasePage', currentOffset?: number | null, currentPage?: number | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, nextOffset?: number | null, nextPage?: number | null, pageSize?: number | null, previousOffset?: number | null, previousPage?: number | null, startCursor?: string | null, totalCount?: number | null, totalPages?: number | null } | null } | null };

export type RedemptionsSavedQueryVariables = Exact<{
  query?: InputMaybe<RedemptionPageInput>;
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
  currentLocation?: InputMaybe<GeoPointInput>;
  evaluate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RedemptionsSavedQuery = { __typename?: 'RootQueryType', redemptionsSaved?: { __typename?: 'RedemptionPage', data: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, description: string, name: string, isNonProfit: boolean, validEnd?: string | null, redeemCount: number, saved?: boolean | null, vendor: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string }, limits?: { __typename?: 'RedemptionLimits', id: string, canRedeem?: boolean | null, limits?: Array<{ __typename?: 'RedemptionLimitCount', blocking?: boolean | null, count?: number | null, description: string, limit: number, limitScope: RedemptionLimitScope, limitType: RedemptionLimitType } | { __typename?: 'RedemptionLimitRate', blocking?: boolean | null, count?: number | null, description: string, endOfDay?: boolean | null, interval: number, limit: number, limitScope: RedemptionLimitScope, limitType: RedemptionLimitType, unit: RedemptionLimitUnit }> | null } | null, price: { __typename?: 'Money', amount?: number | null }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, linkedVendor?: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, proxy?: { __typename?: 'SignedUrl', url: string } | null, proxySrcSet?: { __typename?: 'SignedUrl', url: string } | null } | null }>, page?: { __typename?: 'BasePage', currentOffset?: number | null, currentPage?: number | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, nextOffset?: number | null, nextPage?: number | null, pageSize?: number | null, previousOffset?: number | null, previousPage?: number | null, startCursor?: string | null, totalCount?: number | null, totalPages?: number | null } | null, query?: { __typename?: 'RedemptionQuery', filters?: Array<{ __typename?: 'RedemptionFilters', attribute: RedemptionQueryAttributes, op: PageFilterOp, value: { __typename?: 'PageFilterValues', boolean?: boolean | null, float?: number | null, floats?: Array<number | null> | null, integer?: number | null, integers?: Array<number | null> | null, string?: string | null, strings?: Array<string | null> | null } }> | null } | null } | null };

export type TopLiveRedemptionQueryVariables = Exact<{
  vendorId: Scalars['ID']['input'];
}>;


export type TopLiveRedemptionQuery = { __typename?: 'RootQueryType', topLiveRedemption?: { __typename?: 'Redemption', id: string } | null };

export type NearestSpotlightRedemptionQueryVariables = Exact<{
  currentLocation?: InputMaybe<GeoPointInput>;
}>;


export type NearestSpotlightRedemptionQuery = { __typename?: 'RootQueryType', nearestSpotlightRedemption?: { __typename?: 'Redemption', id: string } | null };

export type AccessTokenPartsFragment = { __typename?: 'AccessToken', validForSeconds?: number | null, validUntil?: string | null, value?: string | null };

export type DeviceTokenPartsFragment = { __typename?: 'DeviceToken', id: string, deviceId?: string | null, deviceName?: string | null, deviceToken: string, insertedAt: string, service: PushService };

export type CreateAccessTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateAccessTokenMutation = { __typename?: 'RootMutationType', createAccessToken: { __typename?: 'AccessToken', validForSeconds?: number | null, validUntil?: string | null, value?: string | null } };

export type AddDeviceTokenMutationVariables = Exact<{
  deviceToken: DeviceTokenInput;
}>;


export type AddDeviceTokenMutation = { __typename?: 'RootMutationType', addDeviceToken: { __typename?: 'DeviceTokenResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'DeviceToken', id: string, deviceId?: string | null, deviceName?: string | null, deviceToken: string, insertedAt: string, service: PushService } | null } };

export type RemoveDeviceTokenMutationVariables = Exact<{
  deviceTokenId: Scalars['ID']['input'];
}>;


export type RemoveDeviceTokenMutation = { __typename?: 'RootMutationType', removeDeviceToken: { __typename?: 'DeviceTokenResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'DeviceToken', id: string, deviceId?: string | null, deviceName?: string | null, deviceToken: string, insertedAt: string, service: PushService } | null } };

export type DeviceTokensQueryVariables = Exact<{ [key: string]: never; }>;


export type DeviceTokensQuery = { __typename?: 'RootQueryType', deviceTokens: Array<{ __typename?: 'DeviceToken', id: string, deviceId?: string | null, deviceName?: string | null, deviceToken: string, insertedAt: string, service: PushService }> };

export type TosVersionPartsFragment = { __typename?: 'TosVersion', id: string, version: string, requireUserAcceptance: boolean, insertedAt: string };

export type TosAcceptedPartsFragment = { __typename?: 'TosAccepted', id: string, insertedAt: string, version: { __typename?: 'TosVersion', id: string, version: string, requireUserAcceptance: boolean, insertedAt: string }, user: { __typename?: 'User', id?: string | null, acceptedTerms: boolean } };

export type TosAcceptMutationVariables = Exact<{
  version: Scalars['String']['input'];
}>;


export type TosAcceptMutation = { __typename?: 'RootMutationType', tosAccept: { __typename?: 'UserTosAcceptedResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'TosAccepted', id: string, insertedAt: string, version: { __typename?: 'TosVersion', id: string, version: string, requireUserAcceptance: boolean, insertedAt: string }, user: { __typename?: 'User', id?: string | null, acceptedTerms: boolean } } | null } };

export type TosCurrentQueryVariables = Exact<{ [key: string]: never; }>;


export type TosCurrentQuery = { __typename?: 'RootQueryType', tosCurrent: { __typename?: 'TosVersion', content: string, id: string, version: string, requireUserAcceptance: boolean, insertedAt: string } };

export type PollAndTriviaPartsFragment = { __typename?: 'PollObject', id: string, bonusText?: string | null, caption?: string | null, consolationPrice?: number | null, endAt?: string | null, important?: boolean | null, name?: string | null, price?: number | null, question?: string | null, startAt?: string | null, type?: PollType | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType, correct?: boolean | null } | { __typename?: 'PollTextOption', text: string, order?: number | null, id: string, type: PollOptionType, correct?: boolean | null } | null> | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, name: string, downloadUrls: Array<{ __typename?: 'SignedUrl', key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, url: string }> } | null };

export type PollAndTriviaPrimaryMediaPartsFragment = { __typename?: 'MediaPointer', id: string, name: string, downloadUrls: Array<{ __typename?: 'SignedUrl', key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, url: string }> };

export type PollAndTriviaResultPartsFragment = { __typename?: 'PollResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'PollObject', id: string, bonusText?: string | null, caption?: string | null, consolationPrice?: number | null, endAt?: string | null, important?: boolean | null, name?: string | null, price?: number | null, question?: string | null, startAt?: string | null, type?: PollType | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType, correct?: boolean | null } | { __typename?: 'PollTextOption', text: string, order?: number | null, id: string, type: PollOptionType, correct?: boolean | null } | null> | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, name: string, downloadUrls: Array<{ __typename?: 'SignedUrl', key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, url: string }> } | null } | null };

export type PollCreateMutationVariables = Exact<{
  poll: PollObjectInput;
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type PollCreateMutation = { __typename?: 'RootMutationType', pollCreate: { __typename?: 'PollResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'PollObject', id: string, bonusText?: string | null, caption?: string | null, consolationPrice?: number | null, endAt?: string | null, important?: boolean | null, name?: string | null, price?: number | null, question?: string | null, startAt?: string | null, type?: PollType | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType, correct?: boolean | null } | { __typename?: 'PollTextOption', text: string, order?: number | null, id: string, type: PollOptionType, correct?: boolean | null } | null> | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, name: string, downloadUrls: Array<{ __typename?: 'SignedUrl', key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, url: string }> } | null } | null } };

export type PollUpdateMutationVariables = Exact<{
  poll: PollObjectInput;
  pollId: Scalars['ID']['input'];
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type PollUpdateMutation = { __typename?: 'RootMutationType', pollUpdate: { __typename?: 'PollResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'PollObject', id: string, bonusText?: string | null, caption?: string | null, consolationPrice?: number | null, endAt?: string | null, important?: boolean | null, name?: string | null, price?: number | null, question?: string | null, startAt?: string | null, type?: PollType | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType, correct?: boolean | null } | { __typename?: 'PollTextOption', text: string, order?: number | null, id: string, type: PollOptionType, correct?: boolean | null } | null> | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, name: string, downloadUrls: Array<{ __typename?: 'SignedUrl', key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, url: string }> } | null } | null } };

export type PollSetToLiveMutationVariables = Exact<{
  pollId: Scalars['ID']['input'];
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type PollSetToLiveMutation = { __typename?: 'RootMutationType', pollSetToLive: { __typename?: 'PollResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'PollObject', id: string, bonusText?: string | null, caption?: string | null, consolationPrice?: number | null, endAt?: string | null, important?: boolean | null, name?: string | null, price?: number | null, question?: string | null, startAt?: string | null, type?: PollType | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType, correct?: boolean | null } | { __typename?: 'PollTextOption', text: string, order?: number | null, id: string, type: PollOptionType, correct?: boolean | null } | null> | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, name: string, downloadUrls: Array<{ __typename?: 'SignedUrl', key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, url: string }> } | null } | null } };

export type PollArchiveMutationVariables = Exact<{
  pollId: Scalars['ID']['input'];
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type PollArchiveMutation = { __typename?: 'RootMutationType', pollArchive: { __typename?: 'PollResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'PollObject', id: string, bonusText?: string | null, caption?: string | null, consolationPrice?: number | null, endAt?: string | null, important?: boolean | null, name?: string | null, price?: number | null, question?: string | null, startAt?: string | null, type?: PollType | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType, correct?: boolean | null } | { __typename?: 'PollTextOption', text: string, order?: number | null, id: string, type: PollOptionType, correct?: boolean | null } | null> | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, name: string, downloadUrls: Array<{ __typename?: 'SignedUrl', key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, url: string }> } | null } | null } };

export type PollPublishMutationVariables = Exact<{
  pollId: Scalars['ID']['input'];
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type PollPublishMutation = { __typename?: 'RootMutationType', pollPublish: { __typename?: 'PollResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'PollObject', id: string, bonusText?: string | null, caption?: string | null, consolationPrice?: number | null, endAt?: string | null, important?: boolean | null, name?: string | null, price?: number | null, question?: string | null, startAt?: string | null, type?: PollType | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType, correct?: boolean | null } | { __typename?: 'PollTextOption', text: string, order?: number | null, id: string, type: PollOptionType, correct?: boolean | null } | null> | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, name: string, downloadUrls: Array<{ __typename?: 'SignedUrl', key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, url: string }> } | null } | null } };

export type PollCompleteMutationVariables = Exact<{
  pollId: Scalars['ID']['input'];
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type PollCompleteMutation = { __typename?: 'RootMutationType', pollComplete: { __typename?: 'PollResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'PollObject', id: string, bonusText?: string | null, caption?: string | null, consolationPrice?: number | null, endAt?: string | null, important?: boolean | null, name?: string | null, price?: number | null, question?: string | null, startAt?: string | null, type?: PollType | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType, correct?: boolean | null } | { __typename?: 'PollTextOption', text: string, order?: number | null, id: string, type: PollOptionType, correct?: boolean | null } | null> | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, name: string, downloadUrls: Array<{ __typename?: 'SignedUrl', key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, url: string }> } | null } | null } };

export type VendorPollsListQueryVariables = Exact<{
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
  query?: InputMaybe<PollPageInput>;
}>;


export type VendorPollsListQuery = { __typename?: 'RootQueryType', pollAll: { __typename?: 'PollPage', data: Array<{ __typename?: 'PollObject', status: PollStatus, id: string, bonusText?: string | null, caption?: string | null, consolationPrice?: number | null, endAt?: string | null, important?: boolean | null, name?: string | null, price?: number | null, question?: string | null, startAt?: string | null, type?: PollType | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType, correct?: boolean | null } | { __typename?: 'PollTextOption', text: string, order?: number | null, id: string, type: PollOptionType, correct?: boolean | null } | null> | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, name: string, downloadUrls: Array<{ __typename?: 'SignedUrl', key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, url: string }> } | null }>, page?: { __typename?: 'BasePage', currentOffset?: number | null, currentPage?: number | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, nextOffset?: number | null, nextPage?: number | null, pageSize?: number | null, previousOffset?: number | null, previousPage?: number | null, startCursor?: string | null, totalCount?: number | null, totalPages?: number | null } | null } };

export type VendorCompletedPollsListQueryVariables = Exact<{
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
  query?: InputMaybe<PollPageInput>;
}>;


export type VendorCompletedPollsListQuery = { __typename?: 'RootQueryType', pollAll: { __typename?: 'PollPage', data: Array<{ __typename?: 'PollObject', status: PollStatus, id: string, bonusText?: string | null, caption?: string | null, consolationPrice?: number | null, endAt?: string | null, important?: boolean | null, name?: string | null, price?: number | null, question?: string | null, startAt?: string | null, type?: PollType | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType, correct?: boolean | null } | { __typename?: 'PollTextOption', text: string, order?: number | null, id: string, type: PollOptionType, correct?: boolean | null } | null> | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, name: string, downloadUrls: Array<{ __typename?: 'SignedUrl', key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, url: string }> } | null }>, page?: { __typename?: 'BasePage', currentOffset?: number | null, currentPage?: number | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, nextOffset?: number | null, nextPage?: number | null, pageSize?: number | null, previousOffset?: number | null, previousPage?: number | null, startCursor?: string | null, totalCount?: number | null, totalPages?: number | null } | null } };

export type VendorGetSinglePollObjectQueryVariables = Exact<{
  pollGetId: Scalars['ID']['input'];
  imgixOpts?: InputMaybe<Array<MediaOption> | MediaOption>;
}>;


export type VendorGetSinglePollObjectQuery = { __typename?: 'RootQueryType', pollGet: { __typename?: 'PollObject', status: PollStatus, id: string, bonusText?: string | null, caption?: string | null, consolationPrice?: number | null, endAt?: string | null, important?: boolean | null, name?: string | null, price?: number | null, question?: string | null, startAt?: string | null, type?: PollType | null, options?: Array<{ __typename?: 'PollMediaOption', id: string, order?: number | null, type: PollOptionType, correct?: boolean | null } | { __typename?: 'PollTextOption', text: string, order?: number | null, id: string, type: PollOptionType, correct?: boolean | null } | null> | null, primaryMedia?: { __typename?: 'MediaPointer', id: string, name: string, downloadUrls: Array<{ __typename?: 'SignedUrl', key: SignedUrlKey, mediaPointerId: string, mediaType: MediaType, metadata?: string | null, url: string }> } | null } };

export type FirstPollOfTheDaySubscriptionVariables = Exact<{ [key: string]: never; }>;


export type FirstPollOfTheDaySubscription = { __typename?: 'RootSubscriptionType', pollEvents?: { __typename?: 'FirstPollOfTheDay', profileId?: string | null, type?: string | null } | null };

export type UserPartsFragment = { __typename?: 'User', id?: string | null, acceptedTerms: boolean, adminDeactivatedAt?: string | null, anonymizedAt?: string | null, confirmedAt?: string | null, deactivatedAt?: string | null, earnerOnboardingLastSeen?: string | null, email?: string | null, smsLast4?: string | null, blocks: Array<{ __typename?: 'Block', id: string, insertedAt: string, blockingProfile: { __typename?: 'Profile', id: string }, blockedProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, firstName?: string | null, lastName?: string | null, profilePictureUrl: string, profileType: ProfileType, verified: boolean } }>, lastTosAccepted?: { __typename?: 'TosAccepted', id: string, insertedAt: string, version: { __typename?: 'TosVersion', id: string, version: string, requireUserAcceptance: boolean, insertedAt: string }, user: { __typename?: 'User', id?: string | null, acceptedTerms: boolean } } | null, profile?: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, earningEnabled: boolean, firstName?: string | null, introduction?: string | null, lastName?: string | null, profilePhotoUrl: string, profilePictureUrl: string, profileType: ProfileType, timezone?: string | null, unclaimed: boolean, verified: boolean, isNonProfit: boolean, blocks: Array<{ __typename?: 'Block', id: string, insertedAt: string, blockingProfile: { __typename?: 'Profile', id: string }, blockedProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, firstName?: string | null, lastName?: string | null, profilePictureUrl: string, profileType: ProfileType, verified: boolean } }>, pricing: { __typename?: 'Pricing', replyPrice?: { __typename?: 'Money', amount?: number | null } | null }, profileLinks: Array<{ __typename?: 'ProfileLink', id?: string | null, title?: string | null, url?: string | null }>, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, linkedVendor?: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string } | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }> } | null, userRoles?: Array<{ __typename?: 'UserRole', roleName: RoleName } | null> | null };

export type UserLoginPartsFragment = { __typename?: 'User', id?: string | null, acceptedTerms: boolean, email?: string | null, lastTosAccepted?: { __typename?: 'TosAccepted', id: string, insertedAt: string, version: { __typename?: 'TosVersion', id: string, version: string, requireUserAcceptance: boolean, insertedAt: string }, user: { __typename?: 'User', id?: string | null, acceptedTerms: boolean } } | null, profile?: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, profilePictureUrl: string, profilePhotoUrl: string, firstName?: string | null, lastName?: string | null, profileType: ProfileType, isNonProfit: boolean } | null };

export type UserRolePartsFragment = { __typename?: 'UserRole', roleName: RoleName };

export type LoginMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  magicLinkToken?: InputMaybe<Scalars['String']['input']>;
  emailToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type LoginMutation = { __typename?: 'RootMutationType', login: { __typename?: 'Session', accessToken?: { __typename?: 'AccessToken', validForSeconds?: number | null, validUntil?: string | null, value?: string | null } | null, impersonator?: { __typename?: 'User', id?: string | null, email?: string | null } | null, user?: { __typename?: 'User', id?: string | null, acceptedTerms: boolean, email?: string | null, lastTosAccepted?: { __typename?: 'TosAccepted', id: string, insertedAt: string, version: { __typename?: 'TosVersion', id: string, version: string, requireUserAcceptance: boolean, insertedAt: string }, user: { __typename?: 'User', id?: string | null, acceptedTerms: boolean } } | null, profile?: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, profilePictureUrl: string, profilePhotoUrl: string, firstName?: string | null, lastName?: string | null, profileType: ProfileType, isNonProfit: boolean } | null } | null } };

export type LogoutMutationVariables = Exact<{
  deviceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LogoutMutation = { __typename?: 'RootMutationType', logout: string };

export type NotifyUserTypedMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type NotifyUserTypedMutation = { __typename?: 'RootMutationType', notifyUserTyped?: string | null };

export type ChangeEmailMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type ChangeEmailMutation = { __typename?: 'RootMutationType', changeEmail: { __typename?: 'BasicResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null } | null> | null, result?: { __typename?: 'Result', message: string } | null } };

export type ChangePasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'RootMutationType', changePassword: { __typename?: 'BasicResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null } | null> | null, result?: { __typename?: 'Result', message: string } | null } };

export type ResetPasswordInitiateMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResetPasswordInitiateMutation = { __typename?: 'RootMutationType', resetPasswordInitiate: { __typename?: 'BasicResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Result', message: string } | null } };

export type ResetPasswordFinalizeMutationVariables = Exact<{
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type ResetPasswordFinalizeMutation = { __typename?: 'RootMutationType', resetPasswordFinalize: { __typename?: 'BasicResult', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null, template?: string | null, options?: Array<{ __typename?: 'ValidationOption', key: string, value: string } | null> | null } | null> | null, result?: { __typename?: 'Result', message: string } | null } };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'RootQueryType', impersonator?: { __typename?: 'User', id?: string | null, email?: string | null } | null, user: { __typename?: 'User', id?: string | null, acceptedTerms: boolean, adminDeactivatedAt?: string | null, anonymizedAt?: string | null, confirmedAt?: string | null, deactivatedAt?: string | null, earnerOnboardingLastSeen?: string | null, email?: string | null, smsLast4?: string | null, blocks: Array<{ __typename?: 'Block', id: string, insertedAt: string, blockingProfile: { __typename?: 'Profile', id: string }, blockedProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, firstName?: string | null, lastName?: string | null, profilePictureUrl: string, profileType: ProfileType, verified: boolean } }>, lastTosAccepted?: { __typename?: 'TosAccepted', id: string, insertedAt: string, version: { __typename?: 'TosVersion', id: string, version: string, requireUserAcceptance: boolean, insertedAt: string }, user: { __typename?: 'User', id?: string | null, acceptedTerms: boolean } } | null, profile?: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, earningEnabled: boolean, firstName?: string | null, introduction?: string | null, lastName?: string | null, profilePhotoUrl: string, profilePictureUrl: string, profileType: ProfileType, timezone?: string | null, unclaimed: boolean, verified: boolean, isNonProfit: boolean, blocks: Array<{ __typename?: 'Block', id: string, insertedAt: string, blockingProfile: { __typename?: 'Profile', id: string }, blockedProfile: { __typename?: 'Profile', id: string, communityName?: string | null, displayName: string, firstName?: string | null, lastName?: string | null, profilePictureUrl: string, profileType: ProfileType, verified: boolean } }>, pricing: { __typename?: 'Pricing', replyPrice?: { __typename?: 'Money', amount?: number | null } | null }, profileLinks: Array<{ __typename?: 'ProfileLink', id?: string | null, title?: string | null, url?: string | null }>, redemptions: Array<{ __typename?: 'Redemption', id: string, active: boolean, archivedAt?: string | null, confirmationTextOverrideHtml?: string | null, description: string, globalRank: number, name: string, position: number, referralLink: string, validEnd?: string | null, validStart?: string | null, important?: boolean | null, spotlight?: boolean | null, isNonProfit: boolean, isSweepstakes: boolean, saved?: boolean | null, linkedVendor?: { __typename?: 'PublicVendor', id: string, displayName: string, name: string, photoUrl: string } | null, price: { __typename?: 'Money', amount?: number | null }, primaryMedia?: { __typename?: 'MediaPointer', id: string, mediaType: MediaType, redemptionDownloadUrls: Array<{ __typename?: 'SignedUrl', mediaType: MediaType, key: SignedUrlKey, url: string }> } | null, vendor: { __typename?: 'PublicVendor', photoUrl: string }, donationProgress?: { __typename?: 'RedemptionDonationProgress', progress?: number | null, current: { __typename?: 'Money', amount?: number | null }, goal?: { __typename?: 'Money', amount?: number | null } | null } | null, location?: { __typename?: 'GeoPoint', lng: number, lat: number } | null }> } | null, userRoles?: Array<{ __typename?: 'UserRole', roleName: RoleName } | null> | null } };

export type UserCheckInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type UserCheckInfoQuery = { __typename?: 'RootQueryType', user: { __typename?: 'User', id?: string | null, email?: string | null, profile?: { __typename?: 'Profile', displayName: string, profilePhotoUrl: string, profileType: ProfileType, firstName?: string | null, lastName?: string | null } | null } };

export type WaivePaymentMutationVariables = Exact<{
  messageId: Scalars['ID']['input'];
}>;


export type WaivePaymentMutation = { __typename?: 'RootMutationType', refusePayment?: { __typename?: 'Message', id: string, transaction?: { __typename?: 'MessageTransaction', id: string, status: MessageTransactionStatus } | null } | null };

export type WalletQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WalletQuery = { __typename?: 'RootQueryType', wallet?: { __typename?: 'Wallet', frozen: boolean, id: string, role: WalletRole, type: WalletType, balance: { __typename?: 'Money', amount?: number | null }, adjustments?: { __typename?: 'AdjustmentPage', data: Array<{ __typename?: 'Adjustment', id: string, insertedAt: string, title: string, description: string, walletType: WalletType, amountInCents: { __typename?: 'Money', amount?: number | null } }>, page?: { __typename?: 'BasePage', totalCount?: number | null } | null } | null } | null };

export type WalletBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type WalletBalanceQuery = { __typename?: 'RootQueryType', wallet?: { __typename?: 'Wallet', balance: { __typename?: 'Money', amount?: number | null } } | null };

export type WalletEventsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type WalletEventsSubscription = { __typename?: 'RootSubscriptionType', walletEvents?: { __typename?: 'WalletBalanceEvent', updatedAt: string } | null };

export const RedemptionPartsFragmentDoc = gql`
    fragment RedemptionParts on Redemption {
  id
  active
  archivedAt
  confirmationTextOverrideHtml
  description
  globalRank
  name
  position
  price {
    amount
  }
  primaryMedia {
    id
    mediaType
    redemptionDownloadUrls: downloadUrls {
      mediaType
      key
      url
    }
  }
  referralLink
  validEnd
  validStart
  vendor {
    photoUrl
  }
  donationProgress {
    current {
      amount
    }
    goal {
      amount
    }
    progress
  }
  important
  spotlight
  isNonProfit
  isSweepstakes
  location {
    lng
    lat
  }
  saved
}
    `;
export const SignedUrlPartsFragmentDoc = gql`
    fragment SignedUrlParts on SignedUrl {
  expectedSizeInBytes
  expiresInSeconds
  key
  mediaPointerId
  mediaType
  metadata
  mimeType
  provider
  url
}
    `;
export const MediaPointerPartsFragmentDoc = gql`
    fragment MediaPointerParts on MediaPointer {
  id
  downloadUrls {
    ...SignedUrlParts
  }
  filesizeInBytes
  mediaType
  mimeType
  name
  provider
  status
}
    ${SignedUrlPartsFragmentDoc}`;
export const PollOptionPartsFragmentDoc = gql`
    fragment PollOptionParts on PollOption {
  id
  order
  type
  ... on PollTextOption {
    text
  }
}
    `;
export const MessageTemplatePartsFragmentDoc = gql`
    fragment MessageTemplateParts on MessageTemplate {
  name
  body
  type
  price {
    amount
  }
  redemptionOffers {
    ...RedemptionParts
    primaryMedia {
      id
      mediaType
      downloadUrls {
        mediaType
        key
        url
      }
    }
  }
  primaryAttachment {
    ...MediaPointerParts
  }
  options {
    ...PollOptionParts
  }
}
    ${RedemptionPartsFragmentDoc}
${MediaPointerPartsFragmentDoc}
${PollOptionPartsFragmentDoc}`;
export const BroadcastCostsPartsFragmentDoc = gql`
    fragment BroadcastCostsParts on BroadcastCosts {
  finalCost {
    amount
  }
  potentialTotalCost {
    amount
  }
  messagePrice {
    amount
  }
  currentCost {
    amount
  }
  outstandingCost {
    amount
  }
  returnedCost {
    amount
  }
}
    `;
export const BroadcastPartsFragmentDoc = gql`
    fragment BroadcastParts on Broadcast {
  id
  broadcastArchivedAt
  broadcastEnd
  broadcastName
  broadcastPublishedAt
  broadcastStart
  broadcastTarget {
    allFollowers
    radiusKm
    usePrimaryLocation
  }
  followUpMessageTemplate {
    ...MessageTemplateParts
  }
  messageTemplate {
    ...MessageTemplateParts
  }
  insertedAt
  status
  updatedAt
  isPersistent
  costs {
    ...BroadcastCostsParts
  }
  followUpMessageCosts {
    ...BroadcastCostsParts
  }
}
    ${MessageTemplatePartsFragmentDoc}
${BroadcastCostsPartsFragmentDoc}`;
export const BroadcastStatsPartsFragmentDoc = gql`
    fragment BroadcastStatsParts on BroadcastStats {
  expired
  fulfilled
  pending
  rejected
  total
  pollResponses {
    pollOption {
      ... on PollTextOption {
        text
      }
    }
    count
  }
}
    `;
export const FeedMessagePreviewMediaPointerFragmentDoc = gql`
    fragment FeedMessagePreviewMediaPointer on MediaPointer {
  id
  thumbnail: downloadUrl(encoding: PROXY, imgixOpts: $imgixOpts) {
    url
  }
  mediaType
  mimeType
  name
}
    `;
export const FeedInteractionPollFragmentDoc = gql`
    fragment FeedInteractionPoll on Interaction {
  id
  ctaDetails
  ctaTitle
  earningPotential {
    amount
  }
  expiresAt
  interactionType
  status
  ... on InteractionPoll {
    primaryMedia {
      ...FeedMessagePreviewMediaPointer
    }
    pollMessage: message {
      author {
        id
        communityName
        displayName
        profilePictureUrl
      }
      body
      conversationId
    }
    options {
      ...PollOptionParts
    }
    pollResults {
      pollOptionResults {
        pollOption {
          ...PollOptionParts
        }
      }
      totalResponseCount
    }
    userAnswer {
      ... on PollTextOption {
        id
        order
        text
        type
      }
    }
  }
}
    ${FeedMessagePreviewMediaPointerFragmentDoc}
${PollOptionPartsFragmentDoc}`;
export const FeedInteractionReplyFragmentDoc = gql`
    fragment FeedInteractionReply on Interaction {
  id
  ctaDetails
  ctaTitle
  earningPotential {
    amount
  }
  expiresAt
  interactionType
  status
  ... on InteractionReply {
    primaryMedia {
      ...FeedMessagePreviewMediaPointer
    }
    replyMessage: message {
      attachments {
        ...FeedMessagePreviewMediaPointer
      }
      author {
        id
        communityName
        displayName
        profilePictureUrl
      }
      body
    }
  }
}
    ${FeedMessagePreviewMediaPointerFragmentDoc}`;
export const FeedInteractionClickFragmentDoc = gql`
    fragment FeedInteractionClick on Interaction {
  id
  ctaDetails
  ctaTitle
  earningPotential {
    amount
  }
  expiresAt
  interactionType
  status
  ... on InteractionClick {
    primaryMedia {
      ...FeedMessagePreviewMediaPointer
    }
    clickMessage: message {
      attachments {
        ...FeedMessagePreviewMediaPointer
      }
      author {
        id
        communityName
        displayName
        profilePictureUrl
      }
      body
    }
  }
}
    ${FeedMessagePreviewMediaPointerFragmentDoc}`;
export const FeedInteractionRedemptionFragmentDoc = gql`
    fragment FeedInteractionRedemption on Interaction {
  id
  ctaDetails
  ctaTitle
  earningPotential {
    amount
  }
  expiresAt
  interactionType
  status
  ... on InteractionRedemption {
    redemptionMessage: message {
      attachments {
        ...FeedMessagePreviewMediaPointer
      }
      author {
        id
        communityName
        displayName
        profilePictureUrl
      }
      body
    }
    redemption {
      ...RedemptionParts
    }
  }
}
    ${FeedMessagePreviewMediaPointerFragmentDoc}
${RedemptionPartsFragmentDoc}`;
export const FeedInteractionRedemptionOfferFragmentDoc = gql`
    fragment FeedInteractionRedemptionOffer on Interaction {
  id
  ctaDetails
  ctaTitle
  earningPotential {
    amount
  }
  expiresAt
  interactionType
  status
  ... on InteractionRedemption {
    redemptionOfferMessage: message {
      attachments {
        ...FeedMessagePreviewMediaPointer
      }
      author {
        id
        communityName
        displayName
        profilePictureUrl
      }
      body
    }
    redemption {
      ...RedemptionParts
    }
  }
}
    ${FeedMessagePreviewMediaPointerFragmentDoc}
${RedemptionPartsFragmentDoc}`;
export const PagePartsFragmentDoc = gql`
    fragment PageParts on BasePage {
  currentOffset
  currentPage
  endCursor
  hasNextPage
  hasPreviousPage
  nextOffset
  nextPage
  pageSize
  previousOffset
  previousPage
  startCursor
  totalCount
  totalPages
}
    `;
export const PageFilterPartsFragmentDoc = gql`
    fragment PageFilterParts on PageFilterValues {
  boolean
  float
  floats
  integer
  integers
  string
  strings
}
    `;
export const ValidationMessagePartsFragmentDoc = gql`
    fragment ValidationMessageParts on ValidationMessage {
  code
  field
  message
  options {
    key
    value
  }
  template
}
    `;
export const InteractionPartsFragmentDoc = gql`
    fragment InteractionParts on Interaction {
  id
  ctaDetails
  ctaTitle
  earningPotential {
    amount
  }
  expiresAt
  interactionType
  status
  ... on InteractionPoll {
    options {
      ...PollOptionParts
    }
    pollResults {
      pollOptionResults {
        pollOption {
          ...PollOptionParts
        }
      }
      totalResponseCount
    }
    userAnswer {
      ... on PollTextOption {
        id
        order
        text
        type
      }
    }
  }
  ... on InteractionRedemption {
    redemption {
      ...RedemptionParts
    }
  }
  ... on InteractionRedemptionOffer {
    redemptions {
      ...RedemptionParts
      primaryMedia {
        id
        mediaType
        downloadUrls {
          mediaType
          key
          url
        }
      }
    }
  }
}
    ${PollOptionPartsFragmentDoc}
${RedemptionPartsFragmentDoc}`;
export const InteractionResultPartsFragmentDoc = gql`
    fragment InteractionResultParts on InteractionResult {
  messages {
    ...ValidationMessageParts
  }
  result {
    ...InteractionParts
    followUpInteraction {
      id
    }
  }
  successful
}
    ${ValidationMessagePartsFragmentDoc}
${InteractionPartsFragmentDoc}`;
export const SwayCashLeaderboardPartsFragmentDoc = gql`
    fragment SwayCashLeaderboardParts on SwayCashLeaderboardRecord {
  displayName
  firstName
  lastName
  profileId
  rank
  rowNumber
  overallStreak
  swayCash {
    amount
  }
}
    `;
export const TriviaLeaderboardPartsFragmentDoc = gql`
    fragment TriviaLeaderboardParts on TriviaLeaderboardRecord {
  correctCount
  displayName
  firstName
  incorrectCount
  lastCorrectAt
  lastName
  profileId
  rank
  rowNumber
}
    `;
export const MediaPointerProxyPartsFragmentDoc = gql`
    fragment MediaPointerProxyParts on MediaPointer {
  proxy: downloadUrl(encoding: PROXY, imgixOpts: $imgixOpts) {
    url
  }
}
    `;
export const MediaPointerProxySrcSetPartsFragmentDoc = gql`
    fragment MediaPointerProxySrcSetParts on MediaPointer {
  proxySrcSet: downloadUrl(encoding: PROXY_SRCSET, imgixOpts: $imgixOpts) {
    url
  }
}
    `;
export const RedemptionMediaPreviewPartsFragmentDoc = gql`
    fragment RedemptionMediaPreviewParts on Redemption {
  primaryMedia {
    id
    ...MediaPointerProxyParts
    ...MediaPointerProxySrcSetParts
  }
}
    ${MediaPointerProxyPartsFragmentDoc}
${MediaPointerProxySrcSetPartsFragmentDoc}`;
export const LinkPartsFragmentDoc = gql`
    fragment LinkParts on Link {
  id
  creator {
    id
  }
  disabledAt
  insertedAt
  internal
  name
  redirectProfile {
    id
    displayName
    profilePhotoUrl
    profilePhotoUrlSrcset
  }
  redirectRedemption {
    id
    active
    archivedAt
    name
    price {
      amount
    }
    ...RedemptionMediaPreviewParts
  }
  shortCode
  trackingCode
  updatedAt
  uri
}
    ${RedemptionMediaPreviewPartsFragmentDoc}`;
export const ActivityPartsFragmentDoc = gql`
    fragment ActivityParts on Link {
  activity {
    granularity
    lookbackInterval
    lookbackUnit
    total
    data {
      count
      interval
    }
  }
}
    `;
export const SignedUploadUrlPartsFragmentDoc = gql`
    fragment SignedUploadUrlParts on SignedUrl {
  key
  mediaPointerId
  metadata
  url
}
    `;
export const MessagePreviewMediaPointerPartsFragmentDoc = gql`
    fragment MessagePreviewMediaPointerParts on MediaPointer {
  id
  thumbnail: downloadUrl(
    encoding: PROXY
    imgixOpts: [{key: "fit", value: "crop"}, {key: "width", value: "300"}, {key: "height", value: "200"}]
  ) {
    url
  }
  thumbnailSrcSet: downloadUrl(
    encoding: PROXY_SRCSET
    imgixOpts: [{key: "fit", value: "crop"}, {key: "width", value: "300"}, {key: "height", value: "200"}]
  ) {
    url
  }
  fullSize: downloadUrl(encoding: PROXY) {
    url
  }
  fullSizeSrcSet: downloadUrl(encoding: PROXY_SRCSET) {
    url
  }
  thumbnailAnimated: downloadUrl(encoding: THUMBNAIL_ANIMATED) {
    url
  }
  original: downloadUrl(encoding: ORIGINAL) {
    url
  }
  storyboard: downloadUrl(encoding: STORYBOARD) {
    url
  }
  filesizeInBytes
  mediaType
  mimeType
  name
  provider
  status
}
    `;
export const EmojiReactionPartsFragmentDoc = gql`
    fragment EmojiReactionParts on EmojiReaction {
  id
  reactedAt
  reaction
  reactorProfileId
}
    `;
export const TransactionPartsFragmentDoc = gql`
    fragment TransactionParts on MessageTransaction {
  id
  status
  price {
    amount
  }
  earningPotential {
    amount
  }
  expiresAt
}
    `;
export const MessagePartsFragmentDoc = gql`
    fragment MessageParts on Message {
  id
  attachments {
    ...MessagePreviewMediaPointerParts
  }
  author {
    id
    communityName
    firstName
    lastName
    profilePictureUrl
  }
  sentBySway
  body
  emojiReactions {
    ...EmojiReactionParts
  }
  insertedAt
  interactions {
    ...InteractionParts
  }
  transaction {
    ...TransactionParts
  }
  type
}
    ${MessagePreviewMediaPointerPartsFragmentDoc}
${EmojiReactionPartsFragmentDoc}
${InteractionPartsFragmentDoc}
${TransactionPartsFragmentDoc}`;
export const NotificationPreferencesPartsFragmentDoc = gql`
    fragment NotificationPreferencesParts on NotificationPreferences {
  channels {
    id
    description
    enabled
    type
    title
  }
  workflows {
    id
    channelPreferences {
      id
      description
      enabled
      type
    }
    description
    enabled
    key
    profileTypes
    title
  }
}
    `;
export const SmsPendingVerificationPartsFragmentDoc = gql`
    fragment SmsPendingVerificationParts on SmsPendingVerification {
  message
  smsPhoneNumber
}
    `;
export const ChannelPreferencePartsFragmentDoc = gql`
    fragment ChannelPreferenceParts on ChannelPreference {
  id
  description
  enabled
  title
  type
}
    `;
export const WorkflowPreferencePartsFragmentDoc = gql`
    fragment WorkflowPreferenceParts on WorkflowPreference {
  id
  channelPreferences {
    ...ChannelPreferenceParts
  }
  description
  enabled
  key
  profileTypes
  title
}
    ${ChannelPreferencePartsFragmentDoc}`;
export const BlockPartsFragmentDoc = gql`
    fragment BlockParts on Block {
  id
  blockingProfile {
    id
  }
  blockedProfile {
    id
    communityName
    displayName
    firstName
    lastName
    profilePictureUrl
    profileType
    verified
  }
  insertedAt
}
    `;
export const BlockSubscriptionPartsFragmentDoc = gql`
    fragment BlockSubscriptionParts on BlockEvent {
  __typename
  block {
    ...BlockParts
  }
  blockType: type
}
    ${BlockPartsFragmentDoc}`;
export const RedemptionLimitPartsFragmentDoc = gql`
    fragment RedemptionLimitParts on RedemptionLimit {
  blocking
  count
  description
  limit
  limitScope
  limitType
  ... on RedemptionLimitCount {
    blocking
    count
    description
    limit
    limitScope
    limitType
  }
  ... on RedemptionLimitRate {
    blocking
    count
    description
    endOfDay
    interval
    limit
    limitScope
    limitType
    unit
  }
}
    `;
export const AccessTokenPartsFragmentDoc = gql`
    fragment AccessTokenParts on AccessToken {
  validForSeconds
  validUntil
  value
}
    `;
export const DeviceTokenPartsFragmentDoc = gql`
    fragment DeviceTokenParts on DeviceToken {
  id
  deviceId
  deviceName
  deviceToken
  insertedAt
  service
}
    `;
export const PollAndTriviaPrimaryMediaPartsFragmentDoc = gql`
    fragment PollAndTriviaPrimaryMediaParts on MediaPointer {
  id
  name
  downloadUrls(imgixOpts: $imgixOpts) {
    key
    mediaPointerId
    mediaType
    metadata
    url
  }
}
    `;
export const PollAndTriviaPartsFragmentDoc = gql`
    fragment PollAndTriviaParts on PollObject {
  id
  bonusText
  caption
  consolationPrice
  endAt
  important
  name
  options {
    id
    order
    type
    correct
    ... on PollTextOption {
      text
      order
      id
    }
  }
  price
  primaryMedia {
    ...PollAndTriviaPrimaryMediaParts
  }
  question
  startAt
  type
}
    ${PollAndTriviaPrimaryMediaPartsFragmentDoc}`;
export const PollAndTriviaResultPartsFragmentDoc = gql`
    fragment PollAndTriviaResultParts on PollResult {
  successful
  messages {
    code
    field
    message
    options {
      key
      value
    }
    template
  }
  result {
    ...PollAndTriviaParts
  }
}
    ${PollAndTriviaPartsFragmentDoc}`;
export const TosVersionPartsFragmentDoc = gql`
    fragment TosVersionParts on TosVersion {
  id
  version
  requireUserAcceptance
  insertedAt
}
    `;
export const TosAcceptedPartsFragmentDoc = gql`
    fragment TosAcceptedParts on TosAccepted {
  id
  insertedAt
  version {
    ...TosVersionParts
  }
  user {
    id
    acceptedTerms
  }
}
    ${TosVersionPartsFragmentDoc}`;
export const ProfilePartsFragmentDoc = gql`
    fragment ProfileParts on Profile {
  id
  blocks {
    ...BlockParts
  }
  communityName
  displayName
  earningEnabled
  firstName
  introduction
  lastName
  pricing {
    replyPrice {
      amount
    }
  }
  profileLinks {
    id
    title
    url
  }
  profilePhotoUrl
  profilePictureUrl
  profileType
  redemptions {
    ...RedemptionParts
    linkedVendor {
      id
      displayName
      name
      photoUrl
    }
  }
  timezone
  unclaimed
  verified
  isNonProfit
}
    ${BlockPartsFragmentDoc}
${RedemptionPartsFragmentDoc}`;
export const UserRolePartsFragmentDoc = gql`
    fragment UserRoleParts on UserRole {
  roleName
}
    `;
export const UserPartsFragmentDoc = gql`
    fragment UserParts on User {
  id
  acceptedTerms
  adminDeactivatedAt
  anonymizedAt
  blocks {
    ...BlockParts
  }
  confirmedAt
  deactivatedAt
  earnerOnboardingLastSeen
  email
  id
  lastTosAccepted {
    ...TosAcceptedParts
  }
  profile {
    ...ProfileParts
  }
  smsLast4
  userRoles {
    ...UserRoleParts
  }
}
    ${BlockPartsFragmentDoc}
${TosAcceptedPartsFragmentDoc}
${ProfilePartsFragmentDoc}
${UserRolePartsFragmentDoc}`;
export const UserLoginPartsFragmentDoc = gql`
    fragment UserLoginParts on User {
  id
  acceptedTerms
  email
  lastTosAccepted {
    ...TosAcceptedParts
  }
  profile {
    id
    communityName
    displayName
    profilePictureUrl
    profilePhotoUrl
    firstName
    lastName
    profileType
    isNonProfit
  }
}
    ${TosAcceptedPartsFragmentDoc}`;
export const AccountDeactivateDocument = gql`
    mutation AccountDeactivate($password: String!) {
  accountDeactivate(password: $password) {
    messages {
      ...ValidationMessageParts
    }
    result {
      message
      user {
        id
        adminDeactivatedAt
        deactivatedAt
      }
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type AccountDeactivateMutationFn = Apollo.MutationFunction<AccountDeactivateMutation, AccountDeactivateMutationVariables>;

/**
 * __useAccountDeactivateMutation__
 *
 * To run a mutation, you first call `useAccountDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountDeactivateMutation, { data, loading, error }] = useAccountDeactivateMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAccountDeactivateMutation(baseOptions?: Apollo.MutationHookOptions<AccountDeactivateMutation, AccountDeactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountDeactivateMutation, AccountDeactivateMutationVariables>(AccountDeactivateDocument, options);
      }
export type AccountDeactivateMutationHookResult = ReturnType<typeof useAccountDeactivateMutation>;
export type AccountDeactivateMutationResult = Apollo.MutationResult<AccountDeactivateMutation>;
export type AccountDeactivateMutationOptions = Apollo.BaseMutationOptions<AccountDeactivateMutation, AccountDeactivateMutationVariables>;
export const AccountReactivateDocument = gql`
    mutation AccountReactivate {
  accountReactivate {
    messages {
      ...ValidationMessageParts
    }
    result {
      message
      user {
        id
        adminDeactivatedAt
        deactivatedAt
      }
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type AccountReactivateMutationFn = Apollo.MutationFunction<AccountReactivateMutation, AccountReactivateMutationVariables>;

/**
 * __useAccountReactivateMutation__
 *
 * To run a mutation, you first call `useAccountReactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountReactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountReactivateMutation, { data, loading, error }] = useAccountReactivateMutation({
 *   variables: {
 *   },
 * });
 */
export function useAccountReactivateMutation(baseOptions?: Apollo.MutationHookOptions<AccountReactivateMutation, AccountReactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountReactivateMutation, AccountReactivateMutationVariables>(AccountReactivateDocument, options);
      }
export type AccountReactivateMutationHookResult = ReturnType<typeof useAccountReactivateMutation>;
export type AccountReactivateMutationResult = Apollo.MutationResult<AccountReactivateMutation>;
export type AccountReactivateMutationOptions = Apollo.BaseMutationOptions<AccountReactivateMutation, AccountReactivateMutationVariables>;
export const RequestAccountManagementActionDocument = gql`
    mutation RequestAccountManagementAction($password: String!, $permanentAccountDeletion: Boolean!, $permanentDataDeletion: Boolean!) {
  requestAccountManagementAction(
    password: $password
    permanentAccountDeletion: $permanentAccountDeletion
    permanentDataDeletion: $permanentDataDeletion
  ) {
    messages {
      ...ValidationMessageParts
    }
    result {
      insertedAt
      permanentAccountDeletion
      permanentDataDeletion
      requestingUserId
      resolvedAt
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type RequestAccountManagementActionMutationFn = Apollo.MutationFunction<RequestAccountManagementActionMutation, RequestAccountManagementActionMutationVariables>;

/**
 * __useRequestAccountManagementActionMutation__
 *
 * To run a mutation, you first call `useRequestAccountManagementActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccountManagementActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAccountManagementActionMutation, { data, loading, error }] = useRequestAccountManagementActionMutation({
 *   variables: {
 *      password: // value for 'password'
 *      permanentAccountDeletion: // value for 'permanentAccountDeletion'
 *      permanentDataDeletion: // value for 'permanentDataDeletion'
 *   },
 * });
 */
export function useRequestAccountManagementActionMutation(baseOptions?: Apollo.MutationHookOptions<RequestAccountManagementActionMutation, RequestAccountManagementActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAccountManagementActionMutation, RequestAccountManagementActionMutationVariables>(RequestAccountManagementActionDocument, options);
      }
export type RequestAccountManagementActionMutationHookResult = ReturnType<typeof useRequestAccountManagementActionMutation>;
export type RequestAccountManagementActionMutationResult = Apollo.MutationResult<RequestAccountManagementActionMutation>;
export type RequestAccountManagementActionMutationOptions = Apollo.BaseMutationOptions<RequestAccountManagementActionMutation, RequestAccountManagementActionMutationVariables>;
export const VendorAnalyticsDocument = gql`
    query VendorAnalytics($lookbackDays: Int = 7) {
  vendorAnalytics(lookbackDays: $lookbackDays) {
    completedRedemptionsCount
    responseCount
    impressionAnalytics {
      impressionStats {
        action
        actionSource
        targetType
        total
      }
      total
    }
    lookbackDays
    newFollowerCount
    startAt
    endAt
  }
}
    `;

/**
 * __useVendorAnalyticsQuery__
 *
 * To run a query within a React component, call `useVendorAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorAnalyticsQuery({
 *   variables: {
 *      lookbackDays: // value for 'lookbackDays'
 *   },
 * });
 */
export function useVendorAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<VendorAnalyticsQuery, VendorAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorAnalyticsQuery, VendorAnalyticsQueryVariables>(VendorAnalyticsDocument, options);
      }
export function useVendorAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorAnalyticsQuery, VendorAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorAnalyticsQuery, VendorAnalyticsQueryVariables>(VendorAnalyticsDocument, options);
        }
export function useVendorAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VendorAnalyticsQuery, VendorAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VendorAnalyticsQuery, VendorAnalyticsQueryVariables>(VendorAnalyticsDocument, options);
        }
export type VendorAnalyticsQueryHookResult = ReturnType<typeof useVendorAnalyticsQuery>;
export type VendorAnalyticsLazyQueryHookResult = ReturnType<typeof useVendorAnalyticsLazyQuery>;
export type VendorAnalyticsSuspenseQueryHookResult = ReturnType<typeof useVendorAnalyticsSuspenseQuery>;
export type VendorAnalyticsQueryResult = Apollo.QueryResult<VendorAnalyticsQuery, VendorAnalyticsQueryVariables>;
export const VendorWeeklyAnalyticsDocument = gql`
    query VendorWeeklyAnalytics($endAt: DateTime, $lookbackDays: Int) {
  vendorWeeklyAnalytics(endAt: $endAt, lookbackDays: $lookbackDays) {
    startAt
    endAt
    memberAcquisitionSwaycashEarned
    newFollowers
    redemptionSwaycashEarned
    successfulRedemptions
    totalSwaycashEarned
    broadcastStats {
      broadcastId
      broadcastName
      fulfilled
      fulfillmentRate
      total
      totalUniqueMembers
      viewRate
      views
    }
    persistentBroadcastStats {
      broadcastId
      broadcastName
      fulfilled
      fulfillmentRate
      total
      totalUniqueMembers
      viewRate
      views
    }
  }
}
    `;

/**
 * __useVendorWeeklyAnalyticsQuery__
 *
 * To run a query within a React component, call `useVendorWeeklyAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorWeeklyAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorWeeklyAnalyticsQuery({
 *   variables: {
 *      endAt: // value for 'endAt'
 *      lookbackDays: // value for 'lookbackDays'
 *   },
 * });
 */
export function useVendorWeeklyAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<VendorWeeklyAnalyticsQuery, VendorWeeklyAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorWeeklyAnalyticsQuery, VendorWeeklyAnalyticsQueryVariables>(VendorWeeklyAnalyticsDocument, options);
      }
export function useVendorWeeklyAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorWeeklyAnalyticsQuery, VendorWeeklyAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorWeeklyAnalyticsQuery, VendorWeeklyAnalyticsQueryVariables>(VendorWeeklyAnalyticsDocument, options);
        }
export function useVendorWeeklyAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VendorWeeklyAnalyticsQuery, VendorWeeklyAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VendorWeeklyAnalyticsQuery, VendorWeeklyAnalyticsQueryVariables>(VendorWeeklyAnalyticsDocument, options);
        }
export type VendorWeeklyAnalyticsQueryHookResult = ReturnType<typeof useVendorWeeklyAnalyticsQuery>;
export type VendorWeeklyAnalyticsLazyQueryHookResult = ReturnType<typeof useVendorWeeklyAnalyticsLazyQuery>;
export type VendorWeeklyAnalyticsSuspenseQueryHookResult = ReturnType<typeof useVendorWeeklyAnalyticsSuspenseQuery>;
export type VendorWeeklyAnalyticsQueryResult = Apollo.QueryResult<VendorWeeklyAnalyticsQuery, VendorWeeklyAnalyticsQueryVariables>;
export const AnalyticsVendorProfileViewsDocument = gql`
    query AnalyticsVendorProfileViews($actionSources: [String!] = ["feed", "vendor-profile-page"], $actions: [String!] = ["viewed"], $targetTypes: [String!] = ["vendor"], $lookbackDays: Int = 7) {
  vendorAnalytics(lookbackDays: $lookbackDays) {
    impressionAnalytics(
      actionSources: $actionSources
      actions: $actions
      targetTypes: $targetTypes
    ) {
      total
      impressionStats {
        action
        actionSource
        targetType
        total
      }
    }
  }
}
    `;

/**
 * __useAnalyticsVendorProfileViewsQuery__
 *
 * To run a query within a React component, call `useAnalyticsVendorProfileViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsVendorProfileViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsVendorProfileViewsQuery({
 *   variables: {
 *      actionSources: // value for 'actionSources'
 *      actions: // value for 'actions'
 *      targetTypes: // value for 'targetTypes'
 *      lookbackDays: // value for 'lookbackDays'
 *   },
 * });
 */
export function useAnalyticsVendorProfileViewsQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsVendorProfileViewsQuery, AnalyticsVendorProfileViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsVendorProfileViewsQuery, AnalyticsVendorProfileViewsQueryVariables>(AnalyticsVendorProfileViewsDocument, options);
      }
export function useAnalyticsVendorProfileViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsVendorProfileViewsQuery, AnalyticsVendorProfileViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsVendorProfileViewsQuery, AnalyticsVendorProfileViewsQueryVariables>(AnalyticsVendorProfileViewsDocument, options);
        }
export function useAnalyticsVendorProfileViewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsVendorProfileViewsQuery, AnalyticsVendorProfileViewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsVendorProfileViewsQuery, AnalyticsVendorProfileViewsQueryVariables>(AnalyticsVendorProfileViewsDocument, options);
        }
export type AnalyticsVendorProfileViewsQueryHookResult = ReturnType<typeof useAnalyticsVendorProfileViewsQuery>;
export type AnalyticsVendorProfileViewsLazyQueryHookResult = ReturnType<typeof useAnalyticsVendorProfileViewsLazyQuery>;
export type AnalyticsVendorProfileViewsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsVendorProfileViewsSuspenseQuery>;
export type AnalyticsVendorProfileViewsQueryResult = Apollo.QueryResult<AnalyticsVendorProfileViewsQuery, AnalyticsVendorProfileViewsQueryVariables>;
export const AnalyticsVendorRedemptionViewsDocument = gql`
    query AnalyticsVendorRedemptionViews($actionSources: [String!] = ["feed", "redemption-page"], $actions: [String!] = ["viewed"], $targetTypes: [String!] = ["redemption"], $lookbackDays: Int = 7) {
  vendorAnalytics(lookbackDays: $lookbackDays) {
    impressionAnalytics(
      actionSources: $actionSources
      actions: $actions
      targetTypes: $targetTypes
    ) {
      total
      impressionStats {
        action
        actionSource
        targetType
        total
      }
    }
  }
}
    `;

/**
 * __useAnalyticsVendorRedemptionViewsQuery__
 *
 * To run a query within a React component, call `useAnalyticsVendorRedemptionViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsVendorRedemptionViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsVendorRedemptionViewsQuery({
 *   variables: {
 *      actionSources: // value for 'actionSources'
 *      actions: // value for 'actions'
 *      targetTypes: // value for 'targetTypes'
 *      lookbackDays: // value for 'lookbackDays'
 *   },
 * });
 */
export function useAnalyticsVendorRedemptionViewsQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsVendorRedemptionViewsQuery, AnalyticsVendorRedemptionViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsVendorRedemptionViewsQuery, AnalyticsVendorRedemptionViewsQueryVariables>(AnalyticsVendorRedemptionViewsDocument, options);
      }
export function useAnalyticsVendorRedemptionViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsVendorRedemptionViewsQuery, AnalyticsVendorRedemptionViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsVendorRedemptionViewsQuery, AnalyticsVendorRedemptionViewsQueryVariables>(AnalyticsVendorRedemptionViewsDocument, options);
        }
export function useAnalyticsVendorRedemptionViewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsVendorRedemptionViewsQuery, AnalyticsVendorRedemptionViewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsVendorRedemptionViewsQuery, AnalyticsVendorRedemptionViewsQueryVariables>(AnalyticsVendorRedemptionViewsDocument, options);
        }
export type AnalyticsVendorRedemptionViewsQueryHookResult = ReturnType<typeof useAnalyticsVendorRedemptionViewsQuery>;
export type AnalyticsVendorRedemptionViewsLazyQueryHookResult = ReturnType<typeof useAnalyticsVendorRedemptionViewsLazyQuery>;
export type AnalyticsVendorRedemptionViewsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsVendorRedemptionViewsSuspenseQuery>;
export type AnalyticsVendorRedemptionViewsQueryResult = Apollo.QueryResult<AnalyticsVendorRedemptionViewsQuery, AnalyticsVendorRedemptionViewsQueryVariables>;
export const BroadcastArchiveDocument = gql`
    mutation BroadcastArchive($broadcastId: ID!) {
  broadcastArchive(broadcastId: $broadcastId) {
    messages {
      ...ValidationMessageParts
    }
    result {
      ...BroadcastParts
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}
${BroadcastPartsFragmentDoc}`;
export type BroadcastArchiveMutationFn = Apollo.MutationFunction<BroadcastArchiveMutation, BroadcastArchiveMutationVariables>;

/**
 * __useBroadcastArchiveMutation__
 *
 * To run a mutation, you first call `useBroadcastArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBroadcastArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [broadcastArchiveMutation, { data, loading, error }] = useBroadcastArchiveMutation({
 *   variables: {
 *      broadcastId: // value for 'broadcastId'
 *   },
 * });
 */
export function useBroadcastArchiveMutation(baseOptions?: Apollo.MutationHookOptions<BroadcastArchiveMutation, BroadcastArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BroadcastArchiveMutation, BroadcastArchiveMutationVariables>(BroadcastArchiveDocument, options);
      }
export type BroadcastArchiveMutationHookResult = ReturnType<typeof useBroadcastArchiveMutation>;
export type BroadcastArchiveMutationResult = Apollo.MutationResult<BroadcastArchiveMutation>;
export type BroadcastArchiveMutationOptions = Apollo.BaseMutationOptions<BroadcastArchiveMutation, BroadcastArchiveMutationVariables>;
export const BroadcastUnarchiveDocument = gql`
    mutation BroadcastUnarchive($broadcastId: ID!) {
  broadcastUnarchive(broadcastId: $broadcastId) {
    messages {
      ...ValidationMessageParts
    }
    result {
      ...BroadcastParts
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}
${BroadcastPartsFragmentDoc}`;
export type BroadcastUnarchiveMutationFn = Apollo.MutationFunction<BroadcastUnarchiveMutation, BroadcastUnarchiveMutationVariables>;

/**
 * __useBroadcastUnarchiveMutation__
 *
 * To run a mutation, you first call `useBroadcastUnarchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBroadcastUnarchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [broadcastUnarchiveMutation, { data, loading, error }] = useBroadcastUnarchiveMutation({
 *   variables: {
 *      broadcastId: // value for 'broadcastId'
 *   },
 * });
 */
export function useBroadcastUnarchiveMutation(baseOptions?: Apollo.MutationHookOptions<BroadcastUnarchiveMutation, BroadcastUnarchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BroadcastUnarchiveMutation, BroadcastUnarchiveMutationVariables>(BroadcastUnarchiveDocument, options);
      }
export type BroadcastUnarchiveMutationHookResult = ReturnType<typeof useBroadcastUnarchiveMutation>;
export type BroadcastUnarchiveMutationResult = Apollo.MutationResult<BroadcastUnarchiveMutation>;
export type BroadcastUnarchiveMutationOptions = Apollo.BaseMutationOptions<BroadcastUnarchiveMutation, BroadcastUnarchiveMutationVariables>;
export const BroadcastCreateDocument = gql`
    mutation BroadcastCreate($broadcast: BroadcastInput!) {
  broadcastCreate(broadcast: $broadcast) {
    messages {
      ...ValidationMessageParts
    }
    result {
      ...BroadcastParts
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}
${BroadcastPartsFragmentDoc}`;
export type BroadcastCreateMutationFn = Apollo.MutationFunction<BroadcastCreateMutation, BroadcastCreateMutationVariables>;

/**
 * __useBroadcastCreateMutation__
 *
 * To run a mutation, you first call `useBroadcastCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBroadcastCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [broadcastCreateMutation, { data, loading, error }] = useBroadcastCreateMutation({
 *   variables: {
 *      broadcast: // value for 'broadcast'
 *   },
 * });
 */
export function useBroadcastCreateMutation(baseOptions?: Apollo.MutationHookOptions<BroadcastCreateMutation, BroadcastCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BroadcastCreateMutation, BroadcastCreateMutationVariables>(BroadcastCreateDocument, options);
      }
export type BroadcastCreateMutationHookResult = ReturnType<typeof useBroadcastCreateMutation>;
export type BroadcastCreateMutationResult = Apollo.MutationResult<BroadcastCreateMutation>;
export type BroadcastCreateMutationOptions = Apollo.BaseMutationOptions<BroadcastCreateMutation, BroadcastCreateMutationVariables>;
export const BroadcastPublishDocument = gql`
    mutation BroadcastPublish($broadcastId: ID!) {
  broadcastPublish(broadcastId: $broadcastId) {
    messages {
      ...ValidationMessageParts
    }
    result {
      ...BroadcastParts
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}
${BroadcastPartsFragmentDoc}`;
export type BroadcastPublishMutationFn = Apollo.MutationFunction<BroadcastPublishMutation, BroadcastPublishMutationVariables>;

/**
 * __useBroadcastPublishMutation__
 *
 * To run a mutation, you first call `useBroadcastPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBroadcastPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [broadcastPublishMutation, { data, loading, error }] = useBroadcastPublishMutation({
 *   variables: {
 *      broadcastId: // value for 'broadcastId'
 *   },
 * });
 */
export function useBroadcastPublishMutation(baseOptions?: Apollo.MutationHookOptions<BroadcastPublishMutation, BroadcastPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BroadcastPublishMutation, BroadcastPublishMutationVariables>(BroadcastPublishDocument, options);
      }
export type BroadcastPublishMutationHookResult = ReturnType<typeof useBroadcastPublishMutation>;
export type BroadcastPublishMutationResult = Apollo.MutationResult<BroadcastPublishMutation>;
export type BroadcastPublishMutationOptions = Apollo.BaseMutationOptions<BroadcastPublishMutation, BroadcastPublishMutationVariables>;
export const BroadcastUpdateDocument = gql`
    mutation BroadcastUpdate($broadcast: BroadcastInput!, $broadcastId: ID!) {
  broadcastUpdate(broadcast: $broadcast, broadcastId: $broadcastId) {
    messages {
      ...ValidationMessageParts
    }
    result {
      ...BroadcastParts
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}
${BroadcastPartsFragmentDoc}`;
export type BroadcastUpdateMutationFn = Apollo.MutationFunction<BroadcastUpdateMutation, BroadcastUpdateMutationVariables>;

/**
 * __useBroadcastUpdateMutation__
 *
 * To run a mutation, you first call `useBroadcastUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBroadcastUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [broadcastUpdateMutation, { data, loading, error }] = useBroadcastUpdateMutation({
 *   variables: {
 *      broadcast: // value for 'broadcast'
 *      broadcastId: // value for 'broadcastId'
 *   },
 * });
 */
export function useBroadcastUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BroadcastUpdateMutation, BroadcastUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BroadcastUpdateMutation, BroadcastUpdateMutationVariables>(BroadcastUpdateDocument, options);
      }
export type BroadcastUpdateMutationHookResult = ReturnType<typeof useBroadcastUpdateMutation>;
export type BroadcastUpdateMutationResult = Apollo.MutationResult<BroadcastUpdateMutation>;
export type BroadcastUpdateMutationOptions = Apollo.BaseMutationOptions<BroadcastUpdateMutation, BroadcastUpdateMutationVariables>;
export const BroadcastsDocument = gql`
    query Broadcasts($query: BroadcastPageInput) {
  broadcasts(query: $query) {
    data {
      ...BroadcastParts
      stats {
        ...BroadcastStatsParts
      }
      followUpMessageStats {
        ...BroadcastStatsParts
      }
    }
    page {
      ...PageParts
    }
    query {
      filters {
        attribute
        op
        value {
          ...PageFilterParts
        }
      }
    }
  }
}
    ${BroadcastPartsFragmentDoc}
${BroadcastStatsPartsFragmentDoc}
${PagePartsFragmentDoc}
${PageFilterPartsFragmentDoc}`;

/**
 * __useBroadcastsQuery__
 *
 * To run a query within a React component, call `useBroadcastsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBroadcastsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBroadcastsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useBroadcastsQuery(baseOptions?: Apollo.QueryHookOptions<BroadcastsQuery, BroadcastsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BroadcastsQuery, BroadcastsQueryVariables>(BroadcastsDocument, options);
      }
export function useBroadcastsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BroadcastsQuery, BroadcastsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BroadcastsQuery, BroadcastsQueryVariables>(BroadcastsDocument, options);
        }
export function useBroadcastsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastsQuery, BroadcastsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BroadcastsQuery, BroadcastsQueryVariables>(BroadcastsDocument, options);
        }
export type BroadcastsQueryHookResult = ReturnType<typeof useBroadcastsQuery>;
export type BroadcastsLazyQueryHookResult = ReturnType<typeof useBroadcastsLazyQuery>;
export type BroadcastsSuspenseQueryHookResult = ReturnType<typeof useBroadcastsSuspenseQuery>;
export type BroadcastsQueryResult = Apollo.QueryResult<BroadcastsQuery, BroadcastsQueryVariables>;
export const BroadcastTargetsDocument = gql`
    query BroadcastTargets($query: TargetedMemberPageInput) {
  broadcastTargets(query: $query) {
    data {
      member {
        id
        displayName
        fullName
        photoUrl
        photoUrlSrcset
      }
    }
    page {
      totalCount
    }
  }
}
    `;

/**
 * __useBroadcastTargetsQuery__
 *
 * To run a query within a React component, call `useBroadcastTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBroadcastTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBroadcastTargetsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useBroadcastTargetsQuery(baseOptions?: Apollo.QueryHookOptions<BroadcastTargetsQuery, BroadcastTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BroadcastTargetsQuery, BroadcastTargetsQueryVariables>(BroadcastTargetsDocument, options);
      }
export function useBroadcastTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BroadcastTargetsQuery, BroadcastTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BroadcastTargetsQuery, BroadcastTargetsQueryVariables>(BroadcastTargetsDocument, options);
        }
export function useBroadcastTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastTargetsQuery, BroadcastTargetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BroadcastTargetsQuery, BroadcastTargetsQueryVariables>(BroadcastTargetsDocument, options);
        }
export type BroadcastTargetsQueryHookResult = ReturnType<typeof useBroadcastTargetsQuery>;
export type BroadcastTargetsLazyQueryHookResult = ReturnType<typeof useBroadcastTargetsLazyQuery>;
export type BroadcastTargetsSuspenseQueryHookResult = ReturnType<typeof useBroadcastTargetsSuspenseQuery>;
export type BroadcastTargetsQueryResult = Apollo.QueryResult<BroadcastTargetsQuery, BroadcastTargetsQueryVariables>;
export const ChallengesOverviewDocument = gql`
    query ChallengesOverview($lookback: Int) {
  challengeAnswerCounts: challenge(key: "answer-count") {
    progress {
      state {
        ... on ProgressTriviaAnswerCounts {
          completedCorrectMilestones
          completedIncorrectMilestones
          correct
          incorrect
          milestones
          total
        }
      }
    }
  }
  challengeAnswerStreaks: challenge(key: "answer-streaks") {
    progress {
      state {
        ... on ProgressTriviaAnswerStreaks {
          overallStreak
          goal
          recordStreak
          moreThanSevenDaysReward
          moreThanFourteenDaysReward
          dailyStatus(lookback: $lookback) {
            day
            status
          }
          lastResponseAt
        }
      }
    }
  }
}
    `;

/**
 * __useChallengesOverviewQuery__
 *
 * To run a query within a React component, call `useChallengesOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengesOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengesOverviewQuery({
 *   variables: {
 *      lookback: // value for 'lookback'
 *   },
 * });
 */
export function useChallengesOverviewQuery(baseOptions?: Apollo.QueryHookOptions<ChallengesOverviewQuery, ChallengesOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChallengesOverviewQuery, ChallengesOverviewQueryVariables>(ChallengesOverviewDocument, options);
      }
export function useChallengesOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChallengesOverviewQuery, ChallengesOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChallengesOverviewQuery, ChallengesOverviewQueryVariables>(ChallengesOverviewDocument, options);
        }
export function useChallengesOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChallengesOverviewQuery, ChallengesOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChallengesOverviewQuery, ChallengesOverviewQueryVariables>(ChallengesOverviewDocument, options);
        }
export type ChallengesOverviewQueryHookResult = ReturnType<typeof useChallengesOverviewQuery>;
export type ChallengesOverviewLazyQueryHookResult = ReturnType<typeof useChallengesOverviewLazyQuery>;
export type ChallengesOverviewSuspenseQueryHookResult = ReturnType<typeof useChallengesOverviewSuspenseQuery>;
export type ChallengesOverviewQueryResult = Apollo.QueryResult<ChallengesOverviewQuery, ChallengesOverviewQueryVariables>;
export const AnswerStreakShieldsDocument = gql`
    query AnswerStreakShields {
  answerStreakRepairPrice {
    amount
    currency
  }
  amountOfAvailableStreakRepairs
}
    `;

/**
 * __useAnswerStreakShieldsQuery__
 *
 * To run a query within a React component, call `useAnswerStreakShieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnswerStreakShieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnswerStreakShieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnswerStreakShieldsQuery(baseOptions?: Apollo.QueryHookOptions<AnswerStreakShieldsQuery, AnswerStreakShieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnswerStreakShieldsQuery, AnswerStreakShieldsQueryVariables>(AnswerStreakShieldsDocument, options);
      }
export function useAnswerStreakShieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnswerStreakShieldsQuery, AnswerStreakShieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnswerStreakShieldsQuery, AnswerStreakShieldsQueryVariables>(AnswerStreakShieldsDocument, options);
        }
export function useAnswerStreakShieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnswerStreakShieldsQuery, AnswerStreakShieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnswerStreakShieldsQuery, AnswerStreakShieldsQueryVariables>(AnswerStreakShieldsDocument, options);
        }
export type AnswerStreakShieldsQueryHookResult = ReturnType<typeof useAnswerStreakShieldsQuery>;
export type AnswerStreakShieldsLazyQueryHookResult = ReturnType<typeof useAnswerStreakShieldsLazyQuery>;
export type AnswerStreakShieldsSuspenseQueryHookResult = ReturnType<typeof useAnswerStreakShieldsSuspenseQuery>;
export type AnswerStreakShieldsQueryResult = Apollo.QueryResult<AnswerStreakShieldsQuery, AnswerStreakShieldsQueryVariables>;
export const PurchaseStreakShieldDocument = gql`
    mutation PurchaseStreakShield {
  purchaseAnswerStreakRepair {
    amountInCents {
      amount
      currency
    }
  }
}
    `;
export type PurchaseStreakShieldMutationFn = Apollo.MutationFunction<PurchaseStreakShieldMutation, PurchaseStreakShieldMutationVariables>;

/**
 * __usePurchaseStreakShieldMutation__
 *
 * To run a mutation, you first call `usePurchaseStreakShieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseStreakShieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseStreakShieldMutation, { data, loading, error }] = usePurchaseStreakShieldMutation({
 *   variables: {
 *   },
 * });
 */
export function usePurchaseStreakShieldMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseStreakShieldMutation, PurchaseStreakShieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseStreakShieldMutation, PurchaseStreakShieldMutationVariables>(PurchaseStreakShieldDocument, options);
      }
export type PurchaseStreakShieldMutationHookResult = ReturnType<typeof usePurchaseStreakShieldMutation>;
export type PurchaseStreakShieldMutationResult = Apollo.MutationResult<PurchaseStreakShieldMutation>;
export type PurchaseStreakShieldMutationOptions = Apollo.BaseMutationOptions<PurchaseStreakShieldMutation, PurchaseStreakShieldMutationVariables>;
export const MilestonesEventDocument = gql`
    subscription MilestonesEvent {
  challengeEvents {
    ... on CorrectMilestoneReachedEvent {
      milestone
      swayCashEarned
    }
  }
}
    `;

/**
 * __useMilestonesEventSubscription__
 *
 * To run a query within a React component, call `useMilestonesEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMilestonesEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMilestonesEventSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMilestonesEventSubscription(baseOptions?: Apollo.SubscriptionHookOptions<MilestonesEventSubscription, MilestonesEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MilestonesEventSubscription, MilestonesEventSubscriptionVariables>(MilestonesEventDocument, options);
      }
export type MilestonesEventSubscriptionHookResult = ReturnType<typeof useMilestonesEventSubscription>;
export type MilestonesEventSubscriptionResult = Apollo.SubscriptionResult<MilestonesEventSubscription>;
export const ChallengesEventDocument = gql`
    subscription ChallengesEvent {
  challengeEvents {
    ... on AnswerStreakUpdatedEvent {
      status
    }
  }
}
    `;

/**
 * __useChallengesEventSubscription__
 *
 * To run a query within a React component, call `useChallengesEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChallengesEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengesEventSubscription({
 *   variables: {
 *   },
 * });
 */
export function useChallengesEventSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ChallengesEventSubscription, ChallengesEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChallengesEventSubscription, ChallengesEventSubscriptionVariables>(ChallengesEventDocument, options);
      }
export type ChallengesEventSubscriptionHookResult = ReturnType<typeof useChallengesEventSubscription>;
export type ChallengesEventSubscriptionResult = Apollo.SubscriptionResult<ChallengesEventSubscription>;
export const FollowCommunityDocument = gql`
    mutation FollowCommunity($communityId: ID!) {
  follow(communityId: $communityId) {
    messages {
      ...ValidationMessageParts
    }
    result {
      id
      messagePreview {
        ...MessageParts
      }
      partnerProfile {
        ...ProfileParts
      }
      type
      unreadMessageCount
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}
${MessagePartsFragmentDoc}
${ProfilePartsFragmentDoc}`;
export type FollowCommunityMutationFn = Apollo.MutationFunction<FollowCommunityMutation, FollowCommunityMutationVariables>;

/**
 * __useFollowCommunityMutation__
 *
 * To run a mutation, you first call `useFollowCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followCommunityMutation, { data, loading, error }] = useFollowCommunityMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useFollowCommunityMutation(baseOptions?: Apollo.MutationHookOptions<FollowCommunityMutation, FollowCommunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowCommunityMutation, FollowCommunityMutationVariables>(FollowCommunityDocument, options);
      }
export type FollowCommunityMutationHookResult = ReturnType<typeof useFollowCommunityMutation>;
export type FollowCommunityMutationResult = Apollo.MutationResult<FollowCommunityMutation>;
export type FollowCommunityMutationOptions = Apollo.BaseMutationOptions<FollowCommunityMutation, FollowCommunityMutationVariables>;
export const RegisterVendorDocument = gql`
    mutation registerVendor($communityName: String!, $displayName: String!, $email: String!, $firstName: String!, $lastName: String!, $postcode: String!, $password: String!, $passwordConfirmation: String!, $acceptedTerms: Boolean!, $acquisitionSource: String!) {
  registerVendor(
    communityName: $communityName
    displayName: $displayName
    email: $email
    firstName: $firstName
    lastName: $lastName
    postcode: $postcode
    password: $password
    passwordConfirmation: $passwordConfirmation
    acceptedTerms: $acceptedTerms
    acquisitionSource: $acquisitionSource
  ) {
    messages {
      ...ValidationMessageParts
    }
    result {
      message
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type RegisterVendorMutationFn = Apollo.MutationFunction<RegisterVendorMutation, RegisterVendorMutationVariables>;

/**
 * __useRegisterVendorMutation__
 *
 * To run a mutation, you first call `useRegisterVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerVendorMutation, { data, loading, error }] = useRegisterVendorMutation({
 *   variables: {
 *      communityName: // value for 'communityName'
 *      displayName: // value for 'displayName'
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      postcode: // value for 'postcode'
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *      acceptedTerms: // value for 'acceptedTerms'
 *      acquisitionSource: // value for 'acquisitionSource'
 *   },
 * });
 */
export function useRegisterVendorMutation(baseOptions?: Apollo.MutationHookOptions<RegisterVendorMutation, RegisterVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterVendorMutation, RegisterVendorMutationVariables>(RegisterVendorDocument, options);
      }
export type RegisterVendorMutationHookResult = ReturnType<typeof useRegisterVendorMutation>;
export type RegisterVendorMutationResult = Apollo.MutationResult<RegisterVendorMutation>;
export type RegisterVendorMutationOptions = Apollo.BaseMutationOptions<RegisterVendorMutation, RegisterVendorMutationVariables>;
export const VendorDocument = gql`
    query Vendor($displayName: String, $id: ID, $imgixOpts: [MediaOption!] = []) {
  vendor(displayName: $displayName, id: $id) {
    bio
    displayName
    id
    name
    photoUrl
    photoUrlSrcset
    profileLinks {
      id
      title
      url
    }
    redemptions {
      vendor {
        id
        name
        photoUrl
      }
      id
      active
      archivedAt
      description
      name
      price {
        amount
      }
      isNonProfit
      redeemCount
      limits {
        limits {
          limit
          limitScope
        }
      }
      donationProgress {
        current {
          amount
        }
        goal {
          amount
        }
        progress
      }
      linkedVendor {
        id
        displayName
        photoUrl
        name
      }
      limits {
        limits {
          ...RedemptionLimitParts
        }
      }
      saved
      ...RedemptionMediaPreviewParts
    }
    referralLink
    verified
    blockStatus
    unclaimed
    isNonProfit
    followRecord {
      conversationId
      memberId
      vendorId
    }
  }
}
    ${RedemptionLimitPartsFragmentDoc}
${RedemptionMediaPreviewPartsFragmentDoc}`;

/**
 * __useVendorQuery__
 *
 * To run a query within a React component, call `useVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorQuery({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      id: // value for 'id'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function useVendorQuery(baseOptions?: Apollo.QueryHookOptions<VendorQuery, VendorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorQuery, VendorQueryVariables>(VendorDocument, options);
      }
export function useVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorQuery, VendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorQuery, VendorQueryVariables>(VendorDocument, options);
        }
export function useVendorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VendorQuery, VendorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VendorQuery, VendorQueryVariables>(VendorDocument, options);
        }
export type VendorQueryHookResult = ReturnType<typeof useVendorQuery>;
export type VendorLazyQueryHookResult = ReturnType<typeof useVendorLazyQuery>;
export type VendorSuspenseQueryHookResult = ReturnType<typeof useVendorSuspenseQuery>;
export type VendorQueryResult = Apollo.QueryResult<VendorQuery, VendorQueryVariables>;
export const CommunitiesDiscoveryDocument = gql`
    query CommunitiesDiscovery($query: CommunityDiscoveryPageInput, $currentLocation: GeoPointInput) {
  discoverCommunities(query: $query, currentLocation: $currentLocation) {
    data {
      vendor {
        id
        name
        displayName
        photoUrl
        unclaimed
        isNonProfit
      }
      followRecord {
        conversationId
      }
    }
    page {
      ...PageParts
    }
    query {
      filters {
        attribute
        op
        value {
          ...PageFilterParts
        }
      }
    }
  }
}
    ${PagePartsFragmentDoc}
${PageFilterPartsFragmentDoc}`;

/**
 * __useCommunitiesDiscoveryQuery__
 *
 * To run a query within a React component, call `useCommunitiesDiscoveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitiesDiscoveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitiesDiscoveryQuery({
 *   variables: {
 *      query: // value for 'query'
 *      currentLocation: // value for 'currentLocation'
 *   },
 * });
 */
export function useCommunitiesDiscoveryQuery(baseOptions?: Apollo.QueryHookOptions<CommunitiesDiscoveryQuery, CommunitiesDiscoveryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitiesDiscoveryQuery, CommunitiesDiscoveryQueryVariables>(CommunitiesDiscoveryDocument, options);
      }
export function useCommunitiesDiscoveryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitiesDiscoveryQuery, CommunitiesDiscoveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitiesDiscoveryQuery, CommunitiesDiscoveryQueryVariables>(CommunitiesDiscoveryDocument, options);
        }
export function useCommunitiesDiscoverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunitiesDiscoveryQuery, CommunitiesDiscoveryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunitiesDiscoveryQuery, CommunitiesDiscoveryQueryVariables>(CommunitiesDiscoveryDocument, options);
        }
export type CommunitiesDiscoveryQueryHookResult = ReturnType<typeof useCommunitiesDiscoveryQuery>;
export type CommunitiesDiscoveryLazyQueryHookResult = ReturnType<typeof useCommunitiesDiscoveryLazyQuery>;
export type CommunitiesDiscoverySuspenseQueryHookResult = ReturnType<typeof useCommunitiesDiscoverySuspenseQuery>;
export type CommunitiesDiscoveryQueryResult = Apollo.QueryResult<CommunitiesDiscoveryQuery, CommunitiesDiscoveryQueryVariables>;
export const LookupMemberDocument = gql`
    query LookupMember($displayName: String, $profileId: ID) {
  lookupMember(id: $profileId, displayName: $displayName) {
    deactivatedAt
    displayName
    followRecord {
      conversationId
      memberId
      vendorId
    }
    fullName
    id
    photoUrl
    photoUrlSrcset
    blockStatus
  }
}
    `;

/**
 * __useLookupMemberQuery__
 *
 * To run a query within a React component, call `useLookupMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookupMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookupMemberQuery({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useLookupMemberQuery(baseOptions?: Apollo.QueryHookOptions<LookupMemberQuery, LookupMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LookupMemberQuery, LookupMemberQueryVariables>(LookupMemberDocument, options);
      }
export function useLookupMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LookupMemberQuery, LookupMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LookupMemberQuery, LookupMemberQueryVariables>(LookupMemberDocument, options);
        }
export function useLookupMemberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LookupMemberQuery, LookupMemberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LookupMemberQuery, LookupMemberQueryVariables>(LookupMemberDocument, options);
        }
export type LookupMemberQueryHookResult = ReturnType<typeof useLookupMemberQuery>;
export type LookupMemberLazyQueryHookResult = ReturnType<typeof useLookupMemberLazyQuery>;
export type LookupMemberSuspenseQueryHookResult = ReturnType<typeof useLookupMemberSuspenseQuery>;
export type LookupMemberQueryResult = Apollo.QueryResult<LookupMemberQuery, LookupMemberQueryVariables>;
export const FeaturesDocument = gql`
    query Features {
  features {
    enabled
    name
  }
}
    `;

/**
 * __useFeaturesQuery__
 *
 * To run a query within a React component, call `useFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<FeaturesQuery, FeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturesQuery, FeaturesQueryVariables>(FeaturesDocument, options);
      }
export function useFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturesQuery, FeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturesQuery, FeaturesQueryVariables>(FeaturesDocument, options);
        }
export function useFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeaturesQuery, FeaturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeaturesQuery, FeaturesQueryVariables>(FeaturesDocument, options);
        }
export type FeaturesQueryHookResult = ReturnType<typeof useFeaturesQuery>;
export type FeaturesLazyQueryHookResult = ReturnType<typeof useFeaturesLazyQuery>;
export type FeaturesSuspenseQueryHookResult = ReturnType<typeof useFeaturesSuspenseQuery>;
export type FeaturesQueryResult = Apollo.QueryResult<FeaturesQuery, FeaturesQueryVariables>;
export const FeedItemSeenDocument = gql`
    mutation FeedItemSeen($feedItemSeenId: ID!, $deltaMs: Int!) {
  feedItemSeen(id: $feedItemSeenId, deltaMs: $deltaMs) {
    successful
    result {
      message
    }
  }
}
    `;
export type FeedItemSeenMutationFn = Apollo.MutationFunction<FeedItemSeenMutation, FeedItemSeenMutationVariables>;

/**
 * __useFeedItemSeenMutation__
 *
 * To run a mutation, you first call `useFeedItemSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeedItemSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [feedItemSeenMutation, { data, loading, error }] = useFeedItemSeenMutation({
 *   variables: {
 *      feedItemSeenId: // value for 'feedItemSeenId'
 *      deltaMs: // value for 'deltaMs'
 *   },
 * });
 */
export function useFeedItemSeenMutation(baseOptions?: Apollo.MutationHookOptions<FeedItemSeenMutation, FeedItemSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeedItemSeenMutation, FeedItemSeenMutationVariables>(FeedItemSeenDocument, options);
      }
export type FeedItemSeenMutationHookResult = ReturnType<typeof useFeedItemSeenMutation>;
export type FeedItemSeenMutationResult = Apollo.MutationResult<FeedItemSeenMutation>;
export type FeedItemSeenMutationOptions = Apollo.BaseMutationOptions<FeedItemSeenMutation, FeedItemSeenMutationVariables>;
export const FeedSetGeoPointDocument = gql`
    mutation FeedSetGeoPoint($geoPoint: GeoPointInput) {
  feedSetGeoPoint(geoPoint: $geoPoint) {
    successful
    result {
      message
    }
  }
}
    `;
export type FeedSetGeoPointMutationFn = Apollo.MutationFunction<FeedSetGeoPointMutation, FeedSetGeoPointMutationVariables>;

/**
 * __useFeedSetGeoPointMutation__
 *
 * To run a mutation, you first call `useFeedSetGeoPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeedSetGeoPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [feedSetGeoPointMutation, { data, loading, error }] = useFeedSetGeoPointMutation({
 *   variables: {
 *      geoPoint: // value for 'geoPoint'
 *   },
 * });
 */
export function useFeedSetGeoPointMutation(baseOptions?: Apollo.MutationHookOptions<FeedSetGeoPointMutation, FeedSetGeoPointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeedSetGeoPointMutation, FeedSetGeoPointMutationVariables>(FeedSetGeoPointDocument, options);
      }
export type FeedSetGeoPointMutationHookResult = ReturnType<typeof useFeedSetGeoPointMutation>;
export type FeedSetGeoPointMutationResult = Apollo.MutationResult<FeedSetGeoPointMutation>;
export type FeedSetGeoPointMutationOptions = Apollo.BaseMutationOptions<FeedSetGeoPointMutation, FeedSetGeoPointMutationVariables>;
export const FeedInteractionItemDocument = gql`
    query FeedInteractionItem($id: ID!) {
  oneInteraction(id: $id) {
    id
    ctaDetails
    ctaTitle
    followUpInteraction {
      id
    }
    earningPotential {
      amount
    }
    expiresAt
    interactionType
    status
  }
}
    `;

/**
 * __useFeedInteractionItemQuery__
 *
 * To run a query within a React component, call `useFeedInteractionItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedInteractionItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedInteractionItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeedInteractionItemQuery(baseOptions: Apollo.QueryHookOptions<FeedInteractionItemQuery, FeedInteractionItemQueryVariables> & ({ variables: FeedInteractionItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedInteractionItemQuery, FeedInteractionItemQueryVariables>(FeedInteractionItemDocument, options);
      }
export function useFeedInteractionItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedInteractionItemQuery, FeedInteractionItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedInteractionItemQuery, FeedInteractionItemQueryVariables>(FeedInteractionItemDocument, options);
        }
export function useFeedInteractionItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedInteractionItemQuery, FeedInteractionItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedInteractionItemQuery, FeedInteractionItemQueryVariables>(FeedInteractionItemDocument, options);
        }
export type FeedInteractionItemQueryHookResult = ReturnType<typeof useFeedInteractionItemQuery>;
export type FeedInteractionItemLazyQueryHookResult = ReturnType<typeof useFeedInteractionItemLazyQuery>;
export type FeedInteractionItemSuspenseQueryHookResult = ReturnType<typeof useFeedInteractionItemSuspenseQuery>;
export type FeedInteractionItemQueryResult = Apollo.QueryResult<FeedInteractionItemQuery, FeedInteractionItemQueryVariables>;
export const FeedDocument = gql`
    query Feed {
  feed {
    id
    key
    name
  }
}
    `;

/**
 * __useFeedQuery__
 *
 * To run a query within a React component, call `useFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeedQuery(baseOptions?: Apollo.QueryHookOptions<FeedQuery, FeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedQuery, FeedQueryVariables>(FeedDocument, options);
      }
export function useFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedQuery, FeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedQuery, FeedQueryVariables>(FeedDocument, options);
        }
export function useFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedQuery, FeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedQuery, FeedQueryVariables>(FeedDocument, options);
        }
export type FeedQueryHookResult = ReturnType<typeof useFeedQuery>;
export type FeedLazyQueryHookResult = ReturnType<typeof useFeedLazyQuery>;
export type FeedSuspenseQueryHookResult = ReturnType<typeof useFeedSuspenseQuery>;
export type FeedQueryResult = Apollo.QueryResult<FeedQuery, FeedQueryVariables>;
export const FeedItemsDocument = gql`
    query FeedItems($afterId: ID, $excludeSeenBefore: DateTime, $geoPoint: GeoPointInput, $includeAfterItemInFeed: Boolean, $includeSeen: Boolean, $maxItems: Int) {
  feedItems(
    afterId: $afterId
    excludeSeenBefore: $excludeSeenBefore
    geoPoint: $geoPoint
    includeAfterItemInFeed: $includeAfterItemInFeed
    includeSeen: $includeSeen
    maxItems: $maxItems
  ) {
    id
    feedInstanceId
    addedAt
    deltaMs
    seenAt
    ... on FeedItemInteraction {
      interactions {
        id
        interactionType
      }
      seenAt
    }
    ... on FeedItemNotification {
      notification {
        body
        title
        type
        payload {
          ... on DonationGoalReachedPayload {
            redemptionId
          }
          ... on LeaderboardWinnerPayload {
            swayCash {
              amount
            }
            winnerMargin {
              amount
            }
            nonWinnerCount
            startDate
            endDate
          }
          ... on LeaderboardNonWinnerPayload {
            position
            swayCash {
              amount
            }
            marginToWinner {
              amount
            }
            startDate
            endDate
          }
          ... on LeaderboardEarningSummaryPayload {
            swayCash {
              amount
            }
            updatedBalance {
              amount
            }
            leaderboardEntry {
              ...SwayCashLeaderboardParts
            }
            topLeaderboardEntries {
              ...SwayCashLeaderboardParts
            }
            startDate
            endDate
          }
          ... on GenericNotificationPayload {
            topIcon
            title
            subtitle
            body
            badgeText
            badgeColor
            actionText
            actionUrl
            actionButtonColor
            backgroundColor
          }
          ... on ReferredAccountVerifiedPayload {
            referredName
            referredId
            swayCash {
              amount
            }
          }
          ... on DonationSummaryPayload {
            profileId
            startDate
            endDate
            totalSwayCashDonated
            topPercentage
          }
          ... on LastStreakRepairUsedPayload {
            usedAt
          }
        }
      }
      seenAt
    }
    ... on FeedItemRedemptionSuggestion {
      redemptionSuggestion {
        redemptionId
      }
    }
    ... on FeedItemVendorSuggestion {
      vendorSuggestion {
        vendorId
      }
    }
    ... on FeedItemUnclaimedVendorSuggestion {
      unclaimedVendorSuggestion {
        vendorsIds
      }
    }
    ... on FeedItemPersistentBroadcastSuggestion {
      interaction {
        id
        interactionType
      }
    }
    ... on FeedItemPoll {
      id
      pollSuggestion {
        interactionId
      }
    }
    ... on FeedItemSessionSummary {
      id
    }
    ... on FeedItemOnboardingItem {
      onboardingItem {
        type
      }
    }
  }
}
    ${SwayCashLeaderboardPartsFragmentDoc}`;

/**
 * __useFeedItemsQuery__
 *
 * To run a query within a React component, call `useFeedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedItemsQuery({
 *   variables: {
 *      afterId: // value for 'afterId'
 *      excludeSeenBefore: // value for 'excludeSeenBefore'
 *      geoPoint: // value for 'geoPoint'
 *      includeAfterItemInFeed: // value for 'includeAfterItemInFeed'
 *      includeSeen: // value for 'includeSeen'
 *      maxItems: // value for 'maxItems'
 *   },
 * });
 */
export function useFeedItemsQuery(baseOptions?: Apollo.QueryHookOptions<FeedItemsQuery, FeedItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedItemsQuery, FeedItemsQueryVariables>(FeedItemsDocument, options);
      }
export function useFeedItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedItemsQuery, FeedItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedItemsQuery, FeedItemsQueryVariables>(FeedItemsDocument, options);
        }
export function useFeedItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedItemsQuery, FeedItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedItemsQuery, FeedItemsQueryVariables>(FeedItemsDocument, options);
        }
export type FeedItemsQueryHookResult = ReturnType<typeof useFeedItemsQuery>;
export type FeedItemsLazyQueryHookResult = ReturnType<typeof useFeedItemsLazyQuery>;
export type FeedItemsSuspenseQueryHookResult = ReturnType<typeof useFeedItemsSuspenseQuery>;
export type FeedItemsQueryResult = Apollo.QueryResult<FeedItemsQuery, FeedItemsQueryVariables>;
export const FeedGetSingleInteractionDocument = gql`
    query FeedGetSingleInteraction($id: ID!, $imgixOpts: [MediaOption!]) {
  oneInteraction(id: $id) {
    id
    followUpInteraction {
      id
    }
    ... on InteractionPoll {
      ...FeedInteractionPoll
    }
    ... on InteractionReply {
      ...FeedInteractionReply
    }
    ... on InteractionClick {
      ...FeedInteractionClick
    }
    ... on InteractionRedemptionOffer {
      ...FeedInteractionRedemptionOffer
    }
    ... on InteractionRedemption {
      ...FeedInteractionRedemption
    }
  }
}
    ${FeedInteractionPollFragmentDoc}
${FeedInteractionReplyFragmentDoc}
${FeedInteractionClickFragmentDoc}
${FeedInteractionRedemptionOfferFragmentDoc}
${FeedInteractionRedemptionFragmentDoc}`;

/**
 * __useFeedGetSingleInteractionQuery__
 *
 * To run a query within a React component, call `useFeedGetSingleInteractionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedGetSingleInteractionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedGetSingleInteractionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function useFeedGetSingleInteractionQuery(baseOptions: Apollo.QueryHookOptions<FeedGetSingleInteractionQuery, FeedGetSingleInteractionQueryVariables> & ({ variables: FeedGetSingleInteractionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedGetSingleInteractionQuery, FeedGetSingleInteractionQueryVariables>(FeedGetSingleInteractionDocument, options);
      }
export function useFeedGetSingleInteractionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedGetSingleInteractionQuery, FeedGetSingleInteractionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedGetSingleInteractionQuery, FeedGetSingleInteractionQueryVariables>(FeedGetSingleInteractionDocument, options);
        }
export function useFeedGetSingleInteractionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedGetSingleInteractionQuery, FeedGetSingleInteractionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedGetSingleInteractionQuery, FeedGetSingleInteractionQueryVariables>(FeedGetSingleInteractionDocument, options);
        }
export type FeedGetSingleInteractionQueryHookResult = ReturnType<typeof useFeedGetSingleInteractionQuery>;
export type FeedGetSingleInteractionLazyQueryHookResult = ReturnType<typeof useFeedGetSingleInteractionLazyQuery>;
export type FeedGetSingleInteractionSuspenseQueryHookResult = ReturnType<typeof useFeedGetSingleInteractionSuspenseQuery>;
export type FeedGetSingleInteractionQueryResult = Apollo.QueryResult<FeedGetSingleInteractionQuery, FeedGetSingleInteractionQueryVariables>;
export const FeedGetSingleRedemptionDocument = gql`
    query FeedGetSingleRedemption($id: ID!, $evaluate: Boolean, $includeArchived: Boolean = false, $imgixOpts: [MediaOption!] = []) {
  getRedemption(id: $id, includeArchived: $includeArchived) {
    id
    description
    name
    isNonProfit
    referralLink
    limits(evaluate: $evaluate) {
      canRedeem
      limits {
        blocking
        count
        description
        id
        limit
        limitScope
        limitType
        ... on RedemptionLimitCount {
          blocking
          count
          description
          id
          limit
          limitScope
          limitType
        }
        ... on RedemptionLimitRate {
          blocking
          count
          description
          endOfDay
          id
          interval
          limit
          limitScope
          limitType
          unit
        }
      }
    }
    donationProgress {
      current {
        amount
      }
      goal {
        amount
      }
      progress
    }
    isSweepstakes
    validEnd
    linkedVendor {
      id
      displayName
      name
      photoUrl
    }
    location {
      lat
      lng
    }
    price {
      amount
    }
    primaryMedia {
      downloadUrl(encoding: PROXY, imgixOpts: $imgixOpts) {
        url
      }
      downloadUrls {
        key
        url
      }
      filesizeInBytes
      id
      mediaType
      mimeType
      name
      provider
      status
    }
    vendor {
      id
      displayName
      photoUrl
      photoUrlSrcset
      name
    }
    saved
  }
}
    `;

/**
 * __useFeedGetSingleRedemptionQuery__
 *
 * To run a query within a React component, call `useFeedGetSingleRedemptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedGetSingleRedemptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedGetSingleRedemptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      evaluate: // value for 'evaluate'
 *      includeArchived: // value for 'includeArchived'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function useFeedGetSingleRedemptionQuery(baseOptions: Apollo.QueryHookOptions<FeedGetSingleRedemptionQuery, FeedGetSingleRedemptionQueryVariables> & ({ variables: FeedGetSingleRedemptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedGetSingleRedemptionQuery, FeedGetSingleRedemptionQueryVariables>(FeedGetSingleRedemptionDocument, options);
      }
export function useFeedGetSingleRedemptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedGetSingleRedemptionQuery, FeedGetSingleRedemptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedGetSingleRedemptionQuery, FeedGetSingleRedemptionQueryVariables>(FeedGetSingleRedemptionDocument, options);
        }
export function useFeedGetSingleRedemptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedGetSingleRedemptionQuery, FeedGetSingleRedemptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedGetSingleRedemptionQuery, FeedGetSingleRedemptionQueryVariables>(FeedGetSingleRedemptionDocument, options);
        }
export type FeedGetSingleRedemptionQueryHookResult = ReturnType<typeof useFeedGetSingleRedemptionQuery>;
export type FeedGetSingleRedemptionLazyQueryHookResult = ReturnType<typeof useFeedGetSingleRedemptionLazyQuery>;
export type FeedGetSingleRedemptionSuspenseQueryHookResult = ReturnType<typeof useFeedGetSingleRedemptionSuspenseQuery>;
export type FeedGetSingleRedemptionQueryResult = Apollo.QueryResult<FeedGetSingleRedemptionQuery, FeedGetSingleRedemptionQueryVariables>;
export const FeedGetSingleVendorDocument = gql`
    query FeedGetSingleVendor($id: ID, $imgixOpts: [MediaOption!] = []) {
  vendor(id: $id) {
    displayName
    id
    name
    photoUrl
    redemptions {
      vendor {
        id
        name
        photoUrl
      }
      id
      active
      archivedAt
      validEnd
      description
      name
      price {
        amount
      }
      isNonProfit
      redeemCount
      saved
      donationProgress {
        current {
          amount
        }
        goal {
          amount
        }
        progress
      }
      linkedVendor {
        id
        displayName
        name
        photoUrl
      }
      limits {
        limits {
          ...RedemptionLimitParts
        }
      }
      ...RedemptionMediaPreviewParts
    }
    referralLink
    verified
    blockStatus
    bio
    unclaimed
    isNonProfit
    followRecord {
      conversationId
      memberId
      vendorId
    }
  }
}
    ${RedemptionLimitPartsFragmentDoc}
${RedemptionMediaPreviewPartsFragmentDoc}`;

/**
 * __useFeedGetSingleVendorQuery__
 *
 * To run a query within a React component, call `useFeedGetSingleVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedGetSingleVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedGetSingleVendorQuery({
 *   variables: {
 *      id: // value for 'id'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function useFeedGetSingleVendorQuery(baseOptions?: Apollo.QueryHookOptions<FeedGetSingleVendorQuery, FeedGetSingleVendorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedGetSingleVendorQuery, FeedGetSingleVendorQueryVariables>(FeedGetSingleVendorDocument, options);
      }
export function useFeedGetSingleVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedGetSingleVendorQuery, FeedGetSingleVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedGetSingleVendorQuery, FeedGetSingleVendorQueryVariables>(FeedGetSingleVendorDocument, options);
        }
export function useFeedGetSingleVendorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedGetSingleVendorQuery, FeedGetSingleVendorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedGetSingleVendorQuery, FeedGetSingleVendorQueryVariables>(FeedGetSingleVendorDocument, options);
        }
export type FeedGetSingleVendorQueryHookResult = ReturnType<typeof useFeedGetSingleVendorQuery>;
export type FeedGetSingleVendorLazyQueryHookResult = ReturnType<typeof useFeedGetSingleVendorLazyQuery>;
export type FeedGetSingleVendorSuspenseQueryHookResult = ReturnType<typeof useFeedGetSingleVendorSuspenseQuery>;
export type FeedGetSingleVendorQueryResult = Apollo.QueryResult<FeedGetSingleVendorQuery, FeedGetSingleVendorQueryVariables>;
export const FeedGetVendorsDocument = gql`
    query FeedGetVendors($query: CommunityDiscoveryPageInput) {
  discoverCommunities(query: $query) {
    data {
      vendor {
        id
        name
        displayName
      }
    }
    query {
      filters {
        attribute
        op
        value {
          ...PageFilterParts
        }
      }
    }
  }
}
    ${PageFilterPartsFragmentDoc}`;

/**
 * __useFeedGetVendorsQuery__
 *
 * To run a query within a React component, call `useFeedGetVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedGetVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedGetVendorsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFeedGetVendorsQuery(baseOptions?: Apollo.QueryHookOptions<FeedGetVendorsQuery, FeedGetVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedGetVendorsQuery, FeedGetVendorsQueryVariables>(FeedGetVendorsDocument, options);
      }
export function useFeedGetVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedGetVendorsQuery, FeedGetVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedGetVendorsQuery, FeedGetVendorsQueryVariables>(FeedGetVendorsDocument, options);
        }
export function useFeedGetVendorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedGetVendorsQuery, FeedGetVendorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedGetVendorsQuery, FeedGetVendorsQueryVariables>(FeedGetVendorsDocument, options);
        }
export type FeedGetVendorsQueryHookResult = ReturnType<typeof useFeedGetVendorsQuery>;
export type FeedGetVendorsLazyQueryHookResult = ReturnType<typeof useFeedGetVendorsLazyQuery>;
export type FeedGetVendorsSuspenseQueryHookResult = ReturnType<typeof useFeedGetVendorsSuspenseQuery>;
export type FeedGetVendorsQueryResult = Apollo.QueryResult<FeedGetVendorsQuery, FeedGetVendorsQueryVariables>;
export const FeedGetSinglePollDocument = gql`
    query FeedGetSinglePoll($id: ID!, $encoding: SignedUrlKey!, $imgixOpts: [MediaOption!]) {
  oneInteraction(id: $id) {
    interactionType
    ... on InteractionPoll {
      bonusText
      caption
      consolationPrice
      creator {
        name
        displayName
        photoUrl
        photoUrlSrcset
      }
      earningPotential {
        amount
      }
      expiresAt
      id
      question
      status
      userAnswer {
        ... on PollTextOption {
          correct
          id
          text
          type
        }
      }
      options {
        ... on PollTextOption {
          correct
          id
          order
          text
          type
        }
      }
      pollId
      pollResults {
        pollOptionResults {
          pollOption {
            id
          }
          responseCount
          responsePct
        }
        totalResponseCount
      }
      pollType
      primaryMedia {
        downloadUrl(encoding: $encoding, imgixOpts: $imgixOpts) {
          url
        }
        mediaType
      }
    }
  }
}
    `;

/**
 * __useFeedGetSinglePollQuery__
 *
 * To run a query within a React component, call `useFeedGetSinglePollQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedGetSinglePollQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedGetSinglePollQuery({
 *   variables: {
 *      id: // value for 'id'
 *      encoding: // value for 'encoding'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function useFeedGetSinglePollQuery(baseOptions: Apollo.QueryHookOptions<FeedGetSinglePollQuery, FeedGetSinglePollQueryVariables> & ({ variables: FeedGetSinglePollQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedGetSinglePollQuery, FeedGetSinglePollQueryVariables>(FeedGetSinglePollDocument, options);
      }
export function useFeedGetSinglePollLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedGetSinglePollQuery, FeedGetSinglePollQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedGetSinglePollQuery, FeedGetSinglePollQueryVariables>(FeedGetSinglePollDocument, options);
        }
export function useFeedGetSinglePollSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedGetSinglePollQuery, FeedGetSinglePollQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedGetSinglePollQuery, FeedGetSinglePollQueryVariables>(FeedGetSinglePollDocument, options);
        }
export type FeedGetSinglePollQueryHookResult = ReturnType<typeof useFeedGetSinglePollQuery>;
export type FeedGetSinglePollLazyQueryHookResult = ReturnType<typeof useFeedGetSinglePollLazyQuery>;
export type FeedGetSinglePollSuspenseQueryHookResult = ReturnType<typeof useFeedGetSinglePollSuspenseQuery>;
export type FeedGetSinglePollQueryResult = Apollo.QueryResult<FeedGetSinglePollQuery, FeedGetSinglePollQueryVariables>;
export const SessionSummaryCardDocument = gql`
    query SessionSummaryCard($id: ID!) {
  feedSession(id: $id) {
    date
    id
    pollsAnswered
    swayCashEarned
    triviaCorrect
    triviaIncorrect
  }
  challengeAnswerStreaks: challenge(key: "answer-streaks") {
    progress {
      state {
        ... on ProgressTriviaAnswerStreaks {
          overallStreak
        }
      }
    }
  }
  challengeAnswerCounts: challenge(key: "answer-count") {
    progress {
      state {
        ... on ProgressTriviaAnswerCounts {
          correct
          completedCorrectMilestones
          milestones
        }
      }
    }
  }
}
    `;

/**
 * __useSessionSummaryCardQuery__
 *
 * To run a query within a React component, call `useSessionSummaryCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionSummaryCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionSummaryCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSessionSummaryCardQuery(baseOptions: Apollo.QueryHookOptions<SessionSummaryCardQuery, SessionSummaryCardQueryVariables> & ({ variables: SessionSummaryCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionSummaryCardQuery, SessionSummaryCardQueryVariables>(SessionSummaryCardDocument, options);
      }
export function useSessionSummaryCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionSummaryCardQuery, SessionSummaryCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionSummaryCardQuery, SessionSummaryCardQueryVariables>(SessionSummaryCardDocument, options);
        }
export function useSessionSummaryCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SessionSummaryCardQuery, SessionSummaryCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SessionSummaryCardQuery, SessionSummaryCardQueryVariables>(SessionSummaryCardDocument, options);
        }
export type SessionSummaryCardQueryHookResult = ReturnType<typeof useSessionSummaryCardQuery>;
export type SessionSummaryCardLazyQueryHookResult = ReturnType<typeof useSessionSummaryCardLazyQuery>;
export type SessionSummaryCardSuspenseQueryHookResult = ReturnType<typeof useSessionSummaryCardSuspenseQuery>;
export type SessionSummaryCardQueryResult = Apollo.QueryResult<SessionSummaryCardQuery, SessionSummaryCardQueryVariables>;
export const InteractionClickDocument = gql`
    mutation InteractionClick($interactionId: ID!) {
  interactionClick(interactionId: $interactionId) {
    ...InteractionResultParts
  }
}
    ${InteractionResultPartsFragmentDoc}`;
export type InteractionClickMutationFn = Apollo.MutationFunction<InteractionClickMutation, InteractionClickMutationVariables>;

/**
 * __useInteractionClickMutation__
 *
 * To run a mutation, you first call `useInteractionClickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInteractionClickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interactionClickMutation, { data, loading, error }] = useInteractionClickMutation({
 *   variables: {
 *      interactionId: // value for 'interactionId'
 *   },
 * });
 */
export function useInteractionClickMutation(baseOptions?: Apollo.MutationHookOptions<InteractionClickMutation, InteractionClickMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InteractionClickMutation, InteractionClickMutationVariables>(InteractionClickDocument, options);
      }
export type InteractionClickMutationHookResult = ReturnType<typeof useInteractionClickMutation>;
export type InteractionClickMutationResult = Apollo.MutationResult<InteractionClickMutation>;
export type InteractionClickMutationOptions = Apollo.BaseMutationOptions<InteractionClickMutation, InteractionClickMutationVariables>;
export const InteractionReplyDocument = gql`
    mutation InteractionReply($body: String!, $interactionId: ID!) {
  interactionReply(body: $body, interactionId: $interactionId) {
    ...InteractionResultParts
  }
}
    ${InteractionResultPartsFragmentDoc}`;
export type InteractionReplyMutationFn = Apollo.MutationFunction<InteractionReplyMutation, InteractionReplyMutationVariables>;

/**
 * __useInteractionReplyMutation__
 *
 * To run a mutation, you first call `useInteractionReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInteractionReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interactionReplyMutation, { data, loading, error }] = useInteractionReplyMutation({
 *   variables: {
 *      body: // value for 'body'
 *      interactionId: // value for 'interactionId'
 *   },
 * });
 */
export function useInteractionReplyMutation(baseOptions?: Apollo.MutationHookOptions<InteractionReplyMutation, InteractionReplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InteractionReplyMutation, InteractionReplyMutationVariables>(InteractionReplyDocument, options);
      }
export type InteractionReplyMutationHookResult = ReturnType<typeof useInteractionReplyMutation>;
export type InteractionReplyMutationResult = Apollo.MutationResult<InteractionReplyMutation>;
export type InteractionReplyMutationOptions = Apollo.BaseMutationOptions<InteractionReplyMutation, InteractionReplyMutationVariables>;
export const InteractionRespondToPollDocument = gql`
    mutation InteractionRespondToPoll($pollId: ID!, $pollOptionId: ID!) {
  interactionRespondToPoll(pollId: $pollId, pollOptionId: $pollOptionId) {
    ...InteractionResultParts
    result {
      ... on InteractionPoll {
        pollResults {
          pollOptionResults {
            pollOption {
              id
              correct
              ... on PollTextOption {
                text
              }
              type
            }
            responseCount
            responsePct
          }
        }
      }
    }
  }
}
    ${InteractionResultPartsFragmentDoc}`;
export type InteractionRespondToPollMutationFn = Apollo.MutationFunction<InteractionRespondToPollMutation, InteractionRespondToPollMutationVariables>;

/**
 * __useInteractionRespondToPollMutation__
 *
 * To run a mutation, you first call `useInteractionRespondToPollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInteractionRespondToPollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interactionRespondToPollMutation, { data, loading, error }] = useInteractionRespondToPollMutation({
 *   variables: {
 *      pollId: // value for 'pollId'
 *      pollOptionId: // value for 'pollOptionId'
 *   },
 * });
 */
export function useInteractionRespondToPollMutation(baseOptions?: Apollo.MutationHookOptions<InteractionRespondToPollMutation, InteractionRespondToPollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InteractionRespondToPollMutation, InteractionRespondToPollMutationVariables>(InteractionRespondToPollDocument, options);
      }
export type InteractionRespondToPollMutationHookResult = ReturnType<typeof useInteractionRespondToPollMutation>;
export type InteractionRespondToPollMutationResult = Apollo.MutationResult<InteractionRespondToPollMutation>;
export type InteractionRespondToPollMutationOptions = Apollo.BaseMutationOptions<InteractionRespondToPollMutation, InteractionRespondToPollMutationVariables>;
export const SwayCashLeaderboardDocument = gql`
    query SwayCashLeaderboard($top: Int, $profileId: ID, $padding: Int, $offset: Int, $weeksBack: Int) {
  swayCashLeaderboard {
    earningsFor(profileId: $profileId, weeksBack: $weeksBack) {
      ...SwayCashLeaderboardParts
    }
    positionFor(profileId: $profileId, padding: $padding, weeksBack: $weeksBack) {
      ...SwayCashLeaderboardParts
    }
    top(top: $top, offset: $offset, weeksBack: $weeksBack) {
      ...SwayCashLeaderboardParts
    }
    totalCount(weeksBack: $weeksBack)
    oldestLeaderboardDate
  }
}
    ${SwayCashLeaderboardPartsFragmentDoc}`;

/**
 * __useSwayCashLeaderboardQuery__
 *
 * To run a query within a React component, call `useSwayCashLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useSwayCashLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwayCashLeaderboardQuery({
 *   variables: {
 *      top: // value for 'top'
 *      profileId: // value for 'profileId'
 *      padding: // value for 'padding'
 *      offset: // value for 'offset'
 *      weeksBack: // value for 'weeksBack'
 *   },
 * });
 */
export function useSwayCashLeaderboardQuery(baseOptions?: Apollo.QueryHookOptions<SwayCashLeaderboardQuery, SwayCashLeaderboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SwayCashLeaderboardQuery, SwayCashLeaderboardQueryVariables>(SwayCashLeaderboardDocument, options);
      }
export function useSwayCashLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SwayCashLeaderboardQuery, SwayCashLeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SwayCashLeaderboardQuery, SwayCashLeaderboardQueryVariables>(SwayCashLeaderboardDocument, options);
        }
export function useSwayCashLeaderboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SwayCashLeaderboardQuery, SwayCashLeaderboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SwayCashLeaderboardQuery, SwayCashLeaderboardQueryVariables>(SwayCashLeaderboardDocument, options);
        }
export type SwayCashLeaderboardQueryHookResult = ReturnType<typeof useSwayCashLeaderboardQuery>;
export type SwayCashLeaderboardLazyQueryHookResult = ReturnType<typeof useSwayCashLeaderboardLazyQuery>;
export type SwayCashLeaderboardSuspenseQueryHookResult = ReturnType<typeof useSwayCashLeaderboardSuspenseQuery>;
export type SwayCashLeaderboardQueryResult = Apollo.QueryResult<SwayCashLeaderboardQuery, SwayCashLeaderboardQueryVariables>;
export const TriviaLeaderboardDocument = gql`
    query TriviaLeaderboard($top: Int, $profileId: ID, $padding: Int, $offset: Int, $weeksBack: Int) {
  triviaLeaderboard {
    top(top: $top, offset: $offset, weeksBack: $weeksBack) {
      ...TriviaLeaderboardParts
    }
    answersFor(profileId: $profileId, weeksBack: $weeksBack) {
      ...TriviaLeaderboardParts
    }
    positionFor(profileId: $profileId, padding: $padding, weeksBack: $weeksBack) {
      ...TriviaLeaderboardParts
    }
    totalCount(weeksBack: $weeksBack)
    oldestLeaderboardDate
  }
}
    ${TriviaLeaderboardPartsFragmentDoc}`;

/**
 * __useTriviaLeaderboardQuery__
 *
 * To run a query within a React component, call `useTriviaLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriviaLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriviaLeaderboardQuery({
 *   variables: {
 *      top: // value for 'top'
 *      profileId: // value for 'profileId'
 *      padding: // value for 'padding'
 *      offset: // value for 'offset'
 *      weeksBack: // value for 'weeksBack'
 *   },
 * });
 */
export function useTriviaLeaderboardQuery(baseOptions?: Apollo.QueryHookOptions<TriviaLeaderboardQuery, TriviaLeaderboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TriviaLeaderboardQuery, TriviaLeaderboardQueryVariables>(TriviaLeaderboardDocument, options);
      }
export function useTriviaLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TriviaLeaderboardQuery, TriviaLeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TriviaLeaderboardQuery, TriviaLeaderboardQueryVariables>(TriviaLeaderboardDocument, options);
        }
export function useTriviaLeaderboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TriviaLeaderboardQuery, TriviaLeaderboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TriviaLeaderboardQuery, TriviaLeaderboardQueryVariables>(TriviaLeaderboardDocument, options);
        }
export type TriviaLeaderboardQueryHookResult = ReturnType<typeof useTriviaLeaderboardQuery>;
export type TriviaLeaderboardLazyQueryHookResult = ReturnType<typeof useTriviaLeaderboardLazyQuery>;
export type TriviaLeaderboardSuspenseQueryHookResult = ReturnType<typeof useTriviaLeaderboardSuspenseQuery>;
export type TriviaLeaderboardQueryResult = Apollo.QueryResult<TriviaLeaderboardQuery, TriviaLeaderboardQueryVariables>;
export const LinkAssociateDocument = gql`
    mutation LinkAssociate($link: LinkInput!, $imgixOpts: [MediaOption!] = []) {
  linkAssociate(link: $link) {
    messages {
      ...ValidationMessageParts
    }
    result {
      ...LinkParts
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}
${LinkPartsFragmentDoc}`;
export type LinkAssociateMutationFn = Apollo.MutationFunction<LinkAssociateMutation, LinkAssociateMutationVariables>;

/**
 * __useLinkAssociateMutation__
 *
 * To run a mutation, you first call `useLinkAssociateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkAssociateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkAssociateMutation, { data, loading, error }] = useLinkAssociateMutation({
 *   variables: {
 *      link: // value for 'link'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function useLinkAssociateMutation(baseOptions?: Apollo.MutationHookOptions<LinkAssociateMutation, LinkAssociateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkAssociateMutation, LinkAssociateMutationVariables>(LinkAssociateDocument, options);
      }
export type LinkAssociateMutationHookResult = ReturnType<typeof useLinkAssociateMutation>;
export type LinkAssociateMutationResult = Apollo.MutationResult<LinkAssociateMutation>;
export type LinkAssociateMutationOptions = Apollo.BaseMutationOptions<LinkAssociateMutation, LinkAssociateMutationVariables>;
export const LinkCreateDocument = gql`
    mutation LinkCreate($link: LinkCreateInput!, $imgixOpts: [MediaOption!] = []) {
  linkCreate(link: $link) {
    messages {
      ...ValidationMessageParts
    }
    result {
      ...LinkParts
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}
${LinkPartsFragmentDoc}`;
export type LinkCreateMutationFn = Apollo.MutationFunction<LinkCreateMutation, LinkCreateMutationVariables>;

/**
 * __useLinkCreateMutation__
 *
 * To run a mutation, you first call `useLinkCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkCreateMutation, { data, loading, error }] = useLinkCreateMutation({
 *   variables: {
 *      link: // value for 'link'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function useLinkCreateMutation(baseOptions?: Apollo.MutationHookOptions<LinkCreateMutation, LinkCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkCreateMutation, LinkCreateMutationVariables>(LinkCreateDocument, options);
      }
export type LinkCreateMutationHookResult = ReturnType<typeof useLinkCreateMutation>;
export type LinkCreateMutationResult = Apollo.MutationResult<LinkCreateMutation>;
export type LinkCreateMutationOptions = Apollo.BaseMutationOptions<LinkCreateMutation, LinkCreateMutationVariables>;
export const LinkGetSingleDocument = gql`
    query LinkGetSingle($id: ID, $shortCode: String, $imgixOpts: [MediaOption!] = []) {
  linkGet(id: $id, shortCode: $shortCode) {
    ...LinkParts
    ...ActivityParts
  }
}
    ${LinkPartsFragmentDoc}
${ActivityPartsFragmentDoc}`;

/**
 * __useLinkGetSingleQuery__
 *
 * To run a query within a React component, call `useLinkGetSingleQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkGetSingleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkGetSingleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      shortCode: // value for 'shortCode'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function useLinkGetSingleQuery(baseOptions?: Apollo.QueryHookOptions<LinkGetSingleQuery, LinkGetSingleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkGetSingleQuery, LinkGetSingleQueryVariables>(LinkGetSingleDocument, options);
      }
export function useLinkGetSingleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkGetSingleQuery, LinkGetSingleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkGetSingleQuery, LinkGetSingleQueryVariables>(LinkGetSingleDocument, options);
        }
export function useLinkGetSingleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LinkGetSingleQuery, LinkGetSingleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LinkGetSingleQuery, LinkGetSingleQueryVariables>(LinkGetSingleDocument, options);
        }
export type LinkGetSingleQueryHookResult = ReturnType<typeof useLinkGetSingleQuery>;
export type LinkGetSingleLazyQueryHookResult = ReturnType<typeof useLinkGetSingleLazyQuery>;
export type LinkGetSingleSuspenseQueryHookResult = ReturnType<typeof useLinkGetSingleSuspenseQuery>;
export type LinkGetSingleQueryResult = Apollo.QueryResult<LinkGetSingleQuery, LinkGetSingleQueryVariables>;
export const LinksGetMultipleDocument = gql`
    query LinksGetMultiple($query: LinkPageInput, $imgixOpts: [MediaOption!] = []) {
  linksGet(query: $query) {
    data {
      ...LinkParts
      ...ActivityParts
    }
    page {
      ...PageParts
    }
  }
}
    ${LinkPartsFragmentDoc}
${ActivityPartsFragmentDoc}
${PagePartsFragmentDoc}`;

/**
 * __useLinksGetMultipleQuery__
 *
 * To run a query within a React component, call `useLinksGetMultipleQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinksGetMultipleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinksGetMultipleQuery({
 *   variables: {
 *      query: // value for 'query'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function useLinksGetMultipleQuery(baseOptions?: Apollo.QueryHookOptions<LinksGetMultipleQuery, LinksGetMultipleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinksGetMultipleQuery, LinksGetMultipleQueryVariables>(LinksGetMultipleDocument, options);
      }
export function useLinksGetMultipleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinksGetMultipleQuery, LinksGetMultipleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinksGetMultipleQuery, LinksGetMultipleQueryVariables>(LinksGetMultipleDocument, options);
        }
export function useLinksGetMultipleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LinksGetMultipleQuery, LinksGetMultipleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LinksGetMultipleQuery, LinksGetMultipleQueryVariables>(LinksGetMultipleDocument, options);
        }
export type LinksGetMultipleQueryHookResult = ReturnType<typeof useLinksGetMultipleQuery>;
export type LinksGetMultipleLazyQueryHookResult = ReturnType<typeof useLinksGetMultipleLazyQuery>;
export type LinksGetMultipleSuspenseQueryHookResult = ReturnType<typeof useLinksGetMultipleSuspenseQuery>;
export type LinksGetMultipleQueryResult = Apollo.QueryResult<LinksGetMultipleQuery, LinksGetMultipleQueryVariables>;
export const MagicLinkDocument = gql`
    query MagicLink {
  magicLink {
    ...AccessTokenParts
  }
}
    ${AccessTokenPartsFragmentDoc}`;

/**
 * __useMagicLinkQuery__
 *
 * To run a query within a React component, call `useMagicLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useMagicLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMagicLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useMagicLinkQuery(baseOptions?: Apollo.QueryHookOptions<MagicLinkQuery, MagicLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MagicLinkQuery, MagicLinkQueryVariables>(MagicLinkDocument, options);
      }
export function useMagicLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MagicLinkQuery, MagicLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MagicLinkQuery, MagicLinkQueryVariables>(MagicLinkDocument, options);
        }
export function useMagicLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MagicLinkQuery, MagicLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MagicLinkQuery, MagicLinkQueryVariables>(MagicLinkDocument, options);
        }
export type MagicLinkQueryHookResult = ReturnType<typeof useMagicLinkQuery>;
export type MagicLinkLazyQueryHookResult = ReturnType<typeof useMagicLinkLazyQuery>;
export type MagicLinkSuspenseQueryHookResult = ReturnType<typeof useMagicLinkSuspenseQuery>;
export type MagicLinkQueryResult = Apollo.QueryResult<MagicLinkQuery, MagicLinkQueryVariables>;
export const UploadMediaDocument = gql`
    mutation UploadMedia($broadcastId: ID, $conversationId: ID, $filesizeInBytes: Int!, $mediaType: MediaType!, $mimeType: String!, $name: String!, $profileId: ID, $redemptionId: ID) {
  uploadMedia(
    broadcastId: $broadcastId
    conversationId: $conversationId
    filesizeInBytes: $filesizeInBytes
    mediaType: $mediaType
    mimeType: $mimeType
    name: $name
    profileId: $profileId
    redemptionId: $redemptionId
  ) {
    messages {
      ...ValidationMessageParts
    }
    result {
      mediaPointer {
        id
      }
      uploadUrls {
        ...SignedUploadUrlParts
      }
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}
${SignedUploadUrlPartsFragmentDoc}`;
export type UploadMediaMutationFn = Apollo.MutationFunction<UploadMediaMutation, UploadMediaMutationVariables>;

/**
 * __useUploadMediaMutation__
 *
 * To run a mutation, you first call `useUploadMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMediaMutation, { data, loading, error }] = useUploadMediaMutation({
 *   variables: {
 *      broadcastId: // value for 'broadcastId'
 *      conversationId: // value for 'conversationId'
 *      filesizeInBytes: // value for 'filesizeInBytes'
 *      mediaType: // value for 'mediaType'
 *      mimeType: // value for 'mimeType'
 *      name: // value for 'name'
 *      profileId: // value for 'profileId'
 *      redemptionId: // value for 'redemptionId'
 *   },
 * });
 */
export function useUploadMediaMutation(baseOptions?: Apollo.MutationHookOptions<UploadMediaMutation, UploadMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMediaMutation, UploadMediaMutationVariables>(UploadMediaDocument, options);
      }
export type UploadMediaMutationHookResult = ReturnType<typeof useUploadMediaMutation>;
export type UploadMediaMutationResult = Apollo.MutationResult<UploadMediaMutation>;
export type UploadMediaMutationOptions = Apollo.BaseMutationOptions<UploadMediaMutation, UploadMediaMutationVariables>;
export const SetMediaPointerStatusDocument = gql`
    mutation SetMediaPointerStatus($mediaPointerId: ID!, $status: MediaPointerStatus!) {
  setMediaPointerStatus(mediaPointerId: $mediaPointerId, status: $status) {
    id
  }
}
    `;
export type SetMediaPointerStatusMutationFn = Apollo.MutationFunction<SetMediaPointerStatusMutation, SetMediaPointerStatusMutationVariables>;

/**
 * __useSetMediaPointerStatusMutation__
 *
 * To run a mutation, you first call `useSetMediaPointerStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMediaPointerStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMediaPointerStatusMutation, { data, loading, error }] = useSetMediaPointerStatusMutation({
 *   variables: {
 *      mediaPointerId: // value for 'mediaPointerId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetMediaPointerStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetMediaPointerStatusMutation, SetMediaPointerStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMediaPointerStatusMutation, SetMediaPointerStatusMutationVariables>(SetMediaPointerStatusDocument, options);
      }
export type SetMediaPointerStatusMutationHookResult = ReturnType<typeof useSetMediaPointerStatusMutation>;
export type SetMediaPointerStatusMutationResult = Apollo.MutationResult<SetMediaPointerStatusMutation>;
export type SetMediaPointerStatusMutationOptions = Apollo.BaseMutationOptions<SetMediaPointerStatusMutation, SetMediaPointerStatusMutationVariables>;
export const MediaPointerDocument = gql`
    query MediaPointer($mediaPointerId: ID!, $optsOriginal: [MediaOption!], $opts9by16: [MediaOption!], $opts1by1: [MediaOption!], $opts5by3: [MediaOption!]) {
  mediaPointer(mediaPointerId: $mediaPointerId) {
    id
    name
    status
    mediaType
    original: downloadUrl(encoding: PROXY, imgixOpts: $optsOriginal) {
      url
    }
    nine_by_sixteen: downloadUrl(encoding: PROXY, imgixOpts: $opts9by16) {
      url
    }
    one_by_one: downloadUrl(encoding: PROXY, imgixOpts: $opts1by1) {
      url
    }
    five_by_three: downloadUrl(encoding: PROXY, imgixOpts: $opts5by3) {
      url
    }
  }
}
    `;

/**
 * __useMediaPointerQuery__
 *
 * To run a query within a React component, call `useMediaPointerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaPointerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaPointerQuery({
 *   variables: {
 *      mediaPointerId: // value for 'mediaPointerId'
 *      optsOriginal: // value for 'optsOriginal'
 *      opts9by16: // value for 'opts9by16'
 *      opts1by1: // value for 'opts1by1'
 *      opts5by3: // value for 'opts5by3'
 *   },
 * });
 */
export function useMediaPointerQuery(baseOptions: Apollo.QueryHookOptions<MediaPointerQuery, MediaPointerQueryVariables> & ({ variables: MediaPointerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaPointerQuery, MediaPointerQueryVariables>(MediaPointerDocument, options);
      }
export function useMediaPointerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaPointerQuery, MediaPointerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaPointerQuery, MediaPointerQueryVariables>(MediaPointerDocument, options);
        }
export function useMediaPointerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaPointerQuery, MediaPointerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaPointerQuery, MediaPointerQueryVariables>(MediaPointerDocument, options);
        }
export type MediaPointerQueryHookResult = ReturnType<typeof useMediaPointerQuery>;
export type MediaPointerLazyQueryHookResult = ReturnType<typeof useMediaPointerLazyQuery>;
export type MediaPointerSuspenseQueryHookResult = ReturnType<typeof useMediaPointerSuspenseQuery>;
export type MediaPointerQueryResult = Apollo.QueryResult<MediaPointerQuery, MediaPointerQueryVariables>;
export const UploadMediaEventDocument = gql`
    subscription UploadMediaEvent($conversationId: ID!) {
  conversationEvent(conversationId: $conversationId) {
    ... on MediaEvent {
      __typename
      mediaPointer {
        ...MessagePreviewMediaPointerParts
      }
      mediaType: type
    }
  }
}
    ${MessagePreviewMediaPointerPartsFragmentDoc}`;

/**
 * __useUploadMediaEventSubscription__
 *
 * To run a query within a React component, call `useUploadMediaEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUploadMediaEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploadMediaEventSubscription({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useUploadMediaEventSubscription(baseOptions: Apollo.SubscriptionHookOptions<UploadMediaEventSubscription, UploadMediaEventSubscriptionVariables> & ({ variables: UploadMediaEventSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UploadMediaEventSubscription, UploadMediaEventSubscriptionVariables>(UploadMediaEventDocument, options);
      }
export type UploadMediaEventSubscriptionHookResult = ReturnType<typeof useUploadMediaEventSubscription>;
export type UploadMediaEventSubscriptionResult = Apollo.SubscriptionResult<UploadMediaEventSubscription>;
export const RegisterMemberDocument = gql`
    mutation registerMember($email: String!, $firstName: String!, $lastName: String!, $postcode: String!, $password: String!, $passwordConfirmation: String!, $acceptedTerms: Boolean!, $acquisitionSource: String!, $communityId: ID, $redemptionId: ID) {
  registerMember(
    email: $email
    firstName: $firstName
    lastName: $lastName
    postcode: $postcode
    password: $password
    passwordConfirmation: $passwordConfirmation
    acceptedTerms: $acceptedTerms
    acquisitionSource: $acquisitionSource
    communityId: $communityId
    redemptionId: $redemptionId
  ) {
    messages {
      ...ValidationMessageParts
    }
    result {
      message
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type RegisterMemberMutationFn = Apollo.MutationFunction<RegisterMemberMutation, RegisterMemberMutationVariables>;

/**
 * __useRegisterMemberMutation__
 *
 * To run a mutation, you first call `useRegisterMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMemberMutation, { data, loading, error }] = useRegisterMemberMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      postcode: // value for 'postcode'
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *      acceptedTerms: // value for 'acceptedTerms'
 *      acquisitionSource: // value for 'acquisitionSource'
 *      communityId: // value for 'communityId'
 *      redemptionId: // value for 'redemptionId'
 *   },
 * });
 */
export function useRegisterMemberMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMemberMutation, RegisterMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMemberMutation, RegisterMemberMutationVariables>(RegisterMemberDocument, options);
      }
export type RegisterMemberMutationHookResult = ReturnType<typeof useRegisterMemberMutation>;
export type RegisterMemberMutationResult = Apollo.MutationResult<RegisterMemberMutation>;
export type RegisterMemberMutationOptions = Apollo.BaseMutationOptions<RegisterMemberMutation, RegisterMemberMutationVariables>;
export const EarnerOnboardingDocument = gql`
    mutation EarnerOnboarding($complete: Boolean!) {
  earnerOnboarding(complete: $complete) {
    earnerOnboardingLastSeen
  }
}
    `;
export type EarnerOnboardingMutationFn = Apollo.MutationFunction<EarnerOnboardingMutation, EarnerOnboardingMutationVariables>;

/**
 * __useEarnerOnboardingMutation__
 *
 * To run a mutation, you first call `useEarnerOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEarnerOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [earnerOnboardingMutation, { data, loading, error }] = useEarnerOnboardingMutation({
 *   variables: {
 *      complete: // value for 'complete'
 *   },
 * });
 */
export function useEarnerOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<EarnerOnboardingMutation, EarnerOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EarnerOnboardingMutation, EarnerOnboardingMutationVariables>(EarnerOnboardingDocument, options);
      }
export type EarnerOnboardingMutationHookResult = ReturnType<typeof useEarnerOnboardingMutation>;
export type EarnerOnboardingMutationResult = Apollo.MutationResult<EarnerOnboardingMutation>;
export type EarnerOnboardingMutationOptions = Apollo.BaseMutationOptions<EarnerOnboardingMutation, EarnerOnboardingMutationVariables>;
export const MemberReferralPageDocument = gql`
    query MemberReferralPage {
  memberReferral {
    referralLink {
      name
      uri
      activity {
        granularity
        lookbackInterval
        lookbackUnit
        total
        data {
          count
          interval
        }
      }
    }
    referralStats {
      referralCount
      earnings {
        amount
      }
    }
    activity {
      granularity
      lookbackInterval
      lookbackUnit
      total
      data {
        count
        interval
      }
    }
  }
}
    `;

/**
 * __useMemberReferralPageQuery__
 *
 * To run a query within a React component, call `useMemberReferralPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberReferralPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberReferralPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useMemberReferralPageQuery(baseOptions?: Apollo.QueryHookOptions<MemberReferralPageQuery, MemberReferralPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberReferralPageQuery, MemberReferralPageQueryVariables>(MemberReferralPageDocument, options);
      }
export function useMemberReferralPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberReferralPageQuery, MemberReferralPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberReferralPageQuery, MemberReferralPageQueryVariables>(MemberReferralPageDocument, options);
        }
export function useMemberReferralPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemberReferralPageQuery, MemberReferralPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberReferralPageQuery, MemberReferralPageQueryVariables>(MemberReferralPageDocument, options);
        }
export type MemberReferralPageQueryHookResult = ReturnType<typeof useMemberReferralPageQuery>;
export type MemberReferralPageLazyQueryHookResult = ReturnType<typeof useMemberReferralPageLazyQuery>;
export type MemberReferralPageSuspenseQueryHookResult = ReturnType<typeof useMemberReferralPageSuspenseQuery>;
export type MemberReferralPageQueryResult = Apollo.QueryResult<MemberReferralPageQuery, MemberReferralPageQueryVariables>;
export const ViewMessageDocument = gql`
    mutation ViewMessage($messageId: ID!) {
  viewMessage(messageId: $messageId) {
    id
    transaction {
      id
      status
    }
  }
}
    `;
export type ViewMessageMutationFn = Apollo.MutationFunction<ViewMessageMutation, ViewMessageMutationVariables>;

/**
 * __useViewMessageMutation__
 *
 * To run a mutation, you first call `useViewMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewMessageMutation, { data, loading, error }] = useViewMessageMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useViewMessageMutation(baseOptions?: Apollo.MutationHookOptions<ViewMessageMutation, ViewMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ViewMessageMutation, ViewMessageMutationVariables>(ViewMessageDocument, options);
      }
export type ViewMessageMutationHookResult = ReturnType<typeof useViewMessageMutation>;
export type ViewMessageMutationResult = Apollo.MutationResult<ViewMessageMutation>;
export type ViewMessageMutationOptions = Apollo.BaseMutationOptions<ViewMessageMutation, ViewMessageMutationVariables>;
export const SendMessageDocument = gql`
    mutation SendMessage($conversationId: ID!, $body: String!, $parentId: ID, $mediaPointerIds: [ID!]!, $type: MessageType!) {
  sendMessage(
    conversationId: $conversationId
    body: $body
    parentId: $parentId
    mediaPointerIds: $mediaPointerIds
    type: $type
  ) {
    ...MessageParts
  }
}
    ${MessagePartsFragmentDoc}`;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      body: // value for 'body'
 *      parentId: // value for 'parentId'
 *      mediaPointerIds: // value for 'mediaPointerIds'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const ReportContentDocument = gql`
    mutation ReportContent($reportMessageOther: String, $reportReasons: [ContentReportReasons!]!, $targetId: ID!, $targetType: ContentReportTarget!) {
  reportContent(
    reportMessageOther: $reportMessageOther
    reportReasons: $reportReasons
    targetId: $targetId
    targetType: $targetType
  )
}
    `;
export type ReportContentMutationFn = Apollo.MutationFunction<ReportContentMutation, ReportContentMutationVariables>;

/**
 * __useReportContentMutation__
 *
 * To run a mutation, you first call `useReportContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportContentMutation, { data, loading, error }] = useReportContentMutation({
 *   variables: {
 *      reportMessageOther: // value for 'reportMessageOther'
 *      reportReasons: // value for 'reportReasons'
 *      targetId: // value for 'targetId'
 *      targetType: // value for 'targetType'
 *   },
 * });
 */
export function useReportContentMutation(baseOptions?: Apollo.MutationHookOptions<ReportContentMutation, ReportContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportContentMutation, ReportContentMutationVariables>(ReportContentDocument, options);
      }
export type ReportContentMutationHookResult = ReturnType<typeof useReportContentMutation>;
export type ReportContentMutationResult = Apollo.MutationResult<ReportContentMutation>;
export type ReportContentMutationOptions = Apollo.BaseMutationOptions<ReportContentMutation, ReportContentMutationVariables>;
export const AddReactionDocument = gql`
    mutation AddReaction($messageId: ID!, $reaction: String!) {
  addReaction(messageId: $messageId, reaction: $reaction) {
    ...MessageParts
  }
}
    ${MessagePartsFragmentDoc}`;
export type AddReactionMutationFn = Apollo.MutationFunction<AddReactionMutation, AddReactionMutationVariables>;

/**
 * __useAddReactionMutation__
 *
 * To run a mutation, you first call `useAddReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReactionMutation, { data, loading, error }] = useAddReactionMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      reaction: // value for 'reaction'
 *   },
 * });
 */
export function useAddReactionMutation(baseOptions?: Apollo.MutationHookOptions<AddReactionMutation, AddReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddReactionMutation, AddReactionMutationVariables>(AddReactionDocument, options);
      }
export type AddReactionMutationHookResult = ReturnType<typeof useAddReactionMutation>;
export type AddReactionMutationResult = Apollo.MutationResult<AddReactionMutation>;
export type AddReactionMutationOptions = Apollo.BaseMutationOptions<AddReactionMutation, AddReactionMutationVariables>;
export const DeleteReactionDocument = gql`
    mutation DeleteReaction($emojiReactionId: ID!, $messageId: ID!) {
  deleteReaction(emojiReactionId: $emojiReactionId, messageId: $messageId) {
    ...MessageParts
  }
}
    ${MessagePartsFragmentDoc}`;
export type DeleteReactionMutationFn = Apollo.MutationFunction<DeleteReactionMutation, DeleteReactionMutationVariables>;

/**
 * __useDeleteReactionMutation__
 *
 * To run a mutation, you first call `useDeleteReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReactionMutation, { data, loading, error }] = useDeleteReactionMutation({
 *   variables: {
 *      emojiReactionId: // value for 'emojiReactionId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useDeleteReactionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReactionMutation, DeleteReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReactionMutation, DeleteReactionMutationVariables>(DeleteReactionDocument, options);
      }
export type DeleteReactionMutationHookResult = ReturnType<typeof useDeleteReactionMutation>;
export type DeleteReactionMutationResult = Apollo.MutationResult<DeleteReactionMutation>;
export type DeleteReactionMutationOptions = Apollo.BaseMutationOptions<DeleteReactionMutation, DeleteReactionMutationVariables>;
export const MessageDocument = gql`
    query Message($id: ID!) {
  message(id: $id) {
    ...MessageParts
  }
}
    ${MessagePartsFragmentDoc}`;

/**
 * __useMessageQuery__
 *
 * To run a query within a React component, call `useMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageQuery(baseOptions: Apollo.QueryHookOptions<MessageQuery, MessageQueryVariables> & ({ variables: MessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageQuery, MessageQueryVariables>(MessageDocument, options);
      }
export function useMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageQuery, MessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageQuery, MessageQueryVariables>(MessageDocument, options);
        }
export function useMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MessageQuery, MessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MessageQuery, MessageQueryVariables>(MessageDocument, options);
        }
export type MessageQueryHookResult = ReturnType<typeof useMessageQuery>;
export type MessageLazyQueryHookResult = ReturnType<typeof useMessageLazyQuery>;
export type MessageSuspenseQueryHookResult = ReturnType<typeof useMessageSuspenseQuery>;
export type MessageQueryResult = Apollo.QueryResult<MessageQuery, MessageQueryVariables>;
export const SetNotificationPreferencesDocument = gql`
    mutation SetNotificationPreferences($np: NotificationPreferencesInput!) {
  setNotificationPreferences(notificationPreferences: $np) {
    channels {
      id
      enabled
      type
    }
    workflows {
      id
      channelPreferences {
        id
        enabled
        type
      }
      enabled
      key
    }
  }
}
    `;
export type SetNotificationPreferencesMutationFn = Apollo.MutationFunction<SetNotificationPreferencesMutation, SetNotificationPreferencesMutationVariables>;

/**
 * __useSetNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useSetNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotificationPreferencesMutation, { data, loading, error }] = useSetNotificationPreferencesMutation({
 *   variables: {
 *      np: // value for 'np'
 *   },
 * });
 */
export function useSetNotificationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<SetNotificationPreferencesMutation, SetNotificationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNotificationPreferencesMutation, SetNotificationPreferencesMutationVariables>(SetNotificationPreferencesDocument, options);
      }
export type SetNotificationPreferencesMutationHookResult = ReturnType<typeof useSetNotificationPreferencesMutation>;
export type SetNotificationPreferencesMutationResult = Apollo.MutationResult<SetNotificationPreferencesMutation>;
export type SetNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<SetNotificationPreferencesMutation, SetNotificationPreferencesMutationVariables>;
export const SmsRemoveDocument = gql`
    mutation SmsRemove {
  smsRemove {
    messages {
      ...ValidationMessageParts
    }
    result {
      message
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type SmsRemoveMutationFn = Apollo.MutationFunction<SmsRemoveMutation, SmsRemoveMutationVariables>;

/**
 * __useSmsRemoveMutation__
 *
 * To run a mutation, you first call `useSmsRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSmsRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [smsRemoveMutation, { data, loading, error }] = useSmsRemoveMutation({
 *   variables: {
 *   },
 * });
 */
export function useSmsRemoveMutation(baseOptions?: Apollo.MutationHookOptions<SmsRemoveMutation, SmsRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SmsRemoveMutation, SmsRemoveMutationVariables>(SmsRemoveDocument, options);
      }
export type SmsRemoveMutationHookResult = ReturnType<typeof useSmsRemoveMutation>;
export type SmsRemoveMutationResult = Apollo.MutationResult<SmsRemoveMutation>;
export type SmsRemoveMutationOptions = Apollo.BaseMutationOptions<SmsRemoveMutation, SmsRemoveMutationVariables>;
export const SmsVerificationCancelDocument = gql`
    mutation SmsVerificationCancel {
  smsVerificationCancel {
    messages {
      ...ValidationMessageParts
    }
    result {
      message
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type SmsVerificationCancelMutationFn = Apollo.MutationFunction<SmsVerificationCancelMutation, SmsVerificationCancelMutationVariables>;

/**
 * __useSmsVerificationCancelMutation__
 *
 * To run a mutation, you first call `useSmsVerificationCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSmsVerificationCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [smsVerificationCancelMutation, { data, loading, error }] = useSmsVerificationCancelMutation({
 *   variables: {
 *   },
 * });
 */
export function useSmsVerificationCancelMutation(baseOptions?: Apollo.MutationHookOptions<SmsVerificationCancelMutation, SmsVerificationCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SmsVerificationCancelMutation, SmsVerificationCancelMutationVariables>(SmsVerificationCancelDocument, options);
      }
export type SmsVerificationCancelMutationHookResult = ReturnType<typeof useSmsVerificationCancelMutation>;
export type SmsVerificationCancelMutationResult = Apollo.MutationResult<SmsVerificationCancelMutation>;
export type SmsVerificationCancelMutationOptions = Apollo.BaseMutationOptions<SmsVerificationCancelMutation, SmsVerificationCancelMutationVariables>;
export const SmsVerificationInitiateDocument = gql`
    mutation SmsVerificationInitiate($smsPhoneNumber: String!) {
  smsVerificationInitiate(smsPhoneNumber: $smsPhoneNumber) {
    messages {
      ...ValidationMessageParts
    }
    result {
      message
      smsPhoneNumber
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type SmsVerificationInitiateMutationFn = Apollo.MutationFunction<SmsVerificationInitiateMutation, SmsVerificationInitiateMutationVariables>;

/**
 * __useSmsVerificationInitiateMutation__
 *
 * To run a mutation, you first call `useSmsVerificationInitiateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSmsVerificationInitiateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [smsVerificationInitiateMutation, { data, loading, error }] = useSmsVerificationInitiateMutation({
 *   variables: {
 *      smsPhoneNumber: // value for 'smsPhoneNumber'
 *   },
 * });
 */
export function useSmsVerificationInitiateMutation(baseOptions?: Apollo.MutationHookOptions<SmsVerificationInitiateMutation, SmsVerificationInitiateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SmsVerificationInitiateMutation, SmsVerificationInitiateMutationVariables>(SmsVerificationInitiateDocument, options);
      }
export type SmsVerificationInitiateMutationHookResult = ReturnType<typeof useSmsVerificationInitiateMutation>;
export type SmsVerificationInitiateMutationResult = Apollo.MutationResult<SmsVerificationInitiateMutation>;
export type SmsVerificationInitiateMutationOptions = Apollo.BaseMutationOptions<SmsVerificationInitiateMutation, SmsVerificationInitiateMutationVariables>;
export const SmsVerificationVerifyDocument = gql`
    mutation SmsVerificationVerify($code: String!) {
  smsVerificationVerify(code: $code) {
    messages {
      ...ValidationMessageParts
    }
    result {
      message
      user {
        ...UserParts
      }
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}
${UserPartsFragmentDoc}`;
export type SmsVerificationVerifyMutationFn = Apollo.MutationFunction<SmsVerificationVerifyMutation, SmsVerificationVerifyMutationVariables>;

/**
 * __useSmsVerificationVerifyMutation__
 *
 * To run a mutation, you first call `useSmsVerificationVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSmsVerificationVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [smsVerificationVerifyMutation, { data, loading, error }] = useSmsVerificationVerifyMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSmsVerificationVerifyMutation(baseOptions?: Apollo.MutationHookOptions<SmsVerificationVerifyMutation, SmsVerificationVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SmsVerificationVerifyMutation, SmsVerificationVerifyMutationVariables>(SmsVerificationVerifyDocument, options);
      }
export type SmsVerificationVerifyMutationHookResult = ReturnType<typeof useSmsVerificationVerifyMutation>;
export type SmsVerificationVerifyMutationResult = Apollo.MutationResult<SmsVerificationVerifyMutation>;
export type SmsVerificationVerifyMutationOptions = Apollo.BaseMutationOptions<SmsVerificationVerifyMutation, SmsVerificationVerifyMutationVariables>;
export const SetDefaultNotificationPreferencesForMobileDocument = gql`
    mutation SetDefaultNotificationPreferencesForMobile {
  setDefaultNotificationPreferencesForMobile {
    channels {
      description
      enabled
      id
      title
      type
    }
    workflows {
      channelPreferences {
        description
        enabled
        id
        title
        type
      }
      description
      enabled
      id
      key
      profileTypes
      title
    }
  }
}
    `;
export type SetDefaultNotificationPreferencesForMobileMutationFn = Apollo.MutationFunction<SetDefaultNotificationPreferencesForMobileMutation, SetDefaultNotificationPreferencesForMobileMutationVariables>;

/**
 * __useSetDefaultNotificationPreferencesForMobileMutation__
 *
 * To run a mutation, you first call `useSetDefaultNotificationPreferencesForMobileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultNotificationPreferencesForMobileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultNotificationPreferencesForMobileMutation, { data, loading, error }] = useSetDefaultNotificationPreferencesForMobileMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetDefaultNotificationPreferencesForMobileMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultNotificationPreferencesForMobileMutation, SetDefaultNotificationPreferencesForMobileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultNotificationPreferencesForMobileMutation, SetDefaultNotificationPreferencesForMobileMutationVariables>(SetDefaultNotificationPreferencesForMobileDocument, options);
      }
export type SetDefaultNotificationPreferencesForMobileMutationHookResult = ReturnType<typeof useSetDefaultNotificationPreferencesForMobileMutation>;
export type SetDefaultNotificationPreferencesForMobileMutationResult = Apollo.MutationResult<SetDefaultNotificationPreferencesForMobileMutation>;
export type SetDefaultNotificationPreferencesForMobileMutationOptions = Apollo.BaseMutationOptions<SetDefaultNotificationPreferencesForMobileMutation, SetDefaultNotificationPreferencesForMobileMutationVariables>;
export const ResendEmailVerificationDocument = gql`
    mutation ResendEmailVerification($email: String!) {
  resendEmailVerification(email: $email) {
    messages {
      ...ValidationMessageParts
    }
    result {
      message
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type ResendEmailVerificationMutationFn = Apollo.MutationFunction<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>;

/**
 * __useResendEmailVerificationMutation__
 *
 * To run a mutation, you first call `useResendEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailVerificationMutation, { data, loading, error }] = useResendEmailVerificationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>(ResendEmailVerificationDocument, options);
      }
export type ResendEmailVerificationMutationHookResult = ReturnType<typeof useResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationResult = Apollo.MutationResult<ResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationOptions = Apollo.BaseMutationOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>;
export const KnockCredentialsDocument = gql`
    query KnockCredentials {
  knockCredentials {
    publicKey
    userToken
    userId
    feedChannelId
  }
}
    `;

/**
 * __useKnockCredentialsQuery__
 *
 * To run a query within a React component, call `useKnockCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKnockCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnockCredentialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useKnockCredentialsQuery(baseOptions?: Apollo.QueryHookOptions<KnockCredentialsQuery, KnockCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KnockCredentialsQuery, KnockCredentialsQueryVariables>(KnockCredentialsDocument, options);
      }
export function useKnockCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KnockCredentialsQuery, KnockCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KnockCredentialsQuery, KnockCredentialsQueryVariables>(KnockCredentialsDocument, options);
        }
export function useKnockCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KnockCredentialsQuery, KnockCredentialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KnockCredentialsQuery, KnockCredentialsQueryVariables>(KnockCredentialsDocument, options);
        }
export type KnockCredentialsQueryHookResult = ReturnType<typeof useKnockCredentialsQuery>;
export type KnockCredentialsLazyQueryHookResult = ReturnType<typeof useKnockCredentialsLazyQuery>;
export type KnockCredentialsSuspenseQueryHookResult = ReturnType<typeof useKnockCredentialsSuspenseQuery>;
export type KnockCredentialsQueryResult = Apollo.QueryResult<KnockCredentialsQuery, KnockCredentialsQueryVariables>;
export const NotificationPreferencesPageDocument = gql`
    query NotificationPreferencesPage {
  notificationPreferences {
    ...NotificationPreferencesParts
  }
  user {
    ...UserParts
  }
  smsVerificationCurrent {
    ...SmsPendingVerificationParts
  }
}
    ${NotificationPreferencesPartsFragmentDoc}
${UserPartsFragmentDoc}
${SmsPendingVerificationPartsFragmentDoc}`;

/**
 * __useNotificationPreferencesPageQuery__
 *
 * To run a query within a React component, call `useNotificationPreferencesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationPreferencesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationPreferencesPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationPreferencesPageQuery(baseOptions?: Apollo.QueryHookOptions<NotificationPreferencesPageQuery, NotificationPreferencesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationPreferencesPageQuery, NotificationPreferencesPageQueryVariables>(NotificationPreferencesPageDocument, options);
      }
export function useNotificationPreferencesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationPreferencesPageQuery, NotificationPreferencesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationPreferencesPageQuery, NotificationPreferencesPageQueryVariables>(NotificationPreferencesPageDocument, options);
        }
export function useNotificationPreferencesPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationPreferencesPageQuery, NotificationPreferencesPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationPreferencesPageQuery, NotificationPreferencesPageQueryVariables>(NotificationPreferencesPageDocument, options);
        }
export type NotificationPreferencesPageQueryHookResult = ReturnType<typeof useNotificationPreferencesPageQuery>;
export type NotificationPreferencesPageLazyQueryHookResult = ReturnType<typeof useNotificationPreferencesPageLazyQuery>;
export type NotificationPreferencesPageSuspenseQueryHookResult = ReturnType<typeof useNotificationPreferencesPageSuspenseQuery>;
export type NotificationPreferencesPageQueryResult = Apollo.QueryResult<NotificationPreferencesPageQuery, NotificationPreferencesPageQueryVariables>;
export const NotificationPreferencesDocument = gql`
    query NotificationPreferences {
  notificationPreferences {
    channels {
      ...ChannelPreferenceParts
    }
    workflows {
      id
      channelPreferences {
        ...ChannelPreferenceParts
      }
      description
      enabled
      key
      profileTypes
      title
    }
  }
}
    ${ChannelPreferencePartsFragmentDoc}`;

/**
 * __useNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>(NotificationPreferencesDocument, options);
      }
export function useNotificationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>(NotificationPreferencesDocument, options);
        }
export function useNotificationPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>(NotificationPreferencesDocument, options);
        }
export type NotificationPreferencesQueryHookResult = ReturnType<typeof useNotificationPreferencesQuery>;
export type NotificationPreferencesLazyQueryHookResult = ReturnType<typeof useNotificationPreferencesLazyQuery>;
export type NotificationPreferencesSuspenseQueryHookResult = ReturnType<typeof useNotificationPreferencesSuspenseQuery>;
export type NotificationPreferencesQueryResult = Apollo.QueryResult<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>;
export const SmsVerificationCurrentDocument = gql`
    query SmsVerificationCurrent {
  smsVerificationCurrent {
    ...SmsPendingVerificationParts
  }
}
    ${SmsPendingVerificationPartsFragmentDoc}`;

/**
 * __useSmsVerificationCurrentQuery__
 *
 * To run a query within a React component, call `useSmsVerificationCurrentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmsVerificationCurrentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmsVerificationCurrentQuery({
 *   variables: {
 *   },
 * });
 */
export function useSmsVerificationCurrentQuery(baseOptions?: Apollo.QueryHookOptions<SmsVerificationCurrentQuery, SmsVerificationCurrentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmsVerificationCurrentQuery, SmsVerificationCurrentQueryVariables>(SmsVerificationCurrentDocument, options);
      }
export function useSmsVerificationCurrentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmsVerificationCurrentQuery, SmsVerificationCurrentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmsVerificationCurrentQuery, SmsVerificationCurrentQueryVariables>(SmsVerificationCurrentDocument, options);
        }
export function useSmsVerificationCurrentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmsVerificationCurrentQuery, SmsVerificationCurrentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SmsVerificationCurrentQuery, SmsVerificationCurrentQueryVariables>(SmsVerificationCurrentDocument, options);
        }
export type SmsVerificationCurrentQueryHookResult = ReturnType<typeof useSmsVerificationCurrentQuery>;
export type SmsVerificationCurrentLazyQueryHookResult = ReturnType<typeof useSmsVerificationCurrentLazyQuery>;
export type SmsVerificationCurrentSuspenseQueryHookResult = ReturnType<typeof useSmsVerificationCurrentSuspenseQuery>;
export type SmsVerificationCurrentQueryResult = Apollo.QueryResult<SmsVerificationCurrentQuery, SmsVerificationCurrentQueryVariables>;
export const BlockProfileDocument = gql`
    mutation BlockProfile($conversationId: ID!, $profileId: ID!) {
  blockProfile(conversationId: $conversationId, profileId: $profileId) {
    ...BlockParts
  }
}
    ${BlockPartsFragmentDoc}`;
export type BlockProfileMutationFn = Apollo.MutationFunction<BlockProfileMutation, BlockProfileMutationVariables>;

/**
 * __useBlockProfileMutation__
 *
 * To run a mutation, you first call `useBlockProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockProfileMutation, { data, loading, error }] = useBlockProfileMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useBlockProfileMutation(baseOptions?: Apollo.MutationHookOptions<BlockProfileMutation, BlockProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockProfileMutation, BlockProfileMutationVariables>(BlockProfileDocument, options);
      }
export type BlockProfileMutationHookResult = ReturnType<typeof useBlockProfileMutation>;
export type BlockProfileMutationResult = Apollo.MutationResult<BlockProfileMutation>;
export type BlockProfileMutationOptions = Apollo.BaseMutationOptions<BlockProfileMutation, BlockProfileMutationVariables>;
export const ChangeVendorProfileDocument = gql`
    mutation ChangeVendorProfile($displayName: String!, $vendorName: String!, $firstName: String!, $lastName: String!, $bio: String, $city: String!, $state: String!, $timezone: String!, $profileLinks: [ProfileLinkInput!], $profilePhotoMediaPointerId: ID, $profilePhotoCrop: String) {
  changeVendorProfile(
    displayName: $displayName
    vendorName: $vendorName
    firstName: $firstName
    lastName: $lastName
    bio: $bio
    city: $city
    state: $state
    timezone: $timezone
    profileLinks: $profileLinks
    profilePhotoMediaPointerId: $profilePhotoMediaPointerId
    profilePhotoCrop: $profilePhotoCrop
  ) {
    successful
    messages {
      code
      field
      message
      template
    }
  }
}
    `;
export type ChangeVendorProfileMutationFn = Apollo.MutationFunction<ChangeVendorProfileMutation, ChangeVendorProfileMutationVariables>;

/**
 * __useChangeVendorProfileMutation__
 *
 * To run a mutation, you first call `useChangeVendorProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeVendorProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeVendorProfileMutation, { data, loading, error }] = useChangeVendorProfileMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      vendorName: // value for 'vendorName'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      bio: // value for 'bio'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      timezone: // value for 'timezone'
 *      profileLinks: // value for 'profileLinks'
 *      profilePhotoMediaPointerId: // value for 'profilePhotoMediaPointerId'
 *      profilePhotoCrop: // value for 'profilePhotoCrop'
 *   },
 * });
 */
export function useChangeVendorProfileMutation(baseOptions?: Apollo.MutationHookOptions<ChangeVendorProfileMutation, ChangeVendorProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeVendorProfileMutation, ChangeVendorProfileMutationVariables>(ChangeVendorProfileDocument, options);
      }
export type ChangeVendorProfileMutationHookResult = ReturnType<typeof useChangeVendorProfileMutation>;
export type ChangeVendorProfileMutationResult = Apollo.MutationResult<ChangeVendorProfileMutation>;
export type ChangeVendorProfileMutationOptions = Apollo.BaseMutationOptions<ChangeVendorProfileMutation, ChangeVendorProfileMutationVariables>;
export const ChangeMemberProfileDocument = gql`
    mutation ChangeMemberProfile($displayName: String!, $firstName: String, $lastName: String) {
  changeMemberProfile(
    displayName: $displayName
    firstName: $firstName
    lastName: $lastName
  ) {
    successful
    result {
      displayName
      firstName
      id
      lastName
      profileType
      timezone
    }
    messages {
      code
      field
      message
      template
    }
  }
}
    `;
export type ChangeMemberProfileMutationFn = Apollo.MutationFunction<ChangeMemberProfileMutation, ChangeMemberProfileMutationVariables>;

/**
 * __useChangeMemberProfileMutation__
 *
 * To run a mutation, you first call `useChangeMemberProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMemberProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMemberProfileMutation, { data, loading, error }] = useChangeMemberProfileMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useChangeMemberProfileMutation(baseOptions?: Apollo.MutationHookOptions<ChangeMemberProfileMutation, ChangeMemberProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeMemberProfileMutation, ChangeMemberProfileMutationVariables>(ChangeMemberProfileDocument, options);
      }
export type ChangeMemberProfileMutationHookResult = ReturnType<typeof useChangeMemberProfileMutation>;
export type ChangeMemberProfileMutationResult = Apollo.MutationResult<ChangeMemberProfileMutation>;
export type ChangeMemberProfileMutationOptions = Apollo.BaseMutationOptions<ChangeMemberProfileMutation, ChangeMemberProfileMutationVariables>;
export const UnBlockProfileDocument = gql`
    mutation UnBlockProfile($conversationId: ID, $profileId: ID!) {
  unblockProfile(conversationId: $conversationId, profileId: $profileId) {
    ...BlockParts
  }
}
    ${BlockPartsFragmentDoc}`;
export type UnBlockProfileMutationFn = Apollo.MutationFunction<UnBlockProfileMutation, UnBlockProfileMutationVariables>;

/**
 * __useUnBlockProfileMutation__
 *
 * To run a mutation, you first call `useUnBlockProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnBlockProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unBlockProfileMutation, { data, loading, error }] = useUnBlockProfileMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useUnBlockProfileMutation(baseOptions?: Apollo.MutationHookOptions<UnBlockProfileMutation, UnBlockProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnBlockProfileMutation, UnBlockProfileMutationVariables>(UnBlockProfileDocument, options);
      }
export type UnBlockProfileMutationHookResult = ReturnType<typeof useUnBlockProfileMutation>;
export type UnBlockProfileMutationResult = Apollo.MutationResult<UnBlockProfileMutation>;
export type UnBlockProfileMutationOptions = Apollo.BaseMutationOptions<UnBlockProfileMutation, UnBlockProfileMutationVariables>;
export const HideSuggestedProfileDocument = gql`
    mutation HideSuggestedProfile($profileId: ID!) {
  hideSuggestedProfile(profileId: $profileId) {
    messages {
      ...ValidationMessageParts
    }
    result {
      message
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type HideSuggestedProfileMutationFn = Apollo.MutationFunction<HideSuggestedProfileMutation, HideSuggestedProfileMutationVariables>;

/**
 * __useHideSuggestedProfileMutation__
 *
 * To run a mutation, you first call `useHideSuggestedProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideSuggestedProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideSuggestedProfileMutation, { data, loading, error }] = useHideSuggestedProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useHideSuggestedProfileMutation(baseOptions?: Apollo.MutationHookOptions<HideSuggestedProfileMutation, HideSuggestedProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideSuggestedProfileMutation, HideSuggestedProfileMutationVariables>(HideSuggestedProfileDocument, options);
      }
export type HideSuggestedProfileMutationHookResult = ReturnType<typeof useHideSuggestedProfileMutation>;
export type HideSuggestedProfileMutationResult = Apollo.MutationResult<HideSuggestedProfileMutation>;
export type HideSuggestedProfileMutationOptions = Apollo.BaseMutationOptions<HideSuggestedProfileMutation, HideSuggestedProfileMutationVariables>;
export const EditableProfileDocument = gql`
    query EditableProfile {
  editableProfile {
    ... on EditableMember {
      displayName
      firstName
      id
      lastName
      profilePhotoCrop
      profilePhotoMediaPointerId
      profilePhotoMediaPointer {
        ...MediaPointerParts
      }
      profilePhotoUrl
      profilePhotoUrlSrcset
      profileType
      timezone
    }
    ... on EditableVendor {
      bio
      displayName
      firstName
      id
      lastName
      profileLinks {
        id
        title
        url
      }
      profilePhotoCrop
      profilePhotoMediaPointerId
      profilePhotoMediaPointer {
        ...MediaPointerParts
      }
      profilePhotoUrl
      profilePhotoUrlSrcset
      profileType
      timezone
      vendorName
      city
      state
    }
  }
}
    ${MediaPointerPartsFragmentDoc}`;

/**
 * __useEditableProfileQuery__
 *
 * To run a query within a React component, call `useEditableProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditableProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditableProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditableProfileQuery(baseOptions?: Apollo.QueryHookOptions<EditableProfileQuery, EditableProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditableProfileQuery, EditableProfileQueryVariables>(EditableProfileDocument, options);
      }
export function useEditableProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditableProfileQuery, EditableProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditableProfileQuery, EditableProfileQueryVariables>(EditableProfileDocument, options);
        }
export function useEditableProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditableProfileQuery, EditableProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditableProfileQuery, EditableProfileQueryVariables>(EditableProfileDocument, options);
        }
export type EditableProfileQueryHookResult = ReturnType<typeof useEditableProfileQuery>;
export type EditableProfileLazyQueryHookResult = ReturnType<typeof useEditableProfileLazyQuery>;
export type EditableProfileSuspenseQueryHookResult = ReturnType<typeof useEditableProfileSuspenseQuery>;
export type EditableProfileQueryResult = Apollo.QueryResult<EditableProfileQuery, EditableProfileQueryVariables>;
export const ProfileNameDocument = gql`
    query ProfileName($id: ID) {
  profileName(id: $id)
}
    `;

/**
 * __useProfileNameQuery__
 *
 * To run a query within a React component, call `useProfileNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfileNameQuery(baseOptions?: Apollo.QueryHookOptions<ProfileNameQuery, ProfileNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileNameQuery, ProfileNameQueryVariables>(ProfileNameDocument, options);
      }
export function useProfileNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileNameQuery, ProfileNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileNameQuery, ProfileNameQueryVariables>(ProfileNameDocument, options);
        }
export function useProfileNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileNameQuery, ProfileNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileNameQuery, ProfileNameQueryVariables>(ProfileNameDocument, options);
        }
export type ProfileNameQueryHookResult = ReturnType<typeof useProfileNameQuery>;
export type ProfileNameLazyQueryHookResult = ReturnType<typeof useProfileNameLazyQuery>;
export type ProfileNameSuspenseQueryHookResult = ReturnType<typeof useProfileNameSuspenseQuery>;
export type ProfileNameQueryResult = Apollo.QueryResult<ProfileNameQuery, ProfileNameQueryVariables>;
export const ProfileTimezoneDocument = gql`
    query ProfileTimezone($displayName: String, $id: ID) {
  profile(displayName: $displayName, id: $id) {
    timezone
  }
}
    `;

/**
 * __useProfileTimezoneQuery__
 *
 * To run a query within a React component, call `useProfileTimezoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileTimezoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileTimezoneQuery({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfileTimezoneQuery(baseOptions?: Apollo.QueryHookOptions<ProfileTimezoneQuery, ProfileTimezoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileTimezoneQuery, ProfileTimezoneQueryVariables>(ProfileTimezoneDocument, options);
      }
export function useProfileTimezoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileTimezoneQuery, ProfileTimezoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileTimezoneQuery, ProfileTimezoneQueryVariables>(ProfileTimezoneDocument, options);
        }
export function useProfileTimezoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileTimezoneQuery, ProfileTimezoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileTimezoneQuery, ProfileTimezoneQueryVariables>(ProfileTimezoneDocument, options);
        }
export type ProfileTimezoneQueryHookResult = ReturnType<typeof useProfileTimezoneQuery>;
export type ProfileTimezoneLazyQueryHookResult = ReturnType<typeof useProfileTimezoneLazyQuery>;
export type ProfileTimezoneSuspenseQueryHookResult = ReturnType<typeof useProfileTimezoneSuspenseQuery>;
export type ProfileTimezoneQueryResult = Apollo.QueryResult<ProfileTimezoneQuery, ProfileTimezoneQueryVariables>;
export const ProfileDocument = gql`
    query Profile($displayName: String, $id: ID) {
  profile(displayName: $displayName, id: $id) {
    ...ProfileParts
  }
}
    ${ProfilePartsFragmentDoc}`;

/**
 * __useProfileQuery__
 *
 * To run a query within a React component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQuery({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfileQuery(baseOptions?: Apollo.QueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
      }
export function useProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export function useProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileSuspenseQueryHookResult = ReturnType<typeof useProfileSuspenseQuery>;
export type ProfileQueryResult = Apollo.QueryResult<ProfileQuery, ProfileQueryVariables>;
export const ProfileLocationsDocument = gql`
    query ProfileLocations {
  profileLocations {
    isPrimary
    title
    address
    location {
      lat
      lng
    }
  }
}
    `;

/**
 * __useProfileLocationsQuery__
 *
 * To run a query within a React component, call `useProfileLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileLocationsQuery(baseOptions?: Apollo.QueryHookOptions<ProfileLocationsQuery, ProfileLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileLocationsQuery, ProfileLocationsQueryVariables>(ProfileLocationsDocument, options);
      }
export function useProfileLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileLocationsQuery, ProfileLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileLocationsQuery, ProfileLocationsQueryVariables>(ProfileLocationsDocument, options);
        }
export function useProfileLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileLocationsQuery, ProfileLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileLocationsQuery, ProfileLocationsQueryVariables>(ProfileLocationsDocument, options);
        }
export type ProfileLocationsQueryHookResult = ReturnType<typeof useProfileLocationsQuery>;
export type ProfileLocationsLazyQueryHookResult = ReturnType<typeof useProfileLocationsLazyQuery>;
export type ProfileLocationsSuspenseQueryHookResult = ReturnType<typeof useProfileLocationsSuspenseQuery>;
export type ProfileLocationsQueryResult = Apollo.QueryResult<ProfileLocationsQuery, ProfileLocationsQueryVariables>;
export const SuggestedProfilesDocument = gql`
    query SuggestedProfiles($limit: Int) {
  suggestedProfiles(limit: $limit) {
    data {
      suggestedAt
      suggestedProfile {
        ...ProfileParts
      }
      suggestedVia
    }
    page {
      ...PageParts
    }
  }
}
    ${ProfilePartsFragmentDoc}
${PagePartsFragmentDoc}`;

/**
 * __useSuggestedProfilesQuery__
 *
 * To run a query within a React component, call `useSuggestedProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestedProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestedProfilesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSuggestedProfilesQuery(baseOptions?: Apollo.QueryHookOptions<SuggestedProfilesQuery, SuggestedProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestedProfilesQuery, SuggestedProfilesQueryVariables>(SuggestedProfilesDocument, options);
      }
export function useSuggestedProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestedProfilesQuery, SuggestedProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestedProfilesQuery, SuggestedProfilesQueryVariables>(SuggestedProfilesDocument, options);
        }
export function useSuggestedProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestedProfilesQuery, SuggestedProfilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestedProfilesQuery, SuggestedProfilesQueryVariables>(SuggestedProfilesDocument, options);
        }
export type SuggestedProfilesQueryHookResult = ReturnType<typeof useSuggestedProfilesQuery>;
export type SuggestedProfilesLazyQueryHookResult = ReturnType<typeof useSuggestedProfilesLazyQuery>;
export type SuggestedProfilesSuspenseQueryHookResult = ReturnType<typeof useSuggestedProfilesSuspenseQuery>;
export type SuggestedProfilesQueryResult = Apollo.QueryResult<SuggestedProfilesQuery, SuggestedProfilesQueryVariables>;
export const RedemptionArchiveDocument = gql`
    mutation RedemptionArchive($redemptionId: ID!) {
  redemptionArchive(id: $redemptionId) {
    messages {
      ...ValidationMessageParts
    }
    result {
      id
      active
      archivedAt
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type RedemptionArchiveMutationFn = Apollo.MutationFunction<RedemptionArchiveMutation, RedemptionArchiveMutationVariables>;

/**
 * __useRedemptionArchiveMutation__
 *
 * To run a mutation, you first call `useRedemptionArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedemptionArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redemptionArchiveMutation, { data, loading, error }] = useRedemptionArchiveMutation({
 *   variables: {
 *      redemptionId: // value for 'redemptionId'
 *   },
 * });
 */
export function useRedemptionArchiveMutation(baseOptions?: Apollo.MutationHookOptions<RedemptionArchiveMutation, RedemptionArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedemptionArchiveMutation, RedemptionArchiveMutationVariables>(RedemptionArchiveDocument, options);
      }
export type RedemptionArchiveMutationHookResult = ReturnType<typeof useRedemptionArchiveMutation>;
export type RedemptionArchiveMutationResult = Apollo.MutationResult<RedemptionArchiveMutation>;
export type RedemptionArchiveMutationOptions = Apollo.BaseMutationOptions<RedemptionArchiveMutation, RedemptionArchiveMutationVariables>;
export const RedemptionCreateDocument = gql`
    mutation RedemptionCreate($name: String) {
  redemptionCreate(name: $name) {
    messages {
      ...ValidationMessageParts
    }
    result {
      id
      name
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type RedemptionCreateMutationFn = Apollo.MutationFunction<RedemptionCreateMutation, RedemptionCreateMutationVariables>;

/**
 * __useRedemptionCreateMutation__
 *
 * To run a mutation, you first call `useRedemptionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedemptionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redemptionCreateMutation, { data, loading, error }] = useRedemptionCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRedemptionCreateMutation(baseOptions?: Apollo.MutationHookOptions<RedemptionCreateMutation, RedemptionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedemptionCreateMutation, RedemptionCreateMutationVariables>(RedemptionCreateDocument, options);
      }
export type RedemptionCreateMutationHookResult = ReturnType<typeof useRedemptionCreateMutation>;
export type RedemptionCreateMutationResult = Apollo.MutationResult<RedemptionCreateMutation>;
export type RedemptionCreateMutationOptions = Apollo.BaseMutationOptions<RedemptionCreateMutation, RedemptionCreateMutationVariables>;
export const RedemptionUnarchiveDocument = gql`
    mutation RedemptionUnarchive($redemptionId: ID!) {
  redemptionUnarchive(id: $redemptionId) {
    messages {
      ...ValidationMessageParts
    }
    result {
      id
      active
      archivedAt
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type RedemptionUnarchiveMutationFn = Apollo.MutationFunction<RedemptionUnarchiveMutation, RedemptionUnarchiveMutationVariables>;

/**
 * __useRedemptionUnarchiveMutation__
 *
 * To run a mutation, you first call `useRedemptionUnarchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedemptionUnarchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redemptionUnarchiveMutation, { data, loading, error }] = useRedemptionUnarchiveMutation({
 *   variables: {
 *      redemptionId: // value for 'redemptionId'
 *   },
 * });
 */
export function useRedemptionUnarchiveMutation(baseOptions?: Apollo.MutationHookOptions<RedemptionUnarchiveMutation, RedemptionUnarchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedemptionUnarchiveMutation, RedemptionUnarchiveMutationVariables>(RedemptionUnarchiveDocument, options);
      }
export type RedemptionUnarchiveMutationHookResult = ReturnType<typeof useRedemptionUnarchiveMutation>;
export type RedemptionUnarchiveMutationResult = Apollo.MutationResult<RedemptionUnarchiveMutation>;
export type RedemptionUnarchiveMutationOptions = Apollo.BaseMutationOptions<RedemptionUnarchiveMutation, RedemptionUnarchiveMutationVariables>;
export const RedemptionUpdateDocument = gql`
    mutation RedemptionUpdate($redemptionId: ID!, $redemption: RedemptionUpdateInput!) {
  redemptionUpdate(id: $redemptionId, redemption: $redemption) {
    messages {
      ...ValidationMessageParts
    }
    result {
      id
      name
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type RedemptionUpdateMutationFn = Apollo.MutationFunction<RedemptionUpdateMutation, RedemptionUpdateMutationVariables>;

/**
 * __useRedemptionUpdateMutation__
 *
 * To run a mutation, you first call `useRedemptionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedemptionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redemptionUpdateMutation, { data, loading, error }] = useRedemptionUpdateMutation({
 *   variables: {
 *      redemptionId: // value for 'redemptionId'
 *      redemption: // value for 'redemption'
 *   },
 * });
 */
export function useRedemptionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RedemptionUpdateMutation, RedemptionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedemptionUpdateMutation, RedemptionUpdateMutationVariables>(RedemptionUpdateDocument, options);
      }
export type RedemptionUpdateMutationHookResult = ReturnType<typeof useRedemptionUpdateMutation>;
export type RedemptionUpdateMutationResult = Apollo.MutationResult<RedemptionUpdateMutation>;
export type RedemptionUpdateMutationOptions = Apollo.BaseMutationOptions<RedemptionUpdateMutation, RedemptionUpdateMutationVariables>;
export const RedemptionsReorderDocument = gql`
    mutation RedemptionsReorder($ids: [ID!]!) {
  redemptionsReorder(ids: $ids) {
    messages {
      ...ValidationMessageParts
    }
    result {
      id
      position
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type RedemptionsReorderMutationFn = Apollo.MutationFunction<RedemptionsReorderMutation, RedemptionsReorderMutationVariables>;

/**
 * __useRedemptionsReorderMutation__
 *
 * To run a mutation, you first call `useRedemptionsReorderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedemptionsReorderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redemptionsReorderMutation, { data, loading, error }] = useRedemptionsReorderMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRedemptionsReorderMutation(baseOptions?: Apollo.MutationHookOptions<RedemptionsReorderMutation, RedemptionsReorderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedemptionsReorderMutation, RedemptionsReorderMutationVariables>(RedemptionsReorderDocument, options);
      }
export type RedemptionsReorderMutationHookResult = ReturnType<typeof useRedemptionsReorderMutation>;
export type RedemptionsReorderMutationResult = Apollo.MutationResult<RedemptionsReorderMutation>;
export type RedemptionsReorderMutationOptions = Apollo.BaseMutationOptions<RedemptionsReorderMutation, RedemptionsReorderMutationVariables>;
export const RedemptionSaveDocument = gql`
    mutation RedemptionSave($redemptionId: ID!) {
  redemptionSave(redemptionId: $redemptionId) {
    result {
      id
      saved
    }
    successful
    messages {
      code
    }
  }
}
    `;
export type RedemptionSaveMutationFn = Apollo.MutationFunction<RedemptionSaveMutation, RedemptionSaveMutationVariables>;

/**
 * __useRedemptionSaveMutation__
 *
 * To run a mutation, you first call `useRedemptionSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedemptionSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redemptionSaveMutation, { data, loading, error }] = useRedemptionSaveMutation({
 *   variables: {
 *      redemptionId: // value for 'redemptionId'
 *   },
 * });
 */
export function useRedemptionSaveMutation(baseOptions?: Apollo.MutationHookOptions<RedemptionSaveMutation, RedemptionSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedemptionSaveMutation, RedemptionSaveMutationVariables>(RedemptionSaveDocument, options);
      }
export type RedemptionSaveMutationHookResult = ReturnType<typeof useRedemptionSaveMutation>;
export type RedemptionSaveMutationResult = Apollo.MutationResult<RedemptionSaveMutation>;
export type RedemptionSaveMutationOptions = Apollo.BaseMutationOptions<RedemptionSaveMutation, RedemptionSaveMutationVariables>;
export const RedemptionUnsaveDocument = gql`
    mutation RedemptionUnsave($redemptionId: ID!) {
  redemptionUnsave(redemptionId: $redemptionId) {
    result {
      id
      saved
    }
    successful
    messages {
      code
    }
  }
}
    `;
export type RedemptionUnsaveMutationFn = Apollo.MutationFunction<RedemptionUnsaveMutation, RedemptionUnsaveMutationVariables>;

/**
 * __useRedemptionUnsaveMutation__
 *
 * To run a mutation, you first call `useRedemptionUnsaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedemptionUnsaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redemptionUnsaveMutation, { data, loading, error }] = useRedemptionUnsaveMutation({
 *   variables: {
 *      redemptionId: // value for 'redemptionId'
 *   },
 * });
 */
export function useRedemptionUnsaveMutation(baseOptions?: Apollo.MutationHookOptions<RedemptionUnsaveMutation, RedemptionUnsaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedemptionUnsaveMutation, RedemptionUnsaveMutationVariables>(RedemptionUnsaveDocument, options);
      }
export type RedemptionUnsaveMutationHookResult = ReturnType<typeof useRedemptionUnsaveMutation>;
export type RedemptionUnsaveMutationResult = Apollo.MutationResult<RedemptionUnsaveMutation>;
export type RedemptionUnsaveMutationOptions = Apollo.BaseMutationOptions<RedemptionUnsaveMutation, RedemptionUnsaveMutationVariables>;
export const RedemptionCloneDocument = gql`
    mutation RedemptionClone($redemptionId: ID!) {
  redemptionClone(redemptionId: $redemptionId) {
    messages {
      ...ValidationMessageParts
    }
    result {
      id
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type RedemptionCloneMutationFn = Apollo.MutationFunction<RedemptionCloneMutation, RedemptionCloneMutationVariables>;

/**
 * __useRedemptionCloneMutation__
 *
 * To run a mutation, you first call `useRedemptionCloneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedemptionCloneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redemptionCloneMutation, { data, loading, error }] = useRedemptionCloneMutation({
 *   variables: {
 *      redemptionId: // value for 'redemptionId'
 *   },
 * });
 */
export function useRedemptionCloneMutation(baseOptions?: Apollo.MutationHookOptions<RedemptionCloneMutation, RedemptionCloneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedemptionCloneMutation, RedemptionCloneMutationVariables>(RedemptionCloneDocument, options);
      }
export type RedemptionCloneMutationHookResult = ReturnType<typeof useRedemptionCloneMutation>;
export type RedemptionCloneMutationResult = Apollo.MutationResult<RedemptionCloneMutation>;
export type RedemptionCloneMutationOptions = Apollo.BaseMutationOptions<RedemptionCloneMutation, RedemptionCloneMutationVariables>;
export const RedeemDocument = gql`
    mutation Redeem($redemptionId: ID!) {
  redeem(redemptionId: $redemptionId) {
    messages {
      ...ValidationMessageParts
    }
    result {
      redemption {
        id
        name
        donationProgress {
          current {
            amount
          }
          goal {
            amount
          }
          progress
        }
      }
      bonusAmountGranted
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type RedeemMutationFn = Apollo.MutationFunction<RedeemMutation, RedeemMutationVariables>;

/**
 * __useRedeemMutation__
 *
 * To run a mutation, you first call `useRedeemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemMutation, { data, loading, error }] = useRedeemMutation({
 *   variables: {
 *      redemptionId: // value for 'redemptionId'
 *   },
 * });
 */
export function useRedeemMutation(baseOptions?: Apollo.MutationHookOptions<RedeemMutation, RedeemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemMutation, RedeemMutationVariables>(RedeemDocument, options);
      }
export type RedeemMutationHookResult = ReturnType<typeof useRedeemMutation>;
export type RedeemMutationResult = Apollo.MutationResult<RedeemMutation>;
export type RedeemMutationOptions = Apollo.BaseMutationOptions<RedeemMutation, RedeemMutationVariables>;
export const RedemptionsDocument = gql`
    query Redemptions($query: RedemptionPageInput, $imgixOpts: [MediaOption!] = []) {
  redemptions(query: $query) {
    data {
      vendor {
        id
        displayName
        name
        photoUrl
      }
      stats {
        viewCount
        redeemCount
        saveCount
        qrCodeScans
      }
      limits(evaluate: false) {
        id
        canRedeem
        limits {
          ...RedemptionLimitParts
        }
      }
      linkedVendor {
        id
        displayName
        name
        photoUrl
      }
      redeemCount
      ...RedemptionParts
      ...RedemptionMediaPreviewParts
    }
    page {
      ...PageParts
    }
    query {
      filters {
        attribute
        op
        value {
          ...PageFilterParts
        }
      }
    }
  }
}
    ${RedemptionLimitPartsFragmentDoc}
${RedemptionPartsFragmentDoc}
${RedemptionMediaPreviewPartsFragmentDoc}
${PagePartsFragmentDoc}
${PageFilterPartsFragmentDoc}`;

/**
 * __useRedemptionsQuery__
 *
 * To run a query within a React component, call `useRedemptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedemptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedemptionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function useRedemptionsQuery(baseOptions?: Apollo.QueryHookOptions<RedemptionsQuery, RedemptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RedemptionsQuery, RedemptionsQueryVariables>(RedemptionsDocument, options);
      }
export function useRedemptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RedemptionsQuery, RedemptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RedemptionsQuery, RedemptionsQueryVariables>(RedemptionsDocument, options);
        }
export function useRedemptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RedemptionsQuery, RedemptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RedemptionsQuery, RedemptionsQueryVariables>(RedemptionsDocument, options);
        }
export type RedemptionsQueryHookResult = ReturnType<typeof useRedemptionsQuery>;
export type RedemptionsLazyQueryHookResult = ReturnType<typeof useRedemptionsLazyQuery>;
export type RedemptionsSuspenseQueryHookResult = ReturnType<typeof useRedemptionsSuspenseQuery>;
export type RedemptionsQueryResult = Apollo.QueryResult<RedemptionsQuery, RedemptionsQueryVariables>;
export const RedemptionsDiscoveryDocument = gql`
    query RedemptionsDiscovery($query: RedemptionPageInput, $imgixOpts: [MediaOption!] = [], $currentLocation: GeoPointInput, $evaluate: Boolean = false) {
  discoverRedemptions(query: $query, currentLocation: $currentLocation) {
    data {
      id
      active
      archivedAt
      vendor {
        id
        displayName
        name
        photoUrl
      }
      description
      limits(evaluate: $evaluate) {
        id
        canRedeem
        limits {
          ...RedemptionLimitParts
        }
      }
      name
      price {
        amount
      }
      vendor {
        photoUrl
      }
      isNonProfit
      isSweepstakes
      donationProgress {
        current {
          amount
        }
        goal {
          amount
        }
        progress
      }
      validEnd
      linkedVendor {
        id
        displayName
        name
        photoUrl
      }
      location {
        lng
        lat
      }
      redeemCount
      saved
      ...RedemptionMediaPreviewParts
    }
    page {
      ...PageParts
    }
    query {
      filters {
        attribute
        op
        value {
          ...PageFilterParts
        }
      }
    }
  }
}
    ${RedemptionLimitPartsFragmentDoc}
${RedemptionMediaPreviewPartsFragmentDoc}
${PagePartsFragmentDoc}
${PageFilterPartsFragmentDoc}`;

/**
 * __useRedemptionsDiscoveryQuery__
 *
 * To run a query within a React component, call `useRedemptionsDiscoveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedemptionsDiscoveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedemptionsDiscoveryQuery({
 *   variables: {
 *      query: // value for 'query'
 *      imgixOpts: // value for 'imgixOpts'
 *      currentLocation: // value for 'currentLocation'
 *      evaluate: // value for 'evaluate'
 *   },
 * });
 */
export function useRedemptionsDiscoveryQuery(baseOptions?: Apollo.QueryHookOptions<RedemptionsDiscoveryQuery, RedemptionsDiscoveryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RedemptionsDiscoveryQuery, RedemptionsDiscoveryQueryVariables>(RedemptionsDiscoveryDocument, options);
      }
export function useRedemptionsDiscoveryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RedemptionsDiscoveryQuery, RedemptionsDiscoveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RedemptionsDiscoveryQuery, RedemptionsDiscoveryQueryVariables>(RedemptionsDiscoveryDocument, options);
        }
export function useRedemptionsDiscoverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RedemptionsDiscoveryQuery, RedemptionsDiscoveryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RedemptionsDiscoveryQuery, RedemptionsDiscoveryQueryVariables>(RedemptionsDiscoveryDocument, options);
        }
export type RedemptionsDiscoveryQueryHookResult = ReturnType<typeof useRedemptionsDiscoveryQuery>;
export type RedemptionsDiscoveryLazyQueryHookResult = ReturnType<typeof useRedemptionsDiscoveryLazyQuery>;
export type RedemptionsDiscoverySuspenseQueryHookResult = ReturnType<typeof useRedemptionsDiscoverySuspenseQuery>;
export type RedemptionsDiscoveryQueryResult = Apollo.QueryResult<RedemptionsDiscoveryQuery, RedemptionsDiscoveryQueryVariables>;
export const RedemptionsGetSingleDocument = gql`
    query RedemptionsGetSingle($id: ID!, $includeArchived: Boolean = false, $imgixOpts: [MediaOption!] = [], $evaluate: Boolean = false) {
  getRedemption(id: $id, includeArchived: $includeArchived) {
    id
    active
    vendor {
      id
      displayName
      name
      photoUrl
    }
    confirmationTextOverrideHtml
    description
    limits(evaluate: $evaluate) {
      id
      canRedeem
      limits {
        ...RedemptionLimitParts
      }
    }
    redeemCount
    name
    important
    isNonProfit
    isSweepstakes
    location {
      lat
      lng
    }
    donationProgress {
      current {
        amount
      }
      goal {
        amount
      }
      progress
    }
    linkedVendor {
      id
      displayName
      name
      photoUrl
      followRecord {
        conversationId
        memberId
        vendorId
      }
    }
    price {
      amount
    }
    referralLink
    validEnd
    archivedAt
    saved
    stats {
      viewCount
      redeemCount
      saveCount
      qrCodeScans
    }
    ...RedemptionMediaPreviewParts
  }
}
    ${RedemptionLimitPartsFragmentDoc}
${RedemptionMediaPreviewPartsFragmentDoc}`;

/**
 * __useRedemptionsGetSingleQuery__
 *
 * To run a query within a React component, call `useRedemptionsGetSingleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedemptionsGetSingleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedemptionsGetSingleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeArchived: // value for 'includeArchived'
 *      imgixOpts: // value for 'imgixOpts'
 *      evaluate: // value for 'evaluate'
 *   },
 * });
 */
export function useRedemptionsGetSingleQuery(baseOptions: Apollo.QueryHookOptions<RedemptionsGetSingleQuery, RedemptionsGetSingleQueryVariables> & ({ variables: RedemptionsGetSingleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RedemptionsGetSingleQuery, RedemptionsGetSingleQueryVariables>(RedemptionsGetSingleDocument, options);
      }
export function useRedemptionsGetSingleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RedemptionsGetSingleQuery, RedemptionsGetSingleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RedemptionsGetSingleQuery, RedemptionsGetSingleQueryVariables>(RedemptionsGetSingleDocument, options);
        }
export function useRedemptionsGetSingleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RedemptionsGetSingleQuery, RedemptionsGetSingleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RedemptionsGetSingleQuery, RedemptionsGetSingleQueryVariables>(RedemptionsGetSingleDocument, options);
        }
export type RedemptionsGetSingleQueryHookResult = ReturnType<typeof useRedemptionsGetSingleQuery>;
export type RedemptionsGetSingleLazyQueryHookResult = ReturnType<typeof useRedemptionsGetSingleLazyQuery>;
export type RedemptionsGetSingleSuspenseQueryHookResult = ReturnType<typeof useRedemptionsGetSingleSuspenseQuery>;
export type RedemptionsGetSingleQueryResult = Apollo.QueryResult<RedemptionsGetSingleQuery, RedemptionsGetSingleQueryVariables>;
export const RedemptionMemberHistoryDocument = gql`
    query RedemptionMemberHistory($query: RedemptionHistoryPageInput, $imgixOpts: [MediaOption!] = []) {
  redemptionHistory(query: $query) {
    data {
      id
      redemptionName
      redemptionPrice {
        amount
      }
      vendor {
        id
        name
        displayName
        photoUrl
      }
      redemption {
        id
        isNonProfit
        isSweepstakes
        ...RedemptionMediaPreviewParts
      }
      insertedAt
    }
    page {
      ...PageParts
    }
  }
}
    ${RedemptionMediaPreviewPartsFragmentDoc}
${PagePartsFragmentDoc}`;

/**
 * __useRedemptionMemberHistoryQuery__
 *
 * To run a query within a React component, call `useRedemptionMemberHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedemptionMemberHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedemptionMemberHistoryQuery({
 *   variables: {
 *      query: // value for 'query'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function useRedemptionMemberHistoryQuery(baseOptions?: Apollo.QueryHookOptions<RedemptionMemberHistoryQuery, RedemptionMemberHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RedemptionMemberHistoryQuery, RedemptionMemberHistoryQueryVariables>(RedemptionMemberHistoryDocument, options);
      }
export function useRedemptionMemberHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RedemptionMemberHistoryQuery, RedemptionMemberHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RedemptionMemberHistoryQuery, RedemptionMemberHistoryQueryVariables>(RedemptionMemberHistoryDocument, options);
        }
export function useRedemptionMemberHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RedemptionMemberHistoryQuery, RedemptionMemberHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RedemptionMemberHistoryQuery, RedemptionMemberHistoryQueryVariables>(RedemptionMemberHistoryDocument, options);
        }
export type RedemptionMemberHistoryQueryHookResult = ReturnType<typeof useRedemptionMemberHistoryQuery>;
export type RedemptionMemberHistoryLazyQueryHookResult = ReturnType<typeof useRedemptionMemberHistoryLazyQuery>;
export type RedemptionMemberHistorySuspenseQueryHookResult = ReturnType<typeof useRedemptionMemberHistorySuspenseQuery>;
export type RedemptionMemberHistoryQueryResult = Apollo.QueryResult<RedemptionMemberHistoryQuery, RedemptionMemberHistoryQueryVariables>;
export const RedemptionVendorHistoryDocument = gql`
    query RedemptionVendorHistory($query: RedemptionHistoryPageInput, $imgixOpts: [MediaOption!] = []) {
  redemptionHistory(query: $query) {
    data {
      id
      redemptionName
      redemptionPrice {
        amount
      }
      member {
        displayName
        profilePhotoUrl
      }
      redemption {
        id
        ...RedemptionMediaPreviewParts
      }
      vendor {
        name
        displayName
        photoUrl
      }
      insertedAt
    }
    page {
      ...PageParts
    }
  }
}
    ${RedemptionMediaPreviewPartsFragmentDoc}
${PagePartsFragmentDoc}`;

/**
 * __useRedemptionVendorHistoryQuery__
 *
 * To run a query within a React component, call `useRedemptionVendorHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedemptionVendorHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedemptionVendorHistoryQuery({
 *   variables: {
 *      query: // value for 'query'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function useRedemptionVendorHistoryQuery(baseOptions?: Apollo.QueryHookOptions<RedemptionVendorHistoryQuery, RedemptionVendorHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RedemptionVendorHistoryQuery, RedemptionVendorHistoryQueryVariables>(RedemptionVendorHistoryDocument, options);
      }
export function useRedemptionVendorHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RedemptionVendorHistoryQuery, RedemptionVendorHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RedemptionVendorHistoryQuery, RedemptionVendorHistoryQueryVariables>(RedemptionVendorHistoryDocument, options);
        }
export function useRedemptionVendorHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RedemptionVendorHistoryQuery, RedemptionVendorHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RedemptionVendorHistoryQuery, RedemptionVendorHistoryQueryVariables>(RedemptionVendorHistoryDocument, options);
        }
export type RedemptionVendorHistoryQueryHookResult = ReturnType<typeof useRedemptionVendorHistoryQuery>;
export type RedemptionVendorHistoryLazyQueryHookResult = ReturnType<typeof useRedemptionVendorHistoryLazyQuery>;
export type RedemptionVendorHistorySuspenseQueryHookResult = ReturnType<typeof useRedemptionVendorHistorySuspenseQuery>;
export type RedemptionVendorHistoryQueryResult = Apollo.QueryResult<RedemptionVendorHistoryQuery, RedemptionVendorHistoryQueryVariables>;
export const RedemptionsSavedDocument = gql`
    query RedemptionsSaved($query: RedemptionPageInput, $imgixOpts: [MediaOption!] = [], $currentLocation: GeoPointInput, $evaluate: Boolean = false) {
  redemptionsSaved(query: $query, currentLocation: $currentLocation) {
    data {
      id
      active
      archivedAt
      vendor {
        id
        displayName
        name
        photoUrl
      }
      description
      limits(evaluate: $evaluate) {
        id
        canRedeem
        limits {
          ...RedemptionLimitParts
        }
      }
      name
      price {
        amount
      }
      vendor {
        photoUrl
      }
      isNonProfit
      donationProgress {
        current {
          amount
        }
        goal {
          amount
        }
        progress
      }
      validEnd
      linkedVendor {
        id
        displayName
        name
        photoUrl
      }
      location {
        lng
        lat
      }
      redeemCount
      saved
      ...RedemptionMediaPreviewParts
    }
    page {
      ...PageParts
    }
    query {
      filters {
        attribute
        op
        value {
          ...PageFilterParts
        }
      }
    }
  }
}
    ${RedemptionLimitPartsFragmentDoc}
${RedemptionMediaPreviewPartsFragmentDoc}
${PagePartsFragmentDoc}
${PageFilterPartsFragmentDoc}`;

/**
 * __useRedemptionsSavedQuery__
 *
 * To run a query within a React component, call `useRedemptionsSavedQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedemptionsSavedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedemptionsSavedQuery({
 *   variables: {
 *      query: // value for 'query'
 *      imgixOpts: // value for 'imgixOpts'
 *      currentLocation: // value for 'currentLocation'
 *      evaluate: // value for 'evaluate'
 *   },
 * });
 */
export function useRedemptionsSavedQuery(baseOptions?: Apollo.QueryHookOptions<RedemptionsSavedQuery, RedemptionsSavedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RedemptionsSavedQuery, RedemptionsSavedQueryVariables>(RedemptionsSavedDocument, options);
      }
export function useRedemptionsSavedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RedemptionsSavedQuery, RedemptionsSavedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RedemptionsSavedQuery, RedemptionsSavedQueryVariables>(RedemptionsSavedDocument, options);
        }
export function useRedemptionsSavedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RedemptionsSavedQuery, RedemptionsSavedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RedemptionsSavedQuery, RedemptionsSavedQueryVariables>(RedemptionsSavedDocument, options);
        }
export type RedemptionsSavedQueryHookResult = ReturnType<typeof useRedemptionsSavedQuery>;
export type RedemptionsSavedLazyQueryHookResult = ReturnType<typeof useRedemptionsSavedLazyQuery>;
export type RedemptionsSavedSuspenseQueryHookResult = ReturnType<typeof useRedemptionsSavedSuspenseQuery>;
export type RedemptionsSavedQueryResult = Apollo.QueryResult<RedemptionsSavedQuery, RedemptionsSavedQueryVariables>;
export const TopLiveRedemptionDocument = gql`
    query TopLiveRedemption($vendorId: ID!) {
  topLiveRedemption(vendorId: $vendorId) {
    id
  }
}
    `;

/**
 * __useTopLiveRedemptionQuery__
 *
 * To run a query within a React component, call `useTopLiveRedemptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopLiveRedemptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopLiveRedemptionQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useTopLiveRedemptionQuery(baseOptions: Apollo.QueryHookOptions<TopLiveRedemptionQuery, TopLiveRedemptionQueryVariables> & ({ variables: TopLiveRedemptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopLiveRedemptionQuery, TopLiveRedemptionQueryVariables>(TopLiveRedemptionDocument, options);
      }
export function useTopLiveRedemptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopLiveRedemptionQuery, TopLiveRedemptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopLiveRedemptionQuery, TopLiveRedemptionQueryVariables>(TopLiveRedemptionDocument, options);
        }
export function useTopLiveRedemptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopLiveRedemptionQuery, TopLiveRedemptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopLiveRedemptionQuery, TopLiveRedemptionQueryVariables>(TopLiveRedemptionDocument, options);
        }
export type TopLiveRedemptionQueryHookResult = ReturnType<typeof useTopLiveRedemptionQuery>;
export type TopLiveRedemptionLazyQueryHookResult = ReturnType<typeof useTopLiveRedemptionLazyQuery>;
export type TopLiveRedemptionSuspenseQueryHookResult = ReturnType<typeof useTopLiveRedemptionSuspenseQuery>;
export type TopLiveRedemptionQueryResult = Apollo.QueryResult<TopLiveRedemptionQuery, TopLiveRedemptionQueryVariables>;
export const NearestSpotlightRedemptionDocument = gql`
    query NearestSpotlightRedemption($currentLocation: GeoPointInput) {
  nearestSpotlightRedemption(currentLocation: $currentLocation) {
    id
  }
}
    `;

/**
 * __useNearestSpotlightRedemptionQuery__
 *
 * To run a query within a React component, call `useNearestSpotlightRedemptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNearestSpotlightRedemptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNearestSpotlightRedemptionQuery({
 *   variables: {
 *      currentLocation: // value for 'currentLocation'
 *   },
 * });
 */
export function useNearestSpotlightRedemptionQuery(baseOptions?: Apollo.QueryHookOptions<NearestSpotlightRedemptionQuery, NearestSpotlightRedemptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NearestSpotlightRedemptionQuery, NearestSpotlightRedemptionQueryVariables>(NearestSpotlightRedemptionDocument, options);
      }
export function useNearestSpotlightRedemptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NearestSpotlightRedemptionQuery, NearestSpotlightRedemptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NearestSpotlightRedemptionQuery, NearestSpotlightRedemptionQueryVariables>(NearestSpotlightRedemptionDocument, options);
        }
export function useNearestSpotlightRedemptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NearestSpotlightRedemptionQuery, NearestSpotlightRedemptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NearestSpotlightRedemptionQuery, NearestSpotlightRedemptionQueryVariables>(NearestSpotlightRedemptionDocument, options);
        }
export type NearestSpotlightRedemptionQueryHookResult = ReturnType<typeof useNearestSpotlightRedemptionQuery>;
export type NearestSpotlightRedemptionLazyQueryHookResult = ReturnType<typeof useNearestSpotlightRedemptionLazyQuery>;
export type NearestSpotlightRedemptionSuspenseQueryHookResult = ReturnType<typeof useNearestSpotlightRedemptionSuspenseQuery>;
export type NearestSpotlightRedemptionQueryResult = Apollo.QueryResult<NearestSpotlightRedemptionQuery, NearestSpotlightRedemptionQueryVariables>;
export const CreateAccessTokenDocument = gql`
    mutation CreateAccessToken {
  createAccessToken {
    ...AccessTokenParts
  }
}
    ${AccessTokenPartsFragmentDoc}`;
export type CreateAccessTokenMutationFn = Apollo.MutationFunction<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>;

/**
 * __useCreateAccessTokenMutation__
 *
 * To run a mutation, you first call `useCreateAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccessTokenMutation, { data, loading, error }] = useCreateAccessTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>(CreateAccessTokenDocument, options);
      }
export type CreateAccessTokenMutationHookResult = ReturnType<typeof useCreateAccessTokenMutation>;
export type CreateAccessTokenMutationResult = Apollo.MutationResult<CreateAccessTokenMutation>;
export type CreateAccessTokenMutationOptions = Apollo.BaseMutationOptions<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>;
export const AddDeviceTokenDocument = gql`
    mutation AddDeviceToken($deviceToken: DeviceTokenInput!) {
  addDeviceToken(deviceToken: $deviceToken) {
    messages {
      ...ValidationMessageParts
    }
    result {
      ...DeviceTokenParts
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}
${DeviceTokenPartsFragmentDoc}`;
export type AddDeviceTokenMutationFn = Apollo.MutationFunction<AddDeviceTokenMutation, AddDeviceTokenMutationVariables>;

/**
 * __useAddDeviceTokenMutation__
 *
 * To run a mutation, you first call `useAddDeviceTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDeviceTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDeviceTokenMutation, { data, loading, error }] = useAddDeviceTokenMutation({
 *   variables: {
 *      deviceToken: // value for 'deviceToken'
 *   },
 * });
 */
export function useAddDeviceTokenMutation(baseOptions?: Apollo.MutationHookOptions<AddDeviceTokenMutation, AddDeviceTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDeviceTokenMutation, AddDeviceTokenMutationVariables>(AddDeviceTokenDocument, options);
      }
export type AddDeviceTokenMutationHookResult = ReturnType<typeof useAddDeviceTokenMutation>;
export type AddDeviceTokenMutationResult = Apollo.MutationResult<AddDeviceTokenMutation>;
export type AddDeviceTokenMutationOptions = Apollo.BaseMutationOptions<AddDeviceTokenMutation, AddDeviceTokenMutationVariables>;
export const RemoveDeviceTokenDocument = gql`
    mutation RemoveDeviceToken($deviceTokenId: ID!) {
  removeDeviceToken(deviceTokenId: $deviceTokenId) {
    messages {
      ...ValidationMessageParts
    }
    result {
      ...DeviceTokenParts
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}
${DeviceTokenPartsFragmentDoc}`;
export type RemoveDeviceTokenMutationFn = Apollo.MutationFunction<RemoveDeviceTokenMutation, RemoveDeviceTokenMutationVariables>;

/**
 * __useRemoveDeviceTokenMutation__
 *
 * To run a mutation, you first call `useRemoveDeviceTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDeviceTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDeviceTokenMutation, { data, loading, error }] = useRemoveDeviceTokenMutation({
 *   variables: {
 *      deviceTokenId: // value for 'deviceTokenId'
 *   },
 * });
 */
export function useRemoveDeviceTokenMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDeviceTokenMutation, RemoveDeviceTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDeviceTokenMutation, RemoveDeviceTokenMutationVariables>(RemoveDeviceTokenDocument, options);
      }
export type RemoveDeviceTokenMutationHookResult = ReturnType<typeof useRemoveDeviceTokenMutation>;
export type RemoveDeviceTokenMutationResult = Apollo.MutationResult<RemoveDeviceTokenMutation>;
export type RemoveDeviceTokenMutationOptions = Apollo.BaseMutationOptions<RemoveDeviceTokenMutation, RemoveDeviceTokenMutationVariables>;
export const DeviceTokensDocument = gql`
    query DeviceTokens {
  deviceTokens {
    ...DeviceTokenParts
  }
}
    ${DeviceTokenPartsFragmentDoc}`;

/**
 * __useDeviceTokensQuery__
 *
 * To run a query within a React component, call `useDeviceTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceTokensQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeviceTokensQuery(baseOptions?: Apollo.QueryHookOptions<DeviceTokensQuery, DeviceTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceTokensQuery, DeviceTokensQueryVariables>(DeviceTokensDocument, options);
      }
export function useDeviceTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceTokensQuery, DeviceTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceTokensQuery, DeviceTokensQueryVariables>(DeviceTokensDocument, options);
        }
export function useDeviceTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceTokensQuery, DeviceTokensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeviceTokensQuery, DeviceTokensQueryVariables>(DeviceTokensDocument, options);
        }
export type DeviceTokensQueryHookResult = ReturnType<typeof useDeviceTokensQuery>;
export type DeviceTokensLazyQueryHookResult = ReturnType<typeof useDeviceTokensLazyQuery>;
export type DeviceTokensSuspenseQueryHookResult = ReturnType<typeof useDeviceTokensSuspenseQuery>;
export type DeviceTokensQueryResult = Apollo.QueryResult<DeviceTokensQuery, DeviceTokensQueryVariables>;
export const TosAcceptDocument = gql`
    mutation TosAccept($version: String!) {
  tosAccept(version: $version) {
    messages {
      ...ValidationMessageParts
    }
    result {
      ...TosAcceptedParts
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}
${TosAcceptedPartsFragmentDoc}`;
export type TosAcceptMutationFn = Apollo.MutationFunction<TosAcceptMutation, TosAcceptMutationVariables>;

/**
 * __useTosAcceptMutation__
 *
 * To run a mutation, you first call `useTosAcceptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTosAcceptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tosAcceptMutation, { data, loading, error }] = useTosAcceptMutation({
 *   variables: {
 *      version: // value for 'version'
 *   },
 * });
 */
export function useTosAcceptMutation(baseOptions?: Apollo.MutationHookOptions<TosAcceptMutation, TosAcceptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TosAcceptMutation, TosAcceptMutationVariables>(TosAcceptDocument, options);
      }
export type TosAcceptMutationHookResult = ReturnType<typeof useTosAcceptMutation>;
export type TosAcceptMutationResult = Apollo.MutationResult<TosAcceptMutation>;
export type TosAcceptMutationOptions = Apollo.BaseMutationOptions<TosAcceptMutation, TosAcceptMutationVariables>;
export const TosCurrentDocument = gql`
    query TosCurrent {
  tosCurrent {
    content
    ...TosVersionParts
  }
}
    ${TosVersionPartsFragmentDoc}`;

/**
 * __useTosCurrentQuery__
 *
 * To run a query within a React component, call `useTosCurrentQuery` and pass it any options that fit your needs.
 * When your component renders, `useTosCurrentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTosCurrentQuery({
 *   variables: {
 *   },
 * });
 */
export function useTosCurrentQuery(baseOptions?: Apollo.QueryHookOptions<TosCurrentQuery, TosCurrentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TosCurrentQuery, TosCurrentQueryVariables>(TosCurrentDocument, options);
      }
export function useTosCurrentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TosCurrentQuery, TosCurrentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TosCurrentQuery, TosCurrentQueryVariables>(TosCurrentDocument, options);
        }
export function useTosCurrentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TosCurrentQuery, TosCurrentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TosCurrentQuery, TosCurrentQueryVariables>(TosCurrentDocument, options);
        }
export type TosCurrentQueryHookResult = ReturnType<typeof useTosCurrentQuery>;
export type TosCurrentLazyQueryHookResult = ReturnType<typeof useTosCurrentLazyQuery>;
export type TosCurrentSuspenseQueryHookResult = ReturnType<typeof useTosCurrentSuspenseQuery>;
export type TosCurrentQueryResult = Apollo.QueryResult<TosCurrentQuery, TosCurrentQueryVariables>;
export const PollCreateDocument = gql`
    mutation PollCreate($poll: PollObjectInput!, $imgixOpts: [MediaOption!]) {
  pollCreate(poll: $poll) {
    ...PollAndTriviaResultParts
  }
}
    ${PollAndTriviaResultPartsFragmentDoc}`;
export type PollCreateMutationFn = Apollo.MutationFunction<PollCreateMutation, PollCreateMutationVariables>;

/**
 * __usePollCreateMutation__
 *
 * To run a mutation, you first call `usePollCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePollCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pollCreateMutation, { data, loading, error }] = usePollCreateMutation({
 *   variables: {
 *      poll: // value for 'poll'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function usePollCreateMutation(baseOptions?: Apollo.MutationHookOptions<PollCreateMutation, PollCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PollCreateMutation, PollCreateMutationVariables>(PollCreateDocument, options);
      }
export type PollCreateMutationHookResult = ReturnType<typeof usePollCreateMutation>;
export type PollCreateMutationResult = Apollo.MutationResult<PollCreateMutation>;
export type PollCreateMutationOptions = Apollo.BaseMutationOptions<PollCreateMutation, PollCreateMutationVariables>;
export const PollUpdateDocument = gql`
    mutation PollUpdate($poll: PollObjectInput!, $pollId: ID!, $imgixOpts: [MediaOption!]) {
  pollUpdate(poll: $poll, pollId: $pollId) {
    ...PollAndTriviaResultParts
  }
}
    ${PollAndTriviaResultPartsFragmentDoc}`;
export type PollUpdateMutationFn = Apollo.MutationFunction<PollUpdateMutation, PollUpdateMutationVariables>;

/**
 * __usePollUpdateMutation__
 *
 * To run a mutation, you first call `usePollUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePollUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pollUpdateMutation, { data, loading, error }] = usePollUpdateMutation({
 *   variables: {
 *      poll: // value for 'poll'
 *      pollId: // value for 'pollId'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function usePollUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PollUpdateMutation, PollUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PollUpdateMutation, PollUpdateMutationVariables>(PollUpdateDocument, options);
      }
export type PollUpdateMutationHookResult = ReturnType<typeof usePollUpdateMutation>;
export type PollUpdateMutationResult = Apollo.MutationResult<PollUpdateMutation>;
export type PollUpdateMutationOptions = Apollo.BaseMutationOptions<PollUpdateMutation, PollUpdateMutationVariables>;
export const PollSetToLiveDocument = gql`
    mutation PollSetToLive($pollId: ID!, $endAt: DateTime, $imgixOpts: [MediaOption!]) {
  pollSetToLive(pollId: $pollId, endAt: $endAt) {
    ...PollAndTriviaResultParts
  }
}
    ${PollAndTriviaResultPartsFragmentDoc}`;
export type PollSetToLiveMutationFn = Apollo.MutationFunction<PollSetToLiveMutation, PollSetToLiveMutationVariables>;

/**
 * __usePollSetToLiveMutation__
 *
 * To run a mutation, you first call `usePollSetToLiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePollSetToLiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pollSetToLiveMutation, { data, loading, error }] = usePollSetToLiveMutation({
 *   variables: {
 *      pollId: // value for 'pollId'
 *      endAt: // value for 'endAt'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function usePollSetToLiveMutation(baseOptions?: Apollo.MutationHookOptions<PollSetToLiveMutation, PollSetToLiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PollSetToLiveMutation, PollSetToLiveMutationVariables>(PollSetToLiveDocument, options);
      }
export type PollSetToLiveMutationHookResult = ReturnType<typeof usePollSetToLiveMutation>;
export type PollSetToLiveMutationResult = Apollo.MutationResult<PollSetToLiveMutation>;
export type PollSetToLiveMutationOptions = Apollo.BaseMutationOptions<PollSetToLiveMutation, PollSetToLiveMutationVariables>;
export const PollArchiveDocument = gql`
    mutation PollArchive($pollId: ID!, $imgixOpts: [MediaOption!]) {
  pollArchive(pollId: $pollId) {
    ...PollAndTriviaResultParts
  }
}
    ${PollAndTriviaResultPartsFragmentDoc}`;
export type PollArchiveMutationFn = Apollo.MutationFunction<PollArchiveMutation, PollArchiveMutationVariables>;

/**
 * __usePollArchiveMutation__
 *
 * To run a mutation, you first call `usePollArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePollArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pollArchiveMutation, { data, loading, error }] = usePollArchiveMutation({
 *   variables: {
 *      pollId: // value for 'pollId'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function usePollArchiveMutation(baseOptions?: Apollo.MutationHookOptions<PollArchiveMutation, PollArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PollArchiveMutation, PollArchiveMutationVariables>(PollArchiveDocument, options);
      }
export type PollArchiveMutationHookResult = ReturnType<typeof usePollArchiveMutation>;
export type PollArchiveMutationResult = Apollo.MutationResult<PollArchiveMutation>;
export type PollArchiveMutationOptions = Apollo.BaseMutationOptions<PollArchiveMutation, PollArchiveMutationVariables>;
export const PollPublishDocument = gql`
    mutation PollPublish($pollId: ID!, $imgixOpts: [MediaOption!]) {
  pollPublish(pollId: $pollId) {
    ...PollAndTriviaResultParts
  }
}
    ${PollAndTriviaResultPartsFragmentDoc}`;
export type PollPublishMutationFn = Apollo.MutationFunction<PollPublishMutation, PollPublishMutationVariables>;

/**
 * __usePollPublishMutation__
 *
 * To run a mutation, you first call `usePollPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePollPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pollPublishMutation, { data, loading, error }] = usePollPublishMutation({
 *   variables: {
 *      pollId: // value for 'pollId'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function usePollPublishMutation(baseOptions?: Apollo.MutationHookOptions<PollPublishMutation, PollPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PollPublishMutation, PollPublishMutationVariables>(PollPublishDocument, options);
      }
export type PollPublishMutationHookResult = ReturnType<typeof usePollPublishMutation>;
export type PollPublishMutationResult = Apollo.MutationResult<PollPublishMutation>;
export type PollPublishMutationOptions = Apollo.BaseMutationOptions<PollPublishMutation, PollPublishMutationVariables>;
export const PollCompleteDocument = gql`
    mutation PollComplete($pollId: ID!, $imgixOpts: [MediaOption!]) {
  pollComplete(pollId: $pollId) {
    ...PollAndTriviaResultParts
  }
}
    ${PollAndTriviaResultPartsFragmentDoc}`;
export type PollCompleteMutationFn = Apollo.MutationFunction<PollCompleteMutation, PollCompleteMutationVariables>;

/**
 * __usePollCompleteMutation__
 *
 * To run a mutation, you first call `usePollCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePollCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pollCompleteMutation, { data, loading, error }] = usePollCompleteMutation({
 *   variables: {
 *      pollId: // value for 'pollId'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function usePollCompleteMutation(baseOptions?: Apollo.MutationHookOptions<PollCompleteMutation, PollCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PollCompleteMutation, PollCompleteMutationVariables>(PollCompleteDocument, options);
      }
export type PollCompleteMutationHookResult = ReturnType<typeof usePollCompleteMutation>;
export type PollCompleteMutationResult = Apollo.MutationResult<PollCompleteMutation>;
export type PollCompleteMutationOptions = Apollo.BaseMutationOptions<PollCompleteMutation, PollCompleteMutationVariables>;
export const VendorPollsListDocument = gql`
    query VendorPollsList($imgixOpts: [MediaOption!], $query: PollPageInput) {
  pollAll(query: $query) {
    data {
      ...PollAndTriviaParts
      status
    }
    page {
      ...PageParts
    }
  }
}
    ${PollAndTriviaPartsFragmentDoc}
${PagePartsFragmentDoc}`;

/**
 * __useVendorPollsListQuery__
 *
 * To run a query within a React component, call `useVendorPollsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorPollsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorPollsListQuery({
 *   variables: {
 *      imgixOpts: // value for 'imgixOpts'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useVendorPollsListQuery(baseOptions?: Apollo.QueryHookOptions<VendorPollsListQuery, VendorPollsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorPollsListQuery, VendorPollsListQueryVariables>(VendorPollsListDocument, options);
      }
export function useVendorPollsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorPollsListQuery, VendorPollsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorPollsListQuery, VendorPollsListQueryVariables>(VendorPollsListDocument, options);
        }
export function useVendorPollsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VendorPollsListQuery, VendorPollsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VendorPollsListQuery, VendorPollsListQueryVariables>(VendorPollsListDocument, options);
        }
export type VendorPollsListQueryHookResult = ReturnType<typeof useVendorPollsListQuery>;
export type VendorPollsListLazyQueryHookResult = ReturnType<typeof useVendorPollsListLazyQuery>;
export type VendorPollsListSuspenseQueryHookResult = ReturnType<typeof useVendorPollsListSuspenseQuery>;
export type VendorPollsListQueryResult = Apollo.QueryResult<VendorPollsListQuery, VendorPollsListQueryVariables>;
export const VendorCompletedPollsListDocument = gql`
    query VendorCompletedPollsList($imgixOpts: [MediaOption!], $query: PollPageInput) {
  pollAll(query: $query) {
    data {
      ...PollAndTriviaParts
      status
    }
    page {
      ...PageParts
    }
  }
}
    ${PollAndTriviaPartsFragmentDoc}
${PagePartsFragmentDoc}`;

/**
 * __useVendorCompletedPollsListQuery__
 *
 * To run a query within a React component, call `useVendorCompletedPollsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorCompletedPollsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorCompletedPollsListQuery({
 *   variables: {
 *      imgixOpts: // value for 'imgixOpts'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useVendorCompletedPollsListQuery(baseOptions?: Apollo.QueryHookOptions<VendorCompletedPollsListQuery, VendorCompletedPollsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorCompletedPollsListQuery, VendorCompletedPollsListQueryVariables>(VendorCompletedPollsListDocument, options);
      }
export function useVendorCompletedPollsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorCompletedPollsListQuery, VendorCompletedPollsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorCompletedPollsListQuery, VendorCompletedPollsListQueryVariables>(VendorCompletedPollsListDocument, options);
        }
export function useVendorCompletedPollsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VendorCompletedPollsListQuery, VendorCompletedPollsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VendorCompletedPollsListQuery, VendorCompletedPollsListQueryVariables>(VendorCompletedPollsListDocument, options);
        }
export type VendorCompletedPollsListQueryHookResult = ReturnType<typeof useVendorCompletedPollsListQuery>;
export type VendorCompletedPollsListLazyQueryHookResult = ReturnType<typeof useVendorCompletedPollsListLazyQuery>;
export type VendorCompletedPollsListSuspenseQueryHookResult = ReturnType<typeof useVendorCompletedPollsListSuspenseQuery>;
export type VendorCompletedPollsListQueryResult = Apollo.QueryResult<VendorCompletedPollsListQuery, VendorCompletedPollsListQueryVariables>;
export const VendorGetSinglePollObjectDocument = gql`
    query VendorGetSinglePollObject($pollGetId: ID!, $imgixOpts: [MediaOption!]) {
  pollGet(id: $pollGetId) {
    ...PollAndTriviaParts
    status
  }
}
    ${PollAndTriviaPartsFragmentDoc}`;

/**
 * __useVendorGetSinglePollObjectQuery__
 *
 * To run a query within a React component, call `useVendorGetSinglePollObjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorGetSinglePollObjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorGetSinglePollObjectQuery({
 *   variables: {
 *      pollGetId: // value for 'pollGetId'
 *      imgixOpts: // value for 'imgixOpts'
 *   },
 * });
 */
export function useVendorGetSinglePollObjectQuery(baseOptions: Apollo.QueryHookOptions<VendorGetSinglePollObjectQuery, VendorGetSinglePollObjectQueryVariables> & ({ variables: VendorGetSinglePollObjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorGetSinglePollObjectQuery, VendorGetSinglePollObjectQueryVariables>(VendorGetSinglePollObjectDocument, options);
      }
export function useVendorGetSinglePollObjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorGetSinglePollObjectQuery, VendorGetSinglePollObjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorGetSinglePollObjectQuery, VendorGetSinglePollObjectQueryVariables>(VendorGetSinglePollObjectDocument, options);
        }
export function useVendorGetSinglePollObjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VendorGetSinglePollObjectQuery, VendorGetSinglePollObjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VendorGetSinglePollObjectQuery, VendorGetSinglePollObjectQueryVariables>(VendorGetSinglePollObjectDocument, options);
        }
export type VendorGetSinglePollObjectQueryHookResult = ReturnType<typeof useVendorGetSinglePollObjectQuery>;
export type VendorGetSinglePollObjectLazyQueryHookResult = ReturnType<typeof useVendorGetSinglePollObjectLazyQuery>;
export type VendorGetSinglePollObjectSuspenseQueryHookResult = ReturnType<typeof useVendorGetSinglePollObjectSuspenseQuery>;
export type VendorGetSinglePollObjectQueryResult = Apollo.QueryResult<VendorGetSinglePollObjectQuery, VendorGetSinglePollObjectQueryVariables>;
export const FirstPollOfTheDayDocument = gql`
    subscription FirstPollOfTheDay {
  pollEvents {
    ... on FirstPollOfTheDay {
      profileId
      type
    }
  }
}
    `;

/**
 * __useFirstPollOfTheDaySubscription__
 *
 * To run a query within a React component, call `useFirstPollOfTheDaySubscription` and pass it any options that fit your needs.
 * When your component renders, `useFirstPollOfTheDaySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirstPollOfTheDaySubscription({
 *   variables: {
 *   },
 * });
 */
export function useFirstPollOfTheDaySubscription(baseOptions?: Apollo.SubscriptionHookOptions<FirstPollOfTheDaySubscription, FirstPollOfTheDaySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<FirstPollOfTheDaySubscription, FirstPollOfTheDaySubscriptionVariables>(FirstPollOfTheDayDocument, options);
      }
export type FirstPollOfTheDaySubscriptionHookResult = ReturnType<typeof useFirstPollOfTheDaySubscription>;
export type FirstPollOfTheDaySubscriptionResult = Apollo.SubscriptionResult<FirstPollOfTheDaySubscription>;
export const LoginDocument = gql`
    mutation Login($email: String, $password: String, $magicLinkToken: String, $emailToken: String) {
  login(
    email: $email
    password: $password
    magicLinkToken: $magicLinkToken
    emailToken: $emailToken
  ) {
    accessToken {
      ...AccessTokenParts
    }
    impersonator {
      id
      email
    }
    user {
      ...UserLoginParts
    }
  }
}
    ${AccessTokenPartsFragmentDoc}
${UserLoginPartsFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      magicLinkToken: // value for 'magicLinkToken'
 *      emailToken: // value for 'emailToken'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout($deviceId: String) {
  logout(deviceId: $deviceId)
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const NotifyUserTypedDocument = gql`
    mutation NotifyUserTyped($conversationId: ID!) {
  notifyUserTyped(conversationId: $conversationId)
}
    `;
export type NotifyUserTypedMutationFn = Apollo.MutationFunction<NotifyUserTypedMutation, NotifyUserTypedMutationVariables>;

/**
 * __useNotifyUserTypedMutation__
 *
 * To run a mutation, you first call `useNotifyUserTypedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyUserTypedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyUserTypedMutation, { data, loading, error }] = useNotifyUserTypedMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useNotifyUserTypedMutation(baseOptions?: Apollo.MutationHookOptions<NotifyUserTypedMutation, NotifyUserTypedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyUserTypedMutation, NotifyUserTypedMutationVariables>(NotifyUserTypedDocument, options);
      }
export type NotifyUserTypedMutationHookResult = ReturnType<typeof useNotifyUserTypedMutation>;
export type NotifyUserTypedMutationResult = Apollo.MutationResult<NotifyUserTypedMutation>;
export type NotifyUserTypedMutationOptions = Apollo.BaseMutationOptions<NotifyUserTypedMutation, NotifyUserTypedMutationVariables>;
export const ChangeEmailDocument = gql`
    mutation ChangeEmail($currentPassword: String!, $email: String!) {
  changeEmail(currentPassword: $currentPassword, email: $email) {
    messages {
      code
      field
      message
      template
    }
    result {
      message
    }
    successful
  }
}
    `;
export type ChangeEmailMutationFn = Apollo.MutationFunction<ChangeEmailMutation, ChangeEmailMutationVariables>;

/**
 * __useChangeEmailMutation__
 *
 * To run a mutation, you first call `useChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailMutation, { data, loading, error }] = useChangeEmailMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useChangeEmailMutation(baseOptions?: Apollo.MutationHookOptions<ChangeEmailMutation, ChangeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeEmailMutation, ChangeEmailMutationVariables>(ChangeEmailDocument, options);
      }
export type ChangeEmailMutationHookResult = ReturnType<typeof useChangeEmailMutation>;
export type ChangeEmailMutationResult = Apollo.MutationResult<ChangeEmailMutation>;
export type ChangeEmailMutationOptions = Apollo.BaseMutationOptions<ChangeEmailMutation, ChangeEmailMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($currentPassword: String!, $password: String!, $passwordConfirmation: String!) {
  changePassword(
    currentPassword: $currentPassword
    password: $password
    passwordConfirmation: $passwordConfirmation
  ) {
    messages {
      code
      field
      message
      template
    }
    result {
      message
    }
    successful
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ResetPasswordInitiateDocument = gql`
    mutation ResetPasswordInitiate($email: String!) {
  resetPasswordInitiate(email: $email) {
    messages {
      ...ValidationMessageParts
    }
    result {
      message
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type ResetPasswordInitiateMutationFn = Apollo.MutationFunction<ResetPasswordInitiateMutation, ResetPasswordInitiateMutationVariables>;

/**
 * __useResetPasswordInitiateMutation__
 *
 * To run a mutation, you first call `useResetPasswordInitiateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordInitiateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordInitiateMutation, { data, loading, error }] = useResetPasswordInitiateMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordInitiateMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordInitiateMutation, ResetPasswordInitiateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordInitiateMutation, ResetPasswordInitiateMutationVariables>(ResetPasswordInitiateDocument, options);
      }
export type ResetPasswordInitiateMutationHookResult = ReturnType<typeof useResetPasswordInitiateMutation>;
export type ResetPasswordInitiateMutationResult = Apollo.MutationResult<ResetPasswordInitiateMutation>;
export type ResetPasswordInitiateMutationOptions = Apollo.BaseMutationOptions<ResetPasswordInitiateMutation, ResetPasswordInitiateMutationVariables>;
export const ResetPasswordFinalizeDocument = gql`
    mutation ResetPasswordFinalize($password: String!, $passwordConfirmation: String!, $token: String!) {
  resetPasswordFinalize(
    password: $password
    passwordConfirmation: $passwordConfirmation
    token: $token
  ) {
    messages {
      ...ValidationMessageParts
    }
    result {
      message
    }
    successful
  }
}
    ${ValidationMessagePartsFragmentDoc}`;
export type ResetPasswordFinalizeMutationFn = Apollo.MutationFunction<ResetPasswordFinalizeMutation, ResetPasswordFinalizeMutationVariables>;

/**
 * __useResetPasswordFinalizeMutation__
 *
 * To run a mutation, you first call `useResetPasswordFinalizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordFinalizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordFinalizeMutation, { data, loading, error }] = useResetPasswordFinalizeMutation({
 *   variables: {
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResetPasswordFinalizeMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordFinalizeMutation, ResetPasswordFinalizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordFinalizeMutation, ResetPasswordFinalizeMutationVariables>(ResetPasswordFinalizeDocument, options);
      }
export type ResetPasswordFinalizeMutationHookResult = ReturnType<typeof useResetPasswordFinalizeMutation>;
export type ResetPasswordFinalizeMutationResult = Apollo.MutationResult<ResetPasswordFinalizeMutation>;
export type ResetPasswordFinalizeMutationOptions = Apollo.BaseMutationOptions<ResetPasswordFinalizeMutation, ResetPasswordFinalizeMutationVariables>;
export const UserDocument = gql`
    query User {
  impersonator {
    id
    email
  }
  user {
    ...UserParts
  }
}
    ${UserPartsFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UserCheckInfoDocument = gql`
    query UserCheckInfo {
  user {
    id
    email
    profile {
      displayName
      profilePhotoUrl
      profileType
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useUserCheckInfoQuery__
 *
 * To run a query within a React component, call `useUserCheckInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCheckInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCheckInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserCheckInfoQuery(baseOptions?: Apollo.QueryHookOptions<UserCheckInfoQuery, UserCheckInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCheckInfoQuery, UserCheckInfoQueryVariables>(UserCheckInfoDocument, options);
      }
export function useUserCheckInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCheckInfoQuery, UserCheckInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCheckInfoQuery, UserCheckInfoQueryVariables>(UserCheckInfoDocument, options);
        }
export function useUserCheckInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserCheckInfoQuery, UserCheckInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserCheckInfoQuery, UserCheckInfoQueryVariables>(UserCheckInfoDocument, options);
        }
export type UserCheckInfoQueryHookResult = ReturnType<typeof useUserCheckInfoQuery>;
export type UserCheckInfoLazyQueryHookResult = ReturnType<typeof useUserCheckInfoLazyQuery>;
export type UserCheckInfoSuspenseQueryHookResult = ReturnType<typeof useUserCheckInfoSuspenseQuery>;
export type UserCheckInfoQueryResult = Apollo.QueryResult<UserCheckInfoQuery, UserCheckInfoQueryVariables>;
export const WaivePaymentDocument = gql`
    mutation WaivePayment($messageId: ID!) {
  refusePayment(messageId: $messageId) {
    id
    transaction {
      id
      status
    }
  }
}
    `;
export type WaivePaymentMutationFn = Apollo.MutationFunction<WaivePaymentMutation, WaivePaymentMutationVariables>;

/**
 * __useWaivePaymentMutation__
 *
 * To run a mutation, you first call `useWaivePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWaivePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [waivePaymentMutation, { data, loading, error }] = useWaivePaymentMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useWaivePaymentMutation(baseOptions?: Apollo.MutationHookOptions<WaivePaymentMutation, WaivePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WaivePaymentMutation, WaivePaymentMutationVariables>(WaivePaymentDocument, options);
      }
export type WaivePaymentMutationHookResult = ReturnType<typeof useWaivePaymentMutation>;
export type WaivePaymentMutationResult = Apollo.MutationResult<WaivePaymentMutation>;
export type WaivePaymentMutationOptions = Apollo.BaseMutationOptions<WaivePaymentMutation, WaivePaymentMutationVariables>;
export const WalletDocument = gql`
    query WALLET($offset: Int, $limit: Int) {
  wallet {
    balance {
      amount
    }
    frozen
    id
    role
    type
    adjustments(offset: $offset, limit: $limit) {
      data {
        id
        amountInCents {
          amount
        }
        insertedAt
        title
        description
        walletType
      }
      page {
        totalCount
      }
    }
    type
  }
}
    `;

/**
 * __useWalletQuery__
 *
 * To run a query within a React component, call `useWalletQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useWalletQuery(baseOptions?: Apollo.QueryHookOptions<WalletQuery, WalletQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletQuery, WalletQueryVariables>(WalletDocument, options);
      }
export function useWalletLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletQuery, WalletQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletQuery, WalletQueryVariables>(WalletDocument, options);
        }
export function useWalletSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WalletQuery, WalletQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletQuery, WalletQueryVariables>(WalletDocument, options);
        }
export type WalletQueryHookResult = ReturnType<typeof useWalletQuery>;
export type WalletLazyQueryHookResult = ReturnType<typeof useWalletLazyQuery>;
export type WalletSuspenseQueryHookResult = ReturnType<typeof useWalletSuspenseQuery>;
export type WalletQueryResult = Apollo.QueryResult<WalletQuery, WalletQueryVariables>;
export const WalletBalanceDocument = gql`
    query walletBalance {
  wallet {
    balance {
      amount
    }
  }
}
    `;

/**
 * __useWalletBalanceQuery__
 *
 * To run a query within a React component, call `useWalletBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletBalanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useWalletBalanceQuery(baseOptions?: Apollo.QueryHookOptions<WalletBalanceQuery, WalletBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletBalanceQuery, WalletBalanceQueryVariables>(WalletBalanceDocument, options);
      }
export function useWalletBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletBalanceQuery, WalletBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletBalanceQuery, WalletBalanceQueryVariables>(WalletBalanceDocument, options);
        }
export function useWalletBalanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WalletBalanceQuery, WalletBalanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletBalanceQuery, WalletBalanceQueryVariables>(WalletBalanceDocument, options);
        }
export type WalletBalanceQueryHookResult = ReturnType<typeof useWalletBalanceQuery>;
export type WalletBalanceLazyQueryHookResult = ReturnType<typeof useWalletBalanceLazyQuery>;
export type WalletBalanceSuspenseQueryHookResult = ReturnType<typeof useWalletBalanceSuspenseQuery>;
export type WalletBalanceQueryResult = Apollo.QueryResult<WalletBalanceQuery, WalletBalanceQueryVariables>;
export const WalletEventsDocument = gql`
    subscription WalletEvents {
  walletEvents {
    ... on WalletBalanceEvent {
      updatedAt
    }
  }
}
    `;

/**
 * __useWalletEventsSubscription__
 *
 * To run a query within a React component, call `useWalletEventsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWalletEventsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletEventsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWalletEventsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<WalletEventsSubscription, WalletEventsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WalletEventsSubscription, WalletEventsSubscriptionVariables>(WalletEventsDocument, options);
      }
export type WalletEventsSubscriptionHookResult = ReturnType<typeof useWalletEventsSubscription>;
export type WalletEventsSubscriptionResult = Apollo.SubscriptionResult<WalletEventsSubscription>;